// This file is autogenerated by the script "constants:entity-legal-forms"

export type EntityLegalFormForCode = {
  /**
   * if false, this code is a legacy one
   */
  active: boolean;
  languages: Record<string, { label: string; abbreviations: string[] }>;
  subdivision?: string;
};

export type EntityLegalFormForCountry = Record<string, EntityLegalFormForCode>;

export const GENERIC_DEFAULT_COUNTRY_CODE = 'ZZ';

/**
 * @NOTE: 'ZZ' is a user defined country code that represent all countries
 * It's used for special code "8888" (Other) & "9999" (Not applicable)
 */
export const ENTITY_LEGAL_FORMS: Record<string, EntityLegalFormForCountry> = {
  ZZ: {
    '8888': {
      active: true,
      languages: {
        en: {
          label: 'Other',
          abbreviations: [],
        },
      },
    },
    '9999': {
      active: true,
      languages: {
        en: {
          label: 'Not applicable',
          abbreviations: [],
        },
      },
    },
  },
  AG: {
    CDOV: {
      active: true,
      languages: {
        en: {
          label: 'International Business Corporation',
          abbreviations: [],
        },
      },
    },
  },
  AR: {
    '5AWN': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad del Estado',
          abbreviations: ['S.E'],
        },
      },
    },
    '6M8Y': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Colectiva',
          abbreviations: ['Soc.Col.'],
        },
      },
    },
    D3E0: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Capital e Industria',
          abbreviations: ['S.C.e I.'],
        },
      },
    },
    F0A6: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anonima',
          abbreviations: ['S.A.'],
        },
      },
    },
    FE8K: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Por Acciones Simplificada',
          abbreviations: ['S.A.S'],
        },
      },
    },
    H70T: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita Simple',
          abbreviations: ['S.C.S.'],
        },
      },
    },
    HZ6C: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Cooperativa',
          abbreviations: ['S. Coop.'],
        },
      },
    },
    L4QF: {
      active: true,
      languages: {
        es: {
          label: 'Organismo Publico',
          abbreviations: [],
        },
      },
    },
    LVJZ: {
      active: true,
      languages: {
        es: {
          label: 'Fundacion',
          abbreviations: [],
        },
      },
    },
    O7AL: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Garantía Reciproca',
          abbreviations: ['SGR'],
        },
      },
    },
    PLZ6: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita por Acciones',
          abbreviations: ['S.C.p.A.'],
        },
      },
    },
    RDD3: {
      active: true,
      languages: {
        es: {
          label: 'Asociacion civil',
          abbreviations: [],
        },
      },
    },
    U82F: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad De Responsalided Limitada',
          abbreviations: ['S.R.L'],
        },
      },
    },
    WUAZ: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anonima Unipersonal',
          abbreviations: ['S.A.U.'],
        },
      },
    },
  },
  AW: {
    CRL9: {
      active: true,
      languages: {
        nl: {
          label: 'Stichting',
          abbreviations: [],
        },
      },
    },
    CYW2: {
      active: true,
      languages: {
        nl: {
          label: 'Vennootschap onder firma',
          abbreviations: ['VOF'],
        },
      },
    },
    GAJN: {
      active: true,
      languages: {
        nl: {
          label: 'Commanditaire vennootschap (1)',
          abbreviations: [],
        },
      },
    },
    M27U: {
      active: true,
      languages: {
        nl: {
          label: 'Besloten vennootschap',
          abbreviations: ['BV'],
        },
      },
    },
    OLAI: {
      active: true,
      languages: {
        nl: {
          label: 'Vereniging',
          abbreviations: [],
        },
      },
    },
    P65N: {
      active: true,
      languages: {
        nl: {
          label: 'Naamloze vennootschap',
          abbreviations: ['NV'],
        },
      },
    },
    PCRJ: {
      active: true,
      languages: {
        nl: {
          label: 'Cooperatieve vereniging',
          abbreviations: [],
        },
      },
    },
    PT6C: {
      active: true,
      languages: {
        nl: {
          label: 'Eenmanszaak',
          abbreviations: [],
        },
      },
    },
    REUP: {
      active: true,
      languages: {
        nl: {
          label: 'Aruba vrijgestelde vennootschap',
          abbreviations: ['AVV'],
        },
      },
    },
    T5RL: {
      active: false,
      languages: {
        nl: {
          label: 'Vennootschap buitenlands recht',
          abbreviations: [],
        },
      },
    },
    UV8T: {
      active: true,
      languages: {
        nl: {
          label: 'Maatschap',
          abbreviations: [],
        },
      },
    },
    V905: {
      active: true,
      languages: {
        nl: {
          label: 'Vennootschap met beperkte aansprakelijkheid',
          abbreviations: ['VBA'],
        },
      },
    },
    YCV2: {
      active: true,
      languages: {
        nl: {
          label: 'Commanditaire vennootschap (1+)',
          abbreviations: [],
        },
      },
    },
  },
  AU: {
    '6W6X': {
      active: true,
      languages: {
        en: {
          label: 'Co-operative',
          abbreviations: ['Coop', 'Coop Ltd.'],
        },
      },
    },
    '7TPC': {
      active: true,
      languages: {
        en: {
          label: 'Trust',
          abbreviations: [],
        },
      },
    },
    ADXG: {
      active: true,
      languages: {
        en: {
          label: 'Fund',
          abbreviations: [],
        },
      },
    },
    BC38: {
      active: true,
      languages: {
        en: {
          label: 'Incorporated association',
          abbreviations: ['Inc'],
        },
      },
    },
    J4JC: {
      active: true,
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['ILP', 'LP'],
        },
      },
    },
    LZFR: {
      active: true,
      languages: {
        en: {
          label: 'Public Company limited by guarantee',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    PQHL: {
      active: true,
      languages: {
        en: {
          label: 'No Liability Company',
          abbreviations: ['NL', 'No Liability'],
        },
      },
    },
    Q82Q: {
      active: true,
      languages: {
        en: {
          label: 'Unlimited Proprietary Company',
          abbreviations: ['Proprietary', 'PTY', 'Pty Ltd'],
        },
      },
    },
    R4KK: {
      active: true,
      languages: {
        en: {
          label: 'Public Company limited by shares',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    TXVC: {
      active: true,
      languages: {
        en: {
          label: 'Limited Proprietary Company',
          abbreviations: [
            'Proprietary Limited',
            'Proprietary Ltd',
            'Pty Limited',
            'PTY LTD',
          ],
        },
      },
    },
    XHCV: {
      active: true,
      languages: {
        en: {
          label: 'Indigenous Corporation',
          abbreviations: ['RNTBC'],
        },
      },
    },
  },
  AT: {
    '1NOX': {
      active: true,
      languages: {
        de: {
          label: 'Sonstiger Rechtsträger',
          abbreviations: [],
        },
      },
    },
    '5WWO': {
      active: true,
      languages: {
        de: {
          label: 'Privatstiftung',
          abbreviations: [],
        },
      },
    },
    '69H1': {
      active: true,
      languages: {
        de: {
          label: 'Europäische Genossenschaft (SCE)',
          abbreviations: [],
        },
      },
    },
    '8XDW': {
      active: true,
      languages: {
        de: {
          label: 'Genossenschaft',
          abbreviations: [],
        },
      },
    },
    AAL7: {
      active: true,
      languages: {
        de: {
          label: 'Kommandit-Erwerbsgesellschaft',
          abbreviations: ['KEG'],
        },
      },
    },
    AXSB: {
      active: true,
      languages: {
        de: {
          label: 'Gesellschaft mit beschränkter Haftung',
          abbreviations: ['GmbH', 'Ges.m.b.H.'],
        },
      },
    },
    CAQ1: {
      active: true,
      languages: {
        de: {
          label: 'Versicherungsverein auf Gegenseitigkeit',
          abbreviations: [],
        },
      },
    },
    DM88: {
      active: true,
      languages: {
        de: {
          label: 'Europäische wirtschaftliche Interessenvereinigung',
          abbreviations: [],
        },
      },
    },
    DX6Z: {
      active: true,
      languages: {
        de: {
          label: 'Verein',
          abbreviations: [],
        },
      },
    },
    E9OX: {
      active: true,
      languages: {
        de: {
          label: 'Gemeinnützige Stiftung',
          abbreviations: [],
        },
      },
    },
    ECWU: {
      active: true,
      languages: {
        de: {
          label: 'Einzelunternehmer',
          abbreviations: ['EU'],
        },
      },
    },
    EQOV: {
      active: true,
      languages: {
        de: {
          label: 'Aktiengesellschaft',
          abbreviations: ['AG'],
        },
      },
    },
    G3R6: {
      active: true,
      languages: {
        de: {
          label: 'Einzelkaufmann',
          abbreviations: [],
        },
      },
    },
    GVPD: {
      active: true,
      languages: {
        de: {
          label: 'Offene Handelsgesellschaft',
          abbreviations: ['OHG'],
        },
      },
    },
    JJYT: {
      active: true,
      languages: {
        de: {
          label: 'Körperschaft öffentlichen Rechts',
          abbreviations: [],
        },
      },
    },
    JQOI: {
      active: true,
      languages: {
        de: {
          label: 'Sparkasse',
          abbreviations: [],
        },
      },
    },
    JTAV: {
      active: true,
      languages: {
        de: {
          label: 'Offene Gesellschaft',
          abbreviations: ['OG'],
        },
      },
    },
    JUHG: {
      active: true,
      languages: {
        de: {
          label: 'Offene Erwerbsgesellschaft',
          abbreviations: ['OEG'],
        },
      },
    },
    NIJH: {
      active: true,
      languages: {
        de: {
          label: 'Erwerbs- und Wirtschaftsgenossenschaft',
          abbreviations: [],
        },
      },
    },
    NNLI: {
      active: true,
      languages: {
        de: {
          label: 'Stille Gesellschaft',
          abbreviations: ['stG'],
        },
      },
    },
    O65B: {
      active: true,
      languages: {
        de: {
          label: 'Europäische Gesellschaft (SE)',
          abbreviations: [],
        },
      },
    },
    ONF1: {
      active: true,
      languages: {
        de: {
          label: 'Kommanditgesellschaft',
          abbreviations: ['KG'],
        },
      },
    },
    UI81: {
      active: true,
      languages: {
        de: {
          label: 'Gesellschaft des bürgerlichen Rechts',
          abbreviations: ['GesbR'],
        },
      },
    },
  },
  AZ: {
    '52TH': {
      active: true,
      languages: {
        az: {
          label: 'Törəmə təsərrüfat cəmiyyəti',
          abbreviations: [],
        },
      },
    },
    '6JHZ': {
      active: true,
      languages: {
        az: {
          label: 'Məhdud məsuliyyətli cəmiyyəti',
          abbreviations: ['MMC'],
        },
      },
    },
    DWEA: {
      active: true,
      languages: {
        az: {
          label: 'Kooperativlər',
          abbreviations: [],
        },
      },
    },
    HKL3: {
      active: true,
      languages: {
        az: {
          label: 'Əlavə məsuliyyətli cəmiyyət',
          abbreviations: [],
        },
      },
    },
    K81Q: {
      active: true,
      languages: {
        az: {
          label: 'Açıq səhmdar cəmiyyəti',
          abbreviations: ['ASC'],
        },
      },
    },
    M4LU: {
      active: true,
      languages: {
        az: {
          label: 'Qapalı səhmdar cəmiyyəti',
          abbreviations: ['QSC'],
        },
      },
    },
    MEJT: {
      active: true,
      languages: {
        az: {
          label: 'Tam ortaqlıq',
          abbreviations: [],
        },
      },
    },
    PITR: {
      active: true,
      languages: {
        az: {
          label: 'Hüquqi şəxslərin ittifaqları',
          abbreviations: [],
        },
      },
    },
    SLXJ: {
      active: true,
      languages: {
        az: {
          label: 'Asılı təsərrüfat cəmiyyəti',
          abbreviations: [],
        },
      },
    },
    TD56: {
      active: true,
      languages: {
        az: {
          label: 'Komandit ortaqlıq',
          abbreviations: [],
        },
      },
    },
    U0SP: {
      active: true,
      languages: {
        az: {
          label: 'İctimai birliklər',
          abbreviations: [],
        },
      },
    },
    ZD74: {
      active: true,
      languages: {
        az: {
          label: 'Fondlar',
          abbreviations: [],
        },
      },
    },
  },
  BS: {
    '1W6I': {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    '78QF': {
      active: true,
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
    '98A8': {
      active: true,
      languages: {
        en: {
          label: 'Company Limited by Shares',
          abbreviations: ['Ltd'],
        },
      },
    },
    A9N4: {
      active: true,
      languages: {
        en: {
          label: 'International Business Company',
          abbreviations: [],
        },
      },
    },
    DAEG: {
      active: true,
      languages: {
        en: {
          label: 'Unlimited Liability Company',
          abbreviations: [],
        },
      },
    },
    HNSU: {
      active: true,
      languages: {
        en: {
          label: 'Public Company Limited by Shares',
          abbreviations: ['Ltd'],
        },
      },
    },
    HP0B: {
      active: true,
      languages: {
        en: {
          label: 'Company Limited both by Shares and by Guarantee',
          abbreviations: ['Ltd'],
        },
      },
    },
    PB7W: {
      active: true,
      languages: {
        en: {
          label: 'Company Limited by Guarantee',
          abbreviations: ['Ltd'],
        },
      },
    },
    PICJ: {
      active: true,
      languages: {
        en: {
          label: 'Non-Profit Company',
          abbreviations: [],
        },
      },
    },
    SQ8U: {
      active: true,
      languages: {
        en: {
          label: 'Exempted Limited Partnership',
          abbreviations: [],
        },
      },
    },
    VVOW: {
      active: true,
      languages: {
        en: {
          label: 'Foundation',
          abbreviations: [],
        },
      },
    },
    XDKS: {
      active: true,
      languages: {
        en: {
          label: 'Sole Proprietor',
          abbreviations: [],
        },
      },
    },
  },
  BH: {
    '2MAO': {
      active: true,
      languages: {
        ar: {
          label: 'الشركة غير هادفة للربح',
          abbreviations: [],
        },
      },
    },
    '990B': {
      active: true,
      languages: {
        ar: {
          label: 'وصية الشراكة من قبل شركة الأسهم (شركة التوصية بالأسهم)',
          abbreviations: [],
        },
      },
    },
    JNJI: {
      active: true,
      languages: {
        ar: {
          label: 'الشركة ذات المسؤولية المحدودة',
          abbreviations: ['ذ.م.م'],
        },
      },
    },
    SRQE: {
      active: true,
      languages: {
        ar: {
          label: 'شركة التوصية البسيطة للشراكة (شركة التوصية البسيطة)',
          abbreviations: [],
        },
      },
    },
    SWH1: {
      active: true,
      languages: {
        ar: {
          label: 'شركة تضامن',
          abbreviations: [],
        },
      },
    },
  },
  BB: {
    '2T7B': {
      active: true,
      languages: {
        en: {
          label: 'Society with restricted liability',
          abbreviations: ['SRL'],
        },
      },
    },
    '5IL6': {
      active: true,
      languages: {
        en: {
          label: 'Sole proprietorship',
          abbreviations: [],
        },
      },
    },
    '7FCS': {
      active: true,
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
    EKJG: {
      active: true,
      languages: {
        en: {
          label: 'Segregated cell company',
          abbreviations: [],
        },
      },
    },
    HTBY: {
      active: true,
      languages: {
        en: {
          label: 'Company',
          abbreviations: ['corp.', 'inc.', 'ltd.'],
        },
      },
    },
    KYFD: {
      active: true,
      languages: {
        en: {
          label: 'Non-profit company',
          abbreviations: [],
        },
      },
    },
    Q9Y1: {
      active: true,
      languages: {
        en: {
          label: 'International business company',
          abbreviations: [],
        },
      },
    },
    T4KB: {
      active: true,
      languages: {
        en: {
          label: 'Association',
          abbreviations: [],
        },
      },
    },
    TEPY: {
      active: true,
      languages: {
        en: {
          label: 'Public company',
          abbreviations: ['corp.', 'inc.', 'ltd.'],
        },
      },
    },
    X2X1: {
      active: true,
      languages: {
        en: {
          label: 'Limited partnership',
          abbreviations: [],
        },
      },
    },
  },
  BY: {
    '106J': {
      active: true,
      languages: {
        be: {
          label: 'Закрытае акцыянернае таварыства',
          abbreviations: ['ЗАТ'],
        },
        ru: {
          label: 'Закрытое акционерное общество',
          abbreviations: ['ЗАО'],
        },
      },
    },
    '9X63': {
      active: true,
      languages: {
        be: {
          label: 'Унітарнае прадпрыемства',
          abbreviations: ['УП'],
        },
        ru: {
          label: 'Унитарное предприятие',
          abbreviations: ['УП'],
        },
      },
    },
    AABD: {
      active: true,
      languages: {
        be: {
          label: 'Таварыства з абмежаванай адказнасцю',
          abbreviations: ['ТАА'],
        },
        ru: {
          label: 'Общество с ограниченной ответственностью',
          abbreviations: ['ООО'],
        },
      },
    },
    JLR3: {
      active: true,
      languages: {
        be: {
          label: 'Таварыства з дадатковай адказнасцю',
          abbreviations: ['ТДА'],
        },
        ru: {
          label: 'Общество с дополнительной ответственностью',
          abbreviations: ['ОДО'],
        },
      },
    },
    MR85: {
      active: true,
      languages: {
        be: {
          label: 'Адкрытае акцыянернае таварыства',
          abbreviations: ['ААТ'],
        },
        ru: {
          label: 'Открытое акционерное общество',
          abbreviations: ['ОАО'],
        },
      },
    },
  },
  BE: {
    '1TX8': {
      active: true,
      languages: {
        nl: {
          label:
            'Commanditaire vennootschap op aandelen met een sociaal oogmerk',
          abbreviations: ['CVA SO'],
        },
        fr: {
          label: 'Société en commandite par actions à finalité sociale',
          abbreviations: ['SCA FS'],
        },
        de: {
          label: 'Kommanditgesellschaft auf Aktien mit sozialer Zielsetzung',
          abbreviations: ['KGaAmsZ'],
        },
      },
    },
    '28FE': {
      active: true,
      languages: {
        nl: {
          label: 'Coöperatieve vennootschap',
          abbreviations: ['CV'],
        },
        fr: {
          label: 'Société coopérative',
          abbreviations: ['SC'],
        },
        de: {
          label: 'Genossenschaft',
          abbreviations: ['Gen.'],
        },
      },
    },
    '2QSA': {
      active: true,
      languages: {
        nl: {
          label:
            'Coöperatieve vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk',
          abbreviations: ['CVBA SO'],
        },
        fr: {
          label:
            'Société coopérative à responsabilité limitée à finalité sociale',
          abbreviations: ['SCRL FS'],
        },
        de: {
          label:
            'Genossenschaft mit beschränkter Haftung mit sozialer Zielsetzung',
          abbreviations: ['GbHsZ'],
        },
      },
    },
    '36KV': {
      active: true,
      languages: {
        nl: {
          label: 'Europese vennootschap (Societas Europaea)',
          abbreviations: ['SE'],
        },
        fr: {
          label: 'Société européenne (Societas Europaea)',
          abbreviations: ['SE'],
        },
        de: {
          label: 'Europäische Gesellschaft (Societas Europaea)',
          abbreviations: ['SE'],
        },
      },
    },
    '3LMA': {
      active: false,
      languages: {
        nl: {
          label: 'Buitenlandse onderneming',
          abbreviations: ['BO'],
        },
        fr: {
          label: 'Entreprise étrangère',
          abbreviations: ['ENT E'],
        },
        de: {
          label: 'Ausländische Gesellschaft',
          abbreviations: ['AGes.'],
        },
      },
    },
    '3N94': {
      active: true,
      languages: {
        nl: {
          label: 'Onderneming-natuurlijk persoon',
          abbreviations: ['ONP'],
        },
        fr: {
          label: 'Entreprise personne physique',
          abbreviations: ['EPP'],
        },
        de: {
          label: 'Unternehmen natürliche Person',
          abbreviations: ['UNP'],
        },
      },
    },
    '3W7E': {
      active: true,
      languages: {
        nl: {
          label: 'Besloten Vennootschap',
          abbreviations: ['BV'],
        },
        fr: {
          label: 'Société à responsabilité limitée',
          abbreviations: ['SRL'],
        },
        de: {
          label: 'Gesellschaft mit beschränkter Haftung',
          abbreviations: ['GmbH'],
        },
      },
    },
    '4E5P': {
      active: true,
      languages: {
        nl: {
          label:
            'Coöperatieve vennootschap met onbeperkte aansprakelijkheid met een sociaal oogmerk',
          abbreviations: ['CVOA SO'],
        },
        fr: {
          label:
            'Société coopérative à responsabilité illimitée à finalité sociale',
          abbreviations: ['SCRI FS'],
        },
        de: {
          label:
            'Genossenschaft mit unbeschränkter Haftung mit sozialer Zielsetzung',
          abbreviations: ['GuHsZ'],
        },
      },
    },
    '7SJP': {
      active: true,
      languages: {
        nl: {
          label: 'Europees economisch samenwerkingsverband',
          abbreviations: ['EESV'],
        },
        fr: {
          label: "Groupement européen d'intérêt économique",
          abbreviations: ['GEIE'],
        },
        de: {
          label: 'Europäische wirtschaftliche Interessenvereinigung',
          abbreviations: ['EWIV'],
        },
      },
    },
    '8E2A': {
      active: true,
      languages: {
        nl: {
          label: 'Coöperatieve vennootschap met beperkte aansprakelijkheid',
          abbreviations: ['CVBA'],
        },
        fr: {
          label: 'Société coopérative à responsabilité limitée',
          abbreviations: ['SCRL'],
        },
        de: {
          label: 'Genossenschaft mit beschränkter Haftung',
          abbreviations: ['Gen.mbH'],
        },
      },
    },
    '8YLB': {
      active: true,
      languages: {
        nl: {
          label: 'Instelling zonder winstoogmerk',
          abbreviations: ['IZW'],
        },
        fr: {
          label: 'Institution sans but lucratif',
          abbreviations: ['ISBL'],
        },
        de: {
          label: 'Einrichtung ohne Gewinnerzielungsabsicht',
          abbreviations: ['EoG'],
        },
      },
    },
    B910: {
      active: true,
      languages: {
        nl: {
          label: 'Vennootschap onder firma met een sociaal oogmerk',
          abbreviations: ['VOF SO'],
        },
        fr: {
          label: 'Société en nom collectif à finalité sociale',
          abbreviations: ['SNC FS'],
        },
        de: {
          label: 'Offene Handelsgesellschaft mit sozialer Zielsetzung',
          abbreviations: ['OHGmsZ'],
        },
      },
    },
    C609: {
      active: true,
      languages: {
        nl: {
          label:
            'Eenpersoons besloten vennootschap met beperkte aansprakelijkheid',
          abbreviations: ['EBVBA'],
        },
        fr: {
          label: 'Société privée à responsabilité limitée unipersonnelle',
          abbreviations: ['SPRLU'],
        },
        de: {
          label:
            'Privatgesellschaft mit beschränkter Haftung mit einem Alleingesellschafter',
          abbreviations: ['PGmbHmA'],
        },
      },
    },
    CFH5: {
      active: true,
      languages: {
        nl: {
          label: 'Vennootschap of vereniging zonder rechtspersoonlijkheid',
          abbreviations: ['VVZRL'],
        },
        fr: {
          label: 'Société ou association sans personnalité juridique',
          abbreviations: ['SASPJ'],
        },
        de: {
          label: 'Gesellschaften oder Vereinigungen ohne Rechtspersönlichkeit',
          abbreviations: ['GVoRP'],
        },
      },
    },
    EDMK: {
      active: true,
      languages: {
        nl: {
          label: 'Vereniging zonder winstoogmerk van publiek recht',
          abbreviations: ['VZW PR'],
        },
        fr: {
          label: 'Association sans but lucratif de droit public',
          abbreviations: ['ASBL DPU'],
        },
        de: {
          label:
            'Öffentlich-rechtliche Vereinigung ohne Gewinnerzielungsabsicht',
          abbreviations: ['ÖrVohGza'],
        },
      },
    },
    EXY8: {
      active: true,
      languages: {
        nl: {
          label:
            'Coöperatieve vennootschap met onbeperkte aansprakelijkheid, bij wijze van deelneming van publiek recht',
          abbreviations: ['CVOA CD'],
        },
        fr: {
          label:
            'Coopérative à responsabilité illimitée, coopérative de participation, de droit public',
          abbreviations: ['SCRI CP'],
        },
        de: {
          label:
            'Öffentlich-rechtliche Genossenschaft mit unbeschränkter Haftung, Genossenschaft auf Beteiligung',
          abbreviations: ['GmuHGB'],
        },
      },
    },
    J5OU: {
      active: true,
      languages: {
        nl: {
          label: 'Economisch samenwerkingsverband',
          abbreviations: ['ESV'],
        },
        fr: {
          label: "Groupement d'intérêt économique",
          abbreviations: ['GIE'],
        },
        de: {
          label: 'Wirtschaftliche Interessenvereinigung',
          abbreviations: ['WIV'],
        },
      },
    },
    JAM3: {
      active: true,
      languages: {
        nl: {
          label: 'Coöperatieve vennootschap van publiek recht',
          abbreviations: ['CV PR'],
        },
        fr: {
          label: 'Société coopérative de droit public',
          abbreviations: ['SC DPU'],
        },
        de: {
          label: 'Öffentlich-rechtliche Genossenschaft',
          abbreviations: ['ÖrGen.'],
        },
      },
    },
    JNAD: {
      active: true,
      languages: {
        nl: {
          label:
            'Besloten vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk',
          abbreviations: ['BVBA SO'],
        },
        fr: {
          label: 'Société privée à responsabilité limitée à finalité sociale',
          abbreviations: ['SPRL FS'],
        },
        de: {
          label:
            'Privatgesellschaft mit beschränkter Haftung mit sozialer Zielsetzung',
          abbreviations: ['PmbHsZ'],
        },
      },
    },
    KLBO: {
      active: false,
      languages: {
        nl: {
          label:
            'Burgerlijke vennootschap onder vorm van commanditaire vennootschap op aandelen',
          abbreviations: ['BV CVA'],
        },
        fr: {
          label:
            'Société civile sous forme de société en commandite par actions',
          abbreviations: ['SC SCA'],
        },
        de: {
          label:
            'Zivilrechtliche Gesellschaft in der Rechtsform einer Kommanditgesellschaft auf Aktien',
          abbreviations: ['ZRG KGaA'],
        },
      },
    },
    KM6O: {
      active: true,
      languages: {
        nl: {
          label: 'Maatschap',
          abbreviations: ['MS'],
        },
        fr: {
          label: 'Société de droit commun',
          abbreviations: ['SDC'],
        },
        de: {
          label: 'Gesellschaft des allgemeinen Rechts',
          abbreviations: ['GaR'],
        },
      },
    },
    L05H: {
      active: true,
      languages: {
        nl: {
          label: 'Besloten Vennootschap van publiek recht',
          abbreviations: ['BV PR'],
        },
        fr: {
          label: 'Société à responsabilité limitée de droit public',
          abbreviations: ['SRL DPU'],
        },
        de: {
          label: 'Öffentlich-rechtliche Gesellschaft mit beschränkter Haftung',
          abbreviations: ['ÖrGmbH'],
        },
      },
    },
    LWHF: {
      active: true,
      languages: {
        nl: {
          label: 'Coöperatieve vennootschap met onbeperkte aansprakelijkheid',
          abbreviations: ['CVOA'],
        },
        fr: {
          label: 'Société coopérative à responsabilité illimitée',
          abbreviations: ['SCRI'],
        },
        de: {
          label: 'Genossenschaft mit unbeschränkter Haftung',
          abbreviations: ['Gen.mubH'],
        },
      },
    },
    LWV6: {
      active: true,
      languages: {
        nl: {
          label: 'Gewone commanditaire vennootschap',
          abbreviations: ['Comm.V'],
        },
        fr: {
          label: 'Société en commandite simple',
          abbreviations: ['SCS'],
        },
        de: {
          label: 'Einfache Kommanditgesellschaft',
          abbreviations: ['EKG'],
        },
      },
    },
    MQH3: {
      active: true,
      languages: {
        nl: {
          label: 'Commanditaire vennootschap',
          abbreviations: ['CommV'],
        },
        fr: {
          label: 'Société en commandite',
          abbreviations: ['SComm'],
        },
        de: {
          label: 'Kommanditgesellschaft',
          abbreviations: ['KommG'],
        },
      },
    },
    N5NT: {
      active: true,
      languages: {
        nl: {
          label: 'Besloten vennootschap met beperkte aansprakelijkheid',
          abbreviations: ['BVBA'],
        },
        fr: {
          label: 'Société privée à responsabilité limitée',
          abbreviations: ['SPRL'],
        },
        de: {
          label: 'Privatgesellschaft mit beschränkter Haftung',
          abbreviations: ['PGmbH'],
        },
      },
    },
    O59C: {
      active: true,
      languages: {
        nl: {
          label: 'Economisch samenwerkingsverband met een sociaal oogmerk',
          abbreviations: ['ESV SO'],
        },
        fr: {
          label: "Groupement d'intérêt économique à finalité sociale",
          abbreviations: ['GIE FS'],
        },
        de: {
          label:
            'Wirtschaftliche Interessenvereinigung mit sozialer Zielsetzung',
          abbreviations: ['WIVmsZ'],
        },
      },
    },
    O5HQ: {
      active: false,
      languages: {
        nl: {
          label:
            'Burgerlijke vennootschap onder vorm van coöperatieve vennootschap met beperkte aansprakelijkheid',
          abbreviations: ['BV CVBA'],
        },
        fr: {
          label:
            'Société civile sous forme de société coopérative à responsabilité limitée',
          abbreviations: ['SC SCRL'],
        },
        de: {
          label:
            'Zivilrechtliche Gesellschaft in der Rechtsform einer Genossenschaft mit beschränkter Haftung',
          abbreviations: ['ZvGGbH'],
        },
      },
    },
    PVT3: {
      active: true,
      languages: {
        nl: {
          label:
            'Eenpersoons besloten vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk',
          abbreviations: ['EBVBA SO'],
        },
        fr: {
          label:
            'Société privée à responsabilité limitée unipersonnelle à finalité sociale',
          abbreviations: ['SPRLU FS'],
        },
        de: {
          label:
            'Privatgesellschaft mit beschränkter Haftung mit sozialer Zielsetzung mit einem Alleingesellschafter',
          abbreviations: ['PgbHsZ'],
        },
      },
    },
    QZIS: {
      active: true,
      languages: {
        nl: {
          label: 'Openbare instelling',
          abbreviations: ['OI'],
        },
        fr: {
          label: 'Etablissement public',
          abbreviations: ['ETSPUBLI'],
        },
        de: {
          label: 'Öffentliche Einrichtung',
          abbreviations: ['ÖE'],
        },
      },
    },
    R85P: {
      active: true,
      languages: {
        nl: {
          label: 'Naamloze vennootschap',
          abbreviations: ['NV'],
        },
        fr: {
          label: 'Société anonyme',
          abbreviations: ['SA'],
        },
        de: {
          label: 'Aktiengesellschaft',
          abbreviations: ['AG'],
        },
      },
    },
    T922: {
      active: false,
      languages: {
        nl: {
          label:
            'Burgerlijke vennootschap onder vorm van gewone commanditaire vennootschap',
          abbreviations: ['BV GCV'],
        },
        fr: {
          label: 'Société civile sous forme de société en commandite simple',
          abbreviations: ['SC SCS'],
        },
        de: {
          label:
            'Zivilrechtliche Gesellschaft in der Rechtsform einer einfachen Kommanditgesellschaft',
          abbreviations: ['ZRG EKG'],
        },
      },
    },
    TPTU: {
      active: true,
      languages: {
        nl: {
          label: 'Naamloze vennootschap van publiek recht',
          abbreviations: ['NV PR'],
        },
        fr: {
          label: 'Société anonyme de droit public',
          abbreviations: ['SA DPU'],
        },
        de: {
          label: 'Öffentlich-rechtliche Aktiengesellschaft',
          abbreviations: ['Ö.-r.AG'],
        },
      },
    },
    U2PN: {
      active: true,
      languages: {
        nl: {
          label: 'Commanditaire vennootschap op aandelen',
          abbreviations: ['Comm.VA'],
        },
        fr: {
          label: 'Société en commandite par actions',
          abbreviations: ['SCA'],
        },
        de: {
          label: 'Kommanditgesellschaft auf Aktien',
          abbreviations: ['KGaA'],
        },
      },
    },
    U5KF: {
      active: false,
      languages: {
        nl: {
          label:
            'Burgerlijke vennootschap onder vorm van vennootschap onder firma',
          abbreviations: ['BV VOF'],
        },
        fr: {
          label: 'Société civile sous forme de société en nom collectif',
          abbreviations: ['SC SNC'],
        },
        de: {
          label:
            'Zivilrechtliche Gesellschaft in der Rechtsform einer offenen Handelsgesellschaft',
          abbreviations: ['ZRG OHG'],
        },
      },
    },
    UCT9: {
      active: false,
      languages: {
        nl: {
          label:
            'Burgerlijke Vennootschap onder vorm van Landbouwvennootschap (BV LV)',
          abbreviations: [],
        },
        fr: {
          label: 'Société civile sous forme de société agricole',
          abbreviations: ['SC SAGR'],
        },
        de: {
          label:
            'Zivilrechtliche Gesellschaft in der Rechtsform einer landwirtschaftlichen Gesellschaft',
          abbreviations: ['ZRG LG'],
        },
      },
    },
    UW1Y: {
      active: true,
      languages: {
        nl: {
          label: 'Vennootschap onder firma',
          abbreviations: ['V.O.F.'],
        },
        fr: {
          label: 'Société en nom collectif',
          abbreviations: ['SNC'],
        },
        de: {
          label: 'Offene Handelsgesellschaft',
          abbreviations: ['OHG'],
        },
      },
    },
    V03J: {
      active: true,
      languages: {
        nl: {
          label: 'Internationale vereniging zonder winstoogmerk',
          abbreviations: ['IVZW'],
        },
        fr: {
          label: 'Association internationale sans but lucratif',
          abbreviations: ['AISBL'],
        },
        de: {
          label: 'Internationale Vereinigung ohne Gewinnerzielungsabsicht',
          abbreviations: ['IVoG'],
        },
      },
    },
    V7FT: {
      active: true,
      languages: {
        nl: {
          label: 'Naamloze vennootschap met een sociaal oogmerk',
          abbreviations: ['NV SO'],
        },
        fr: {
          label: 'Société anonyme à finalité sociale',
          abbreviations: ['SA FS'],
        },
        de: {
          label: 'Aktiengesellschaft mit sozialer Zielsetzung',
          abbreviations: ['AGmsZ'],
        },
      },
    },
    V8L7: {
      active: false,
      languages: {
        nl: {
          label:
            'Burgerlijke vennootschap onder vorm van besloten vennootschap met beperkte aansprakelijkheid',
          abbreviations: ['BV BVBA'],
        },
        fr: {
          label:
            'Société civile sous forme de société privée à responsabilité limitée',
          abbreviations: ['SC SPRL'],
        },
        de: {
          label:
            'Zivilrechtliche Gesellschaft in der Rechtsform einer Privatgesellschaft mit beschränkter Haftung',
          abbreviations: ['ZvGPgbH'],
        },
      },
    },
    W3WH: {
      active: true,
      languages: {
        nl: {
          label: 'Vereniging zonder winstoogmerk',
          abbreviations: ['VZW'],
        },
        fr: {
          label: 'Association sans but lucratif',
          abbreviations: ['ASBL'],
        },
        de: {
          label: 'Vereinigung ohne Gewinnerzielungsabsicht',
          abbreviations: ['VoG'],
        },
      },
    },
    WTLP: {
      active: false,
      languages: {
        nl: {
          label:
            'Burgerlijke vennootschap onder vorm van coöperatieve vennootschap met onbeperkte aansprakelijkheid',
          abbreviations: ['BV CVOA'],
        },
        fr: {
          label:
            'Société civile sous forme de société coopérative à responsabilité illimitée',
          abbreviations: ['SC SCRI'],
        },
        de: {
          label:
            'Zivilrechtliche Gesellschaft in der Rechtsform einer Genossenschaft mit unbeschränkter Haftung',
          abbreviations: ['ZvGGugcH'],
        },
      },
    },
    X8ZK: {
      active: true,
      languages: {
        nl: {
          label:
            'Coöperatieve vennootschap met beperkte aansprakelijkheid van publiek recht',
          abbreviations: ['CVBA PR'],
        },
        fr: {
          label: 'Société coopérative à responsabilité limitée de droit public',
          abbreviations: ['SCRL DPU'],
        },
        de: {
          label:
            'Öffentlich-rechtliche Genossenschaft mit beschränkter Haftung',
          abbreviations: ['ÖfrGmbH'],
        },
      },
    },
    XLEO: {
      active: true,
      languages: {
        nl: {
          label: 'Gewone commanditaire vennootschap met een sociaal oogmerk',
          abbreviations: ['GCW SO'],
        },
        fr: {
          label: 'Société en commandite simple à finalité sociale',
          abbreviations: ['SCS FS'],
        },
        de: {
          label: 'Einfache Kommanditgesellschaft mit sozialer Zielsetzung',
          abbreviations: ['EKGmsZ'],
        },
      },
    },
    XQZX: {
      active: false,
      languages: {
        nl: {
          label:
            'Burgerlijke vennootschap onder vorm van naamloze vennootschap',
          abbreviations: ['BV NV'],
        },
        fr: {
          label: 'Société civile sous forme de société anonyme',
          abbreviations: ['SC SA'],
        },
        de: {
          label:
            'Zivilrechtliche Gesellschaft in der Rechtsform einer Aktiengesellschaft',
          abbreviations: ['ZRG AG'],
        },
      },
    },
    Y1Q4: {
      active: true,
      languages: {
        nl: {
          label: 'Private stichting',
          abbreviations: ['PS', 'PRIV ST.'],
        },
        fr: {
          label: 'Fondation privée',
          abbreviations: ['FONDPRIV'],
        },
        de: {
          label: 'Privatstiftung',
          abbreviations: ['PrSt'],
        },
      },
    },
    YBHM: {
      active: true,
      languages: {
        nl: {
          label: 'Europese Coöperatieve Vennootschap',
          abbreviations: ['SCE'],
        },
        fr: {
          label: 'Société coopérative européenne',
          abbreviations: ['SCE'],
        },
        de: {
          label: 'Europäische Genossenschaft',
          abbreviations: ['OFP'],
        },
      },
    },
    ZOK2: {
      active: true,
      languages: {
        nl: {
          label: 'Landbouwvennootschap',
          abbreviations: ['LV'],
        },
        fr: {
          label: 'Société agricole',
          abbreviations: ['S. Agr.'],
        },
        de: {
          label: 'Landwirtschaftliche Gesellschaft',
          abbreviations: ['LG'],
        },
      },
    },
    ZSFX: {
      active: true,
      languages: {
        nl: {
          label: 'Naamloze vennootschap met een sociaal oogmerk',
          abbreviations: ['NV SO'],
        },
        fr: {
          label: 'Société anonyme à finalité sociale',
          abbreviations: ['SA FS'],
        },
        de: {
          label: 'Aktiengesellschaft mit sozialer Zielsetzung',
          abbreviations: ['AGmsZ'],
        },
      },
    },
    ZUHK: {
      active: true,
      languages: {
        nl: {
          label: 'Stichting van openbaar nut',
          abbreviations: ['SON'],
        },
        fr: {
          label: "Fondation d'utilité publique",
          abbreviations: ['FUP'],
        },
        de: {
          label: 'Gemeinnützige Stiftung',
          abbreviations: ['gnS'],
        },
      },
    },
    '6DGX': {
      active: true,
      subdivision: 'BE-VLG',
      languages: {
        fr: {
          label: 'Association prestataire de services (Région flamande)',
          abbreviations: [],
        },
        nl: {
          label: 'Dienstverlenende vereniging (Vlaams Gewest)',
          abbreviations: [],
        },
        de: {
          label: 'Dienstleistungsvereinigung (Flämische Region)',
          abbreviations: [],
        },
      },
    },
    MGCM: {
      active: true,
      subdivision: 'BE-VLG',
      languages: {
        fr: {
          label: 'Association chargée de mission (Région flamande)',
          abbreviations: [],
        },
        nl: {
          label: 'Opdrachthoudende vereniging (Vlaams Gewest)',
          abbreviations: [],
        },
        de: {
          label: 'Beauftragte Vereinigung (Flämische Region)',
          abbreviations: [],
        },
      },
    },
  },
  BZ: {
    '84DD': {
      active: true,
      languages: {
        en: {
          label: 'International Business Company',
          abbreviations: [],
        },
      },
    },
    AO0O: {
      active: true,
      languages: {
        en: {
          label: 'Unlimited Company',
          abbreviations: [],
        },
      },
    },
    D1SL: {
      active: true,
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
    EAD0: {
      active: true,
      languages: {
        en: {
          label: 'Company Limited by Shares',
          abbreviations: [],
        },
      },
    },
    GJKF: {
      active: true,
      languages: {
        en: {
          label: 'Association',
          abbreviations: [],
        },
      },
    },
    ZHT0: {
      active: true,
      languages: {
        en: {
          label: 'Company Limited by Guarantee',
          abbreviations: [],
        },
      },
    },
  },
  BM: {
    '7AS7': {
      active: true,
      languages: {
        en: {
          label: 'Exempted Companies Limited by Shares',
          abbreviations: [],
        },
      },
    },
    '7HCE': {
      active: true,
      languages: {
        en: {
          label: 'Exempted LLC',
          abbreviations: [],
        },
      },
    },
    '7MGJ': {
      active: true,
      languages: {
        en: {
          label: 'Exempted Limited Partnership',
          abbreviations: [],
        },
      },
    },
    '9TCY': {
      active: true,
      languages: {
        en: {
          label: 'Mutual Company (Part XII)',
          abbreviations: [],
        },
      },
    },
    ASR5: {
      active: true,
      languages: {
        en: {
          label: 'Exempted Partnership',
          abbreviations: [],
        },
      },
    },
    CW38: {
      active: true,
      languages: {
        en: {
          label: 'Local Company Limited by Guarantee',
          abbreviations: [],
        },
      },
    },
    EURM: {
      active: true,
      languages: {
        en: {
          label: 'Local Unlimited Company',
          abbreviations: [],
        },
      },
    },
    LC2L: {
      active: true,
      languages: {
        en: {
          label: 'Exempted Company Limited by Guarantee',
          abbreviations: [],
        },
      },
    },
    MBVS: {
      active: true,
      languages: {
        en: {
          label: 'Exempted Unlimited Company',
          abbreviations: [],
        },
      },
    },
    NAQG: {
      active: true,
      languages: {
        en: {
          label: 'Local Company Limited by Shares',
          abbreviations: [],
        },
      },
    },
    UZWE: {
      active: true,
      languages: {
        en: {
          label: 'Local LLC',
          abbreviations: [],
        },
      },
    },
    VFXJ: {
      active: true,
      languages: {
        en: {
          label: 'Mutual Fund Company',
          abbreviations: [],
        },
      },
    },
    WF3Q: {
      active: true,
      languages: {
        en: {
          label: 'Permit (Overseas) Company',
          abbreviations: [],
        },
      },
    },
    ZLTD: {
      active: true,
      languages: {
        en: {
          label: 'Overseas (Permit) Partnership',
          abbreviations: [],
        },
      },
    },
  },
  BO: {
    '38JQ': {
      active: true,
      languages: {
        es: {
          label: 'Empresa Unipersonal',
          abbreviations: [],
        },
      },
    },
    '5T3W': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anónima',
          abbreviations: ['S.A.'],
        },
      },
    },
    '70BS': {
      active: true,
      languages: {
        es: {
          label: 'Empresa Estatal',
          abbreviations: [],
        },
      },
    },
    DSML: {
      active: true,
      languages: {
        es: {
          label: 'Institución Financiera De Desarrollo',
          abbreviations: [],
        },
      },
    },
    JYAN: {
      active: true,
      languages: {
        es: {
          label: 'Empresa Estatal Intergubernamental',
          abbreviations: [],
        },
      },
    },
    LJYQ: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anónima Mixta',
          abbreviations: ['S.A.M.'],
        },
      },
    },
    LN9O: {
      active: true,
      languages: {
        es: {
          label: 'Entidad Financiera De Vivienda',
          abbreviations: [],
        },
      },
    },
    MGOU: {
      active: true,
      languages: {
        es: {
          label: 'Empresa Mixta',
          abbreviations: [],
        },
      },
    },
    PJ29: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita por Acciones.',
          abbreviations: ['S.C.A.'],
        },
      },
    },
    PM48: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Responsabilidad Limitada.',
          abbreviations: ['S.R.L.'],
        },
      },
    },
    RXJN: {
      active: true,
      languages: {
        es: {
          label: 'Empresa Estatal Mixta',
          abbreviations: [],
        },
      },
    },
    TNHO: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Colectiva',
          abbreviations: ['S.C.'],
        },
      },
    },
    XTCQ: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita Simple.',
          abbreviations: ['S.C.S.'],
        },
      },
    },
  },
  BQ: {
    '1A0A': {
      active: true,
      languages: {
        nl: {
          label: 'Besloten vennootschap',
          abbreviations: [],
        },
      },
    },
    '3Y5C': {
      active: true,
      languages: {
        nl: {
          label: 'Besloten vennootschap naar Nederlands recht',
          abbreviations: [],
        },
      },
    },
    '4S4Z': {
      active: true,
      languages: {
        nl: {
          label: 'Commanditaire vennootschap met meerdere beherende vennoten',
          abbreviations: [],
        },
      },
    },
    '4ZBE': {
      active: true,
      languages: {
        nl: {
          label: 'Maatschap',
          abbreviations: [],
        },
      },
    },
    '51WZ': {
      active: true,
      languages: {
        nl: {
          label: 'Vereniging met beperkte rechtsbevoegdheid',
          abbreviations: [],
        },
      },
    },
    '56MU': {
      active: true,
      languages: {
        nl: {
          label: 'Aandeelhouder bestuurde Besloten vennootschap',
          abbreviations: [],
        },
      },
    },
    '92JZ': {
      active: true,
      languages: {
        nl: {
          label: 'Stichting',
          abbreviations: [],
        },
      },
    },
    AS4W: {
      active: true,
      languages: {
        nl: {
          label: 'Stichting particulier fonds',
          abbreviations: [],
        },
      },
    },
    B2UK: {
      active: false,
      languages: {
        nl: {
          label: 'Nevenvestiging met hoofdvestiging buiten bonaire',
          abbreviations: [],
        },
      },
    },
    DQMJ: {
      active: true,
      languages: {
        nl: {
          label: 'Naamloze vennootschap',
          abbreviations: [],
        },
      },
    },
    FCPM: {
      active: true,
      languages: {
        nl: {
          label: 'Vereniging met volledige rechtsbevoegdheid',
          abbreviations: [],
        },
      },
    },
    IPTQ: {
      active: true,
      languages: {
        nl: {
          label: 'Eenmanszaak met meerdere eigenaren',
          abbreviations: [],
        },
      },
    },
    JFQ5: {
      active: false,
      languages: {
        nl: {
          label: 'Buitenlandse rechtsvorm hoofdvestiging op Bonaire',
          abbreviations: [],
        },
      },
    },
    KSHL: {
      active: true,
      languages: {
        nl: {
          label: 'Commanditaire vennootschap op aandelen',
          abbreviations: [],
        },
      },
    },
    NPFB: {
      active: true,
      languages: {
        nl: {
          label: 'Eenmanszaak',
          abbreviations: [],
        },
      },
    },
    SNRI: {
      active: true,
      languages: {
        nl: {
          label: 'Vennootschap onder Firma',
          abbreviations: [],
        },
      },
    },
    VHIY: {
      active: true,
      languages: {
        nl: {
          label: 'Cooperatie',
          abbreviations: [],
        },
      },
    },
    X088: {
      active: true,
      languages: {
        nl: {
          label: 'Vereniging zonder rechtsbevoegdheid',
          abbreviations: [],
        },
      },
    },
    XL51: {
      active: true,
      languages: {
        nl: {
          label: 'Commanditaire vennootschap met één beherend vennoot',
          abbreviations: [],
        },
      },
    },
  },
  BW: {
    '4IXL': {
      active: true,
      languages: {
        en: {
          label: 'Close Companies',
          abbreviations: [],
        },
      },
    },
    '771I': {
      active: true,
      languages: {
        en: {
          label: 'Private Limited Liability Companies',
          abbreviations: [],
        },
      },
    },
    QK1F: {
      active: true,
      languages: {
        en: {
          label: 'Public Limited Liability Companies',
          abbreviations: [],
        },
      },
    },
    Y2L3: {
      active: true,
      languages: {
        en: {
          label: 'Companies limited by Guarantee',
          abbreviations: [],
        },
      },
    },
  },
  BR: {
    '4LKN': {
      active: true,
      languages: {
        pt: {
          label: 'Empresa Pública',
          abbreviations: ['EP'],
        },
      },
    },
    '529B': {
      active: true,
      languages: {
        pt: {
          label: 'Sociedade em Nome Coletivo',
          abbreviations: ['S.N.C.'],
        },
      },
    },
    '8GEA': {
      active: true,
      languages: {
        pt: {
          label: 'Sociedade Simples',
          abbreviations: ['S/S'],
        },
      },
    },
    '9BIS': {
      active: true,
      languages: {
        pt: {
          label: 'Organização Religiosa',
          abbreviations: [],
        },
      },
    },
    ANHM: {
      active: true,
      languages: {
        pt: {
          label: 'Partido Político',
          abbreviations: [],
        },
      },
    },
    I4T1: {
      active: true,
      languages: {
        pt: {
          label: 'Fundação',
          abbreviations: ['Fund.'],
        },
      },
    },
    J7G9: {
      active: true,
      languages: {
        pt: {
          label: 'Associação',
          abbreviations: ['Assoc.'],
        },
      },
    },
    OB5J: {
      active: true,
      languages: {
        pt: {
          label: 'Empresa Individual de Responsabilidade Limitada',
          abbreviations: ['EIRELI'],
        },
      },
    },
    PC5A: {
      active: true,
      languages: {
        pt: {
          label: 'Sociedade Cooperativa',
          abbreviations: [],
        },
      },
    },
    QHW1: {
      active: true,
      languages: {
        pt: {
          label: 'Sociedade Limitada',
          abbreviations: ['LTDA.'],
        },
      },
    },
    WBEC: {
      active: true,
      languages: {
        pt: {
          label: 'Sociedade em Comdandita Simples',
          abbreviations: ['S.C.S.'],
        },
      },
    },
    X0SD: {
      active: true,
      languages: {
        pt: {
          label: 'Sociedade Anônima, Companhia',
          abbreviations: ['S/A', 'S.A.'],
        },
      },
    },
    X2ZT: {
      active: true,
      languages: {
        pt: {
          label: 'Sociedade em Comandita por Ações',
          abbreviations: ['C/A'],
        },
      },
    },
    XQRI: {
      active: true,
      languages: {
        pt: {
          label: 'Sociedade em Conta de Participação',
          abbreviations: ['S.C.P.'],
        },
      },
    },
  },
  BN: {
    '2DGO': {
      active: true,
      languages: {
        en: {
          label: 'Public Company',
          abbreviations: ['Bhd', 'Sdn Bhd'],
        },
      },
    },
    EULU: {
      active: true,
      languages: {
        en: {
          label: 'Private Limited Company',
          abbreviations: ['Bhd', 'Sdn Bhd'],
        },
      },
    },
  },
  BG: {
    '3FUP': {
      active: true,
      languages: {
        bg: {
          label: 'Европейско кооперативно дружество с ограничена отговорност',
          abbreviations: [],
        },
      },
    },
    '3HLJ': {
      active: false,
      languages: {
        bg: {
          label: 'Поделение на eвропейско обединение по икономически интереси',
          abbreviations: [],
        },
      },
    },
    '3SHX': {
      active: true,
      languages: {
        bg: {
          label: 'Сдружение в обществена полза',
          abbreviations: [],
        },
      },
    },
    '45D7': {
      active: false,
      languages: {
        bg: {
          label: 'Клон на чуждестранен търговец',
          abbreviations: [],
        },
      },
    },
    '946C': {
      active: true,
      languages: {
        bg: {
          label: 'Едноличен търговец',
          abbreviations: ['ЕТ'],
        },
      },
    },
    '9F78': {
      active: false,
      languages: {
        bg: {
          label: 'Чуждестранно дружество - физическо лице',
          abbreviations: [],
        },
      },
    },
    CTCH: {
      active: true,
      languages: {
        bg: {
          label: 'Кооперация',
          abbreviations: [],
        },
      },
    },
    EJ06: {
      active: true,
      languages: {
        bg: {
          label: 'Еднолично акционерно дружество',
          abbreviations: ['ЕАД'],
        },
      },
    },
    FPP2: {
      active: true,
      languages: {
        bg: {
          label: 'Събирателно дружество (СД)/Съдружие',
          abbreviations: ['С-ИЕ'],
        },
      },
    },
    HN63: {
      active: true,
      languages: {
        bg: {
          label: 'Командитно дружество с акции',
          abbreviations: ['КДА'],
        },
      },
    },
    LECS: {
      active: true,
      languages: {
        bg: {
          label: 'Сдружение в частна полза',
          abbreviations: [],
        },
      },
    },
    O15N: {
      active: false,
      languages: {
        bg: {
          label: 'Чуждестранно дружество - юридическо лице',
          abbreviations: [],
        },
      },
    },
    PW3Y: {
      active: true,
      languages: {
        bg: {
          label: 'Акционерно дружество със специална инвестиционна цел',
          abbreviations: ['АДСИЦ'],
        },
      },
    },
    QZAU: {
      active: true,
      languages: {
        bg: {
          label:
            'Еднолично aкционерно дружество със специалнa инвестиционна цел',
          abbreviations: [],
        },
      },
    },
    RYDY: {
      active: true,
      languages: {
        bg: {
          label: 'Европейско обединение по икономически интереси',
          abbreviations: ['ЕОИИ'],
        },
      },
    },
    S94S: {
      active: true,
      languages: {
        bg: {
          label: 'Командитно дружество',
          abbreviations: ['КД'],
        },
      },
    },
    SZW0: {
      active: true,
      languages: {
        bg: {
          label: 'Eвропейско дружество',
          abbreviations: ['ЕД'],
        },
      },
    },
    TCGV: {
      active: true,
      languages: {
        bg: {
          label: 'Дружество учредено по Закона за задълженията и договорите',
          abbreviations: ['ДЗЗД'],
        },
      },
    },
    U8LM: {
      active: true,
      languages: {
        bg: {
          label: 'Eвропейско кооперативно дружество',
          abbreviations: ['ЕКД'],
        },
      },
    },
    UFG8: {
      active: true,
      languages: {
        bg: {
          label: 'Фондация',
          abbreviations: [],
        },
      },
    },
    VJ3G: {
      active: true,
      languages: {
        bg: {
          label: 'Дружество с ограничена отговорност',
          abbreviations: ['ООД'],
        },
      },
    },
    WTK4: {
      active: true,
      languages: {
        bg: {
          label: 'Акционерно дружество',
          abbreviations: ['АД'],
        },
      },
    },
    WVIN: {
      active: true,
      languages: {
        bg: {
          label: 'Еднолично дружество с ограничена отговорност',
          abbreviations: ['ЕООД'],
        },
      },
    },
  },
  KH: {
    '15BP': {
      active: true,
      languages: {
        en: {
          label: 'Private Limited Company',
          abbreviations: [],
        },
        km: {
          label: 'ក្រុមហ៊ុនឯកជនទទួលខុសត្រូវមានកម្រិត',
          abbreviations: [],
        },
      },
    },
    BQ0P: {
      active: true,
      languages: {
        en: {
          label: 'Public Limited Company',
          abbreviations: [],
        },
        km: {
          label: 'ក្រុមហ៊ុនមហាជនទទួលខុសត្រូវមានកម្រិត',
          abbreviations: [],
        },
      },
    },
    D3UY: {
      active: true,
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
        km: {
          label: 'ក្រុមហ៊ុនសហកម្មសិទ្ធិមានកម្រិត',
          abbreviations: [],
        },
      },
    },
    KD84: {
      active: true,
      languages: {
        en: {
          label: 'Sole Proprietorship',
          abbreviations: [],
        },
        km: {
          label: 'សហគ្រាស​ឯកបុគ្គល',
          abbreviations: [],
        },
      },
    },
    Z4YC: {
      active: true,
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
        km: {
          label: 'ក្រុមហ៊ុនសហកម្មសិទ្ធិទូទៅ',
          abbreviations: [],
        },
      },
    },
    ZCFU: {
      active: true,
      languages: {
        en: {
          label: 'Foreign Company',
          abbreviations: [],
        },
        km: {
          label: 'ក្រុមហ៊ុនបរទេស',
          abbreviations: [],
        },
      },
    },
  },
  CA: {
    '1EQC': {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Trade name/sole proprietorship',
          abbreviations: [],
        },
      },
    },
    '60MF': {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Alberta trust corporation',
          abbreviations: [],
        },
      },
    },
    '8ZH8': {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Alberta Business Corporation',
          abbreviations: [],
        },
      },
    },
    '94UQ': {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Public recreation company',
          abbreviations: [],
        },
      },
    },
    B69V: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Alberta private non-profit company',
          abbreviations: [],
        },
      },
    },
    BASA: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Alberta cooperative',
          abbreviations: [],
        },
      },
    },
    BH5D: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Rural utility cooperative',
          abbreviations: [],
        },
      },
    },
    C9KZ: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Alberta professional corporation',
          abbreviations: [],
        },
      },
    },
    DK7L: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Alberta loan corporation',
          abbreviations: [],
        },
      },
    },
    G65S: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Alberta credit union',
          abbreviations: [],
        },
      },
    },
    J3C5: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Alberta unlimited liability corporation',
          abbreviations: [],
        },
      },
    },
    K1QX: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Alberta society',
          abbreviations: [],
        },
      },
    },
    KVC1: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'General partnership',
          abbreviations: [],
        },
      },
    },
    PXPK: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Private recreation company',
          abbreviations: [],
        },
      },
    },
    R0KX: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Private act corporation',
          abbreviations: [],
        },
      },
    },
    RHVP: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Private act non-profit corp',
          abbreviations: [],
        },
      },
    },
    RN4K: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Alberta limited partnership',
          abbreviations: [],
        },
      },
    },
    TRO6: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Agricultural society',
          abbreviations: [],
        },
      },
    },
    TS9O: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Religious society',
          abbreviations: [],
        },
      },
    },
    U938: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Alberta limited liability partnership',
          abbreviations: [],
        },
      },
    },
    VHXN: {
      active: true,
      subdivision: 'CA-AB',
      languages: {
        en: {
          label: 'Public non-profit company',
          abbreviations: [],
        },
      },
    },
    '1CML': {
      active: true,
      subdivision: 'CA-BC',
      languages: {
        en: {
          label: 'Sole proprietorship',
          abbreviations: ['LLP', 'SENCRL', 'SRL'],
        },
      },
    },
    '23V9': {
      active: true,
      subdivision: 'CA-BC',
      languages: {
        en: {
          label: 'Limited partnership',
          abbreviations: ['LLP', 'SENCRL', 'SRL'],
        },
      },
    },
    AW80: {
      active: true,
      subdivision: 'CA-BC',
      languages: {
        en: {
          label:
            'Association (includes housing cooperative and community service cooperative)',
          abbreviations: ['coop'],
        },
      },
    },
    F9J3: {
      active: true,
      subdivision: 'CA-BC',
      languages: {
        en: {
          label: 'Limited partnership formed outside of BC',
          abbreviations: ['LLP', 'SENCRL', 'SRL'],
        },
      },
    },
    HLBQ: {
      active: true,
      subdivision: 'CA-BC',
      languages: {
        en: {
          label: 'Pension fund society',
          abbreviations: [],
        },
      },
    },
    LNBY: {
      active: true,
      subdivision: 'CA-BC',
      languages: {
        en: {
          label: 'Limited liability partnership',
          abbreviations: ['LLP', 'SENCRL', 'SRL'],
        },
      },
    },
    LRRN: {
      active: true,
      subdivision: 'CA-BC',
      languages: {
        en: {
          label: 'Mutual fire insurance company',
          abbreviations: [],
        },
      },
    },
    O13B: {
      active: true,
      subdivision: 'CA-BC',
      languages: {
        en: {
          label: 'General partnership',
          abbreviations: ['LLP', 'SENCRL', 'SRL'],
        },
      },
    },
    OTU7: {
      active: true,
      subdivision: 'CA-BC',
      languages: {
        en: {
          label: 'Extraprovincial non-share corporation',
          abbreviations: [],
        },
      },
    },
    QODJ: {
      active: true,
      subdivision: 'CA-BC',
      languages: {
        en: {
          label: 'Extraprovincial limited liability partnership',
          abbreviations: ['LLP', 'SENCRL', 'SRL'],
        },
      },
    },
    S3K4: {
      active: true,
      subdivision: 'CA-BC',
      languages: {
        en: {
          label: 'Registered extraprovincial non-share corporation',
          abbreviations: [],
        },
      },
    },
    TGLV: {
      active: true,
      subdivision: 'CA-BC',
      languages: {
        en: {
          label: 'Extraprovincial corporation (registered foreign entity)',
          abbreviations: ['Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    WFPH: {
      active: true,
      subdivision: 'CA-BC',
      languages: {
        en: {
          label: 'Society (includes member-funded society)',
          abbreviations: [],
        },
      },
    },
    XOYI: {
      active: true,
      subdivision: 'CA-BC',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    YG5M: {
      active: true,
      subdivision: 'CA-BC',
      languages: {
        en: {
          label:
            'Company (includes community contribution company and unlimited liability company)',
          abbreviations: ['Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    '59T2': {
      active: true,
      languages: {
        en: {
          label: 'Board of trade',
          abbreviations: [],
        },
        fr: {
          label: 'Chambre de commerce',
          abbreviations: [],
        },
      },
    },
    '6TRA': {
      active: true,
      languages: {
        en: {
          label: 'Corporations enacted by an Act of Parliament',
          abbreviations: [],
        },
        fr: {
          label: 'Corporation constituée par une loi du Parlement',
          abbreviations: [],
        },
      },
    },
    D90J: {
      active: true,
      languages: {
        en: {
          label: 'Corporation without share capital',
          abbreviations: [],
        },
        fr: {
          label: 'Organisation sans capital-actions',
          abbreviations: [],
        },
      },
    },
    M4IF: {
      active: true,
      languages: {
        en: {
          label: 'Pension fund society',
          abbreviations: [],
        },
        fr: {
          label: 'Société de caisse de retraite',
          abbreviations: [],
        },
      },
    },
    MGE0: {
      active: true,
      languages: {
        en: {
          label: 'Cooperative',
          abbreviations: ['coop'],
        },
        fr: {
          label: 'Coopérative',
          abbreviations: ['coop'],
        },
      },
    },
    UDLA: {
      active: true,
      languages: {
        en: {
          label: 'Business corporation',
          abbreviations: ['Corp.', 'Inc.', 'Ltd.'],
        },
        fr: {
          label: 'Société par actions',
          abbreviations: ['Ltée', 'Inc.', 'S.A.R.F.'],
        },
      },
    },
    '5ONY': {
      active: true,
      subdivision: 'CA-MB',
      languages: {
        en: {
          label: 'Religious Society',
          abbreviations: [],
        },
      },
    },
    '9D1K': {
      active: true,
      subdivision: 'CA-MB',
      languages: {
        en: {
          label: 'Non-share corporations',
          abbreviations: [
            'Corporation',
            'Incorporated',
            'Incorporee',
            'Corp.',
            'Inc.',
          ],
        },
      },
    },
    FN6X: {
      active: true,
      subdivision: 'CA-MB',
      languages: {
        en: {
          label: 'Share corporations (including professional corporations)',
          abbreviations: [
            'Corporation',
            'Incorporated',
            'Incorporee',
            'Limited',
            'Limitee',
            'Ltd',
            'Corp.',
            'Inc.',
            'Ltee.',
          ],
        },
      },
    },
    G9PJ: {
      active: true,
      subdivision: 'CA-MB',
      languages: {
        en: {
          label:
            'Limited Liability Partnership (Manitoba and Extra-provincial, lawyers and accountants only)',
          abbreviations: [
            'Limited Liability Partnership',
            'LLP',
            'Société à Responabilité Limitée',
            's.r.l.',
          ],
        },
      },
    },
    GM04: {
      active: true,
      subdivision: 'CA-MB',
      languages: {
        en: {
          label: 'Cooperative',
          abbreviations: ['Pool Inc.', 'Pool Ltd.'],
        },
      },
    },
    HBCT: {
      active: true,
      subdivision: 'CA-MB',
      languages: {
        en: {
          label: 'Ukrainian Catholic Parish',
          abbreviations: [],
        },
      },
    },
    LV28: {
      active: true,
      subdivision: 'CA-MB',
      languages: {
        en: {
          label: 'Condominium Corporation',
          abbreviations: [],
        },
      },
    },
    MXLT: {
      active: true,
      subdivision: 'CA-MB',
      languages: {
        en: {
          label: 'Sole Proprietorship',
          abbreviations: [],
        },
      },
    },
    OPRT: {
      active: true,
      subdivision: 'CA-MB',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    RBBY: {
      active: true,
      subdivision: 'CA-MB',
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
    SS1V: {
      active: true,
      subdivision: 'CA-MB',
      languages: {
        en: {
          label: 'Registration of extra-provincial corporations',
          abbreviations: [],
        },
      },
    },
    Y485: {
      active: true,
      subdivision: 'CA-MB',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '3Q15': {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
        fr: {
          label: 'Société en nom collectif',
          abbreviations: [],
        },
      },
    },
    '40JO': {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Société en commandite',
          abbreviations: [],
        },
      },
    },
    '44LR': {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Corporation professionnelle',
          abbreviations: ['c.p.'],
        },
        en: {
          label: 'Professional corporation',
          abbreviations: ['P.C.'],
        },
      },
    },
    '4M62': {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Compagnie de prêt',
          abbreviations: ['Société de prêt'],
        },
        en: {
          label: 'Loan company',
          abbreviations: ['Loan Corp.'],
        },
      },
    },
    '56KZ': {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'Agricultural fair association',
          abbreviations: [],
        },
      },
    },
    '64XG': {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Association coopérative',
          abbreviations: ['limitée', 'ltée'],
        },
      },
    },
    '6U2Q': {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'Condominium corporation',
          abbreviations: [],
        },
        fr: {
          label: 'Association condominiale',
          abbreviations: [],
        },
      },
    },
    '7P8Y': {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'Limited partnership',
          abbreviations: ['LP'],
        },
        fr: {
          label: 'Société en commandite',
          abbreviations: ['LP'],
        },
      },
    },
    '8MEC': {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Société à responsabilité limitée du Nouveau-Brunswick',
          abbreviations: [],
        },
        en: {
          label: 'New Brunswick limited liability partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    AXW3: {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Selon la loi de la Législature',
          abbreviations: [],
        },
        en: {
          label: 'Depends on Act of the Legislature',
          abbreviations: [],
        },
      },
    },
    B3RX: {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'Corporation',
          abbreviations: ['Corp.', 'Inc.', 'Ltd.'],
        },
        fr: {
          label: 'Corporation',
          abbreviations: ['Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    D8UQ: {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'Professional corporation',
          abbreviations: ['P.C.'],
        },
      },
    },
    DHGI: {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'Project company',
          abbreviations: [],
        },
        fr: {
          label: 'Gérant de projet',
          abbreviations: [],
        },
      },
    },
    EKRT: {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'Loan company',
          abbreviations: ['Loan Corp.'],
        },
      },
    },
    EPFN: {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'New Brunswick limited liability partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    FGSL: {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Association condominiale',
          abbreviations: [],
        },
      },
    },
    GF6X: {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'Business name - sole proprietor',
          abbreviations: [],
        },
        fr: {
          label: 'Appellation commerciale - propriétaire unique',
          abbreviations: [],
        },
      },
    },
    GLX2: {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'Agricultural society',
          abbreviations: [],
        },
      },
    },
    GPG0: {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Compagnie',
          abbreviations: [],
        },
      },
    },
    IDBS: {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Compagnie de fiducie',
          abbreviations: ['Société fiduciaire'],
        },
      },
    },
    IKMB: {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'Co-operative association',
          abbreviations: ['Limited', 'Ltd'],
        },
        fr: {
          label: 'Association coopérative',
          abbreviations: ['limitée', 'ltée'],
        },
      },
    },
    IKSU: {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Société en nom collectif',
          abbreviations: [],
        },
      },
    },
    ILON: {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Caisse populaire',
          abbreviations: [],
        },
      },
    },
    JBBW: {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'Company',
          abbreviations: [],
        },
        fr: {
          label: 'Compagnie',
          abbreviations: [],
        },
      },
    },
    M53U: {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'Depends on Act of the Legislature',
          abbreviations: [],
        },
      },
    },
    MY4W: {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
        fr: {
          label: 'Caisse populaire',
          abbreviations: [],
        },
      },
    },
    NONB: {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Corporation',
          abbreviations: ['Ltée', 'Corp.', 'Inc.'],
        },
      },
    },
    QJ3A: {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Gérant de projet',
          abbreviations: [],
        },
      },
    },
    QNSC: {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Personne morale étrangère résidante',
          abbreviations: ['C.E.R.'],
        },
        en: {
          label: 'Foreign resident corporation',
          abbreviations: [],
        },
      },
    },
    TSQ7: {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Association de foires agricoles',
          abbreviations: [],
        },
        en: {
          label: 'Agricultural fair association',
          abbreviations: [],
        },
      },
    },
    WI0P: {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Société agricole',
          abbreviations: [],
        },
        en: {
          label: 'Agricultural society',
          abbreviations: [],
        },
      },
    },
    ZACY: {
      active: true,
      subdivision: 'CA-NB',
      languages: {
        en: {
          label: 'Trust company',
          abbreviations: ['Trustco', 'Trust Corp.'],
        },
        fr: {
          label: 'Compagnie de fiducie',
          abbreviations: ['Société fiduciaire'],
        },
      },
    },
    ZY4E: {
      active: false,
      subdivision: 'CA-NB',
      languages: {
        fr: {
          label: 'Appellation commerciale - propriétaire unique',
          abbreviations: [],
        },
      },
    },
    '1E9M': {
      active: true,
      subdivision: 'CA-NL',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    '3Y5V': {
      active: true,
      subdivision: 'CA-NL',
      languages: {
        en: {
          label: 'Co-operatives',
          abbreviations: ['Coopérative'],
        },
      },
    },
    ASWX: {
      active: true,
      subdivision: 'CA-NL',
      languages: {
        en: {
          label: 'Share corporations',
          abbreviations: [
            'Corporation',
            'Incorporated',
            'Incorporee',
            'Limited',
            'Limitee',
            'Ltd',
            'Corp.',
            'Inc.',
            'Ltee.',
          ],
        },
      },
    },
    EBYQ: {
      active: true,
      subdivision: 'CA-NL',
      languages: {
        en: {
          label: 'Credit Union',
          abbreviations: [],
        },
      },
    },
    ER0H: {
      active: true,
      subdivision: 'CA-NL',
      languages: {
        en: {
          label: 'Registration of extra-provincial corporations',
          abbreviations: [
            'Corporation',
            'Incorporated',
            'Incorporee',
            'Limited',
            'Limitee',
            'Ltd',
            'Corp.',
            'Inc.',
            'Ltee.',
          ],
        },
      },
    },
    GTBR: {
      active: true,
      subdivision: 'CA-NL',
      languages: {
        en: {
          label: 'Condominium Corporation',
          abbreviations: [],
        },
      },
    },
    IKGM: {
      active: true,
      subdivision: 'CA-NL',
      languages: {
        en: {
          label: 'Non-share corporations',
          abbreviations: [
            'Corporation',
            'Incorporated',
            'Incorporee',
            'Corp.',
            'Inc.',
          ],
        },
      },
    },
    SYPT: {
      active: true,
      subdivision: 'CA-NL',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    '1ADH': {
      active: true,
      subdivision: 'CA-NT',
      languages: {
        en: {
          label: 'Extra-Territorial Corporation(for profit and not-for-profit)',
          abbreviations: ['Limited', 'Ltd', 'Corp.', 'Inc.', 'Ltée.'],
        },
      },
    },
    '85EC': {
      active: true,
      subdivision: 'CA-NT',
      languages: {
        en: {
          label: 'Limited Liability partnership',
          abbreviations: [],
        },
      },
    },
    CS15: {
      active: true,
      subdivision: 'CA-NT',
      languages: {
        en: {
          label: 'NT society',
          abbreviations: [],
        },
      },
    },
    KAM9: {
      active: true,
      subdivision: 'CA-NT',
      languages: {
        en: {
          label: 'Co-operative',
          abbreviations: ['Limited', 'Ltd', 'Corp.', 'Inc.', 'Ltée.'],
        },
      },
    },
    PIDT: {
      active: true,
      subdivision: 'CA-NT',
      languages: {
        en: {
          label: 'NT corporation',
          abbreviations: ['Limited', 'Ltd', 'Corp.', 'Inc.', 'Ltée.'],
        },
      },
    },
    QN8Y: {
      active: true,
      subdivision: 'CA-NT',
      languages: {
        en: {
          label:
            'NT Professional Corporation authorized under the Professional Corporations Act',
          abbreviations: ['Limited', 'Ltd', 'Corp.', 'Inc.', 'Ltée.'],
        },
      },
    },
    QR4F: {
      active: true,
      subdivision: 'CA-NT',
      languages: {
        en: {
          label: 'Business name/sole proprietorship',
          abbreviations: [],
        },
      },
    },
    TA98: {
      active: true,
      subdivision: 'CA-NT',
      languages: {
        en: {
          label: 'Limited partnership',
          abbreviations: [],
        },
      },
    },
    TPZ2: {
      active: true,
      subdivision: 'CA-NT',
      languages: {
        en: {
          label: 'Private act corporation',
          abbreviations: [],
        },
      },
    },
    VAPN: {
      active: true,
      subdivision: 'CA-NT',
      languages: {
        en: {
          label: 'General partnership',
          abbreviations: [],
        },
      },
    },
    W126: {
      active: true,
      subdivision: 'CA-NT',
      languages: {
        en: {
          label: 'Private act not-for-profit corporation',
          abbreviations: [],
        },
      },
    },
    '2FHC': {
      active: true,
      subdivision: 'CA-NS',
      languages: {
        en: {
          label: 'Partnerships',
          abbreviations: [],
        },
      },
    },
    '3M14': {
      active: true,
      subdivision: 'CA-NS',
      languages: {
        en: {
          label:
            'A company formed under the Companies Act may seek designation as a Community Interest Company (a hybrid structure having characteristics of both for profit and non-profit entities)',
          abbreviations: [
            'CIC',
            'Community Interest Company',
            'SIC',
            'société d’intérêt communautaire',
          ],
        },
      },
    },
    '42GN': {
      active: true,
      subdivision: 'CA-NS',
      languages: {
        en: {
          label: 'Unlimited company',
          abbreviations: ['Company', 'Corporation', 'ULC', 'Co.', 'Corp.'],
        },
      },
    },
    '876U': {
      active: true,
      subdivision: 'CA-NS',
      languages: {
        en: {
          label: 'Credit Unions',
          abbreviations: ['Limited', 'Limitée', 'Ltée', 'Ltd.'],
        },
      },
    },
    '8M03': {
      active: true,
      subdivision: 'CA-NS',
      languages: {
        en: {
          label: 'Condominiums',
          abbreviations: [],
        },
      },
    },
    '8OZ0': {
      active: true,
      subdivision: 'CA-NS',
      languages: {
        en: {
          label: 'Limited liability partnerships',
          abbreviations: ['LLP'],
        },
      },
    },
    '9XHE': {
      active: true,
      subdivision: 'CA-NS',
      languages: {
        en: {
          label: 'Business names',
          abbreviations: [],
        },
      },
    },
    FQJ9: {
      active: true,
      subdivision: 'CA-NS',
      languages: {
        en: {
          label: 'For profit and not-for profit co-operatives',
          abbreviations: [
            'Ltée',
            'Co-operative and Limited',
            'Co-opérative and Limitée',
            'Ltd.',
          ],
        },
      },
    },
    GG0S: {
      active: true,
      subdivision: 'CA-NS',
      languages: {
        en: {
          label: 'Company limited by guarantee',
          abbreviations: [
            'Incorporated',
            'Limited',
            'Limitée',
            'Ltd',
            'Ltée',
            'Inc.',
          ],
        },
      },
    },
    T0CV: {
      active: true,
      subdivision: 'CA-NS',
      languages: {
        en: {
          label: 'Limited partnerships formed in NS',
          abbreviations: ['Limited Partnership'],
        },
      },
    },
    TY0S: {
      active: true,
      subdivision: 'CA-NS',
      languages: {
        en: {
          label:
            'A company formed under the Companies Act may seek designation as a Private Investment Holding Company',
          abbreviations: [
            'Incorporated',
            'Limited',
            'Limitée',
            'Ltd',
            'Ltée',
            'Inc.',
          ],
        },
      },
    },
    ULJ1: {
      active: true,
      subdivision: 'CA-NS',
      languages: {
        en: {
          label: 'Company limited by shares (limited company)',
          abbreviations: [
            'Incorporated',
            'Limited',
            'limited by guarantee',
            'limited company',
            'Limitée',
            'Ltd',
            'Ltée',
            'Inc.',
          ],
        },
      },
    },
    W8XG: {
      active: true,
      subdivision: 'CA-NS',
      languages: {
        en: {
          label: 'Sole proprietors',
          abbreviations: [],
        },
      },
    },
    Y80K: {
      active: true,
      subdivision: 'CA-NS',
      languages: {
        en: {
          label: 'Non-profit Corporations',
          abbreviations: ['Association', 'Society'],
        },
      },
    },
    '1JGX': {
      active: true,
      subdivision: 'CA-ON',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    '456Q': {
      active: true,
      subdivision: 'CA-ON',
      languages: {
        en: {
          label: 'Business name/sole proprietorship',
          abbreviations: [],
        },
      },
    },
    '7VKC': {
      active: true,
      subdivision: 'CA-ON',
      languages: {
        en: {
          label: 'Condominium Corporation',
          abbreviations: [],
        },
      },
    },
    BOYK: {
      active: true,
      subdivision: 'CA-ON',
      languages: {
        en: {
          label:
            'Corporations formed by an Act of the Ontario Legislative Assembly',
          abbreviations: [],
        },
      },
    },
    CMB6: {
      active: true,
      subdivision: 'CA-ON',
      languages: {
        en: {
          label: 'Not-For-Profit corporations',
          abbreviations: [],
        },
      },
    },
    EIDL: {
      active: true,
      subdivision: 'CA-ON',
      languages: {
        en: {
          label:
            'Insurance Corporations incorporated under Part V of the Corporations Act',
          abbreviations: [],
        },
      },
    },
    ESVK: {
      active: true,
      subdivision: 'CA-ON',
      languages: {
        en: {
          label: 'Credit Union',
          abbreviations: [],
        },
      },
    },
    FBQL: {
      active: true,
      subdivision: 'CA-ON',
      languages: {
        en: {
          label: 'Co-operative Corporation',
          abbreviations: [],
        },
      },
    },
    HQKE: {
      active: true,
      subdivision: 'CA-ON',
      languages: {
        en: {
          label: 'General partnership',
          abbreviations: [],
        },
      },
    },
    O90R: {
      active: true,
      subdivision: 'CA-ON',
      languages: {
        en: {
          label:
            'Business corporations (which includes professional corporations)',
          abbreviations: [],
        },
      },
    },
    PCO0: {
      active: true,
      subdivision: 'CA-ON',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    '487P': {
      active: true,
      subdivision: 'CA-PE',
      languages: {
        en: {
          label: 'Corporation created by an Act of the Legislature',
          abbreviations: [],
        },
      },
    },
    '5SGE': {
      active: true,
      subdivision: 'CA-PE',
      languages: {
        en: {
          label: 'Condominium corporation',
          abbreviations: [],
        },
      },
    },
    '790T': {
      active: true,
      subdivision: 'CA-PE',
      languages: {
        en: {
          label: 'Non-profit company',
          abbreviations: ['Ltée', 'Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    CUQF: {
      active: true,
      subdivision: 'CA-PE',
      languages: {
        en: {
          label: 'Public unlimited liability corporation',
          abbreviations: ['ULC'],
        },
      },
    },
    E281: {
      active: true,
      subdivision: 'CA-PE',
      languages: {
        en: {
          label: 'Limited partnership',
          abbreviations: [],
        },
      },
    },
    HK03: {
      active: true,
      subdivision: 'CA-PE',
      languages: {
        en: {
          label: 'Public limited corporation',
          abbreviations: ['Ltée', 'Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    I5NO: {
      active: true,
      subdivision: 'CA-PE',
      languages: {
        en: {
          label: 'Sole proprietorship',
          abbreviations: [],
        },
      },
    },
    JOGO: {
      active: true,
      subdivision: 'CA-PE',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: ['Ltée', 'Ltd.'],
        },
      },
    },
    LT1Y: {
      active: true,
      subdivision: 'CA-PE',
      languages: {
        en: {
          label: 'Professional corporation',
          abbreviations: ['Ltée', 'Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    N745: {
      active: true,
      subdivision: 'CA-PE',
      languages: {
        en: {
          label: 'Public company',
          abbreviations: ['Ltée', 'Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    PFPW: {
      active: true,
      subdivision: 'CA-PE',
      languages: {
        en: {
          label: 'Private limited corporation',
          abbreviations: ['Ltée', 'Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    QZMH: {
      active: true,
      subdivision: 'CA-PE',
      languages: {
        en: {
          label: 'Private unlimited liability corporation',
          abbreviations: ['ULC'],
        },
      },
    },
    W4DB: {
      active: true,
      subdivision: 'CA-PE',
      languages: {
        en: {
          label: 'Private company',
          abbreviations: ['Ltée', 'Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    X6N9: {
      active: true,
      subdivision: 'CA-PE',
      languages: {
        en: {
          label: 'Co-operative association',
          abbreviations: ['Coopérative Ltée', 'Co-operative Ltd'],
        },
      },
    },
    Y33B: {
      active: true,
      subdivision: 'CA-PE',
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
    '10UR': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Syndicat coopératif',
          abbreviations: [],
        },
      },
    },
    '16GH': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les cercles agricoles',
          abbreviations: [],
        },
      },
    },
    '16RL': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur la mise en marché des produits agricoles',
          abbreviations: [],
        },
      },
    },
    '1VTA': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les évêques catholiques romains',
          abbreviations: [],
        },
      },
    },
    '27WJ': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les cités et villes',
          abbreviations: [],
        },
      },
    },
    '2ODA': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les sociétés agricoles et laitières',
          abbreviations: [],
        },
      },
    },
    '2U3G': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Société en nom collectif à responsabilité limitée',
          abbreviations: ['S.E.N.C.R.L.'],
        },
      },
    },
    '30IT': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Société par actions constitué par Loi sur les compagnies minières',
          abbreviations: [],
        },
      },
    },
    '3C5P': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur la probation et sur les établissements de détention',
          abbreviations: [],
        },
      },
    },
    '3FP6': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les corporations de fonds de sécurité',
          abbreviations: [],
        },
      },
    },
    '4B4B': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Société par actions constitué par Loi sur les sociétés de patrons de fabriques de producteurs laitiers',
          abbreviations: [],
        },
      },
    },
    '50Z9': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Société par actions constitué par Loi sur les assurances',
          abbreviations: [],
        },
      },
    },
    '52CK': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les villes minières',
          abbreviations: [],
        },
      },
    },
    '6ZCO': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur la formation et la qualification professionnelles de la main-d’œuvre',
          abbreviations: [],
        },
      },
    },
    '702U': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les Chevaliers de Colomb de la province de Québec',
          abbreviations: [],
        },
      },
    },
    '814Y': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Société en participation',
          abbreviations: [],
        },
      },
    },
    '87OW': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            "Personne morale sans but lucratif par Loi sur les collèges d'enseignement général et professionnel",
          abbreviations: [],
        },
      },
    },
    '95EN': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les services de santé et les services sociaux pour les autochtones cris',
          abbreviations: [],
        },
      },
    },
    '9CB2': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            "Société par actions constitué par Loi sur les syndicats d'élevage",
          abbreviations: [],
        },
      },
    },
    '9CEN': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            "Société par actions constitué par Loi sur les sociétés d'exploration minière",
          abbreviations: [],
        },
      },
    },
    '9IF2': {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les associations coopératives',
          abbreviations: [],
        },
      },
    },
    A7KA: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Selon la loi par Loi spéciale du Québec à caractère public',
          abbreviations: [],
        },
      },
    },
    AS7L: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Société par actions constitué par Loi sur les compagnies de gaz, d’eau et d’électricité',
          abbreviations: [],
        },
      },
    },
    CG81: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur la Société d’habitation du Québec',
          abbreviations: [],
        },
      },
    },
    CT3J: {
      active: false,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            "Personne morale sans but lucratif par Loi sur les compagnies (Partie II et Partie III), Code des professions, Loi concernant le regroupement et la gestion des commissions scolaires , Loi sur l’aménagement et l’urbanisme, Loi sur l’instruction publique, Loi sur l’organisation municipale de certains territoires, Loi sur la conservation de la faune, Loi sur la conservation et la mise en valeur de la faune, Loi sur la constitution de certaines Églises, Loi sur la Fédération des guides catholiques du Québec , Loi sur la Fédération des scouts catholiques du Québec , Loi sur la formation et la qualification professionnelles de la main-d’œuvre, Loi sur la mise en marché des produits agricoles, alimentaires et de la pêche, Loi sur la mise en marché des produits agricoles, Loi sur la probation et sur les établissements de détention, Loi sur la santé et la sécurité du travail, Loi sur la Société d’habitation du Québec, Loi sur la société Saint-Jean-Baptiste de Trois-Rivières, Loi sur la société Saint-Jean-Baptiste du Québec, Loi sur les associations coopératives, Loi sur les assurances, Loi sur les cercles agricoles, Loi sur les Chevaliers de Colomb de la province de Québec, Loi sur les cités et villes, Loi sur les clubs de chasse et de pêche, Loi sur les clubs de récréation, Loi sur les collèges d'enseignement général et professionnel, Loi sur les compagnies de cimetière, Loi sur les compagnies de cimetières catholiques romains, Loi sur les corporations de fonds de sécurité, Loi sur les corporations religieuses, Loi sur les décrets de convention collective, Loi sur les évêques catholiques romains, Loi sur les fabriques, Loi sur les services correctionnels, Loi sur les services de santé et les services sociaux pour les autochtones cris, Loi sur les services de santé et les services sociaux, Loi sur les sociétés agricoles et laitières, Loi sur les sociétés d'agriculture, Loi sur les sociétés d'horticulture, Loi sur les sociétés nationales de bienfaisance, Loi sur les syndicats professionnels, Loi sur les villages miniers, Loi sur les villages nordiques et l’Administration régionale Kativik, Loi sur les villes minières, Loi sur l'organisation territoriale municipale, Loi sur les sociétés préventives de cruauté envers les animaux",
          abbreviations: [],
        },
      },
    },
    D2T8: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les compagnies (Partie II et Partie III)',
          abbreviations: [],
        },
      },
    },
    F9CT: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur l’instruction publique',
          abbreviations: [],
        },
      },
    },
    GAMO: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les sociétés nationales de bienfaisance',
          abbreviations: [],
        },
      },
    },
    HVWR: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur la constitution de certaines Églises',
          abbreviations: [],
        },
      },
    },
    I3UX: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les services de santé et les services sociaux',
          abbreviations: [],
        },
      },
    },
    J5SC: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur la conservation et la mise en valeur de la faune',
          abbreviations: [],
        },
      },
    },
    JBU2: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les clubs de chasse et de pêche',
          abbreviations: [],
        },
      },
    },
    JI4V: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur la mise en marché des produits agricoles, alimentaires et de la pêche',
          abbreviations: [],
        },
      },
    },
    JLE0: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur la conservation de la faune',
          abbreviations: [],
        },
      },
    },
    JLZW: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Société par actions constitué par Loi sur les compagnies de fidéicommis',
          abbreviations: [],
        },
      },
    },
    JQNA: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les sociétés préventives de cruauté envers les animaux',
          abbreviations: [],
        },
      },
    },
    JVMD: {
      active: false,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            "Société par actions par Fonds mutuel constitué par acte de fiducie, Loi sur les assurances, Loi sur les compagnies de fidéicommis, Loi sur les compagnies de flottage, Loi sur les compagnies de gaz, d’eau et d’électricité, Loi sur les compagnies de télégraphe et de téléphone, Loi sur les compagnies minières, Loi sur les sociétés de construction, Loi sur les sociétés de développement de l'entreprise québécoise, Loi sur les sociétés de fiducie et les sociétés d'épargne, Loi sur les sociétés de patrons de fabriques de producteurs laitiers, Loi sur les sociétés d'entraide économique, Loi sur les sociétés d'exploration minière, Loi sur les syndicats d'élevage",
          abbreviations: [],
        },
      },
    },
    JXO5: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            "Société par actions constitué par Loi sur les sociétés de fiducie et les sociétés d'épargne",
          abbreviations: [],
        },
      },
    },
    K08P: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les compagnies de cimetière',
          abbreviations: [],
        },
      },
    },
    L26C: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Société par actions par Fonds mutuel constitué par acte de fiducie',
          abbreviations: [],
        },
      },
    },
    L3XH: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            "Personne morale sans but lucratif par Loi sur les sociétés d'horticulture",
          abbreviations: [],
        },
      },
    },
    LN3N: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les villages miniers',
          abbreviations: [],
        },
      },
    },
    MCY8: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            "Personne morale sans but lucratif par Loi sur les sociétés d'agriculture",
          abbreviations: [],
        },
      },
    },
    MK1I: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            "Société par actions constitué par Loi sur les sociétés d'entraide économique",
          abbreviations: [],
        },
      },
    },
    MQT7: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur la santé et la sécurité du travail',
          abbreviations: [],
        },
      },
    },
    MR95: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les décrets de convention collective',
          abbreviations: [],
        },
      },
    },
    NVXN: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            "Personne morale sans but lucratif par Loi sur l'organisation territoriale municipale",
          abbreviations: [],
        },
      },
    },
    OMUP: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les clubs de récréation',
          abbreviations: [],
        },
      },
    },
    Q8NY: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les syndicats professionnels',
          abbreviations: [],
        },
      },
    },
    QB2W: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Coopérative',
          abbreviations: ['coop'],
        },
      },
    },
    RC3D: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les villages nordiques et l’Administration régionale Kativik',
          abbreviations: [],
        },
      },
    },
    RPGT: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Société par actions constitué par Loi sur les compagnies de télégraphe et de téléphone',
          abbreviations: [],
        },
      },
    },
    RQIC: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Société en commandite',
          abbreviations: ['S.E.C.'],
        },
      },
    },
    S72N: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur la Fédération des scouts catholiques du Québec',
          abbreviations: [],
        },
      },
    },
    T1LR: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Syndicat de copropriété',
          abbreviations: [],
        },
      },
    },
    TA7J: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Société par actions constitué par Loi sur les compagnies de flottage',
          abbreviations: [],
        },
      },
    },
    TKAB: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            "Société par actions constitué par Loi sur les sociétés de développement de l'entreprise québécoise",
          abbreviations: [],
        },
      },
    },
    TWLR: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Association',
          abbreviations: [],
        },
      },
    },
    UG3Z: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Société par actions par Loi sur les sociétés par actions',
          abbreviations: ['ltée', 'inc.', 's.a.'],
        },
      },
    },
    UR1O: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Entreprise individuelle',
          abbreviations: [],
        },
      },
    },
    UVCG: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Société par actions constitué par Loi sur les sociétés de construction',
          abbreviations: [],
        },
      },
    },
    V5IH: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur l’aménagement et l’urbanisme',
          abbreviations: [],
        },
      },
    },
    V9GU: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur la société Saint-Jean-Baptiste de Trois-Rivières',
          abbreviations: [],
        },
      },
    },
    VGP6: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Personne morale sans but lucratif par Loi sur les fabriques',
          abbreviations: [],
        },
      },
    },
    VRVJ: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Personne morale sans but lucratif par Code des professions',
          abbreviations: [],
        },
      },
    },
    WGEA: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur l’organisation municipale de certains territoires',
          abbreviations: [],
        },
      },
    },
    XS49: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi concernant le regroupement et la gestion des commissions scolaires',
          abbreviations: [],
        },
      },
    },
    XW5K: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur la Fédération des guides catholiques du Québec',
          abbreviations: [],
        },
      },
    },
    YBMJ: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Personne morale sans but lucratif par Loi sur les assurances',
          abbreviations: [],
        },
      },
    },
    YIIS: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les corporations religieuses',
          abbreviations: [],
        },
      },
    },
    YRUJ: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Société en nom collectif',
          abbreviations: ['S.E.N.C.'],
        },
      },
    },
    Z6MF: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label: 'Selon la loi par Loi spéciale du Québec à caractère privé',
          abbreviations: [],
        },
      },
    },
    ZGEX: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les services correctionnels',
          abbreviations: [],
        },
      },
    },
    ZQQU: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur la société Saint-Jean-Baptiste du Québec',
          abbreviations: [],
        },
      },
    },
    ZX1F: {
      active: true,
      subdivision: 'CA-QC',
      languages: {
        fr: {
          label:
            'Personne morale sans but lucratif par Loi sur les compagnies de cimetières catholiques romains',
          abbreviations: [],
        },
      },
    },
    '3OVJ': {
      active: true,
      subdivision: 'CA-SK',
      languages: {
        en: {
          label: 'Non-profit Corporations',
          abbreviations: ['Corp.', 'Inc.'],
        },
      },
    },
    '5D9I': {
      active: true,
      subdivision: 'CA-SK',
      languages: {
        en: {
          label: 'Limited Liabilty Partnerships',
          abbreviations: [],
        },
      },
    },
    '5EEA': {
      active: true,
      subdivision: 'CA-SK',
      languages: {
        en: {
          label:
            'Corporations formed by an Act of the Saskatchewan legislature',
          abbreviations: [],
        },
      },
    },
    '7IKZ': {
      active: true,
      subdivision: 'CA-SK',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    '7XZL': {
      active: true,
      subdivision: 'CA-SK',
      languages: {
        en: {
          label: 'New Generation Co-operatives',
          abbreviations: ['co-op. ltd.'],
        },
      },
    },
    '8KL5': {
      active: true,
      subdivision: 'CA-SK',
      languages: {
        en: {
          label: 'Condominium Corporations',
          abbreviations: [],
        },
      },
    },
    FYYY: {
      active: true,
      subdivision: 'CA-SK',
      languages: {
        en: {
          label: 'Credit Unions',
          abbreviations: [],
        },
      },
    },
    I8VP: {
      active: true,
      subdivision: 'CA-SK',
      languages: {
        en: {
          label: 'Sole Proprietors',
          abbreviations: [],
        },
      },
    },
    JNCJ: {
      active: true,
      subdivision: 'CA-SK',
      languages: {
        en: {
          label: 'Co-operatives',
          abbreviations: ['co-op', 'ltd.'],
        },
      },
    },
    KZDW: {
      active: true,
      subdivision: 'CA-SK',
      languages: {
        en: {
          label: 'Syndicates',
          abbreviations: [],
        },
      },
    },
    L2NN: {
      active: true,
      subdivision: 'CA-SK',
      languages: {
        en: {
          label: 'Joint Ventures',
          abbreviations: [],
        },
      },
    },
    LMSY: {
      active: true,
      subdivision: 'CA-SK',
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
    UWMY: {
      active: true,
      subdivision: 'CA-SK',
      languages: {
        en: {
          label: 'Business Corporations',
          abbreviations: ['Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
  },
  KY: {
    '4XP8': {
      active: true,
      languages: {
        en: {
          label: 'Company limited by guarantee',
          abbreviations: ['Ltd'],
        },
      },
    },
    '6XB7': {
      active: true,
      languages: {
        en: {
          label: 'Exempted limited partnership',
          abbreviations: ['ELP'],
        },
      },
    },
    '8HR7': {
      active: true,
      languages: {
        en: {
          label: 'Unlimited company',
          abbreviations: [],
        },
      },
    },
    JDX6: {
      active: true,
      languages: {
        en: {
          label: 'Special economic zone company',
          abbreviations: ['SEZC'],
        },
      },
    },
    K575: {
      active: true,
      languages: {
        en: {
          label: 'Foundation company',
          abbreviations: [],
        },
      },
    },
    MP7S: {
      active: true,
      languages: {
        en: {
          label: 'Segregated portfolio company',
          abbreviations: ['SPC'],
        },
      },
    },
    MPUG: {
      active: true,
      languages: {
        en: {
          label: 'Limited liability company',
          abbreviations: ['LLC'],
        },
      },
    },
    OSBR: {
      active: true,
      languages: {
        en: {
          label: 'Company limited by shares',
          abbreviations: ['Ltd'],
        },
      },
    },
    SNUK: {
      active: true,
      languages: {
        en: {
          label: 'Association',
          abbreviations: [],
        },
      },
    },
    T5UM: {
      active: true,
      languages: {
        en: {
          label: 'Exempted limited duration company',
          abbreviations: ['LDC'],
        },
      },
    },
    XAQA: {
      active: true,
      languages: {
        en: {
          label: 'Limited partnership',
          abbreviations: ['LP'],
        },
      },
    },
  },
  CL: {
    '2UZP': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Colectiva Civil',
          abbreviations: [],
        },
      },
    },
    '78VN': {
      active: true,
      languages: {
        es: {
          label: 'Asociación',
          abbreviations: [],
        },
      },
    },
    '7T6S': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Legal Minera',
          abbreviations: ['SLM'],
        },
      },
    },
    '7ZMX': {
      active: true,
      languages: {
        es: {
          label: 'Asociación Gremial',
          abbreviations: ['A.G.'],
        },
      },
    },
    B8OI: {
      active: true,
      languages: {
        es: {
          label: 'Entidad religiosa',
          abbreviations: [],
        },
      },
    },
    C6AH: {
      active: true,
      languages: {
        es: {
          label: 'Cooperativa',
          abbreviations: [],
        },
      },
    },
    CVDP: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Responsabilidad Limitada',
          abbreviations: ['SRL'],
        },
      },
    },
    CZCE: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Colectiva Comercial',
          abbreviations: [],
        },
      },
    },
    EE3W: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita Comercial',
          abbreviations: [],
        },
      },
    },
    KUUZ: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad por Acciones',
          abbreviations: ['SpA'],
        },
      },
    },
    OA6N: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anónima',
          abbreviations: ['S.A.'],
        },
      },
    },
    Q1J0: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Contractual Minera',
          abbreviations: ['SCM'],
        },
      },
    },
    QFYC: {
      active: true,
      languages: {
        es: {
          label: 'Empresa Individual de Responsabilidad Limitada',
          abbreviations: ['E.I.R.L'],
        },
      },
    },
    RNQ0: {
      active: true,
      languages: {
        es: {
          label: 'Organización Comunitaria',
          abbreviations: [],
        },
      },
    },
    VZ3G: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita Civil',
          abbreviations: [],
        },
      },
    },
    Y8F1: {
      active: true,
      languages: {
        es: {
          label: 'Organización Deportiva',
          abbreviations: [],
        },
      },
    },
    YDNQ: {
      active: true,
      languages: {
        es: {
          label: 'Fundación',
          abbreviations: [],
        },
      },
    },
    ZHHH: {
      active: true,
      languages: {
        es: {
          label: 'Comunidad o Asociación Indígena',
          abbreviations: [],
        },
      },
    },
  },
  CN: {
    '1IWK': {
      active: true,
      languages: {
        zh: {
          label: '外国常驻新闻机构',
          abbreviations: [],
        },
      },
    },
    '2M6Y': {
      active: true,
      languages: {
        zh: {
          label: '基金会',
          abbreviations: [],
        },
      },
    },
    '5A9K': {
      active: true,
      languages: {
        zh: {
          label: '军队事业单位',
          abbreviations: [],
        },
      },
    },
    '5GXA': {
      active: true,
      languages: {
        zh: {
          label: '村级集体经济组织',
          abbreviations: [],
        },
      },
    },
    '6KC0': {
      active: true,
      languages: {
        zh: {
          label: '宗教院校',
          abbreviations: [],
        },
      },
    },
    '6NSC': {
      active: true,
      languages: {
        zh: {
          label: '律师执业机构',
          abbreviations: [],
        },
      },
    },
    '8XAW': {
      active: true,
      languages: {
        zh: {
          label: '外国在华文化中心',
          abbreviations: [],
        },
      },
    },
    B5UZ: {
      active: true,
      languages: {
        zh: {
          label: '事业单位',
          abbreviations: [],
        },
      },
    },
    BDTI: {
      active: true,
      languages: {
        zh: {
          label: '编办直接管理机构编制的群众团体',
          abbreviations: [],
        },
      },
    },
    C38B: {
      active: true,
      languages: {
        zh: {
          label: '其他（外交）',
          abbreviations: [],
        },
      },
    },
    CYV6: {
      active: true,
      languages: {
        zh: {
          label: '其他（中央军委改革和编制办公室）',
          abbreviations: [],
        },
      },
    },
    DLEK: {
      active: true,
      languages: {
        zh: {
          label: '乡镇级集体经济组织',
          abbreviations: [],
        },
      },
    },
    E4FG: {
      active: true,
      languages: {
        zh: {
          label: '民办非企业单位',
          abbreviations: [],
        },
      },
    },
    E4YV: {
      active: true,
      languages: {
        zh: {
          label: '港澳台地区旅游部门常驻内地(大陆)代表机构',
          abbreviations: [],
        },
      },
    },
    E88S: {
      active: true,
      languages: {
        zh: {
          label: '公证处',
          abbreviations: [],
        },
      },
    },
    ECAK: {
      active: true,
      languages: {
        zh: {
          label: '企业',
          abbreviations: [],
        },
      },
    },
    ESZ8: {
      active: true,
      languages: {
        zh: {
          label: '其他（农业）',
          abbreviations: [],
        },
      },
    },
    GGZ5: {
      active: true,
      languages: {
        zh: {
          label: '社会团体',
          abbreviations: [],
        },
      },
    },
    GPHT: {
      active: true,
      languages: {
        zh: {
          label: '其他（文化）',
          abbreviations: [],
        },
      },
    },
    I39S: {
      active: true,
      languages: {
        zh: {
          label: '机关',
          abbreviations: [],
        },
      },
    },
    IBEM: {
      active: true,
      languages: {
        zh: {
          label: '基层法律服务所',
          abbreviations: [],
        },
      },
    },
    LURL: {
      active: true,
      languages: {
        zh: {
          label: '其他（适用于无登记机构的的情况）',
          abbreviations: [],
        },
      },
    },
    NWJX: {
      active: true,
      languages: {
        zh: {
          label: '其他（司法行政）',
          abbreviations: [],
        },
      },
    },
    OH9O: {
      active: true,
      languages: {
        zh: {
          label: '基层工会',
          abbreviations: [],
        },
      },
    },
    OMUD: {
      active: true,
      languages: {
        zh: {
          label: '其他（旅游）',
          abbreviations: [],
        },
      },
    },
    R3O0: {
      active: true,
      languages: {
        zh: {
          label: '其他（工会）',
          abbreviations: [],
        },
      },
    },
    RV48: {
      active: true,
      languages: {
        zh: {
          label: '个体工商户',
          abbreviations: [],
        },
      },
    },
    S9UH: {
      active: true,
      languages: {
        zh: {
          label: '司法鉴定机构',
          abbreviations: [],
        },
      },
    },
    SH05: {
      active: true,
      languages: {
        zh: {
          label: '其他（机构编制）',
          abbreviations: [],
        },
      },
    },
    T0KK: {
      active: true,
      languages: {
        zh: {
          label: '其他（宗教）',
          abbreviations: [],
        },
      },
    },
    TBG2: {
      active: true,
      languages: {
        zh: {
          label: '外国旅游部门常驻代表机构',
          abbreviations: [],
        },
      },
    },
    UMCR: {
      active: true,
      languages: {
        zh: {
          label: '农民专业合作社',
          abbreviations: [],
        },
      },
    },
    V251: {
      active: true,
      languages: {
        zh: {
          label: '仲裁委员会',
          abbreviations: [],
        },
      },
    },
    V816: {
      active: true,
      languages: {
        zh: {
          label: '组级集体经济组织',
          abbreviations: [],
        },
      },
    },
    WEUX: {
      active: true,
      languages: {
        zh: {
          label: '其他（民政）',
          abbreviations: [],
        },
      },
    },
    YXJ5: {
      active: true,
      languages: {
        zh: {
          label: '宗教活动场所',
          abbreviations: [],
        },
      },
    },
  },
  CO: {
    '1PAD': {
      active: true,
      languages: {
        es: {
          label: 'Empresa Unipersonal',
          abbreviations: ['E.U.'],
        },
      },
    },
    '3RHN': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anónima',
          abbreviations: ['S.A.'],
        },
      },
    },
    '4OYE': {
      active: true,
      languages: {
        es: {
          label: 'Persona natural comerciante',
          abbreviations: [],
        },
      },
    },
    '6Z8B': {
      active: true,
      languages: {
        es: {
          label: 'Sucursal de Sociedad Extranjera',
          abbreviations: [],
        },
      },
    },
    D2T3: {
      active: true,
      languages: {
        es: {
          label: 'Empresa Asociativa de Trabajo',
          abbreviations: [],
        },
      },
    },
    DEJ0: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Colectiva',
          abbreviations: [],
        },
      },
    },
    IUIY: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en comandita simple',
          abbreviations: ['Cía S. en C.'],
        },
      },
    },
    KC51: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Economía Mixta',
          abbreviations: [],
        },
      },
    },
    KYVO: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad por Acciones Simplificada',
          abbreviations: ['S.A.S'],
        },
      },
    },
    N1TE: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en comandita por acciones',
          abbreviations: ['Cía SCA.'],
        },
      },
    },
    SJB8: {
      active: true,
      languages: {
        es: {
          label: 'Sociedades Agrarias de Transformación',
          abbreviations: ['SAT'],
        },
      },
    },
    WX45: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Responsabilidad Limitada',
          abbreviations: ['Ltda.'],
        },
      },
    },
  },
  CK: {
    '70NZ': {
      active: true,
      languages: {
        en: {
          label: 'International Company',
          abbreviations: [],
        },
      },
    },
    A7G6: {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    KNIC: {
      active: true,
      languages: {
        en: {
          label: 'International Partnership',
          abbreviations: [],
        },
      },
    },
    N00R: {
      active: true,
      languages: {
        en: {
          label: 'Foundation',
          abbreviations: [],
        },
      },
    },
    YCQM: {
      active: true,
      languages: {
        en: {
          label: 'International Trust',
          abbreviations: [],
        },
      },
    },
    Z3Y2: {
      active: true,
      languages: {
        en: {
          label: 'Foreign Company',
          abbreviations: [],
        },
      },
    },
  },
  CR: {
    '4SFS': {
      active: true,
      languages: {
        es: {
          label: 'Institución Autónoma',
          abbreviations: [],
        },
      },
    },
    '4Y4D': {
      active: true,
      languages: {
        es: {
          label: 'Entidad Creada por Ley Especial',
          abbreviations: [],
        },
      },
    },
    '72BT': {
      active: true,
      languages: {
        es: {
          label: 'Organismo Internacional',
          abbreviations: [],
        },
      },
    },
    DUXT: {
      active: true,
      languages: {
        es: {
          label:
            'Junta de Educación y Junta Administrativa de Patronatos Escolares',
          abbreviations: [],
        },
      },
    },
    E26K: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Profesional',
          abbreviations: [],
        },
      },
    },
    EFE3: {
      active: true,
      languages: {
        es: {
          label: 'Municipalidad',
          abbreviations: [],
        },
      },
    },
    G5RR: {
      active: true,
      languages: {
        es: {
          label: 'Fundación',
          abbreviations: [],
        },
      },
    },
    H2BW: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad civil',
          abbreviations: ['A.C.'],
        },
      },
    },
    HSX9: {
      active: true,
      languages: {
        es: {
          label: 'Temporalidad de la Iglesia',
          abbreviations: [],
        },
      },
    },
    KZMF: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de usuarios de aguas',
          abbreviations: [],
        },
      },
    },
    LQVG: {
      active: true,
      languages: {
        es: {
          label: 'Sucesión Indivisa',
          abbreviations: [],
        },
      },
    },
    M0X8: {
      active: true,
      languages: {
        es: {
          label: 'Condominio',
          abbreviations: [],
        },
      },
    },
    O4X3: {
      active: true,
      languages: {
        es: {
          label: 'Asociación civil, Asociación deportiva, Federación',
          abbreviations: [],
        },
      },
    },
    P864: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Responsabilidad Limitada o Sociedad Limitada',
          abbreviations: ['S.L.', 'S.R.L.'],
        },
      },
    },
    Q4J1: {
      active: true,
      languages: {
        es: {
          label: 'Mutual de Ahorro y Préstamo',
          abbreviations: [],
        },
      },
    },
    SBQF: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad colectiva',
          abbreviations: ['S.C.'],
        },
      },
    },
    SMWM: {
      active: true,
      languages: {
        es: {
          label: 'Sindicato y su Federación',
          abbreviations: [],
        },
      },
    },
    YFZL: {
      active: true,
      languages: {
        es: {
          label: 'Fideicomiso de Partidos Políticos',
          abbreviations: [],
        },
      },
    },
    YOIW: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anónima',
          abbreviations: ['S.A.'],
        },
      },
    },
    YP63: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en comandita',
          abbreviations: ['S. en C.'],
        },
      },
    },
    YW6W: {
      active: true,
      languages: {
        es: {
          label: 'Empresa Individual de Responsabilidad Limitada',
          abbreviations: ['E.I.R.L.'],
        },
      },
    },
    YYZO: {
      active: true,
      languages: {
        es: {
          label: 'Asociación Cooperativa',
          abbreviations: [],
        },
      },
    },
  },
  HR: {
    '24EG': {
      active: true,
      languages: {
        hr: {
          label: 'Kreditna unija',
          abbreviations: [],
        },
      },
    },
    '274G': {
      active: true,
      languages: {
        hr: {
          label: 'Udruga',
          abbreviations: [],
        },
      },
    },
    '28RA': {
      active: true,
      languages: {
        hr: {
          label: 'Fond',
          abbreviations: [],
        },
      },
    },
    '2FED': {
      active: true,
      languages: {
        hr: {
          label: 'Gospodarsko interesno udruženje',
          abbreviations: ['GIU'],
        },
      },
    },
    '3OW3': {
      active: true,
      languages: {
        hr: {
          label: 'Europsko gospodarsko interesno udruženje (skraćeno EGIU)',
          abbreviations: [],
        },
      },
    },
    '6Q6D': {
      active: true,
      languages: {
        hr: {
          label: 'Pravna osoba Katoličke Crkve',
          abbreviations: [],
        },
      },
    },
    '6RD2': {
      active: true,
      languages: {
        hr: {
          label: 'Agencije I druge samostalne pravne osobe s javnim ovlastima',
          abbreviations: [],
        },
      },
    },
    '8VRU': {
      active: true,
      languages: {
        hr: {
          label:
            'Europska zadruga (Societas Cooperativa Europaea, skraćeno SCE)',
          abbreviations: [],
        },
      },
    },
    '9D9U': {
      active: true,
      languages: {
        hr: {
          label: 'Trgovac pojedinac',
          abbreviations: ['t.p.'],
        },
      },
    },
    '9PZC': {
      active: true,
      languages: {
        hr: {
          label: 'Fundacija',
          abbreviations: [],
        },
      },
    },
    E9CM: {
      active: true,
      languages: {
        hr: {
          label: 'Europsko društvo (Societas Europaea, skraćeno SE)',
          abbreviations: [],
        },
      },
    },
    EYKU: {
      active: true,
      languages: {
        hr: {
          label: 'Stečajna masa',
          abbreviations: [],
        },
      },
    },
    G5RH: {
      active: true,
      languages: {
        hr: {
          label: 'Zadruge',
          abbreviations: [],
        },
      },
    },
    IVVD: {
      active: true,
      languages: {
        hr: {
          label: 'Savez zadruga',
          abbreviations: [],
        },
      },
    },
    KP34: {
      active: true,
      languages: {
        hr: {
          label: 'Javno trgovačko društvo',
          abbreviations: ['j.t.d.'],
        },
      },
    },
    LUMA: {
      active: true,
      languages: {
        hr: {
          label: 'Dioničko društvo',
          abbreviations: ['d.d.'],
        },
      },
    },
    MF7P: {
      active: true,
      languages: {
        hr: {
          label: 'Komanditno društvo',
          abbreviations: ['k.d.'],
        },
      },
    },
    NRTG: {
      active: true,
      languages: {
        hr: {
          label: 'Podružnica',
          abbreviations: [],
        },
      },
    },
    OQWO: {
      active: true,
      languages: {
        hr: {
          label:
            'Društvo s ograničenom odgovornošću (jednostavno društvo s ograničenom odgovornošću)',
          abbreviations: ['d.o.o.', 'j.d.o.o'],
        },
      },
    },
    SPJ7: {
      active: true,
      languages: {
        hr: {
          label: 'Vjerska zajednica',
          abbreviations: [],
        },
      },
    },
    TSA0: {
      active: true,
      languages: {
        hr: {
          label: 'Tijelo državne uprave',
          abbreviations: [],
        },
      },
    },
    XQLW: {
      active: true,
      languages: {
        hr: {
          label: 'Jedinica lokalne ili područne (regionalne) samouprave',
          abbreviations: [],
        },
      },
    },
    YA9S: {
      active: true,
      languages: {
        hr: {
          label: 'Zajednica ustanova',
          abbreviations: [],
        },
      },
    },
    ZFQS: {
      active: true,
      languages: {
        hr: {
          label: 'Ustanova',
          abbreviations: [],
        },
      },
    },
    ZMY8: {
      active: true,
      languages: {
        hr: {
          label: 'Zaklada',
          abbreviations: [],
        },
      },
    },
  },
  CW: {
    '1SVL': {
      active: true,
      languages: {
        nl: {
          label: 'Stille vennootschap',
          abbreviations: [],
        },
      },
    },
    '1T06': {
      active: true,
      languages: {
        nl: {
          label: 'Stichting',
          abbreviations: [],
        },
      },
    },
    '2J66': {
      active: true,
      languages: {
        nl: {
          label: 'Stichting Particulier Fonds',
          abbreviations: [],
        },
      },
    },
    '36AO': {
      active: true,
      languages: {
        nl: {
          label: 'Naamloze Vennootschap',
          abbreviations: [],
        },
      },
    },
    '5OZV': {
      active: true,
      languages: {
        nl: {
          label: 'Eenmanszaak',
          abbreviations: [],
        },
      },
    },
    '9E0Q': {
      active: true,
      languages: {
        nl: {
          label: 'Commanditaire vennootschap',
          abbreviations: [],
        },
      },
    },
    ADF8: {
      active: true,
      languages: {
        nl: {
          label: 'Coöperatie',
          abbreviations: [],
        },
      },
    },
    IHD0: {
      active: true,
      languages: {
        nl: {
          label: 'Rederij',
          abbreviations: [],
        },
      },
    },
    KM1T: {
      active: true,
      languages: {
        nl: {
          label: 'Openbare vennootschap',
          abbreviations: [],
        },
      },
    },
    MZB1: {
      active: true,
      languages: {
        nl: {
          label: 'Besloten Vennootschap',
          abbreviations: [],
        },
      },
    },
    SS3A: {
      active: true,
      languages: {
        nl: {
          label: 'Onderlinge waarborgmaatschappij',
          abbreviations: [],
        },
      },
    },
    WV3I: {
      active: true,
      languages: {
        nl: {
          label: 'Vereniging',
          abbreviations: [],
        },
      },
    },
    ZKTC: {
      active: true,
      languages: {
        nl: {
          label: 'Trust',
          abbreviations: [],
        },
      },
    },
  },
  CY: {
    '1MBR': {
      active: false,
      languages: {
        el: {
          label: 'Άλλη νομική μορφή',
          abbreviations: [],
        },
      },
    },
    '233U': {
      active: true,
      languages: {
        el: {
          label: 'Συνεταιρισμός',
          abbreviations: [],
        },
      },
    },
    '8BL9': {
      active: true,
      languages: {
        el: {
          label: 'Ευρωπαϊκή Δημόσια Εταιρεία Περιορισμένης Ευθύνης',
          abbreviations: [],
        },
      },
    },
    '8VZ0': {
      active: true,
      languages: {
        en: {
          label: 'Trust',
          abbreviations: [],
        },
      },
    },
    BCF5: {
      active: true,
      languages: {
        el: {
          label: 'Δημόσια Εταιρεία Περιορισμένης Ευθύνης με μετοχές',
          abbreviations: [],
        },
      },
    },
    FV0K: {
      active: false,
      languages: {
        el: {
          label: 'Eμπορική Επωνυμία',
          abbreviations: [],
        },
      },
    },
    GLCH: {
      active: true,
      languages: {
        el: {
          label: 'Σωματεία και Ιδρυμάτα',
          abbreviations: [],
        },
      },
    },
    HIL6: {
      active: false,
      languages: {
        el: {
          label: 'Αλλοδαπή Εταιρεία',
          abbreviations: [],
        },
      },
    },
    I8RE: {
      active: true,
      languages: {
        el: {
          label: 'Αυτοτελώς εργαζόμενος',
          abbreviations: [],
        },
      },
    },
    INTY: {
      active: true,
      languages: {
        el: {
          label:
            'Εταιρεία Περιορισμένης Ευθύνης με εγγύηση, και που έχει μετοχικό κεφάλαιο',
          abbreviations: [],
        },
      },
    },
    K9L6: {
      active: true,
      languages: {
        el: {
          label: 'Ιδιωτική Εταιρεία Περιορισμένης Ευθύνης με μετοχές',
          abbreviations: [],
        },
      },
    },
    MYKG: {
      active: true,
      languages: {
        el: {
          label: 'Δημόσια Εταιρεία',
          abbreviations: [],
        },
      },
    },
    P12B: {
      active: true,
      languages: {
        el: {
          label: 'Ταμεία Προνοίας/ Συντάξεως',
          abbreviations: [],
        },
      },
    },
    P5JT: {
      active: true,
      languages: {
        el: {
          label: 'Ευρωπαϊκός Όμιλος Οικονομικού Σκοπού',
          abbreviations: ['ΕΟΟΣ'],
        },
      },
    },
    RCPI: {
      active: true,
      languages: {
        el: {
          label: 'Ιδιωτική Εταιρεία',
          abbreviations: [],
        },
      },
    },
    T1JS: {
      active: true,
      languages: {
        el: {
          label: 'Οντότητες που διέπονται από το δημόσιο δίκαιο',
          abbreviations: [],
        },
      },
    },
    U24X: {
      active: true,
      languages: {
        el: {
          label: 'Συνεργατικά Πιστωτικά Ιδρύματα',
          abbreviations: [],
        },
      },
    },
    W86L: {
      active: true,
      languages: {
        el: {
          label:
            'Εταιρεία Περιορισμένης Ευθύνης με εγγύηση, χωρίς μετοχικό κεφάλαιο',
          abbreviations: [],
        },
      },
    },
  },
  CZ: {
    '1JK6': {
      active: true,
      languages: {
        cs: {
          label: 'Svépomocné zemědělské družstvo',
          abbreviations: [],
        },
      },
    },
    '2DK3': {
      active: true,
      languages: {
        cs: {
          label: 'Podnik nebo hospodářské zařízení politické strany',
          abbreviations: [],
        },
      },
    },
    '2N9X': {
      active: true,
      languages: {
        cs: {
          label: 'Česká konsolidační agentura',
          abbreviations: [],
        },
      },
    },
    '3BX3': {
      active: true,
      languages: {
        cs: {
          label: 'Evropské seskupení pro územní spolupráci',
          abbreviations: [],
        },
      },
    },
    '3G3D': {
      active: true,
      languages: {
        cs: {
          label: 'Nadace',
          abbreviations: [],
        },
      },
    },
    '3RMA': {
      active: true,
      languages: {
        cs: {
          label: 'Státní fond ze zákona',
          abbreviations: [],
        },
      },
    },
    '4A26': {
      active: true,
      languages: {
        cs: {
          label: 'Zájmová organizace družstev',
          abbreviations: [],
        },
      },
    },
    '4OTK': {
      active: true,
      languages: {
        cs: {
          label: 'Regionální rada regionu soudržnosti',
          abbreviations: [],
        },
      },
    },
    '4UB2': {
      active: true,
      languages: {
        cs: {
          label: 'Garanční fond obchodníků s cennými papíry',
          abbreviations: [],
        },
      },
    },
    '4YAK': {
      active: true,
      languages: {
        cs: {
          label: 'Stálý rozhodčí soud',
          abbreviations: [],
        },
      },
    },
    '5AP3': {
      active: true,
      languages: {
        cs: {
          label: 'Pobočná mezinárodní organizace zaměstnavatelů',
          abbreviations: [],
        },
      },
    },
    '5KU5': {
      active: true,
      languages: {
        cs: {
          label: 'Veřejná obchodní společnost',
          abbreviations: [],
        },
      },
    },
    '6CQN': {
      active: true,
      languages: {
        cs: {
          label: 'Akciová společnost',
          abbreviations: [],
        },
      },
    },
    '6D9L': {
      active: true,
      languages: {
        cs: {
          label: 'Svěřenský fond',
          abbreviations: [],
        },
      },
    },
    '6FAI': {
      active: true,
      languages: {
        cs: {
          label: 'Státní podnik',
          abbreviations: [],
        },
      },
    },
    '6OMW': {
      active: true,
      languages: {
        cs: {
          label: 'Organizační jednotka občanského sdružení',
          abbreviations: [],
        },
      },
    },
    '747U': {
      active: true,
      languages: {
        cs: {
          label: 'Společnost komanditní na akcie',
          abbreviations: [],
        },
      },
    },
    '74W6': {
      active: true,
      languages: {
        cs: {
          label: 'Státní příspěvková organizace ostatní',
          abbreviations: [],
        },
      },
    },
    '7OZQ': {
      active: true,
      languages: {
        cs: {
          label: 'Zájmové sdružení',
          abbreviations: [],
        },
      },
    },
    '84J8': {
      active: true,
      languages: {
        cs: {
          label: 'Státní hospodářská organizace řízená okresním úřadem',
          abbreviations: [],
        },
      },
    },
    '8K5T': {
      active: true,
      languages: {
        cs: {
          label: 'Spotřební družstvo',
          abbreviations: [],
        },
      },
    },
    '917C': {
      active: true,
      languages: {
        cs: {
          label: 'Česká tisková kancelář',
          abbreviations: [],
        },
      },
    },
    '95G8': {
      active: true,
      languages: {
        cs: {
          label: 'Podnikající fyzická osoba tuzemská',
          abbreviations: [],
        },
      },
    },
    '971Y': {
      active: true,
      languages: {
        cs: {
          label: 'Podnik nebo hospodářské zařízení sdružení',
          abbreviations: [],
        },
      },
    },
    '9HLU': {
      active: true,
      languages: {
        cs: {
          label: 'Společnost s ručením omezeným',
          abbreviations: [],
        },
      },
    },
    '9RVC': {
      active: true,
      languages: {
        cs: {
          label: 'Družstvo',
          abbreviations: [],
        },
      },
    },
    '9XDB': {
      active: true,
      languages: {
        cs: {
          label: 'Občanské sdružení',
          abbreviations: [],
        },
      },
    },
    AM3T: {
      active: true,
      languages: {
        cs: {
          label:
            'Státní fond ze zákona nezapisující se do obchodního rejstříku',
          abbreviations: [],
        },
      },
    },
    APEN: {
      active: true,
      languages: {
        cs: {
          label: 'Správa železniční dopravní cesty, státní organizace',
          abbreviations: [],
        },
      },
    },
    BL4B: {
      active: true,
      languages: {
        cs: {
          label: 'Obecně prospěšná společnost',
          abbreviations: [],
        },
      },
    },
    C4Q2: {
      active: true,
      languages: {
        cs: {
          label: 'Všeobecná zdravotní pojišťovna',
          abbreviations: [],
        },
      },
    },
    C5FE: {
      active: true,
      languages: {
        cs: {
          label: 'Samostatná drobná provozovna (obecního úřadu)',
          abbreviations: [],
        },
      },
    },
    C7GZ: {
      active: true,
      languages: {
        cs: {
          label: 'Výrobní družstvo',
          abbreviations: [],
        },
      },
    },
    CATU: {
      active: true,
      languages: {
        cs: {
          label: 'Spolek',
          abbreviations: [],
        },
      },
    },
    CD28: {
      active: true,
      languages: {
        cs: {
          label: 'Společnost komanditní',
          abbreviations: [],
        },
      },
    },
    CHJR: {
      active: true,
      languages: {
        cs: {
          label: 'Podnik se zahraniční majetkovou účastí',
          abbreviations: [],
        },
      },
    },
    CIO8: {
      active: true,
      languages: {
        cs: {
          label: 'Veřejná výzkumná instituce',
          abbreviations: [],
        },
      },
    },
    CUKQ: {
      active: true,
      languages: {
        cs: {
          label: 'Mezinárodní organizace zaměstnavatelů',
          abbreviations: [],
        },
      },
    },
    CZUA: {
      active: true,
      languages: {
        cs: {
          label: 'Zahraniční fyzická osoba',
          abbreviations: [],
        },
      },
    },
    D1VK: {
      active: true,
      languages: {
        cs: {
          label: 'Školská právnická osoba',
          abbreviations: [],
        },
      },
    },
    D35X: {
      active: true,
      languages: {
        cs: {
          label: 'Zahraniční spolek',
          abbreviations: [],
        },
      },
    },
    ET6Z: {
      active: true,
      languages: {
        cs: {
          label: 'Svazy církví a náboženských společností',
          abbreviations: [],
        },
      },
    },
    FIPS: {
      active: true,
      languages: {
        cs: {
          label: 'Banka-státní peněžní ústav',
          abbreviations: [],
        },
      },
    },
    FY1B: {
      active: true,
      languages: {
        cs: {
          label: 'Církve a náboženské společnosti',
          abbreviations: [],
        },
      },
    },
    G2I3: {
      active: true,
      languages: {
        cs: {
          label: 'Pobočný spolek',
          abbreviations: [],
        },
      },
    },
    H4XQ: {
      active: true,
      languages: {
        cs: {
          label: 'Veřejné neziskové ústavní zdravotnické zařízení',
          abbreviations: [],
        },
      },
    },
    H6WW: {
      active: true,
      languages: {
        cs: {
          label: 'Státní příspěvková organizace',
          abbreviations: [],
        },
      },
    },
    HQPK: {
      active: true,
      languages: {
        cs: {
          label: 'Komora (hospodářská, agrární)',
          abbreviations: [],
        },
      },
    },
    HS5W: {
      active: true,
      languages: {
        cs: {
          label: 'Vnitřní organizační jednotka organizační složky státu',
          abbreviations: [],
        },
      },
    },
    HSNC: {
      active: true,
      languages: {
        cs: {
          label: 'Podnik zahraničního obchodu',
          abbreviations: [],
        },
      },
    },
    HY6K: {
      active: true,
      languages: {
        cs: {
          label: 'Organizační složka zahraničního nadačního fondu',
          abbreviations: [],
        },
      },
    },
    I32F: {
      active: true,
      languages: {
        cs: {
          label: 'Sdružení mezinárodního obchodu',
          abbreviations: [],
        },
      },
    },
    I68R: {
      active: true,
      languages: {
        cs: {
          label:
            'Organizační jednotka zvláštní organizace pro zastoupení českých zájmů v mezinárodních nevládních organizacích',
          abbreviations: [],
        },
      },
    },
    IQ9O: {
      active: true,
      languages: {
        cs: {
          label: 'Společenství vlastníků jednotek',
          abbreviations: [],
        },
      },
    },
    J8PB: {
      active: true,
      languages: {
        cs: {
          label: 'Obec',
          abbreviations: [],
        },
      },
    },
    JCAD: {
      active: true,
      languages: {
        cs: {
          label: 'Evidované církevní právnické osoby',
          abbreviations: [],
        },
      },
    },
    JJYB: {
      active: true,
      languages: {
        cs: {
          label: 'Zahraniční pobočný spolek',
          abbreviations: [],
        },
      },
    },
    KM6Z: {
      active: true,
      languages: {
        cs: {
          label: 'Státní banka československá',
          abbreviations: [],
        },
      },
    },
    LEDI: {
      active: true,
      languages: {
        cs: {
          label: 'Honební společenstvo',
          abbreviations: [],
        },
      },
    },
    LJ92: {
      active: true,
      languages: {
        cs: {
          label: 'Československé státní dráhy-státní organizace',
          abbreviations: [],
        },
      },
    },
    LJL0: {
      active: true,
      languages: {
        cs: {
          label: 'Organizační složka státu',
          abbreviations: [],
        },
      },
    },
    LPCQ: {
      active: true,
      languages: {
        cs: {
          label: 'Mezinárodní odborová organizace',
          abbreviations: [],
        },
      },
    },
    MAVU: {
      active: true,
      languages: {
        cs: {
          label: 'Dobrovolný svazek obcí',
          abbreviations: [],
        },
      },
    },
    MBUU: {
      active: true,
      languages: {
        cs: {
          label: 'Příspěvková organizace zřízená územním samosprávným celkem',
          abbreviations: [],
        },
      },
    },
    NI3I: {
      active: true,
      languages: {
        cs: {
          label: 'Veřejnoprávní instituce',
          abbreviations: [],
        },
      },
    },
    NJ87: {
      active: true,
      languages: {
        cs: {
          label: 'Společný podnik (s více zakladateli)',
          abbreviations: [],
        },
      },
    },
    NPH3: {
      active: true,
      languages: {
        cs: {
          label: 'Česká národní banka',
          abbreviations: [],
        },
      },
    },
    NQHQ: {
      active: true,
      languages: {
        cs: {
          label: 'Komoditní burza',
          abbreviations: [],
        },
      },
    },
    O9PW: {
      active: true,
      languages: {
        cs: {
          label: 'Samosprávná stavovská organizace (profesní komora)',
          abbreviations: [],
        },
      },
    },
    OVKW: {
      active: true,
      languages: {
        cs: {
          label: 'Vysoká škola (veřejná, státní)',
          abbreviations: [],
        },
      },
    },
    P3YF: {
      active: true,
      languages: {
        cs: {
          label: 'Pobočná odborová organizace a organizace zaměstnavatelů',
          abbreviations: [],
        },
      },
    },
    PFE5: {
      active: true,
      languages: {
        cs: {
          label: 'Městská část, městský obvod',
          abbreviations: [],
        },
      },
    },
    PQJE: {
      active: true,
      languages: {
        cs: {
          label: 'Mezinárodní nevládní organizace',
          abbreviations: [],
        },
      },
    },
    Q25I: {
      active: true,
      languages: {
        cs: {
          label: 'Odborová organizace a organizace zaměstnavatelů',
          abbreviations: [],
        },
      },
    },
    QIEL: {
      active: true,
      languages: {
        cs: {
          label: 'Kraj',
          abbreviations: [],
        },
      },
    },
    QJ0F: {
      active: true,
      languages: {
        cs: {
          label: 'Ústav',
          abbreviations: [],
        },
      },
    },
    QJWK: {
      active: true,
      languages: {
        cs: {
          label: 'Rada pro veřejný dohled nad auditem',
          abbreviations: [],
        },
      },
    },
    QQ49: {
      active: true,
      languages: {
        cs: {
          label: 'Zdravotní pojišťovna (mimo VZP)',
          abbreviations: [],
        },
      },
    },
    QS6A: {
      active: true,
      languages: {
        cs: {
          label: 'Nadační fond',
          abbreviations: [],
        },
      },
    },
    R2XE: {
      active: true,
      languages: {
        cs: {
          label: 'Organizační jednotka mezinárodní nevládní organizace',
          abbreviations: [],
        },
      },
    },
    RBGQ: {
      active: true,
      languages: {
        cs: {
          label: 'Evropské hospodářské zájmové sdružení',
          abbreviations: ['EHZS'],
        },
      },
    },
    RHFQ: {
      active: true,
      languages: {
        cs: {
          label: 'Družstevní podnik (s 1 zakladatelem)',
          abbreviations: [],
        },
      },
    },
    RP0E: {
      active: true,
      languages: {
        cs: {
          label: 'Obecní podnik',
          abbreviations: [],
        },
      },
    },
    SNWJ: {
      active: true,
      languages: {
        cs: {
          label: 'Podílový, penzijní fond',
          abbreviations: [],
        },
      },
    },
    T1FT: {
      active: true,
      languages: {
        cs: {
          label: 'Evropská družstevní společnost',
          abbreviations: ['SCE'],
        },
      },
    },
    T3Q1: {
      active: true,
      languages: {
        cs: {
          label: 'Bytové družstvo',
          abbreviations: [],
        },
      },
    },
    TNBA: {
      active: false,
      languages: {
        cs: {
          label: 'Odštěpný závod zahraniční právnické osoby',
          abbreviations: [],
        },
      },
    },
    U95A: {
      active: true,
      languages: {
        cs: {
          label: 'Odštěpný závod zahraniční fyzické osoby',
          abbreviations: [],
        },
      },
    },
    UFDA: {
      active: true,
      languages: {
        cs: {
          label: 'Národní podnik',
          abbreviations: [],
        },
      },
    },
    V6YH: {
      active: true,
      languages: {
        cs: {
          label: 'Společná zájmová organizace družstev',
          abbreviations: [],
        },
      },
    },
    VIE3: {
      active: true,
      languages: {
        cs: {
          label: 'Zájmové sdružení právnických osob',
          abbreviations: [],
        },
      },
    },
    VQU7: {
      active: true,
      languages: {
        cs: {
          label: 'Organizační složka zahraniční nadace',
          abbreviations: [],
        },
      },
    },
    WJ30: {
      active: true,
      languages: {
        cs: {
          label: 'Družstevní podnik zemědělský',
          abbreviations: [],
        },
      },
    },
    WL83: {
      active: true,
      languages: {
        cs: {
          label:
            'Zvláštní organizace pro zastoupení českých zájmů v mezinárodních nevládních organizacích',
          abbreviations: [],
        },
      },
    },
    WO0T: {
      active: true,
      languages: {
        cs: {
          label: 'Pobočná mezinárodní odborová organizace',
          abbreviations: [],
        },
      },
    },
    WUFK: {
      active: true,
      languages: {
        cs: {
          label: 'Odštěpný závod',
          abbreviations: [],
        },
      },
    },
    WVZF: {
      active: true,
      languages: {
        cs: {
          label: 'Účelová zahraničně obchodní organizace',
          abbreviations: [],
        },
      },
    },
    XG70: {
      active: true,
      languages: {
        cs: {
          label:
            'Právnikcá osoba zřízená zvláštním zákonem zapisovaná do veřejného rejstříku',
          abbreviations: [],
        },
      },
    },
    XRK7: {
      active: true,
      languages: {
        cs: {
          label: 'Politická strana, politické hnutí',
          abbreviations: [],
        },
      },
    },
    Y18E: {
      active: true,
      languages: {
        cs: {
          label: 'Společný podnik',
          abbreviations: [],
        },
      },
    },
    Z3BF: {
      active: true,
      languages: {
        cs: {
          label: 'Zemědělské družstvo',
          abbreviations: [],
        },
      },
    },
    ZQO8: {
      active: true,
      languages: {
        cs: {
          label: 'Evropská společnost',
          abbreviations: ['SE'],
        },
      },
    },
    ZU32: {
      active: true,
      languages: {
        cs: {
          label: 'Jiné družstvo',
          abbreviations: [],
        },
      },
    },
  },
  DK: {
    '1MWR': {
      active: true,
      languages: {
        da: {
          label: 'Fond',
          abbreviations: [],
        },
      },
    },
    '37UT': {
      active: true,
      languages: {
        da: {
          label: 'Region',
          abbreviations: [],
        },
      },
    },
    '40R4': {
      active: true,
      languages: {
        da: {
          label: 'Forening',
          abbreviations: [],
        },
      },
    },
    '599X': {
      active: true,
      languages: {
        da: {
          label: 'Fonde og andre selvejende institutioner',
          abbreviations: [],
        },
      },
    },
    '5QS7': {
      active: true,
      languages: {
        da: {
          label: 'Iværksætterselskab',
          abbreviations: ['IVS'],
        },
      },
    },
    '7WRN': {
      active: true,
      languages: {
        da: {
          label: 'Interessentskab',
          abbreviations: ['I/S'],
        },
      },
    },
    '9KSX': {
      active: true,
      languages: {
        da: {
          label: 'Partnerselskab',
          abbreviations: ['P/S'],
        },
      },
    },
    D4PU: {
      active: true,
      languages: {
        da: {
          label: 'Frivillig forening',
          abbreviations: [],
        },
      },
    },
    F7JY: {
      active: true,
      languages: {
        da: {
          label: 'Særlig Finansiel virksomhed',
          abbreviations: [],
        },
      },
    },
    FUKI: {
      active: true,
      languages: {
        da: {
          label: 'Enkeltmandsvirksomhed',
          abbreviations: [],
        },
      },
    },
    FW7S: {
      active: true,
      languages: {
        da: {
          label: 'Europæisk andelsselskab',
          abbreviations: ['SCE-selskab'],
        },
      },
    },
    GFXN: {
      active: true,
      languages: {
        da: {
          label: 'Primærkommune',
          abbreviations: [],
        },
      },
    },
    GULL: {
      active: true,
      languages: {
        da: {
          label: 'Selskab med begrænset ansvar',
          abbreviations: ['SMBA'],
        },
      },
    },
    H8VP: {
      active: true,
      languages: {
        da: {
          label: 'Anpartsselskab',
          abbreviations: ['ApS'],
        },
      },
    },
    LWOD: {
      active: true,
      languages: {
        da: {
          label: 'Medarbejderinvesteringsselskab',
          abbreviations: [],
        },
      },
    },
    NUL8: {
      active: true,
      languages: {
        da: {
          label: 'Kommanditselskab',
          abbreviations: ['K/S'],
        },
      },
    },
    PIOI: {
      active: true,
      languages: {
        da: {
          label: 'Erhvervsdrivende fond',
          abbreviations: [],
        },
      },
    },
    PMJW: {
      active: true,
      languages: {
        da: {
          label: 'Andelsselskab',
          abbreviations: [],
        },
      },
    },
    PZ6Y: {
      active: true,
      languages: {
        da: {
          label: 'Andelsselskab med begrænset ansvar',
          abbreviations: ['AMBA'],
        },
      },
    },
    TB2C: {
      active: true,
      languages: {
        da: {
          label: 'Europæisk økonomisk firmagruppe',
          abbreviations: ['EØFG'],
        },
      },
    },
    UA1O: {
      active: true,
      languages: {
        da: {
          label: 'Europæisk selskab',
          abbreviations: ['SE-selskab'],
        },
      },
    },
    WU7R: {
      active: true,
      languages: {
        da: {
          label: 'Forening med begrænset ansvar',
          abbreviations: ['FMBA'],
        },
      },
    },
    ZRPO: {
      active: true,
      languages: {
        da: {
          label: 'Aktieselskab',
          abbreviations: ['A/S'],
        },
      },
    },
  },
  DO: {
    '3ZBR': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anónima',
          abbreviations: ['S. A.'],
        },
      },
    },
    '8WQ9': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita Simple',
          abbreviations: ['S. en C.'],
        },
      },
    },
    B35X: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Participación(sin personalidad jurídica)',
          abbreviations: [],
        },
      },
    },
    DQAU: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anónima Simplificada',
          abbreviations: ['SAS'],
        },
      },
    },
    K4CD: {
      active: true,
      languages: {
        es: {
          label: 'Empresa Individual de Responsabilidad Limitada',
          abbreviations: ['EIRL'],
        },
      },
    },
    LSWY: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Nombre Colectivo',
          abbreviations: [],
        },
      },
    },
    SWO8: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Responsaibilidad Limitada',
          abbreviations: ['S. R. L.'],
        },
      },
    },
    T4LC: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita por Acciones',
          abbreviations: [],
        },
      },
    },
  },
  EC: {
    '6TPE': {
      active: true,
      languages: {
        es: {
          label: 'Compañía en nombre colectivo',
          abbreviations: ['CNCOL'],
        },
      },
    },
    FKVG: {
      active: true,
      languages: {
        es: {
          label: 'Compañía en Comandita Simple y dividida por acciones',
          abbreviations: ['CCSDA'],
        },
      },
    },
    J3T2: {
      active: true,
      languages: {
        es: {
          label: 'Compañía Anónima',
          abbreviations: ['SA'],
        },
      },
    },
    N9QH: {
      active: true,
      languages: {
        es: {
          label: 'Compañía de Economía Mixta',
          abbreviations: ['CEMIX'],
        },
      },
    },
    XOAD: {
      active: true,
      languages: {
        es: {
          label: 'Compañía de Responsabilidad Limitada',
          abbreviations: ['CIA LTDA'],
        },
      },
    },
  },
  EE: {
    '1NKP': {
      active: true,
      languages: {
        et: {
          label: 'Sihtasutus',
          abbreviations: ['SA'],
        },
      },
    },
    '3UPJ': {
      active: true,
      languages: {
        et: {
          label: 'Füüsilisest isikust ettevõtja',
          abbreviations: ['FIE'],
        },
      },
    },
    '6I0P': {
      active: true,
      languages: {
        et: {
          label: 'Hooneühistu',
          abbreviations: ['HÜ'],
        },
      },
    },
    '752Q': {
      active: true,
      languages: {
        et: {
          label: 'Euroopa äriühing',
          abbreviations: ['SE'],
        },
      },
    },
    '8ZQE': {
      active: true,
      languages: {
        et: {
          label: 'Korteriühistu',
          abbreviations: ['KÜ'],
        },
      },
    },
    '9LJA': {
      active: true,
      languages: {
        et: {
          label: 'Aktsiaselts',
          abbreviations: ['AS'],
        },
      },
    },
    BE56: {
      active: true,
      languages: {
        et: {
          label: 'Avalik-õiguslik juriidiline isik',
          abbreviations: [],
        },
      },
    },
    CKOS: {
      active: true,
      languages: {
        et: {
          label: 'Usuline ühendus',
          abbreviations: [],
        },
      },
    },
    GA3A: {
      active: true,
      languages: {
        et: {
          label: 'Erakond',
          abbreviations: [],
        },
      },
    },
    I1UP: {
      active: true,
      languages: {
        et: {
          label: 'Täisühing',
          abbreviations: ['TÜ'],
        },
      },
    },
    J34T: {
      active: true,
      languages: {
        et: {
          label: 'Ametiühing',
          abbreviations: ['AÜ'],
        },
      },
    },
    JC0Y: {
      active: true,
      languages: {
        et: {
          label: 'Osaühing',
          abbreviations: ['OÜ'],
        },
      },
    },
    LA47: {
      active: true,
      languages: {
        et: {
          label: 'Euroopa majandushuviühing',
          abbreviations: ['EMHÜ'],
        },
      },
    },
    LVEQ: {
      active: true,
      languages: {
        et: {
          label: 'Usaldusühing',
          abbreviations: ['UÜ'],
        },
      },
    },
    PMOF: {
      active: true,
      languages: {
        et: {
          label: 'Loomeliit',
          abbreviations: [],
        },
      },
    },
    PRTB: {
      active: true,
      languages: {
        et: {
          label: 'Mittetulundusühing',
          abbreviations: ['MTÜ'],
        },
      },
    },
    RXTT: {
      active: true,
      languages: {
        et: {
          label: 'Euroopa ühistu',
          abbreviations: ['SCE'],
        },
      },
    },
    VSEV: {
      active: true,
      languages: {
        et: {
          label: 'Tulundusühistu',
          abbreviations: ['TÜH'],
        },
      },
    },
  },
  FI: {
    '1AFG': {
      active: true,
      languages: {
        fi: {
          label: 'Muu yhtiö',
          abbreviations: [],
        },
        sv: {
          label: 'Annat bolag',
          abbreviations: [],
        },
      },
    },
    '1YIR': {
      active: true,
      languages: {
        fi: {
          label: 'Metsänhoitoyhdistys',
          abbreviations: [],
        },
        sv: {
          label: 'Skogsvårdsförening',
          abbreviations: [],
        },
      },
    },
    '2RK5': {
      active: true,
      languages: {
        fi: {
          label: 'Kunta',
          abbreviations: [],
        },
        sv: {
          label: 'Kommun',
          abbreviations: [],
        },
      },
    },
    '37GR': {
      active: true,
      languages: {
        fi: {
          label: 'Elinkeinoyhtymä',
          abbreviations: [],
        },
        sv: {
          label: 'Näringssammanslutning',
          abbreviations: [],
        },
      },
    },
    '4H61': {
      active: true,
      languages: {
        fi: {
          label: 'Keskinäinen vakuutusyhtiö',
          abbreviations: [],
        },
        sv: {
          label: 'Ömsesidigt försäkringsbolag',
          abbreviations: [],
        },
      },
    },
    '5WI2': {
      active: true,
      languages: {
        fi: {
          label: 'Eläkesäätiö',
          abbreviations: [],
        },
        sv: {
          label: 'Pensionsstiftelse',
          abbreviations: [],
        },
      },
    },
    '6PEQ': {
      active: true,
      languages: {
        fi: {
          label: 'Paikallisyhteisö',
          abbreviations: [],
        },
        sv: {
          label: 'Lokalsamfund',
          abbreviations: [],
        },
      },
    },
    '760X': {
      active: true,
      languages: {
        fi: {
          label: 'Muu yhdistys',
          abbreviations: [],
        },
        sv: {
          label: 'Annan förening',
          abbreviations: [],
        },
      },
    },
    '883O': {
      active: false,
      languages: {
        fi: {
          label: 'Sivuliike',
          abbreviations: [],
        },
        sv: {
          label: 'Filial',
          abbreviations: [],
        },
      },
    },
    '8HGS': {
      active: true,
      languages: {
        fi: {
          label: 'Erityislainsäädäntöön perustuva yhdistys',
          abbreviations: [],
        },
        sv: {
          label: 'Förening som grundar sig på speciallagstiftning',
          abbreviations: [],
        },
      },
    },
    '8WJ7': {
      active: true,
      languages: {
        fi: {
          label: 'Keskinäinen kiinteistöosakeyhtiö',
          abbreviations: [],
        },
        sv: {
          label: 'Ömsesidigt fastighetsaktiebolag',
          abbreviations: [],
        },
      },
    },
    '97PB': {
      active: true,
      languages: {
        fi: {
          label: 'Vakuutuskassa',
          abbreviations: [],
        },
        sv: {
          label: 'Försäkringskassa',
          abbreviations: [],
        },
      },
    },
    '9AUC': {
      active: true,
      languages: {
        fi: {
          label: 'Vakuutusyhdistys',
          abbreviations: [],
        },
        sv: {
          label: 'Försäkringsförening',
          abbreviations: [],
        },
      },
    },
    AUPV: {
      active: true,
      languages: {
        fi: {
          label: 'Muu kiinteistöosakeyhtiö',
          abbreviations: [],
        },
        sv: {
          label: 'Annat fastighetsaktiebolag',
          abbreviations: [],
        },
      },
    },
    BKQO: {
      active: true,
      languages: {
        fi: {
          label: 'Valtio ja sen laitokset',
          abbreviations: [],
        },
        sv: {
          label: 'Staten och dess inrättningar',
          abbreviations: [],
        },
      },
    },
    BKVI: {
      active: true,
      languages: {
        fi: {
          label: 'Hypoteekkiyhdistys',
          abbreviations: [],
        },
        sv: {
          label: 'Hypoteksförening',
          abbreviations: [],
        },
      },
    },
    BQ19: {
      active: true,
      languages: {
        fi: {
          label: 'Laivanisännistöyhtiö',
          abbreviations: [],
        },
        sv: {
          label: 'Rederibolag',
          abbreviations: [],
        },
      },
    },
    C51L: {
      active: true,
      languages: {
        fi: {
          label: 'Eurooppalainen taloudellinen etuyhtymä sivutoimipaikka',
          abbreviations: [],
        },
        sv: {
          label: 'Filial för en europeisk ekonomisk intressegrupp',
          abbreviations: [],
        },
      },
    },
    DAFV: {
      active: true,
      languages: {
        fi: {
          label: 'Vakuutusosakeyhtiö',
          abbreviations: [],
        },
        sv: {
          label: 'Försäkringsaktiebolag',
          abbreviations: [],
        },
      },
    },
    DKUW: {
      active: true,
      languages: {
        fi: {
          label: 'Osakeyhtiö',
          abbreviations: ['oy'],
        },
        sv: {
          label: 'Aktiebolag',
          abbreviations: ['ab'],
        },
      },
    },
    DL9Z: {
      active: true,
      languages: {
        fi: {
          label: 'Ulkomainen yhteisö',
          abbreviations: [],
        },
        sv: {
          label: 'Utländskt samfund',
          abbreviations: [],
        },
      },
    },
    DMT8: {
      active: true,
      languages: {
        fi: {
          label: 'Työeläkekassa',
          abbreviations: [],
        },
        sv: {
          label: 'Arbetspensionskassa',
          abbreviations: [],
        },
      },
    },
    EDN7: {
      active: true,
      languages: {
        fi: {
          label: 'Taloudellinen yhdistys',
          abbreviations: [],
        },
        sv: {
          label: 'Ekonomisk förening',
          abbreviations: [],
        },
      },
    },
    EDZP: {
      active: true,
      languages: {
        fi: {
          label: 'Ylioppilaskunta tai osakunta',
          abbreviations: [],
        },
        sv: {
          label: 'Studentkår eller studentnation',
          abbreviations: [],
        },
      },
    },
    EE90: {
      active: true,
      languages: {
        fi: {
          label: 'Osuuskunta',
          abbreviations: ['osk'],
        },
        sv: {
          label: 'Andelslag',
          abbreviations: ['anl'],
        },
      },
    },
    EMC8: {
      active: true,
      languages: {
        fi: {
          label: 'Muu taloudellinen yhdistys',
          abbreviations: [],
        },
        sv: {
          label: 'Annan ekonomisk förening',
          abbreviations: [],
        },
      },
    },
    HBR3: {
      active: true,
      languages: {
        fi: {
          label: 'Julkinen keskinäinen vakuutusyhtiö',
          abbreviations: [],
        },
        sv: {
          label: 'Publikt ömsesidigt försäkringsaktiebolag',
          abbreviations: [],
        },
      },
    },
    HEOB: {
      active: true,
      languages: {
        fi: {
          label: 'Kommandiittiyhtiö',
          abbreviations: ['ky'],
        },
        sv: {
          label: 'Kommanditbolag',
          abbreviations: ['kb'],
        },
      },
    },
    HNWB: {
      active: true,
      languages: {
        fi: {
          label: 'Eurooppalainen taloudellinen etuyhtymä',
          abbreviations: ['ETEY'],
        },
        sv: {
          label: 'Europeisk ekonomisk intresseguppering',
          abbreviations: ['EEIG'],
        },
      },
    },
    HTT9: {
      active: true,
      languages: {
        fi: {
          label: 'Erillishallinnollinen valtion laitos',
          abbreviations: [],
        },
        sv: {
          label: 'Statlig inrättning med separat förvaltning',
          abbreviations: [],
        },
      },
    },
    IX7U: {
      active: true,
      languages: {
        fi: {
          label: 'Asukashallintoalue',
          abbreviations: [],
        },
        sv: {
          label: 'Boendeförvaltningsområde',
          abbreviations: [],
        },
      },
    },
    IYF9: {
      active: true,
      languages: {
        fi: {
          label: 'Evankelis-luterilainen kirkko',
          abbreviations: [],
        },
        sv: {
          label: 'Ev.luth. kyrkan',
          abbreviations: [],
        },
      },
    },
    JI3A: {
      active: true,
      languages: {
        fi: {
          label: 'Keskinäinen vahinkovakuutusyhdistys',
          abbreviations: [],
        },
        sv: {
          label: 'Ömsesidigt skadeförsäkringsförening',
          abbreviations: [],
        },
      },
    },
    K09E: {
      active: true,
      languages: {
        fi: {
          label: 'Yksityinen elinkeinonharjoittaja',
          abbreviations: [],
        },
        sv: {
          label: 'Enskild näringsidkare',
          abbreviations: [],
        },
      },
    },
    K2G8: {
      active: false,
      languages: {
        fi: {
          label: 'Muut oikeushenkilöt',
          abbreviations: [],
        },
        sv: {
          label: 'Övriga juridiska personer',
          abbreviations: [],
        },
      },
    },
    K6VE: {
      active: true,
      languages: {
        fi: {
          label: 'Julkinen osakeyhtiö',
          abbreviations: ['oyj'],
        },
        sv: {
          label: 'Publikt aktiebolag',
          abbreviations: ['abp'],
        },
      },
    },
    KHI5: {
      active: true,
      languages: {
        fi: {
          label: 'Julkinen vakuutusosakeyhtiö',
          abbreviations: [],
        },
        sv: {
          label: 'Publikt försäkringsaktiebolag',
          abbreviations: [],
        },
      },
    },
    L7XJ: {
      active: true,
      languages: {
        fi: {
          label: 'Paliskunta',
          abbreviations: [],
        },
        sv: {
          label: 'Renbeteslag',
          abbreviations: [],
        },
      },
    },
    LBQS: {
      active: true,
      languages: {
        fi: {
          label: 'Muu yhteisvastuullinen pidätysvelvollinen',
          abbreviations: [],
        },
        sv: {
          label: 'Annan solidariskt ansvarig innehållningspliktig',
          abbreviations: [],
        },
      },
    },
    MBPY: {
      active: true,
      languages: {
        fi: {
          label: 'Asumisoikeusyhdistys',
          abbreviations: [],
        },
        sv: {
          label: 'Boenderättsförening',
          abbreviations: [],
        },
      },
    },
    MRW9: {
      active: true,
      languages: {
        fi: {
          label: 'Muu julkisoikeudellinen oikeushenkilö',
          abbreviations: [],
        },
        sv: {
          label: 'Annan offentligrättslig juridisk person',
          abbreviations: [],
        },
      },
    },
    N3LC: {
      active: true,
      languages: {
        fi: {
          label: 'Rekisteröity uskonnollinen yhdyskunta',
          abbreviations: [],
        },
        sv: {
          label: 'Registrerat religiöst samfund',
          abbreviations: [],
        },
      },
    },
    NV7C: {
      active: true,
      languages: {
        fi: {
          label: 'Muu säätiö',
          abbreviations: [],
        },
        sv: {
          label: 'Annan stiftelse',
          abbreviations: [],
        },
      },
    },
    OXLO: {
      active: true,
      languages: {
        fi: {
          label: 'Valtion liikelaitos',
          abbreviations: [],
        },
        sv: {
          label: 'Statlig affärsinrättning',
          abbreviations: [],
        },
      },
    },
    PPMX: {
      active: true,
      languages: {
        fi: {
          label: 'Avoin yhtiö',
          abbreviations: [],
        },
        sv: {
          label: 'Öppet bolag',
          abbreviations: [],
        },
      },
    },
    R39F: {
      active: true,
      languages: {
        fi: {
          label: 'Kauppakamari',
          abbreviations: [],
        },
        sv: {
          label: 'Handelskammare',
          abbreviations: [],
        },
      },
    },
    R5ZC: {
      active: true,
      languages: {
        fi: {
          label: 'Eurooppaosuuskunnan kiinteä toimipaikka',
          abbreviations: [],
        },
        sv: {
          label: 'Fast driftställe för europeisk kooperativ förening',
          abbreviations: [],
        },
      },
    },
    R6UB: {
      active: true,
      languages: {
        fi: {
          label: 'Verotusyhtymä',
          abbreviations: [],
        },
        sv: {
          label: 'Beskattningssammanslutning',
          abbreviations: [],
        },
      },
    },
    SDPE: {
      active: true,
      languages: {
        fi: {
          label: 'Työttömyyskassa',
          abbreviations: [],
        },
        sv: {
          label: 'Arbetslöshetskassa',
          abbreviations: [],
        },
      },
    },
    SJL9: {
      active: true,
      languages: {
        fi: {
          label: 'Osuuspankki',
          abbreviations: [],
        },
        sv: {
          label: 'Andelsbank',
          abbreviations: [],
        },
      },
    },
    SKGX: {
      active: true,
      languages: {
        fi: {
          label: 'Yhteisetuudet',
          abbreviations: [],
        },
        sv: {
          label: 'Samfällda förmåner',
          abbreviations: [],
        },
      },
    },
    SQS1: {
      active: true,
      languages: {
        fi: {
          label: 'Ahvenanmaan maakunta ja sen virastot',
          abbreviations: [],
        },
        sv: {
          label: 'Lanskapet Åland och dess ämbetsverk',
          abbreviations: [],
        },
      },
    },
    SUHV: {
      active: true,
      languages: {
        fi: {
          label: 'Muu verotuksen yksikkö',
          abbreviations: [],
        },
        sv: {
          label: 'Annan enhet inom beskattningen',
          abbreviations: [],
        },
      },
    },
    T31U: {
      active: true,
      languages: {
        fi: {
          label: 'Kuntainliiton liikelaitos',
          abbreviations: [],
        },
        sv: {
          label: 'Kommunförbundets affärsinrättning',
          abbreviations: [],
        },
      },
    },
    T3K4: {
      active: true,
      languages: {
        fi: {
          label: 'Yhteismetsä',
          abbreviations: [],
        },
        sv: {
          label: 'Samfälld skog',
          abbreviations: [],
        },
      },
    },
    TZ1U: {
      active: true,
      languages: {
        fi: {
          label: 'Kunnallinen liikelaitos',
          abbreviations: [],
        },
        sv: {
          label: 'Kommunal affärsinrättning',
          abbreviations: [],
        },
      },
    },
    UAV1: {
      active: true,
      languages: {
        fi: {
          label: 'Eurooppaosuuskunta',
          abbreviations: ['SCE'],
        },
        sv: {
          label: 'Europaandelslag',
          abbreviations: ['SCE'],
        },
      },
    },
    UMF0: {
      active: true,
      languages: {
        fi: {
          label: 'Konkurssipesä',
          abbreviations: [],
        },
        sv: {
          label: 'Konkursbo',
          abbreviations: [],
        },
      },
    },
    UXEW: {
      active: true,
      languages: {
        fi: {
          label: 'Aatteellinen yhdistys',
          abbreviations: [],
        },
        sv: {
          label: 'Ideell förening',
          abbreviations: [],
        },
      },
    },
    V0TJ: {
      active: true,
      languages: {
        fi: {
          label: 'Asunto-osakeyhtiö',
          abbreviations: [],
        },
        sv: {
          label: 'Bostadsaktiebolag',
          abbreviations: [],
        },
      },
    },
    V42B: {
      active: true,
      languages: {
        fi: {
          label: 'Ortodoksinen kirkko',
          abbreviations: [],
        },
        sv: {
          label: 'Ortodoxa kyrkan',
          abbreviations: [],
        },
      },
    },
    VKKN: {
      active: true,
      languages: {
        fi: {
          label: 'Eurooppaosuuspankki',
          abbreviations: [],
        },
        sv: {
          label: 'Europaandelsbank',
          abbreviations: [],
        },
      },
    },
    VOTI: {
      active: true,
      languages: {
        fi: {
          label: 'Kuntayhtymä',
          abbreviations: [],
        },
        sv: {
          label: 'Samkommun',
          abbreviations: [],
        },
      },
    },
    XGKW: {
      active: true,
      languages: {
        fi: {
          label: 'Ahvenanmaan liikelaitos',
          abbreviations: [],
        },
        sv: {
          label: 'Ålands affärsverk',
          abbreviations: [],
        },
      },
    },
    XJH3: {
      active: true,
      languages: {
        fi: {
          label: 'Eurooppayhtiö',
          abbreviations: ['SE'],
        },
        sv: {
          label: 'Europabolag',
          abbreviations: ['SE'],
        },
      },
    },
    YK5G: {
      active: true,
      languages: {
        fi: {
          label: 'Säätiö',
          abbreviations: ['sr'],
        },
        sv: {
          label: 'Stiftelse',
          abbreviations: ['sr'],
        },
      },
    },
    Z38E: {
      active: true,
      languages: {
        fi: {
          label: 'Säästöpankki',
          abbreviations: [],
        },
        sv: {
          label: 'Sparbank',
          abbreviations: [],
        },
      },
    },
    ZMTL: {
      active: true,
      languages: {
        fi: {
          label: 'Kuolinpesä',
          abbreviations: [],
        },
        sv: {
          label: 'Dödsbo',
          abbreviations: [],
        },
      },
    },
  },
  FR: {
    '157O': {
      active: true,
      languages: {
        fr: {
          label: "Régie d'une collectivité locale à caractère administratif",
          abbreviations: [],
        },
      },
    },
    '1B88': {
      active: true,
      languages: {
        fr: {
          label: 'SCP de médecins',
          abbreviations: [],
        },
      },
    },
    '1GNM': {
      active: true,
      languages: {
        fr: {
          label: 'Syndicat de salariés',
          abbreviations: [],
        },
      },
    },
    '1L24': {
      active: true,
      languages: {
        fr: {
          label: 'Autre société civile',
          abbreviations: [],
        },
      },
    },
    '1NF1': {
      active: true,
      languages: {
        fr: {
          label: "SA nationale à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    '1Q16': {
      active: true,
      languages: {
        fr: {
          label: 'Société créée de fait entre personnes physiques',
          abbreviations: [],
        },
      },
    },
    '1Y0C': {
      active: true,
      languages: {
        fr: {
          label: "SARL d'attribution",
          abbreviations: [],
        },
      },
    },
    '211B': {
      active: true,
      languages: {
        fr: {
          label: 'Société coopérative agricole',
          abbreviations: [],
        },
      },
    },
    '29FA': {
      active: true,
      languages: {
        fr: {
          label: 'Institution interrégionale ou entente',
          abbreviations: [],
        },
      },
    },
    '2N4L': {
      active: true,
      languages: {
        fr: {
          label: '(Autre) Collectivité territoriale',
          abbreviations: [],
        },
      },
    },
    '2NL6': {
      active: false,
      languages: {
        fr: {
          label: 'État, collectivité ou établissement public étranger',
          abbreviations: [],
        },
      },
    },
    '2ONM': {
      active: true,
      languages: {
        fr: {
          label: "SA d'attribution à directoire",
          abbreviations: [],
        },
      },
    },
    '2WMP': {
      active: true,
      languages: {
        fr: {
          label: 'Autre personne morale de droit administratif',
          abbreviations: [],
        },
      },
    },
    '2XIK': {
      active: true,
      languages: {
        fr: {
          label: 'Mutuelle',
          abbreviations: [],
        },
      },
    },
    '34QS': {
      active: true,
      languages: {
        fr: {
          label: 'Autre personne morale de droit privé',
          abbreviations: [],
        },
      },
    },
    '3AZY': {
      active: true,
      languages: {
        fr: {
          label:
            "Coopérative d'utilisation de matériel agricole en commun (CUMA)",
          abbreviations: [],
        },
      },
    },
    '3FCU': {
      active: true,
      languages: {
        fr: {
          label: "Société d'exercice libéral par action simplifiée",
          abbreviations: [],
        },
      },
    },
    '3NJL': {
      active: true,
      languages: {
        fr: {
          label:
            'Autre personne de droit privé inscrite au registre du commerce et des sociétés',
          abbreviations: [],
        },
      },
    },
    '3OK3': {
      active: true,
      languages: {
        fr: {
          label: 'SCP de notaires',
          abbreviations: [],
        },
      },
    },
    '3S6E': {
      active: true,
      languages: {
        fr: {
          label: "Service départemental d'incendie et de secours (SDIS)",
          abbreviations: [],
        },
      },
    },
    '3XTE': {
      active: true,
      languages: {
        fr: {
          label: 'SARL coopérative de consommation',
          abbreviations: [],
        },
      },
    },
    '487E': {
      active: true,
      languages: {
        fr: {
          label: "Établissement public local d'enseignement",
          abbreviations: [],
        },
      },
    },
    '491H': {
      active: true,
      languages: {
        fr: {
          label: 'Association non déclarée',
          abbreviations: [],
        },
      },
    },
    '4DZU': {
      active: true,
      languages: {
        fr: {
          label: 'Autre SARL coopérative',
          abbreviations: [],
        },
      },
    },
    '4H0F': {
      active: true,
      languages: {
        fr: {
          label:
            'Autre établissement public local de coopération non spécialisé ou entente',
          abbreviations: [],
        },
      },
    },
    '4JS0': {
      active: true,
      languages: {
        fr: {
          label: 'Association syndicale autorisée',
          abbreviations: [],
        },
      },
    },
    '4RT7': {
      active: true,
      languages: {
        fr: {
          label: "SA de HLM à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    '4TNX': {
      active: false,
      languages: {
        fr: {
          label: 'Profession libérale',
          abbreviations: [],
        },
      },
    },
    '4VD7': {
      active: true,
      languages: {
        fr: {
          label: "Pôle d'équilibre territorial et rural (PETR)",
          abbreviations: [],
        },
      },
    },
    '59F9': {
      active: true,
      languages: {
        fr: {
          label: 'Groupement foncier agricole',
          abbreviations: [],
        },
      },
    },
    '5AJO': {
      active: true,
      languages: {
        fr: {
          label: "Caisse d'Épargne et de Prévoyance",
          abbreviations: [],
        },
      },
    },
    '5H68': {
      active: false,
      languages: {
        fr: {
          label: 'Commerçant',
          abbreviations: [],
        },
      },
    },
    '5K0Q': {
      active: true,
      languages: {
        fr: {
          label: 'Établissement public local social et médico-social',
          abbreviations: [],
        },
      },
    },
    '5VCF': {
      active: true,
      languages: {
        fr: {
          label: 'SA à directoire (s.a.i.)',
          abbreviations: [],
        },
      },
    },
    '61WE': {
      active: true,
      languages: {
        fr: {
          label: 'Institution de retraite supplémentaire',
          abbreviations: [],
        },
      },
    },
    '66JQ': {
      active: true,
      languages: {
        fr: {
          label: 'Syndicat de copropriété',
          abbreviations: [],
        },
      },
    },
    '6CHY': {
      active: true,
      languages: {
        fr: {
          label: 'Société par actions simplifiée',
          abbreviations: ['SAS'],
        },
      },
    },
    '6CJJ': {
      active: true,
      languages: {
        fr: {
          label: 'SCP de géomètres experts',
          abbreviations: [],
        },
      },
    },
    '6DYI': {
      active: true,
      languages: {
        fr: {
          label:
            'Société de Participations Financières de Profession Libérale Société à responsabilité limitée (SPFPL SARL)',
          abbreviations: [],
        },
      },
    },
    '6IIE': {
      active: true,
      languages: {
        fr: {
          label:
            "SA coopérative (d'intérêt) maritime à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    '6KWU': {
      active: true,
      languages: {
        fr: {
          label: "Société d'exercice libéral en commandite par actions",
          abbreviations: [],
        },
      },
    },
    '6RUE': {
      active: true,
      languages: {
        fr: {
          label: "Groupement européen d'intérêt économique (GEIE)",
          abbreviations: [],
        },
      },
    },
    '6SYJ': {
      active: true,
      languages: {
        fr: {
          label: 'SA de HLM à directoire',
          abbreviations: [],
        },
      },
    },
    '6YHU': {
      active: true,
      languages: {
        fr: {
          label:
            "SA d'intérêt collectif agricole (SICA) à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    '74HH': {
      active: true,
      languages: {
        fr: {
          label: 'SCP de vétérinaires',
          abbreviations: [],
        },
      },
    },
    '7O94': {
      active: true,
      languages: {
        fr: {
          label: 'Groupement forestier',
          abbreviations: [],
        },
      },
    },
    '7SZH': {
      active: false,
      languages: {
        fr: {
          label:
            'Autre groupement de droit privé non doté de la personnalité morale',
          abbreviations: [],
        },
      },
    },
    '7UHA': {
      active: true,
      languages: {
        fr: {
          label: "Collectivité et territoire d'Outre Mer",
          abbreviations: [],
        },
      },
    },
    '82QO': {
      active: true,
      languages: {
        fr: {
          label:
            "Service déconcentré de l'État à compétence (inter) départementale",
          abbreviations: [],
        },
      },
    },
    '87VO': {
      active: true,
      languages: {
        fr: {
          label: 'Safer anonyme à directoire',
          abbreviations: [],
        },
      },
    },
    '8FZW': {
      active: true,
      languages: {
        fr: {
          label: 'SCP de conseils juridiques',
          abbreviations: [],
        },
      },
    },
    '8G07': {
      active: false,
      languages: {
        fr: {
          label: '(Autre) Personne physique',
          abbreviations: [],
        },
      },
    },
    '8GTU': {
      active: true,
      languages: {
        fr: {
          label:
            "(Autre) Service déconcentré de l'État à compétence territoriale",
          abbreviations: [],
        },
      },
    },
    '8II5': {
      active: true,
      languages: {
        fr: {
          label: "Autre SA coopérative à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    '8IWA': {
      active: true,
      languages: {
        fr: {
          label: 'Commune associée et commune déléguée',
          abbreviations: [],
        },
      },
    },
    '8LX5': {
      active: true,
      languages: {
        fr: {
          label: 'Autre régime de prévoyance sociale',
          abbreviations: [],
        },
      },
    },
    '8OKM': {
      active: true,
      languages: {
        fr: {
          label:
            "Service déconcentré à compétence nationale d'un ministère (hors Défense)",
          abbreviations: [],
        },
      },
    },
    '8R2G': {
      active: true,
      languages: {
        fr: {
          label: 'Société civile immobilière de construction-vente',
          abbreviations: [],
        },
      },
    },
    '8TYA': {
      active: true,
      languages: {
        fr: {
          label: 'Autre SA coopérative à directoire',
          abbreviations: [],
        },
      },
    },
    '8VDW': {
      active: true,
      languages: {
        fr: {
          label: "Société d'assurance à forme mutuelle",
          abbreviations: [],
        },
      },
    },
    '8VWR': {
      active: true,
      languages: {
        fr: {
          label: "SA d'économie mixte à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    '8WH8': {
      active: false,
      languages: {
        fr: {
          label: 'Autre personne morale de droit étranger',
          abbreviations: [],
        },
      },
    },
    '8XDK': {
      active: true,
      languages: {
        fr: {
          label:
            "SA d'aménagement foncier et d'équipement rural (SAFER) à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    '94WO': {
      active: true,
      languages: {
        fr: {
          label: 'District urbain',
          abbreviations: [],
        },
      },
    },
    '97PZ': {
      active: true,
      languages: {
        fr: {
          label: "SARL coopérative d'intérêt maritime",
          abbreviations: [],
        },
      },
    },
    '9HC8': {
      active: true,
      languages: {
        fr: {
          label: 'Société en participation entre personnes physiques',
          abbreviations: [],
        },
      },
    },
    '9KU7': {
      active: true,
      languages: {
        fr: {
          label: 'Union de sociétés coopératives agricoles',
          abbreviations: [],
        },
      },
    },
    '9N1F': {
      active: true,
      languages: {
        fr: {
          label: "SA d'intérêt collectif agricole (SICA)",
          abbreviations: [],
        },
      },
    },
    '9O0S': {
      active: true,
      languages: {
        fr: {
          label: 'Association fonciére urbaine',
          abbreviations: [],
        },
      },
    },
    '9T5S': {
      active: true,
      languages: {
        fr: {
          label: 'Fondation',
          abbreviations: [],
        },
      },
    },
    A0VZ: {
      active: true,
      languages: {
        fr: {
          label: "SCP d'architectes",
          abbreviations: [],
        },
      },
    },
    AHBR: {
      active: true,
      languages: {
        fr: {
          label: 'SA à participation ouvrière à directoire',
          abbreviations: [],
        },
      },
    },
    AMFI: {
      active: true,
      languages: {
        fr: {
          label: 'Autorité constitutionnelle',
          abbreviations: [],
        },
      },
    },
    B645: {
      active: true,
      languages: {
        fr: {
          label: "SA d'attribution à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    B7I7: {
      active: true,
      languages: {
        fr: {
          label: "SA coopérative artisanale à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    BAK2: {
      active: true,
      languages: {
        fr: {
          label: 'Exploitation agricole à responsabilité limitée',
          abbreviations: [],
        },
      },
    },
    BAUQ: {
      active: true,
      languages: {
        fr: {
          label: "SA de crédit immobilier à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    BDDP: {
      active: true,
      languages: {
        fr: {
          label: "SCP d'infirmiers",
          abbreviations: [],
        },
      },
    },
    BEWI: {
      active: true,
      languages: {
        fr: {
          label: 'Association déclarée',
          abbreviations: [],
        },
      },
    },
    BRGA: {
      active: true,
      languages: {
        fr: {
          label: "SA immobilière d'investissement à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    BYZF: {
      active: true,
      languages: {
        fr: {
          label: 'Paroisse hors zone concordataire',
          abbreviations: [],
        },
      },
    },
    C42J: {
      active: true,
      languages: {
        fr: {
          label: 'SARL immobilière de gestion',
          abbreviations: [],
        },
      },
    },
    C4D7: {
      active: true,
      languages: {
        fr: {
          label: 'Ensemble urbain',
          abbreviations: [],
        },
      },
    },
    CAX5: {
      active: true,
      languages: {
        fr: {
          label: 'Régime général de la Sécurité Sociale',
          abbreviations: [],
        },
      },
    },
    CBO2: {
      active: true,
      languages: {
        fr: {
          label: 'Service du ministère de la Défense',
          abbreviations: [],
        },
      },
    },
    CF56: {
      active: true,
      languages: {
        fr: {
          label: 'Mutualité sociale agricole',
          abbreviations: [],
        },
      },
    },
    CNSS: {
      active: true,
      languages: {
        fr: {
          label: 'Société en participation de professions libérales',
          abbreviations: [],
        },
      },
    },
    CNXL: {
      active: false,
      languages: {
        fr: {
          label: 'Artisan-commerçant',
          abbreviations: [],
        },
      },
    },
    CQJI: {
      active: true,
      languages: {
        fr: {
          label: 'Région',
          abbreviations: [],
        },
      },
    },
    CVH6: {
      active: true,
      languages: {
        fr: {
          label: "SARL d'aménagement foncier et d'équipement rural (SAFER)",
          abbreviations: [],
        },
      },
    },
    D2I2: {
      active: true,
      languages: {
        fr: {
          label: 'Syndicat intercommunal à vocation multiple (SIVOM)',
          abbreviations: [],
        },
      },
    },
    DEG4: {
      active: true,
      languages: {
        fr: {
          label: 'Société en commandite par actions',
          abbreviations: [],
        },
      },
    },
    DRQM: {
      active: true,
      languages: {
        fr: {
          label: "SA coopérative de construction à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    DTAX: {
      active: true,
      languages: {
        fr: {
          label: 'Autre organisme mutualiste',
          abbreviations: [],
        },
      },
    },
    DWYD: {
      active: true,
      languages: {
        fr: {
          label: "Association déclarée d'insertion par l'économique",
          abbreviations: [],
        },
      },
    },
    DXQH: {
      active: true,
      languages: {
        fr: {
          label: 'Société civile foncière',
          abbreviations: [],
        },
      },
    },
    E0YF: {
      active: true,
      languages: {
        fr: {
          label: "SA coopérative d'intérêt maritime à directoire",
          abbreviations: [],
        },
      },
    },
    E6YB: {
      active: true,
      languages: {
        fr: {
          label: 'Caisse (fédérale) de crédit mutuel',
          abbreviations: [],
        },
      },
    },
    EABD: {
      active: true,
      languages: {
        fr: {
          label: 'Société civile coopérative entre médecins',
          abbreviations: [],
        },
      },
    },
    EAC8: {
      active: true,
      languages: {
        fr: {
          label:
            'Société coopérative de production de HLM anonyme à directoire',
          abbreviations: [],
        },
      },
    },
    ECUL: {
      active: true,
      languages: {
        fr: {
          label: 'Secteur de commune',
          abbreviations: [],
        },
      },
    },
    EVYY: {
      active: true,
      languages: {
        fr: {
          label: 'Caisse de crédit maritime mutuel',
          abbreviations: [],
        },
      },
    },
    EYRI: {
      active: true,
      languages: {
        fr: {
          label:
            'Centre technique industriel ou comité professionnel du développement économique',
          abbreviations: [],
        },
      },
    },
    F0B6: {
      active: true,
      languages: {
        fr: {
          label: 'Société en commandite simple coopérative',
          abbreviations: [],
        },
      },
    },
    F6SZ: {
      active: true,
      languages: {
        fr: {
          label: 'SA coopérative de production (SCOP) à directoire',
          abbreviations: [],
        },
      },
    },
    F72Z: {
      active: true,
      languages: {
        fr: {
          label:
            "Établissement public national à caractére industriel ou commercial doté d'un comptable public",
          abbreviations: [],
        },
      },
    },
    F8UD: {
      active: true,
      languages: {
        fr: {
          label: "SCP d'avoués d'appel",
          abbreviations: [],
        },
      },
    },
    F93F: {
      active: true,
      languages: {
        fr: {
          label:
            "SA immobilière pour le commerce et l'industrie (SICOMI) à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    FBYB: {
      active: false,
      languages: {
        fr: {
          label:
            "Représentation ou agence commerciale d'état ou organisme public étranger immatriculé au RCS",
          abbreviations: [],
        },
      },
    },
    FEEA: {
      active: true,
      languages: {
        fr: {
          label:
            "Établissement public national ayant fonction d'administration centrale",
          abbreviations: [],
        },
      },
    },
    FFQL: {
      active: true,
      languages: {
        fr: {
          label: 'Commune et commune nouvelle',
          abbreviations: [],
        },
      },
    },
    FKG2: {
      active: true,
      languages: {
        fr: {
          label: 'Organisation internationale',
          abbreviations: [],
        },
      },
    },
    FOUY: {
      active: true,
      languages: {
        fr: {
          label: 'SCP de commissaires aux comptes',
          abbreviations: [],
        },
      },
    },
    FY0F: {
      active: true,
      languages: {
        fr: {
          label: 'Société civile immobilière',
          abbreviations: [],
        },
      },
    },
    FYBN: {
      active: true,
      languages: {
        fr: {
          label: "SARL mixte d'intérêt agricole (SMIA)",
          abbreviations: [],
        },
      },
    },
    G7Z2: {
      active: true,
      languages: {
        fr: {
          label: 'SARL coopérative de construction',
          abbreviations: [],
        },
      },
    },
    G8LP: {
      active: true,
      languages: {
        fr: {
          label: 'Sociétés Interprofessionnelles de Soins Ambulatoires',
          abbreviations: [],
        },
      },
    },
    G98S: {
      active: true,
      languages: {
        fr: {
          label: 'Ordre professionnel ou assimilé',
          abbreviations: [],
        },
      },
    },
    GFN6: {
      active: true,
      languages: {
        fr: {
          label:
            "SA coopérative de commerçants-détaillants à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    GJJJ: {
      active: true,
      languages: {
        fr: {
          label:
            "Société d'exercice libéral à responsabilité limitée à associé unique",
          abbreviations: [],
        },
      },
    },
    GLN8: {
      active: true,
      languages: {
        fr: {
          label: "Centre Intercommunal d'action sociale (CIAS)",
          abbreviations: [],
        },
      },
    },
    GQV4: {
      active: true,
      languages: {
        fr: {
          label:
            "SA immobilière pour le commerce et l'industrie (SICOMI) à directoire",
          abbreviations: [],
        },
      },
    },
    GXL6: {
      active: true,
      languages: {
        fr: {
          label: "Autre établissement public national d'enseignement",
          abbreviations: [],
        },
      },
    },
    GZCQ: {
      active: true,
      languages: {
        fr: {
          label: 'SCP de greffiers de tribunal de commerce',
          abbreviations: [],
        },
      },
    },
    H1U2: {
      active: true,
      languages: {
        fr: {
          label: 'Société en nom collectif',
          abbreviations: [],
        },
      },
    },
    H3Z4: {
      active: true,
      languages: {
        fr: {
          label: 'SA coopérative de transport à directoire',
          abbreviations: [],
        },
      },
    },
    H3ZD: {
      active: true,
      languages: {
        fr: {
          label: "SARL d'intérêt collectif agricole (SICA)",
          abbreviations: [],
        },
      },
    },
    H4VR: {
      active: true,
      languages: {
        fr: {
          label: 'Société civile coopérative de consommation',
          abbreviations: [],
        },
      },
    },
    HA3N: {
      active: true,
      languages: {
        fr: {
          label: 'Caisse de crédit municipal',
          abbreviations: [],
        },
      },
    },
    HATI: {
      active: true,
      languages: {
        fr: {
          label: 'Association intermédiaire',
          abbreviations: [],
        },
      },
    },
    HC8N: {
      active: true,
      languages: {
        fr: {
          label: 'SARL union de sociétés coopératives',
          abbreviations: [],
        },
      },
    },
    HF2L: {
      active: true,
      languages: {
        fr: {
          label: 'Association de droit local (Bas-Rhin, Haut-Rhin et Moselle)',
          abbreviations: [],
        },
      },
    },
    HMEI: {
      active: true,
      languages: {
        fr: {
          label: 'Autre société civile coopérative',
          abbreviations: [],
        },
      },
    },
    HSYZ: {
      active: true,
      languages: {
        fr: {
          label: 'Autre société civile professionnelle',
          abbreviations: [],
        },
      },
    },
    I0MH: {
      active: true,
      languages: {
        fr: {
          label: 'Société civile coopérative de construction',
          abbreviations: [],
        },
      },
    },
    I8TE: {
      active: true,
      languages: {
        fr: {
          label: "SA mixte d'intérêt agricole (SMIA)",
          abbreviations: [],
        },
      },
    },
    IAP3: {
      active: true,
      languages: {
        fr: {
          label: 'Syndicat intercommunal à vocation unique (SIVU)',
          abbreviations: [],
        },
      },
    },
    IC8G: {
      active: true,
      languages: {
        fr: {
          label: "SCP d'avocats aux conseils",
          abbreviations: [],
        },
      },
    },
    IC98: {
      active: true,
      languages: {
        fr: {
          label: 'SCP de commissaires-priseurs',
          abbreviations: [],
        },
      },
    },
    IF7H: {
      active: true,
      languages: {
        fr: {
          label: "SA coopérative de consommation à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    IGSV: {
      active: false,
      languages: {
        fr: {
          label: 'Société civile laitière',
          abbreviations: [],
        },
      },
    },
    IQR2: {
      active: true,
      languages: {
        fr: {
          label: "Société civile d'intérêt collectif agricole (SICA)",
          abbreviations: [],
        },
      },
    },
    J9OZ: {
      active: true,
      languages: {
        fr: {
          label: "Société d'exercice libéral à responsabilité limitée",
          abbreviations: [],
        },
      },
    },
    JBIQ: {
      active: true,
      languages: {
        fr: {
          label: 'Institution de prévoyance',
          abbreviations: [],
        },
      },
    },
    JFET: {
      active: true,
      languages: {
        fr: {
          label:
            'Société de Participations Financières de Profession Libérale Société anonyme à Directoire (SPFPL SA à directoire)',
          abbreviations: [],
        },
      },
    },
    JIYK: {
      active: true,
      languages: {
        fr: {
          label: 'Syndicat inter hospitalier',
          abbreviations: [],
        },
      },
    },
    JM1W: {
      active: true,
      languages: {
        fr: {
          label: 'SCP de dentistes',
          abbreviations: [],
        },
      },
    },
    JMO0: {
      active: true,
      languages: {
        fr: {
          label:
            'Commission syndicale pour la gestion des biens indivis des communes',
          abbreviations: [],
        },
      },
    },
    JN2P: {
      active: false,
      languages: {
        fr: {
          label: 'SARL unipersonnelle',
          abbreviations: [],
        },
      },
    },
    JR7T: {
      active: true,
      languages: {
        fr: {
          label: 'SARL nationale',
          abbreviations: [],
        },
      },
    },
    JU82: {
      active: true,
      languages: {
        fr: {
          label: 'Ministére',
          abbreviations: [],
        },
      },
    },
    K39X: {
      active: true,
      languages: {
        fr: {
          label: "SA union de sociétés coopératives à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    K5KA: {
      active: true,
      languages: {
        fr: {
          label:
            "Régie d'une collectivité locale à caractère industriel ou commercial",
          abbreviations: [],
        },
      },
    },
    K65D: {
      active: true,
      languages: {
        fr: {
          label: "SA à conseil d'administration (s.a.i.)",
          abbreviations: [],
        },
      },
    },
    K69X: {
      active: true,
      languages: {
        fr: {
          label: 'SA de crédit immobilier à directoire',
          abbreviations: [],
        },
      },
    },
    K7XQ: {
      active: true,
      languages: {
        fr: {
          label:
            'Établissement public national à caractére scientifique culturel et professionnel',
          abbreviations: [],
        },
      },
    },
    K99N: {
      active: true,
      languages: {
        fr: {
          label: 'Comité social économique d’établissement',
          abbreviations: [],
        },
      },
    },
    KBEQ: {
      active: true,
      languages: {
        fr: {
          label:
            "Société civile immobilière d' accession progressive à la propriété",
          abbreviations: [],
        },
      },
    },
    KCN5: {
      active: true,
      languages: {
        fr: {
          label:
            'Etablissement public administratif, cercle et foyer dans les armées',
          abbreviations: [],
        },
      },
    },
    KFR1: {
      active: false,
      languages: {
        fr: {
          label: 'Artisan',
          abbreviations: [],
        },
      },
    },
    KMPN: {
      active: true,
      languages: {
        fr: {
          label: 'Établissement public national à caractére administratif',
          abbreviations: [],
        },
      },
    },
    KQH7: {
      active: true,
      languages: {
        fr: {
          label: "Société civile d'attribution",
          abbreviations: [],
        },
      },
    },
    KS9B: {
      active: true,
      languages: {
        fr: {
          label: 'Syndicat patronal',
          abbreviations: [],
        },
      },
    },
    KWI4: {
      active: true,
      languages: {
        fr: {
          label: 'SCP de masseurs-kinésithérapeutes',
          abbreviations: [],
        },
      },
    },
    L25Z: {
      active: true,
      languages: {
        fr: {
          label:
            "Société anonyme mixte d'intérêt agricole (SMIA) à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    L6QO: {
      active: true,
      languages: {
        fr: {
          label: 'Régime spécial de Sécurité Sociale',
          abbreviations: [],
        },
      },
    },
    LARO: {
      active: false,
      languages: {
        fr: {
          label:
            'Société par actions simplifiée à associé unique ou société par actions simplifiée unipersonnelle',
          abbreviations: [],
        },
      },
    },
    LGME: {
      active: true,
      languages: {
        fr: {
          label: "SA à participation ouvrière à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    LU8S: {
      active: false,
      languages: {
        fr: {
          label: 'Associé gérant de Société',
          abbreviations: [],
        },
      },
    },
    LUIN: {
      active: true,
      languages: {
        fr: {
          label: "SARL immobilière pour le commerce et l'industrie (SICOMI)",
          abbreviations: [],
        },
      },
    },
    M1BJ: {
      active: true,
      languages: {
        fr: {
          label: 'Société civile de moyens',
          abbreviations: [],
        },
      },
    },
    M673: {
      active: true,
      languages: {
        fr: {
          label: "Société civile d'exploitation agricole",
          abbreviations: [],
        },
      },
    },
    MG2O: {
      active: true,
      languages: {
        fr: {
          label: 'Institution interdépartementale ou entente',
          abbreviations: [],
        },
      },
    },
    MMA4: {
      active: true,
      languages: {
        fr: {
          label: 'SA union de sociétés coopératives à directoire',
          abbreviations: [],
        },
      },
    },
    MOUL: {
      active: true,
      languages: {
        fr: {
          label: 'Assurance mutuelle agricole',
          abbreviations: [],
        },
      },
    },
    MQPZ: {
      active: true,
      languages: {
        fr: {
          label: "Caisse d'épargne et de prévoyance à forme coopérative",
          abbreviations: [],
        },
      },
    },
    MQU9: {
      active: true,
      languages: {
        fr: {
          label:
            'Organisme de placement collectif en valeurs mobilières sans personnalité morale',
          abbreviations: [],
        },
      },
    },
    MX8J: {
      active: true,
      languages: {
        fr: {
          label: 'SA coopérative de commerçants-détaillants à directoire',
          abbreviations: [],
        },
      },
    },
    NBA8: {
      active: true,
      languages: {
        fr: {
          label:
            'Autre établissement public national administratif à compétence territoriale limitée',
          abbreviations: [],
        },
      },
    },
    NFCV: {
      active: true,
      languages: {
        fr: {
          label:
            'Association coopérative inscrite (droit local Alsace Moselle)',
          abbreviations: [],
        },
      },
    },
    NM07: {
      active: true,
      languages: {
        fr: {
          label: "SA immobilière d'investissement à directoire",
          abbreviations: [],
        },
      },
    },
    NOI8: {
      active: true,
      languages: {
        fr: {
          label: "Communauté d'agglomération",
          abbreviations: [],
        },
      },
    },
    NQCT: {
      active: true,
      languages: {
        fr: {
          label: '(Autre) Établissement public administratif local',
          abbreviations: [],
        },
      },
    },
    NUMY: {
      active: true,
      languages: {
        fr: {
          label: 'SA coopérative artisanale à directoire',
          abbreviations: [],
        },
      },
    },
    OAGA: {
      active: true,
      languages: {
        fr: {
          label:
            'Régime vieillesse ne dépendant pas du régime général de la Sécurité Sociale',
          abbreviations: [],
        },
      },
    },
    OIQA: {
      active: true,
      languages: {
        fr: {
          label: 'Autre organisme professionnel',
          abbreviations: [],
        },
      },
    },
    OLJ1: {
      active: true,
      languages: {
        fr: {
          label: 'Syndicat mixte fermé',
          abbreviations: [],
        },
      },
    },
    OSLZ: {
      active: true,
      languages: {
        fr: {
          label: 'Société coopérative de banque populaire',
          abbreviations: [],
        },
      },
    },
    OWUN: {
      active: true,
      languages: {
        fr: {
          label: 'Communauté de communes',
          abbreviations: [],
        },
      },
    },
    P3J5: {
      active: true,
      languages: {
        fr: {
          label: "Centre communal d'action sociale",
          abbreviations: [],
        },
      },
    },
    P714: {
      active: true,
      languages: {
        fr: {
          label: 'Association fonciére de remembrement',
          abbreviations: [],
        },
      },
    },
    PESN: {
      active: true,
      languages: {
        fr: {
          label: 'Indivision avec personne morale',
          abbreviations: [],
        },
      },
    },
    PL6V: {
      active: true,
      languages: {
        fr: {
          label: 'Établissement public local culturel',
          abbreviations: [],
        },
      },
    },
    PWKL: {
      active: true,
      languages: {
        fr: {
          label: 'Congrégation',
          abbreviations: [],
        },
      },
    },
    PZLG: {
      active: true,
      languages: {
        fr: {
          label: 'Métropole',
          abbreviations: [],
        },
      },
    },
    Q2A1: {
      active: false,
      languages: {
        fr: {
          label: 'Société commerciale étrangère immatriculée au RCS',
          abbreviations: [],
        },
      },
    },
    Q634: {
      active: true,
      languages: {
        fr: {
          label: 'Indivision entre personnes physiques',
          abbreviations: [],
        },
      },
    },
    Q8E2: {
      active: true,
      languages: {
        fr: {
          label: 'Société en nom collectif coopérative',
          abbreviations: [],
        },
      },
    },
    QCWO: {
      active: true,
      languages: {
        fr: {
          label: "Groupement agricole d'exploitation en commun (GAEC)",
          abbreviations: [],
        },
      },
    },
    QU3G: {
      active: true,
      languages: {
        fr: {
          label:
            "SA coopérative de production de HLM à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    QUB4: {
      active: true,
      languages: {
        fr: {
          label: 'Organisme consulaire',
          abbreviations: [],
        },
      },
    },
    QV2O: {
      active: true,
      languages: {
        fr: {
          label: "Société d'exercice libéral à forme anonyme à directoire",
          abbreviations: [],
        },
      },
    },
    QVPB: {
      active: true,
      languages: {
        fr: {
          label: 'Société anonyme',
          abbreviations: ['SA'],
        },
      },
    },
    R0B6: {
      active: true,
      languages: {
        fr: {
          label: "Groupement d'intérêt économique (GIE)",
          abbreviations: [],
        },
      },
    },
    R1JO: {
      active: true,
      languages: {
        fr: {
          label: 'Communauté urbaine',
          abbreviations: [],
        },
      },
    },
    R59A: {
      active: true,
      languages: {
        fr: {
          label: 'Société en commandite par actions coopérative',
          abbreviations: [],
        },
      },
    },
    R6WQ: {
      active: true,
      languages: {
        fr: {
          label: 'Groupement de coopération sanitaire à gestion publique',
          abbreviations: [],
        },
      },
    },
    RD0Z: {
      active: true,
      languages: {
        fr: {
          label: 'Fiducie',
          abbreviations: [],
        },
      },
    },
    RFWH: {
      active: true,
      languages: {
        fr: {
          label: 'Groupement foncier et rural',
          abbreviations: [],
        },
      },
    },
    RNJZ: {
      active: true,
      languages: {
        fr: {
          label:
            'Société de Participations Financières de Profession Libérale Société en commandite par actions (SPFPL SCA)',
          abbreviations: [],
        },
      },
    },
    RNSB: {
      active: false,
      languages: {
        fr: {
          label: 'Société étrangère non immatriculée au RCS',
          abbreviations: [],
        },
      },
    },
    RT39: {
      active: true,
      languages: {
        fr: {
          label: 'Société créée de fait avec personne morale',
          abbreviations: [],
        },
      },
    },
    RT6Y: {
      active: false,
      languages: {
        fr: {
          label: 'Agent commercial',
          abbreviations: [],
        },
      },
    },
    RWMC: {
      active: true,
      languages: {
        fr: {
          label: 'Communauté de villes',
          abbreviations: [],
        },
      },
    },
    S0X8: {
      active: true,
      languages: {
        fr: {
          label: 'Caisse de crédit agricole mutuel',
          abbreviations: [],
        },
      },
    },
    S82R: {
      active: true,
      languages: {
        fr: {
          label:
            'Société de Participations Financières de Profession Libérale Société par actions simplifiée (SPFPL SAS)',
          abbreviations: [],
        },
      },
    },
    SMZ6: {
      active: true,
      languages: {
        fr: {
          label:
            "Société de Participations Financières de Profession Libérale Société anonyme à conseil d'administration (SPFPL SA à conseil d'administration)",
          abbreviations: [],
        },
      },
    },
    SOXQ: {
      active: true,
      languages: {
        fr: {
          label: 'Société en libre partenariat',
          abbreviations: ['SLP'],
        },
      },
    },
    SSHN: {
      active: true,
      languages: {
        fr: {
          label: "Régime d'assurance chômage",
          abbreviations: [],
        },
      },
    },
    SWPX: {
      active: true,
      languages: {
        fr: {
          label: "SA coopérative de transport à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    SZ63: {
      active: true,
      languages: {
        fr: {
          label: "Service déconcentré de l'État à compétence (inter) régionale",
          abbreviations: [],
        },
      },
    },
    T25Y: {
      active: true,
      languages: {
        fr: {
          label: "SCP d'avocats",
          abbreviations: [],
        },
      },
    },
    TGRE: {
      active: true,
      languages: {
        fr: {
          label: 'Caisse des écoles',
          abbreviations: [],
        },
      },
    },
    TNPO: {
      active: false,
      languages: {
        fr: {
          label: 'Exploitant agricole',
          abbreviations: [],
        },
      },
    },
    TOL2: {
      active: true,
      languages: {
        fr: {
          label: 'SA nationale à directoire',
          abbreviations: [],
        },
      },
    },
    TPNT: {
      active: true,
      languages: {
        fr: {
          label: 'Société européenne',
          abbreviations: ['SE'],
        },
      },
    },
    TUE5: {
      active: true,
      languages: {
        fr: {
          label: "Office public d'habitation à loyer modéré (OPHLM)",
          abbreviations: [],
        },
      },
    },
    UFM7: {
      active: true,
      languages: {
        fr: {
          label: 'SA coopérative de construction à directoire',
          abbreviations: [],
        },
      },
    },
    UHKH: {
      active: true,
      languages: {
        fr: {
          label: 'Société de caution mutuelle',
          abbreviations: [],
        },
      },
    },
    UQRY: {
      active: true,
      languages: {
        fr: {
          label: 'Ecole nationale non dotée de la personnalité morale',
          abbreviations: [],
        },
      },
    },
    UUT8: {
      active: true,
      languages: {
        fr: {
          label: "SCP de directeurs de laboratoire d'analyse médicale",
          abbreviations: [],
        },
      },
    },
    UV02: {
      active: true,
      languages: {
        fr: {
          label: "Service central d'un ministère",
          abbreviations: [],
        },
      },
    },
    UZY3: {
      active: true,
      languages: {
        fr: {
          label: "Établissement d'hospitalisation",
          abbreviations: [],
        },
      },
    },
    V1Z5: {
      active: true,
      languages: {
        fr: {
          label: 'SARL coopérative de production (SCOP)',
          abbreviations: [],
        },
      },
    },
    V5SV: {
      active: true,
      languages: {
        fr: {
          label: "Société civile coopérative d'intérêt maritime",
          abbreviations: [],
        },
      },
    },
    V6G1: {
      active: true,
      languages: {
        fr: {
          label: 'Régime maladie des non-salariés non agricoles',
          abbreviations: [],
        },
      },
    },
    V9QP: {
      active: true,
      languages: {
        fr: {
          label: 'Société à responsabilité limitée (sans autre indication)',
          abbreviations: [],
        },
      },
    },
    VBC7: {
      active: true,
      languages: {
        fr: {
          label: 'Institution Banque de France',
          abbreviations: [],
        },
      },
    },
    VBQP: {
      active: true,
      languages: {
        fr: {
          label: 'Fonds à forme sociétale à directoire',
          abbreviations: [],
        },
      },
    },
    VD7Z: {
      active: true,
      languages: {
        fr: {
          label: 'Société en commandite simple',
          abbreviations: [],
        },
      },
    },
    VJV5: {
      active: true,
      languages: {
        fr: {
          label: "SARL d'économie mixte",
          abbreviations: [],
        },
      },
    },
    VO18: {
      active: true,
      languages: {
        fr: {
          label:
            'Établissement public local à caractére industriel ou commercial',
          abbreviations: [],
        },
      },
    },
    VTFS: {
      active: true,
      languages: {
        fr: {
          label: 'SARL coopérative artisanale',
          abbreviations: [],
        },
      },
    },
    W3LD: {
      active: true,
      languages: {
        fr: {
          label: 'Groupement agricole foncier',
          abbreviations: [],
        },
      },
    },
    W4G1: {
      active: true,
      languages: {
        fr: {
          label: 'SARL coopérative de transport',
          abbreviations: [],
        },
      },
    },
    WGCY: {
      active: true,
      languages: {
        fr: {
          label: "Groupement d'employeurs",
          abbreviations: [],
        },
      },
    },
    WXNU: {
      active: true,
      languages: {
        fr: {
          label: "SCP d'huissiers",
          abbreviations: [],
        },
      },
    },
    X78I: {
      active: true,
      languages: {
        fr: {
          label: "Fonds à forme sociétale à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    XH8C: {
      active: true,
      languages: {
        fr: {
          label: "Association déclarée, reconnue d'utilité publique",
          abbreviations: [],
        },
      },
    },
    XK4T: {
      active: true,
      languages: {
        fr: {
          label: 'Comité social économique d’entreprise',
          abbreviations: [],
        },
      },
    },
    XPX6: {
      active: true,
      languages: {
        fr: {
          label:
            "SA coopérative de production (SCOP) à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    XQBA: {
      active: true,
      languages: {
        fr: {
          label: 'Société en participation avec personne morale',
          abbreviations: [],
        },
      },
    },
    Y1W1: {
      active: true,
      languages: {
        fr: {
          label: 'Section de commune',
          abbreviations: [],
        },
      },
    },
    Y4VA: {
      active: true,
      languages: {
        fr: {
          label: 'Département',
          abbreviations: [],
        },
      },
    },
    Y7G8: {
      active: true,
      languages: {
        fr: {
          label: 'Caisse locale de crédit mutuel',
          abbreviations: [],
        },
      },
    },
    Y8WC: {
      active: true,
      languages: {
        fr: {
          label: 'Groupement de coopération sanitaire à gestion privée',
          abbreviations: [],
        },
      },
    },
    YADL: {
      active: true,
      languages: {
        fr: {
          label: 'Autorité administrative ou publique indépendante',
          abbreviations: [],
        },
      },
    },
    YHI5: {
      active: true,
      languages: {
        fr: {
          label: 'Pôle métropolitain',
          abbreviations: [],
        },
      },
    },
    YJM5: {
      active: false,
      languages: {
        fr: {
          label: 'Officier public ou ministériel',
          abbreviations: [],
        },
      },
    },
    YUCL: {
      active: true,
      languages: {
        fr: {
          label: 'Institution de retraite complémentaire',
          abbreviations: [],
        },
      },
    },
    YX4E: {
      active: true,
      languages: {
        fr: {
          label: 'Société civile de placement collectif immobilier (SCPI)',
          abbreviations: [],
        },
      },
    },
    Z0JP: {
      active: true,
      languages: {
        fr: {
          label:
            "Établissement public national à caractére industriel ou commercial non doté d'un comptable public",
          abbreviations: [],
        },
      },
    },
    Z2FQ: {
      active: true,
      languages: {
        fr: {
          label: "Groupement d'intérêt public (GIP)",
          abbreviations: [],
        },
      },
    },
    Z5WG: {
      active: true,
      languages: {
        fr: {
          label: 'Groupement pastoral',
          abbreviations: [],
        },
      },
    },
    Z9K8: {
      active: true,
      languages: {
        fr: {
          label:
            "Association d'avocats à responsabilité professionnelle individuelle",
          abbreviations: [],
        },
      },
    },
    ZECH: {
      active: true,
      languages: {
        fr: {
          label: 'Syndicat mixte ouvert',
          abbreviations: [],
        },
      },
    },
    ZM5P: {
      active: true,
      languages: {
        fr: {
          label: "SA d'économie mixte à directoire",
          abbreviations: [],
        },
      },
    },
    ZPEZ: {
      active: true,
      languages: {
        fr: {
          label: 'Association syndicale libre',
          abbreviations: [],
        },
      },
    },
    ZQ9B: {
      active: true,
      languages: {
        fr: {
          label: 'Exploitant public',
          abbreviations: [],
        },
      },
    },
    ZQIT: {
      active: true,
      languages: {
        fr: {
          label: 'SA coopérative de consommation à directoire',
          abbreviations: [],
        },
      },
    },
    ZXHJ: {
      active: true,
      languages: {
        fr: {
          label:
            "Société d'exercice libéral à forme anonyme à conseil d'administration",
          abbreviations: [],
        },
      },
    },
    ZY9X: {
      active: true,
      languages: {
        fr: {
          label: 'Entrepreneur individuel',
          abbreviations: [],
        },
      },
    },
    ZZ0X: {
      active: true,
      languages: {
        fr: {
          label: "Établissement public des cultes d'Alsace-Lorraine",
          abbreviations: [],
        },
      },
    },
  },
  DE: {
    '13AV': {
      active: true,
      languages: {
        de: {
          label: 'Versicherungsverein auf Gegenseitigkeit',
          abbreviations: ['VVaG'],
        },
      },
    },
    '2HBR': {
      active: true,
      languages: {
        de: {
          label: 'Gesellschaft mit beschränkter Haftung',
          abbreviations: ['GmbH'],
        },
      },
    },
    '2YZO': {
      active: true,
      languages: {
        de: {
          label: 'Partnerschaftsgesellschaft mit beschränkter Berufshaftung',
          abbreviations: ['PartG mbB'],
        },
      },
    },
    '40DB': {
      active: true,
      languages: {
        de: {
          label: 'Offene Handelsgesellschaft',
          abbreviations: ['OHG', 'OHG mbH', 'AG & Co. OHG', 'GmbH & Co. OHG'],
        },
      },
    },
    '63KS': {
      active: true,
      languages: {
        de: {
          label: 'Unternehmergesellschaft',
          abbreviations: ['GmbH UG'],
        },
      },
    },
    '6QQB': {
      active: true,
      languages: {
        de: {
          label: 'Aktiengesellschaft',
          abbreviations: ['AG'],
        },
      },
    },
    '79H0': {
      active: true,
      languages: {
        de: {
          label: 'Nicht eingetragener Verein',
          abbreviations: [],
        },
      },
    },
    '7J3S': {
      active: true,
      languages: {
        de: {
          label: 'Wirtschaftlicher Verein',
          abbreviations: [],
        },
      },
    },
    '8CM0': {
      active: true,
      languages: {
        de: {
          label: 'Partnerschaftsgesellschaft',
          abbreviations: ['PartG'],
        },
      },
    },
    '8Z6G': {
      active: true,
      languages: {
        de: {
          label: 'Kommanditgesellschaft',
          abbreviations: [
            'KG',
            'GmbH & Co. KG',
            'KGaA & Co. KG',
            'Stiftung & Co. KG',
          ],
        },
      },
    },
    '9JGX': {
      active: true,
      languages: {
        de: {
          label: 'Landesinnungsverband',
          abbreviations: [],
        },
      },
    },
    AMKW: {
      active: true,
      languages: {
        de: {
          label: 'REIT-Aktiengesellschaft',
          abbreviations: ['REIT-AG'],
        },
      },
    },
    AZFE: {
      active: true,
      languages: {
        de: {
          label: 'Eingetragene Genossenschaft',
          abbreviations: ['eG'],
        },
      },
    },
    D40E: {
      active: true,
      languages: {
        de: {
          label: 'Verein alten Rechts',
          abbreviations: [],
        },
      },
    },
    FEBD: {
      active: true,
      languages: {
        de: {
          label: 'Stiftung des öffentlichen Rechts',
          abbreviations: [],
        },
      },
    },
    FR3V: {
      active: true,
      languages: {
        de: {
          label: 'Gesellschaft bürgerlichen Rechts',
          abbreviations: ['GbR'],
        },
      },
    },
    JMVF: {
      active: true,
      languages: {
        de: {
          label: 'Investmentaktiengesellschaft',
          abbreviations: ['InvAG'],
        },
      },
    },
    JNDX: {
      active: true,
      languages: {
        de: {
          label: 'Europäische wirtschaftliche Interessenvereinigung',
          abbreviations: ['EWIV'],
        },
      },
    },
    OL20: {
      active: true,
      languages: {
        de: {
          label:
            'Einzelunternehmen, eingetragener Kaufmann, eingetragene Kauffrau',
          abbreviations: ['eK', 'e. Kffr', 'e. Kfm.'],
        },
      },
    },
    QZ3L: {
      active: true,
      languages: {
        de: {
          label: 'Eingetragener Verein',
          abbreviations: ['eV'],
        },
      },
    },
    SCE1: {
      active: true,
      languages: {
        de: {
          label: 'Gemeinnützige Gesellschaft mit beschränkter Haftung',
          abbreviations: ['gGmbH'],
        },
      },
    },
    SGST: {
      active: true,
      languages: {
        de: {
          label: 'Europäische Aktiengesellschaft',
          abbreviations: ['SE'],
        },
      },
    },
    SQKS: {
      active: true,
      languages: {
        de: {
          label: 'Körperschaft des öffentlichen Rechts',
          abbreviations: [],
        },
      },
    },
    SUA1: {
      active: true,
      languages: {
        de: {
          label: 'Europäische Genossenschaft',
          abbreviations: ['SCE'],
        },
      },
    },
    T0YJ: {
      active: true,
      languages: {
        de: {
          label: 'Kommanditgesellschaft auf Aktien',
          abbreviations: [
            'KGaA',
            'AG & Co. KGaA',
            'GmbH & Co. KGaA',
            'Stiftung & Co. KGaA',
          ],
        },
      },
    },
    US8E: {
      active: true,
      languages: {
        de: {
          label: 'Genossenschaft',
          abbreviations: [],
        },
      },
    },
    V2YH: {
      active: true,
      languages: {
        de: {
          label: 'Stiftung des privaten Rechts',
          abbreviations: [],
        },
      },
    },
    XLWA: {
      active: true,
      languages: {
        de: {
          label: 'Anstalt des öffentlichen Rechts',
          abbreviations: [],
        },
      },
    },
    YA01: {
      active: true,
      languages: {
        de: {
          label: 'Gemeinnützige Aktiengesellschaft',
          abbreviations: ['gAG'],
        },
      },
    },
    YJ4C: {
      active: true,
      languages: {
        de: {
          label: 'Kirchliche Stiftung des öffentlichen Rechts',
          abbreviations: [],
        },
      },
    },
  },
  GH: {
    '4HD1': {
      active: true,
      languages: {
        en: {
          label: 'Sole Proprietorship',
          abbreviations: [],
        },
      },
    },
    '56NA': {
      active: true,
      languages: {
        en: {
          label: 'Private Limited By Share',
          abbreviations: [],
        },
      },
    },
    I0X7: {
      active: true,
      languages: {
        en: {
          label: 'Private Unlimited By Share',
          abbreviations: [],
        },
      },
    },
    J5RC: {
      active: true,
      languages: {
        en: {
          label: 'Private Limited By Guarantee',
          abbreviations: [],
        },
      },
    },
    PH5T: {
      active: true,
      languages: {
        en: {
          label: 'Public Unlimited Company',
          abbreviations: [],
        },
      },
    },
    T69Z: {
      active: true,
      languages: {
        en: {
          label: 'External Company',
          abbreviations: [],
        },
      },
    },
    VBJW: {
      active: true,
      languages: {
        en: {
          label: 'Public Limited Company',
          abbreviations: [],
        },
      },
    },
    W9ZD: {
      active: true,
      languages: {
        en: {
          label: 'Public Limited By Guarantee',
          abbreviations: [],
        },
      },
    },
    WP5I: {
      active: true,
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
    XWPT: {
      active: true,
      languages: {
        en: {
          label: 'Subsidiary Business Name',
          abbreviations: [],
        },
      },
    },
  },
  GI: {
    '7U4R': {
      active: true,
      languages: {
        en: {
          label: 'European Economic Interest Groupings',
          abbreviations: ['E.E.I.G'],
        },
      },
    },
    CB98: {
      active: true,
      languages: {
        en: {
          label: 'Foundations',
          abbreviations: [],
        },
      },
    },
    GCCT: {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Partnerships',
          abbreviations: ['LLP'],
        },
      },
    },
    M4TI: {
      active: true,
      languages: {
        en: {
          label: 'Societe Europeas',
          abbreviations: ['SE'],
        },
      },
    },
    QFLH: {
      active: true,
      languages: {
        en: {
          label: 'Private Limited by Guarantee',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    TKPE: {
      active: true,
      languages: {
        en: {
          label: 'Private Trust Company',
          abbreviations: ['PTC'],
        },
      },
    },
    UUYB: {
      active: true,
      languages: {
        en: {
          label: 'Public Limited Company',
          abbreviations: ['PLC'],
        },
      },
    },
    VJRL: {
      active: true,
      languages: {
        en: {
          label: 'Private Unlimited Company',
          abbreviations: [],
        },
      },
    },
    WBKH: {
      active: true,
      languages: {
        en: {
          label: 'Private Limited Company',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    Y8CL: {
      active: true,
      languages: {
        en: {
          label: 'Limited Partnerships',
          abbreviations: ['LP'],
        },
      },
    },
  },
  GR: {
    '3RHO': {
      active: true,
      languages: {
        el: {
          label: 'Ναυτική εταιρία',
          abbreviations: ['SC'],
        },
      },
    },
    '54AL': {
      active: true,
      languages: {
        el: {
          label: 'Ετερόρρυθμη Εταιρία',
          abbreviations: ['EE'],
        },
      },
    },
    CQ5X: {
      active: true,
      languages: {
        el: {
          label: 'Ευρωπαϊκή Εταιρεία',
          abbreviations: ['SE'],
        },
      },
    },
    H6OR: {
      active: true,
      languages: {
        el: {
          label: 'Εταιρία Περιορισμένης Ευθύνης',
          abbreviations: ['EPE'],
        },
      },
    },
    HKVP: {
      active: true,
      languages: {
        el: {
          label: 'Αστική (Προσωπική) Εταιρία',
          abbreviations: ['SP'],
        },
      },
    },
    J3VJ: {
      active: true,
      languages: {
        el: {
          label: 'Συνεταιρισμός',
          abbreviations: ['COOP'],
        },
      },
    },
    JYKN: {
      active: false,
      languages: {
        el: {
          label: 'Λοιπά',
          abbreviations: [],
        },
      },
    },
    L6IY: {
      active: true,
      languages: {
        el: {
          label: 'Νομικά Πρόσωπα Δημοσίου Δικαίου',
          abbreviations: ['PL'],
        },
      },
    },
    L8D6: {
      active: true,
      languages: {
        el: {
          label: 'Αφανής Εταιρία',
          abbreviations: ['SLP'],
        },
      },
    },
    MCWR: {
      active: true,
      languages: {
        el: {
          label: 'Κοινοπραξία',
          abbreviations: ['JV'],
        },
      },
    },
    QCA0: {
      active: true,
      languages: {
        el: {
          label: 'Ιδιωτική Κεφαλαιουχική Εταιρία',
          abbreviations: ['IKE'],
        },
      },
    },
    QNWW: {
      active: true,
      languages: {
        el: {
          label: 'Ευρωπαϊκός Όμιλος Οικονομικού Σκοπού',
          abbreviations: ['ΕΟΟΣ'],
        },
      },
    },
    QSYQ: {
      active: true,
      languages: {
        el: {
          label: 'Σωματεία - Ιδρύματα',
          abbreviations: ['CLF'],
        },
      },
    },
    TIZ2: {
      active: true,
      languages: {
        el: {
          label: 'Ομόρρυθμη Εταιρία',
          abbreviations: ['OE'],
        },
      },
    },
    UCU5: {
      active: true,
      languages: {
        el: {
          label: 'Ετερόρρυθμη κατά μετοχές εταιρεία',
          abbreviations: [],
        },
      },
    },
    VKSR: {
      active: true,
      languages: {
        el: {
          label: 'Συμπλοιοκτησία',
          abbreviations: ['JSO'],
        },
      },
    },
    W2NK: {
      active: true,
      languages: {
        el: {
          label: 'Ανώνυμη Εταιρία',
          abbreviations: ['SA'],
        },
      },
    },
  },
  GU: {
    '5I7B': {
      active: true,
      languages: {
        en: {
          label: 'Limited liability company',
          abbreviations: [],
        },
      },
    },
    GNYB: {
      active: true,
      languages: {
        en: {
          label: 'Sole proprietorship',
          abbreviations: [],
        },
      },
    },
    KJ1Y: {
      active: true,
      languages: {
        en: {
          label: 'Corporation',
          abbreviations: [],
        },
      },
    },
    TMK1: {
      active: true,
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    U5RF: {
      active: true,
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
    YB1Q: {
      active: true,
      languages: {
        en: {
          label: 'Limited liability partnership',
          abbreviations: [],
        },
      },
    },
    YNEH: {
      active: true,
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
  },
  GT: {
    F0IC: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita por Acciones',
          abbreviations: ['Cía., S.C.A.'],
        },
      },
    },
    GY0L: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Colectiva',
          abbreviations: [],
        },
      },
    },
    RK88: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Responsabilidad Limitada',
          abbreviations: ['Ltda', 'Cía. Ltda.'],
        },
      },
    },
    W9T7: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita Simple',
          abbreviations: ['Cía. S. en C.'],
        },
      },
    },
    XH5R: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anónima',
          abbreviations: ['S.A.'],
        },
      },
    },
  },
  GG: {
    BVOE: {
      active: false,
      languages: {
        en: {
          label: 'Limited Company',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    UO3D: {
      active: false,
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    '1Q2B': {
      active: true,
      languages: {
        en: {
          label: 'Company limited by guarantee',
          abbreviations: [],
        },
      },
    },
    NDC3: {
      active: true,
      languages: {
        en: {
          label: 'Private company',
          abbreviations: [],
        },
      },
    },
    UY66: {
      active: true,
      languages: {
        en: {
          label: 'Public company',
          abbreviations: [],
        },
      },
    },
    '2AUN': {
      active: true,
      languages: {
        en: {
          label: 'Incorporated cell',
          abbreviations: ['ICC'],
        },
      },
    },
    '4C0J': {
      active: true,
      languages: {
        en: {
          label: 'Protected cell company',
          abbreviations: ['PCC'],
        },
      },
    },
    '75XK': {
      active: true,
      languages: {
        en: {
          label: 'Limited partnership (without separate legal personality)',
          abbreviations: [],
        },
      },
    },
    '9XFK': {
      active: true,
      languages: {
        en: {
          label: 'Foundation',
          abbreviations: ['FDN.'],
        },
      },
    },
    E6J3: {
      active: true,
      languages: {
        en: {
          label: 'Company limited by shares',
          abbreviations: ['Ltd'],
        },
      },
    },
    MCQP: {
      active: true,
      languages: {
        en: {
          label: 'Limited partnership (with separate legal personality)',
          abbreviations: [],
        },
      },
    },
    NGR5: {
      active: true,
      languages: {
        en: {
          label: 'Mixed liability company',
          abbreviations: ['ML'],
        },
      },
    },
    OT3Y: {
      active: true,
      languages: {
        en: {
          label: 'Company limited by guarantee',
          abbreviations: ['LBG'],
        },
      },
    },
    Q49K: {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    QJBA: {
      active: true,
      languages: {
        en: {
          label: 'Incorporated cell company',
          abbreviations: ['ICC'],
        },
      },
    },
    YVZD: {
      active: true,
      languages: {
        en: {
          label: 'Unlimited liability company',
          abbreviations: [],
        },
      },
    },
  },
  HN: {
    '12F9': {
      active: true,
      languages: {
        es: {
          label: 'Sociedades de Capital Variable',
          abbreviations: ['de C. V.'],
        },
      },
    },
    '6ETM': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita por Acciones.',
          abbreviations: ['S. en C.'],
        },
      },
    },
    E7JZ: {
      active: true,
      languages: {
        es: {
          label: 'Comerciante Individual',
          abbreviations: [],
        },
      },
    },
    JUDZ: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anónima',
          abbreviations: ['S.A.'],
        },
      },
    },
    O2M6: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Colectiva',
          abbreviations: [],
        },
      },
    },
    RF41: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita Simple',
          abbreviations: ['S. en C.'],
        },
      },
    },
    XE7O: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Responsabilidad Limitada',
          abbreviations: ['S. De R. L.'],
        },
      },
    },
  },
  HK: {
    '254M': {
      active: true,
      languages: {
        zh: {
          label: '私人股份有限公司',
          abbreviations: [],
        },
        en: {
          label: 'Private company limited by shares',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    '2QMJ': {
      active: true,
      languages: {
        en: {
          label: 'Trust',
          abbreviations: [],
        },
      },
    },
    '85VD': {
      active: true,
      languages: {
        zh: {
          label: '註冊受託人',
          abbreviations: [],
        },
        en: {
          label: 'Registered trustee',
          abbreviations: [],
        },
      },
    },
    E1SE: {
      active: true,
      languages: {
        zh: {
          label: '根據法例成立的實體',
          abbreviations: [],
        },
        en: {
          label: 'Entity established by Ordinance',
          abbreviations: [],
        },
      },
    },
    EPG7: {
      active: true,
      languages: {
        zh: {
          label: '公眾股份有限公司',
          abbreviations: [],
        },
        en: {
          label: 'Public company limited by shares',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    KSUS: {
      active: false,
      languages: {
        zh: {
          label: '非香港公司',
          abbreviations: [],
        },
        en: {
          label: 'Non-Hong Kong company',
          abbreviations: [],
        },
      },
    },
    N3VO: {
      active: true,
      languages: {
        zh: {
          label: '有股本的公眾無限公司',
          abbreviations: [],
        },
        en: {
          label: 'Public unlimited company with a share capital',
          abbreviations: ['Ultd', 'Unltd'],
        },
      },
    },
    S2E3: {
      active: true,
      languages: {
        zh: {
          label: '擔保有限公司',
          abbreviations: [],
        },
        en: {
          label: 'Company limited by guarantee',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    UDG6: {
      active: true,
      languages: {
        zh: {
          label: '有股本的私人無限公司',
          abbreviations: [],
        },
        en: {
          label: 'Private unlimited company with a share capital',
          abbreviations: ['Ultd', 'Unltd'],
        },
      },
    },
    XPE5: {
      active: true,
      languages: {
        zh: {
          label: '有限責任合夥',
          abbreviations: ['LP'],
        },
        en: {
          label: 'Limited partnership',
          abbreviations: ['LP'],
        },
      },
    },
  },
  HU: {
    '2A44': {
      active: true,
      languages: {
        hu: {
          label: 'Egyéni cég',
          abbreviations: [],
        },
      },
    },
    '2LB5': {
      active: true,
      languages: {
        hu: {
          label: 'Munkavállalói Résztulajdonosi Program szervezet',
          abbreviations: [],
        },
      },
    },
    '4C5L': {
      active: true,
      languages: {
        hu: {
          label: 'Ügyvédi Iroda',
          abbreviations: [],
        },
      },
    },
    '4QRE': {
      active: true,
      languages: {
        hu: {
          label: 'Önkormányzat',
          abbreviations: [],
        },
      },
    },
    '4WV7': {
      active: true,
      languages: {
        hu: {
          label: 'Egyéb köztestület',
          abbreviations: [],
        },
      },
    },
    '876R': {
      active: true,
      languages: {
        hu: {
          label: 'Egyéb egyesület',
          abbreviations: [],
        },
      },
    },
    '8UEG': {
      active: true,
      languages: {
        hu: {
          label: 'Nyilvánosan működő részvénytársaság',
          abbreviations: ['Nyrt.'],
        },
      },
    },
    '8UMK': {
      active: true,
      languages: {
        hu: {
          label: 'Európai gazdasági egyesülés',
          abbreviations: ['EGE'],
        },
      },
    },
    '8VH3': {
      active: true,
      languages: {
        hu: {
          label: 'Befektetési alap',
          abbreviations: [],
        },
      },
    },
    '995K': {
      active: true,
      languages: {
        hu: {
          label: 'Magánnyugdíjpénztár',
          abbreviations: [],
        },
      },
    },
    BJ8Q: {
      active: true,
      languages: {
        hu: {
          label: 'Egyéni vállalkozás',
          abbreviations: [],
        },
      },
    },
    BKUX: {
      active: true,
      languages: {
        hu: {
          label: 'Zártkörűen működő részvénytársaság',
          abbreviations: ['Zrt.'],
        },
      },
    },
    BMYJ: {
      active: true,
      languages: {
        hu: {
          label: 'Egyéb alapítvány',
          abbreviations: [],
        },
      },
    },
    BSK1: {
      active: true,
      languages: {
        hu: {
          label: 'Oktatási intézmények',
          abbreviations: [],
        },
      },
    },
    DN6F: {
      active: true,
      languages: {
        hu: {
          label: 'Kölcsönös biztosító egyesület',
          abbreviations: [],
        },
      },
    },
    DPY1: {
      active: true,
      languages: {
        hu: {
          label: 'Egyéb szövetkezet',
          abbreviations: [],
        },
      },
    },
    EO9F: {
      active: true,
      languages: {
        hu: {
          label: 'Részvénytársaság',
          abbreviations: ['Rt.'],
        },
      },
    },
    ESTU: {
      active: true,
      languages: {
        hu: {
          label: 'Társasház',
          abbreviations: [],
        },
      },
    },
    HTJD: {
      active: true,
      languages: {
        hu: {
          label: 'Közhasznú társaság',
          abbreviations: ['Kht.'],
        },
      },
    },
    J6MO: {
      active: true,
      languages: {
        hu: {
          label: 'Közkereseti társaság',
          abbreviations: ['Kkt.'],
        },
      },
    },
    LNY0: {
      active: true,
      languages: {
        hu: {
          label: 'Egyházi szervezetek',
          abbreviations: [],
        },
      },
    },
    M1DW: {
      active: true,
      languages: {
        hu: {
          label: 'Önkéntes kölcsönös biztosítópénztár',
          abbreviations: [],
        },
      },
    },
    NZAI: {
      active: false,
      languages: {
        hu: {
          label: 'Külföldi székhelyű vállalkozás kereskedelmi képviselete',
          abbreviations: [],
        },
      },
    },
    OII5: {
      active: true,
      languages: {
        hu: {
          label: 'Egyéni ügyvéd',
          abbreviations: [],
        },
      },
    },
    P9F2: {
      active: true,
      languages: {
        hu: {
          label: 'Korlátolt felelősségű társaság',
          abbreviations: ['Kft.'],
        },
      },
    },
    QYV5: {
      active: true,
      languages: {
        hu: {
          label: 'Költségvetési szerv',
          abbreviations: [],
        },
      },
    },
    S3DA: {
      active: true,
      languages: {
        hu: {
          label: 'Betéti társaság',
          abbreviations: ['Bt.'],
        },
      },
    },
    TQ3O: {
      active: false,
      languages: {
        hu: {
          label: 'Egyéb, máshova nem sorolt jogi személyiségű vállalkozás',
          abbreviations: [],
        },
      },
    },
    TSVO: {
      active: true,
      languages: {
        hu: {
          label: 'Szövetség (kivéve sportszövetség)',
          abbreviations: ['kbe'],
        },
      },
    },
    UD8K: {
      active: false,
      languages: {
        hu: {
          label: 'Külföldi székhelyű vállalkozás fióktelepe',
          abbreviations: [],
        },
      },
    },
    V3LT: {
      active: true,
      languages: {
        hu: {
          label: 'Erdőbirtokossági Társulat',
          abbreviations: [],
        },
      },
    },
    X0SX: {
      active: true,
      languages: {
        hu: {
          label: 'Takarék- és hitelszövetkezet',
          abbreviations: ['tksz,', 'hsz.'],
        },
      },
    },
    XW5U: {
      active: true,
      languages: {
        hu: {
          label: 'Európai részvénytársaság',
          abbreviations: ['SE'],
        },
      },
    },
    Y64R: {
      active: true,
      languages: {
        hu: {
          label: 'Országos betétbiztosítási alap',
          abbreviations: ['OBA'],
        },
      },
    },
    ZQAQ: {
      active: true,
      languages: {
        hu: {
          label: 'Közjegyzői iroda',
          abbreviations: [],
        },
      },
    },
  },
  IS: {
    '2OJP': {
      active: true,
      languages: {
        is: {
          label: 'Samlagshlutafélag',
          abbreviations: ['slhf.'],
        },
      },
    },
    '8T79': {
      active: true,
      languages: {
        is: {
          label: 'Samlagsfélag',
          abbreviations: ['slf.'],
        },
      },
    },
    CMHQ: {
      active: true,
      languages: {
        is: {
          label: 'Evrópufélag',
          abbreviations: ['SE'],
        },
      },
    },
    E4KB: {
      active: true,
      languages: {
        is: {
          label: 'Hlutafélag',
          abbreviations: ['hf.'],
        },
      },
    },
    M8SS: {
      active: true,
      languages: {
        is: {
          label: 'Einkahlutafélag',
          abbreviations: ['ehf.'],
        },
      },
    },
  },
  IN: {
    '180P': {
      active: true,
      languages: {
        en: {
          label: 'Stand Alone Primary Dealer',
          abbreviations: [],
        },
      },
    },
    '2DVA': {
      active: true,
      languages: {
        en: {
          label: 'Cooperative Society',
          abbreviations: [],
        },
      },
    },
    '2Y95': {
      active: true,
      languages: {
        en: {
          label: 'Special Purpose Vehicle - Company',
          abbreviations: [],
        },
      },
    },
    '36YD': {
      active: true,
      languages: {
        en: {
          label: 'Unlimited Company',
          abbreviations: [],
        },
      },
    },
    '3VSP': {
      active: true,
      languages: {
        en: {
          label: 'Public Financial Institutions',
          abbreviations: [],
        },
      },
    },
    '4QIE': {
      active: true,
      languages: {
        en: {
          label: 'Sole Proprietorship',
          abbreviations: [],
        },
      },
    },
    '70GJ': {
      active: true,
      languages: {
        en: {
          label: 'Government Organization',
          abbreviations: [],
        },
      },
    },
    '8ZLF': {
      active: true,
      languages: {
        en: {
          label: 'Special Purpose Vehicle - Trust',
          abbreviations: [],
        },
      },
    },
    '9ME5': {
      active: true,
      languages: {
        en: {
          label: 'Non profit company',
          abbreviations: [],
        },
      },
    },
    A0PS: {
      active: true,
      languages: {
        en: {
          label: 'Partnership Firm',
          abbreviations: [],
        },
      },
    },
    DDKQ: {
      active: true,
      languages: {
        en: {
          label: 'Public Limited Company',
          abbreviations: ['LTD'],
        },
      },
    },
    DW2W: {
      active: true,
      languages: {
        en: {
          label: 'Company Limited by Guarantee',
          abbreviations: [],
        },
      },
    },
    EX8U: {
      active: true,
      languages: {
        en: {
          label: 'Alternative Investment Fund',
          abbreviations: [],
        },
      },
    },
    FC7L: {
      active: true,
      languages: {
        en: {
          label: 'Housing Finance Company',
          abbreviations: [],
        },
      },
    },
    FPZK: {
      active: true,
      languages: {
        en: {
          label: 'Banking Company - Scheduled Urban Cooperative Bank',
          abbreviations: [],
        },
      },
    },
    HBQK: {
      active: true,
      languages: {
        en: {
          label: 'Alternate Investment Fund - Sub scheme',
          abbreviations: [],
        },
      },
    },
    I47Z: {
      active: true,
      languages: {
        en: {
          label: 'One Person Company',
          abbreviations: [],
        },
      },
    },
    JKJX: {
      active: true,
      languages: {
        en: {
          label:
            'Provident fund / Superannuation fund / Gratuity fund / Insurance Fund',
          abbreviations: [],
        },
      },
    },
    K361: {
      active: true,
      languages: {
        en: {
          label: 'Special Purpose Vehicle-Coop  / Multistate Coop Society',
          abbreviations: [],
        },
      },
    },
    K4OX: {
      active: true,
      languages: {
        en: {
          label: 'Special Purpose Vehicle - Partnership Firm',
          abbreviations: [],
        },
      },
    },
    KJ0B: {
      active: true,
      languages: {
        en: {
          label: 'Insurance Company',
          abbreviations: [],
        },
      },
    },
    NBCI: {
      active: true,
      languages: {
        en: {
          label: 'Banking Company - Others',
          abbreviations: [],
        },
      },
    },
    NFPC: {
      active: true,
      languages: {
        en: {
          label: 'Non-Banking Finance Company',
          abbreviations: [],
        },
      },
    },
    OYDA: {
      active: true,
      languages: {
        en: {
          label: 'Pension Fund',
          abbreviations: [],
        },
      },
    },
    QCSO: {
      active: true,
      languages: {
        en: {
          label: 'Multistate Cooperative Society',
          abbreviations: [],
        },
      },
    },
    U5S6: {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    U8NM: {
      active: true,
      languages: {
        en: {
          label: 'Mutual Fund',
          abbreviations: [],
        },
      },
    },
    VX5J: {
      active: true,
      languages: {
        en: {
          label: 'Mutual Fund-Sub Scheme',
          abbreviations: [],
        },
      },
    },
    W0G7: {
      active: true,
      languages: {
        en: {
          label: 'Pension Fund Sub Scheme',
          abbreviations: [],
        },
      },
    },
    W9FI: {
      active: true,
      languages: {
        en: {
          label: 'Trust',
          abbreviations: [],
        },
      },
    },
    X4IT: {
      active: true,
      languages: {
        en: {
          label: 'Government Company',
          abbreviations: [],
        },
      },
    },
    XTZG: {
      active: true,
      languages: {
        en: {
          label: 'Banking Company - Nationalised Bank',
          abbreviations: [],
        },
      },
    },
    YSP9: {
      active: true,
      languages: {
        en: {
          label: 'Private Limited Company',
          abbreviations: ['PVT LTD'],
        },
      },
    },
  },
  ID: {
    '2ZB3': {
      active: true,
      languages: {
        id: {
          label: 'Perseroan Publik',
          abbreviations: [],
        },
      },
    },
    '72I6': {
      active: true,
      languages: {
        id: {
          label: 'Koperasi',
          abbreviations: [],
        },
      },
    },
    AEZW: {
      active: true,
      languages: {
        id: {
          label: 'Perseroan Terbuka',
          abbreviations: ['Tbk'],
        },
      },
    },
    B8VT: {
      active: true,
      languages: {
        id: {
          label: 'Commanditaire Vennootschap',
          abbreviations: ['CV'],
        },
      },
    },
    BJT3: {
      active: true,
      languages: {
        id: {
          label: 'Firma',
          abbreviations: ['Fa'],
        },
      },
    },
    BUSK: {
      active: true,
      languages: {
        id: {
          label: 'Perusahaan Umum',
          abbreviations: ['Perum'],
        },
      },
    },
    F77L: {
      active: true,
      languages: {
        id: {
          label: 'Perusahaan Perseroan',
          abbreviations: ['Persero'],
        },
      },
    },
    HELT: {
      active: true,
      languages: {
        id: {
          label: 'Yayasan',
          abbreviations: [],
        },
      },
    },
    JAJS: {
      active: true,
      languages: {
        id: {
          label: 'Perseroan Terbatas Penanaman Modal Asing',
          abbreviations: ['PT PMA'],
        },
      },
    },
    UD1V: {
      active: true,
      languages: {
        id: {
          label: 'Perseroan Terbatas Penanaman Modal Dalam Negeri',
          abbreviations: ['PT', 'PT PMDN'],
        },
      },
    },
    V05A: {
      active: true,
      languages: {
        id: {
          label: 'Persekutuan Perdata',
          abbreviations: [],
        },
      },
    },
    XFHP: {
      active: true,
      languages: {
        id: {
          label: 'Usaha Dagang',
          abbreviations: [],
        },
      },
    },
  },
  IE: {
    '2GV9': {
      active: true,
      languages: {
        en: {
          label: 'Irish Collective Asset-management Vehicle',
          abbreviations: ['ICAV'],
        },
      },
    },
    '363J': {
      active: true,
      languages: {
        en: {
          label: 'European Economic Interest Grouping',
          abbreviations: ['EEIG'],
        },
        ga: {
          label: 'Grupail Eorpach um Leas Eacnamaioch',
          abbreviations: ['GELE'],
        },
      },
    },
    '54SK': {
      active: true,
      languages: {
        en: {
          label: 'Friendly Society',
          abbreviations: [],
        },
      },
    },
    '5AX8': {
      active: true,
      languages: {
        en: {
          label: 'Designated Activity Company Limited by Guarantee',
          abbreviations: ['DAC – (limited by guarantee)'],
        },
        ga: {
          label: 'Cuideachta Ghníomhaíochta Ainmnithe',
          abbreviations: ['cga'],
        },
      },
    },
    '9BPE': {
      active: true,
      languages: {
        en: {
          label: 'Credit Union',
          abbreviations: [],
        },
      },
    },
    C58S: {
      active: true,
      languages: {
        en: {
          label: 'Company Limited by Guarantee',
          abbreviations: ['CLG'],
        },
        ga: {
          label: 'Cuideachta faoi Theorainn Ráthaíochta',
          abbreviations: ['ctr'],
        },
      },
    },
    DWS3: {
      active: true,
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    FF1D: {
      active: true,
      languages: {
        en: {
          label: 'Public Unlimited Company that has no share capital',
          abbreviations: ['PULC / uc'],
        },
        ga: {
          label: 'Cuideachta Neamhtheoranta',
          abbreviations: ['cn'],
        },
      },
    },
    HNJK: {
      active: true,
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    JXDX: {
      active: true,
      languages: {
        en: {
          label: 'Societas Europaea',
          abbreviations: ['SE'],
        },
      },
    },
    KMFX: {
      active: true,
      languages: {
        en: {
          label: 'Private Unlimited Company',
          abbreviations: ['ULC / uc'],
        },
        ga: {
          label: 'Cuideachta Neamhtheoranta',
          abbreviations: ['cn'],
        },
      },
    },
    LGWG: {
      active: true,
      languages: {
        en: {
          label: 'Designated Activity Company',
          abbreviations: ['DAC – (limited by shares)'],
        },
        ga: {
          label: 'Cuideachta Ghníomhaíochta Ainmnithe',
          abbreviations: ['cga'],
        },
      },
    },
    LMIM: {
      active: false,
      languages: {
        en: {
          label: 'Limited company',
          abbreviations: ['Limited', 'Ltd'],
        },
        ga: {
          label: 'Teoranta',
          abbreviations: ['teo'],
        },
      },
    },
    LZIC: {
      active: true,
      languages: {
        en: {
          label: 'Investment Limited Partnership',
          abbreviations: ['ilp'],
        },
        ga: {
          label: 'Comhpháirtíocht theoranta infheistíochta',
          abbreviations: ['cti'],
        },
      },
    },
    MNQ7: {
      active: true,
      languages: {
        en: {
          label: 'Private Company Limited by Shares',
          abbreviations: ['Limited', 'Ltd'],
        },
        ga: {
          label: 'Teoranta',
          abbreviations: ['teo'],
        },
      },
    },
    URQH: {
      active: true,
      languages: {
        en: {
          label: 'Public Unlimited Company',
          abbreviations: ['PUC / uc'],
        },
        ga: {
          label: 'Cuideachta Neamhtheoranta',
          abbreviations: ['cn'],
        },
      },
    },
    VYAX: {
      active: true,
      languages: {
        en: {
          label: 'Public Limited Company',
          abbreviations: ['PLC'],
        },
        ga: {
          label: 'Cuideachta Phoiblí Theoranta',
          abbreviations: ['cpt'],
        },
      },
    },
    ZJS8: {
      active: true,
      languages: {
        en: {
          label: 'Industrial and Provident Society',
          abbreviations: ['I&PS'],
        },
      },
    },
  },
  IM: {
    '1G26': {
      active: true,
      languages: {
        en: {
          label:
            'Public Limited by Guarantee and not having a Share Capital (1931 Act)',
          abbreviations: [],
        },
      },
    },
    '5ABK': {
      active: true,
      languages: {
        en: {
          label: 'Unlimited with Shares (2006 Act)',
          abbreviations: [],
        },
      },
    },
    CDXK: {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    EMLA: {
      active: true,
      languages: {
        en: {
          label: 'Limited Partnership - without Legal Personality',
          abbreviations: [],
        },
      },
    },
    FI4M: {
      active: true,
      languages: {
        en: {
          label: 'Industrial and Building Society',
          abbreviations: [],
        },
      },
    },
    FMPL: {
      active: true,
      languages: {
        en: {
          label:
            'Private Limited by Guarantee and not having a Share Capital (1931 Act)',
          abbreviations: [],
        },
      },
    },
    G4V6: {
      active: true,
      languages: {
        en: {
          label: 'Public Unlimited and having a Share Capital (1931 Act)',
          abbreviations: [],
        },
      },
    },
    JHC4: {
      active: true,
      languages: {
        en: {
          label: 'Foundation',
          abbreviations: [],
        },
      },
    },
    M44Y: {
      active: true,
      languages: {
        en: {
          label: 'Limited by Shares and by Guarantee (2006 Act)',
          abbreviations: [],
        },
      },
    },
    OESH: {
      active: true,
      languages: {
        en: {
          label:
            'Public Limited by Guarantee and having a Share Capital (1931 Act)',
          abbreviations: [],
        },
      },
    },
    QZTT: {
      active: true,
      languages: {
        en: {
          label: 'Private Limited by shares (1931 Act)',
          abbreviations: [],
        },
      },
    },
    SAI8: {
      active: true,
      languages: {
        en: {
          label: 'Private Unlimited and having a Share Capital (1931 Act)',
          abbreviations: [],
        },
      },
    },
    SP9F: {
      active: true,
      languages: {
        en: {
          label: 'Limited by Guarantee (2006 Act)',
          abbreviations: [],
        },
      },
    },
    TE79: {
      active: true,
      languages: {
        en: {
          label: 'Limited Partnership - with Legal Personality',
          abbreviations: [],
        },
      },
    },
    TQ3Z: {
      active: true,
      languages: {
        en: {
          label: 'Limited by Shares (2006 Act)',
          abbreviations: [],
        },
      },
    },
    TV5P: {
      active: true,
      languages: {
        en: {
          label: 'Unlimited without Shares (2006 Act)',
          abbreviations: [],
        },
      },
    },
    VC3E: {
      active: true,
      languages: {
        en: {
          label:
            'Private Limited by Guarantee and having a Share Capital (1931 Act)',
          abbreviations: [],
        },
      },
    },
    ZGPY: {
      active: true,
      languages: {
        en: {
          label: 'Public Limited by Shares (1931 Act)',
          abbreviations: [],
        },
      },
    },
  },
  IT: {
    '135L': {
      active: false,
      languages: {
        it: {
          label: 'Società Costituita In Base A Leggi Di Altro Stato',
          abbreviations: [],
        },
      },
    },
    '1RI9': {
      active: true,
      languages: {
        it: {
          label: 'Ente Ecclesiastico Civilmente Riconosciuto',
          abbreviations: [],
        },
      },
    },
    '1TON': {
      active: true,
      languages: {
        it: {
          label: 'Associazione',
          abbreviations: [],
        },
      },
    },
    '2HC6': {
      active: true,
      languages: {
        it: {
          label: 'Pubblica amministrazione',
          abbreviations: [],
        },
      },
    },
    '2J7Z': {
      active: true,
      languages: {
        it: {
          label: 'Consorzio con attività Esterna',
          abbreviations: [],
        },
      },
    },
    '2SZI': {
      active: true,
      languages: {
        it: {
          label: 'Ente Sociale',
          abbreviations: [],
        },
      },
    },
    '2XXH': {
      active: true,
      languages: {
        it: {
          label: 'Società Semplice',
          abbreviations: ['SS'],
        },
      },
    },
    '5ODO': {
      active: true,
      languages: {
        it: {
          label: 'Ente Diritto Pubblico',
          abbreviations: [],
        },
      },
    },
    '634M': {
      active: true,
      languages: {
        it: {
          label: 'Gruppo Europeo Di Interesse Economico',
          abbreviations: ['GEIE'],
        },
      },
    },
    '70X0': {
      active: true,
      languages: {
        it: {
          label: 'Fondazione Impresa',
          abbreviations: [],
        },
      },
    },
    '75WC': {
      active: true,
      languages: {
        it: {
          label: 'Fondazione',
          abbreviations: [],
        },
      },
    },
    '8AXV': {
      active: true,
      languages: {
        it: {
          label: 'Società Consortile Cooperativa a Responsabilità Limitata',
          abbreviations: [],
        },
      },
    },
    '8GU1': {
      active: true,
      languages: {
        it: {
          label: 'Società A Responsabilità Limitata Semplificata',
          abbreviations: ['S.R.L. semplificata', 'S.R.L.S.'],
        },
      },
    },
    '9KGS': {
      active: true,
      languages: {
        it: {
          label: 'Società Cooperativa Europea',
          abbreviations: ['SCE'],
        },
      },
    },
    ADAZ: {
      active: true,
      languages: {
        it: {
          label: 'Istituto Religioso',
          abbreviations: [],
        },
      },
    },
    ARJF: {
      active: true,
      languages: {
        it: {
          label: 'Ente Morale',
          abbreviations: [],
        },
      },
    },
    B5TO: {
      active: true,
      languages: {
        it: {
          label: 'Società a Responsabilità Limitata con Unico Socio',
          abbreviations: [],
        },
      },
    },
    BL52: {
      active: true,
      languages: {
        it: {
          label: 'Società Consortile A Responsabilità Limitata',
          abbreviations: ['S.C.A.R.L.', 'S.C.R.L.'],
        },
      },
    },
    C1IC: {
      active: true,
      languages: {
        it: {
          label: 'Società Cooperativa Consortile',
          abbreviations: [
            'gruppo consortile',
            'società cooperativa',
            "societa' cooperativa",
          ],
        },
      },
    },
    CGSO: {
      active: true,
      languages: {
        it: {
          label: 'Società in Accomandita Semplice',
          abbreviations: [],
        },
      },
    },
    CTNS: {
      active: true,
      languages: {
        it: {
          label: 'Società Cooperativa a Responsabilità Limitata',
          abbreviations: [],
        },
      },
    },
    DCRK: {
      active: true,
      languages: {
        it: {
          label: 'Consorzio Fidi',
          abbreviations: [],
        },
      },
    },
    DLS4: {
      active: true,
      languages: {
        it: {
          label: 'Società in Accomandita per Azioni',
          abbreviations: [],
        },
      },
    },
    DSSD: {
      active: true,
      languages: {
        it: {
          label: 'Azienda Autonoma Statale',
          abbreviations: [],
        },
      },
    },
    H7D4: {
      active: false,
      languages: {
        it: {
          label: 'Soggetto Estero',
          abbreviations: [],
        },
      },
    },
    HN75: {
      active: true,
      languages: {
        it: {
          label: 'Consorzio',
          abbreviations: [],
        },
      },
    },
    IMHA: {
      active: true,
      languages: {
        it: {
          label: 'Ente Ecclesiastico',
          abbreviations: [],
        },
      },
    },
    K021: {
      active: true,
      languages: {
        it: {
          label: "Contratto Di Rete Dotato Di Soggettivita' Giuridica",
          abbreviations: [],
        },
      },
    },
    K26L: {
      active: true,
      languages: {
        it: {
          label: 'Ente',
          abbreviations: [],
        },
      },
    },
    KCHO: {
      active: true,
      languages: {
        it: {
          label: 'Azienda Speciale Di Cui Al Dlgs 267/2000',
          abbreviations: [],
        },
      },
    },
    KCSG: {
      active: true,
      languages: {
        it: {
          label: 'Ente Impresa',
          abbreviations: ['consorzio'],
        },
      },
    },
    KXZT: {
      active: true,
      languages: {
        it: {
          label: 'Azienda Speciale',
          abbreviations: [],
        },
      },
    },
    L1ZJ: {
      active: true,
      languages: {
        it: {
          label: 'Azienda Municipale',
          abbreviations: [],
        },
      },
    },
    LHBB: {
      active: true,
      languages: {
        it: {
          label: 'Impresa Individuale',
          abbreviations: [],
        },
      },
    },
    LZZD: {
      active: true,
      languages: {
        it: {
          label: 'Società Consortile Per Azioni',
          abbreviations: [],
        },
      },
    },
    NDEW: {
      active: true,
      languages: {
        it: {
          label: 'Società Consortile Cooperativa',
          abbreviations: [],
        },
      },
    },
    OQ8C: {
      active: true,
      languages: {
        it: {
          label: 'Fondo Pensione',
          abbreviations: [],
        },
      },
    },
    OV32: {
      active: true,
      languages: {
        it: {
          label: 'Società A Responsabilità Limitata',
          abbreviations: ['SRL'],
        },
      },
    },
    P418: {
      active: true,
      languages: {
        it: {
          label: 'Società Per Azioni',
          abbreviations: ['SPA'],
        },
      },
    },
    PHMS: {
      active: true,
      languages: {
        it: {
          label: 'Cooperativa Sociale',
          abbreviations: [],
        },
      },
    },
    QRZJ: {
      active: true,
      languages: {
        it: {
          label: 'Società Cooperativa',
          abbreviations: ['S.C.', 'soc. coop.'],
        },
      },
    },
    RWZD: {
      active: false,
      languages: {
        it: {
          label: 'Altre Forme',
          abbreviations: [],
        },
      },
    },
    SBQN: {
      active: true,
      languages: {
        it: {
          label: 'Consorzio senza Attività Esterna',
          abbreviations: [],
        },
      },
    },
    SSP9: {
      active: true,
      languages: {
        it: {
          label: 'Azienda Speciale Rea',
          abbreviations: [],
        },
      },
    },
    T2X1: {
      active: true,
      languages: {
        it: {
          label: 'Società In Nome Collettivo',
          abbreviations: ['SNC'],
        },
      },
    },
    VA1V: {
      active: true,
      languages: {
        it: {
          label: 'Società Di Mutuo Soccorso',
          abbreviations: [],
        },
      },
    },
    VDRB: {
      active: true,
      languages: {
        it: {
          label: 'Consorzio Municipale',
          abbreviations: [],
        },
      },
    },
    VUPE: {
      active: true,
      languages: {
        it: {
          label: 'Società Europea',
          abbreviations: ['SE'],
        },
      },
    },
    W2PE: {
      active: false,
      languages: {
        it: {
          label: 'Società non prevista dalla Legislazione Italiana',
          abbreviations: [],
        },
      },
    },
    W9SC: {
      active: true,
      languages: {
        it: {
          label: 'Mutua Assicurazione',
          abbreviations: [],
        },
      },
    },
    WPED: {
      active: true,
      languages: {
        it: {
          label: 'Associazione Impresa',
          abbreviations: [],
        },
      },
    },
    WRU2: {
      active: true,
      languages: {
        it: {
          label: 'Società Consortile in Accomandita Semplice',
          abbreviations: [],
        },
      },
    },
    X32V: {
      active: true,
      languages: {
        it: {
          label: 'Società per Azioni con Socio Unico',
          abbreviations: [],
        },
      },
    },
    X62Z: {
      active: true,
      languages: {
        it: {
          label: 'Consorzio Di Cui Alla Dlgs 267/2000',
          abbreviations: [],
        },
      },
    },
    ZG6S: {
      active: true,
      languages: {
        it: {
          label: 'Ente Pubblico Economico',
          abbreviations: [],
        },
      },
    },
    ZU9S: {
      active: true,
      languages: {
        it: {
          label: 'Piccola Società Cooperativa a Responsabilità Limitata',
          abbreviations: [],
        },
      },
    },
    ZZOG: {
      active: true,
      languages: {
        it: {
          label: 'Società Tra Professionisti',
          abbreviations: [],
        },
      },
    },
  },
  JM: {
    '7ZU4': {
      active: true,
      languages: {
        en: {
          label: 'Collective investment scheme company',
          abbreviations: [],
        },
      },
    },
    EBRQ: {
      active: true,
      languages: {
        en: {
          label: 'Unlimited company',
          abbreviations: [],
        },
      },
    },
    HCBE: {
      active: true,
      languages: {
        en: {
          label: 'Company limited by shares',
          abbreviations: [],
        },
      },
    },
    N97C: {
      active: true,
      languages: {
        en: {
          label: 'Company limited by guarantee',
          abbreviations: [],
        },
      },
    },
    PFY0: {
      active: true,
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
    TLCB: {
      active: true,
      languages: {
        en: {
          label: 'Non profit company',
          abbreviations: [],
        },
      },
    },
    WVQN: {
      active: true,
      languages: {
        en: {
          label: 'Sole trader',
          abbreviations: [],
        },
      },
    },
  },
  JP: {
    '2NRQ': {
      active: true,
      languages: {
        ja: {
          label: '地方公共団体',
          abbreviations: [],
        },
      },
    },
    '5MVV': {
      active: true,
      languages: {
        ja: {
          label: '合資会社',
          abbreviations: [],
        },
      },
    },
    '7QQ0': {
      active: true,
      languages: {
        ja: {
          label: '合同会社',
          abbreviations: [],
        },
      },
    },
    DYQK: {
      active: true,
      languages: {
        ja: {
          label: '有限会社',
          abbreviations: [],
        },
      },
    },
    IUVI: {
      active: true,
      languages: {
        ja: {
          label: '合名会社',
          abbreviations: [],
        },
      },
    },
    MXMH: {
      active: true,
      languages: {
        ja: {
          label: '外国会社等',
          abbreviations: [],
        },
      },
    },
    N3JU: {
      active: true,
      languages: {
        ja: {
          label: 'その他の設立登記法人',
          abbreviations: [],
        },
      },
    },
    R4LR: {
      active: true,
      languages: {
        ja: {
          label: '国の機関',
          abbreviations: [],
        },
      },
    },
    T417: {
      active: true,
      languages: {
        ja: {
          label: '株式会社',
          abbreviations: [],
        },
      },
    },
    VQLD: {
      active: true,
      languages: {
        ja: {
          label: 'その他',
          abbreviations: [],
        },
      },
    },
  },
  JE: {
    '21F4': {
      active: true,
      languages: {
        en: {
          label: 'Separate Limited Partnerships',
          abbreviations: ['SLP'],
        },
      },
    },
    '33IP': {
      active: true,
      languages: {
        en: {
          label: 'Incorporated Limited Partnerships',
          abbreviations: ['ILP', 'Inc', 'L. P.'],
        },
      },
    },
    '40A7': {
      active: true,
      languages: {
        en: {
          label: 'Foundation',
          abbreviations: [],
        },
      },
    },
    '7RZH': {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    JOX1: {
      active: true,
      languages: {
        en: {
          label: 'Public Limited Company',
          abbreviations: ['Limited', 'LTD', 'PLC'],
        },
      },
    },
    LO9A: {
      active: true,
      languages: {
        en: {
          label: 'Private Limited by Guarantee',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    SQXV: {
      active: true,
      languages: {
        en: {
          label: 'Private Limited Company',
          abbreviations: ['Limited', 'LTD', 'A.R.L'],
        },
      },
    },
    UBWU: {
      active: true,
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
  },
  JO: {
    '2R82': {
      active: true,
      languages: {
        ar: {
          label: 'شركة رأس المال المغامر',
          abbreviations: [],
        },
      },
    },
    '6B39': {
      active: true,
      languages: {
        ar: {
          label: 'الشركة ذات المسؤولية المحدودة',
          abbreviations: ['ذ.م.م'],
        },
      },
    },
    '6KSC': {
      active: true,
      languages: {
        ar: {
          label: 'شركة التوصية البسيطة',
          abbreviations: ['توصية بسيطة'],
        },
      },
    },
    '9NBN': {
      active: true,
      languages: {
        ar: {
          label: 'شركة التضامن',
          abbreviations: [],
        },
      },
    },
    BL60: {
      active: true,
      languages: {
        ar: {
          label: 'الشركة المساهمة العامة',
          abbreviations: ['ش.م.ع'],
        },
      },
    },
    FZAC: {
      active: true,
      languages: {
        ar: {
          label: 'الشركة المساهمة الخاصة',
          abbreviations: ['ش.م.خ'],
        },
      },
    },
    IXQK: {
      active: true,
      languages: {
        ar: {
          label: 'شركة التوصية بالأسهم',
          abbreviations: [],
        },
      },
    },
    SAST: {
      active: true,
      languages: {
        ar: {
          label: 'الشركة التي لا تهدف لتحقيق الربح',
          abbreviations: [],
        },
      },
    },
  },
  KR: {
    '12KO': {
      active: true,
      languages: {
        kr: {
          label: '회사형 펀드',
          abbreviations: [],
        },
      },
    },
    '5RCH': {
      active: true,
      languages: {
        kr: {
          label: '주식회사',
          abbreviations: ['㈜'],
        },
      },
    },
    AHJG: {
      active: true,
      languages: {
        kr: {
          label: '조합형 펀드',
          abbreviations: [],
        },
      },
    },
    AKF5: {
      active: true,
      languages: {
        kr: {
          label: '재단법인',
          abbreviations: [],
        },
      },
    },
    AXEQ: {
      active: true,
      languages: {
        kr: {
          label: '합명회사',
          abbreviations: [],
        },
      },
    },
    BW92: {
      active: true,
      languages: {
        kr: {
          label: '합자회사',
          abbreviations: [],
        },
      },
    },
    EO0G: {
      active: true,
      languages: {
        kr: {
          label: '변액보험',
          abbreviations: [],
        },
      },
    },
    GF7G: {
      active: true,
      languages: {
        kr: {
          label: '개인사업자',
          abbreviations: [],
        },
      },
    },
    J3U5: {
      active: true,
      languages: {
        kr: {
          label: '유한회사',
          abbreviations: [],
        },
      },
    },
    P2B9: {
      active: true,
      languages: {
        kr: {
          label: '일반 법인 재단',
          abbreviations: [],
        },
      },
    },
    QU16: {
      active: true,
      languages: {
        kr: {
          label: '국가(정부)',
          abbreviations: [],
        },
      },
    },
    S1IS: {
      active: true,
      languages: {
        kr: {
          label: '일반 법인 협회',
          abbreviations: [],
        },
      },
    },
    UDJG: {
      active: true,
      languages: {
        kr: {
          label: '유한책임회사',
          abbreviations: [],
        },
      },
    },
    UGVB: {
      active: true,
      languages: {
        kr: {
          label: '신탁형 펀드',
          abbreviations: [],
        },
      },
    },
    VTH4: {
      active: true,
      languages: {
        kr: {
          label: '비영리 사단법인',
          abbreviations: [],
        },
      },
    },
    W61J: {
      active: true,
      languages: {
        kr: {
          label: '기타 법인',
          abbreviations: [],
        },
      },
    },
    WUJC: {
      active: true,
      languages: {
        kr: {
          label: '공공단체',
          abbreviations: [],
        },
      },
    },
  },
  XK: {
    '3YUD': {
      active: true,
      languages: {
        sq: {
          label:
            'Ndërmarrjet shoqërore nën administrimin e Agjencisë Kosovare të Privatizimit',
          abbreviations: ['NSH'],
        },
      },
    },
    B56A: {
      active: true,
      languages: {
        sq: {
          label: 'Zyra e Përfaqësisë së Shoqërisë së Huaj Tregtare në Kosovë',
          abbreviations: [],
        },
      },
    },
    CRX3: {
      active: true,
      languages: {
        sq: {
          label: 'Kooperativa Bujqësore',
          abbreviations: ['KB'],
        },
      },
    },
    D37H: {
      active: true,
      languages: {
        sq: {
          label: 'Shoqëri me Përgjegjësi të Kufizuar',
          abbreviations: ['SHPK'],
        },
      },
    },
    OZDY: {
      active: true,
      languages: {
        sq: {
          label: 'Dega e Shoqërisë së Huaj Tregtare në Kosovë',
          abbreviations: ['Kompani e Huaj'],
        },
      },
    },
    Q22D: {
      active: true,
      languages: {
        sq: {
          label: 'Shoqëri aksionare',
          abbreviations: ['SHA'],
        },
      },
    },
    QZEN: {
      active: true,
      languages: {
        sq: {
          label: 'Biznes Individual',
          abbreviations: ['BI'],
        },
      },
    },
    T2X0: {
      active: true,
      languages: {
        sq: {
          label: 'Ortakëri e Përgjithshme',
          abbreviations: ['OP'],
        },
      },
    },
    W5H8: {
      active: true,
      languages: {
        sq: {
          label:
            'Ndërmarrjet publike sipas ligjit në fuqi për ndërmarrjet publike',
          abbreviations: ['NP'],
        },
      },
    },
    W7KV: {
      active: true,
      languages: {
        sq: {
          label: 'Ortakëri e Kufizuar',
          abbreviations: ['OK'],
        },
      },
    },
  },
  KW: {
    '3GQ5': {
      active: true,
      languages: {
        ar: {
          label: 'ملكية فردية ( شركة الشخص الواحد)',
          abbreviations: [],
        },
      },
    },
    '5OKA': {
      active: true,
      languages: {
        ar: {
          label: 'شركة المساھمة المقفلة',
          abbreviations: [],
        },
      },
    },
    '7CAL': {
      active: true,
      languages: {
        ar: {
          label: 'شركة المساهمة العامة',
          abbreviations: [],
        },
      },
    },
    '8CIC': {
      active: true,
      languages: {
        ar: {
          label: 'الشركات غیر الھادفة للربح.',
          abbreviations: [],
        },
      },
    },
    '93LG': {
      active: true,
      languages: {
        ar: {
          label: 'شركة التوصية البسيطة',
          abbreviations: [],
        },
      },
    },
    JLNM: {
      active: true,
      languages: {
        ar: {
          label: 'شركة تضامن',
          abbreviations: [],
        },
      },
    },
    PZCW: {
      active: true,
      languages: {
        ar: {
          label: 'شركة التوصية بالأسهم',
          abbreviations: [],
        },
      },
    },
    QZCG: {
      active: true,
      languages: {
        ar: {
          label: 'الشركة ذات المسؤولية المحدودة',
          abbreviations: ['ذ.م.م'],
        },
      },
    },
    W9RU: {
      active: true,
      languages: {
        ar: {
          label: 'الشركة المھنیة',
          abbreviations: [],
        },
      },
    },
  },
  LV: {
    '1IPK': {
      active: true,
      languages: {
        lv: {
          label: 'Komandītsabiedrība',
          abbreviations: ['KS'],
        },
      },
    },
    '3LCY': {
      active: true,
      languages: {
        lv: {
          label: 'Pilnsabiedrība',
          abbreviations: ['PS'],
        },
      },
    },
    '5ULL': {
      active: true,
      languages: {
        lv: {
          label: 'Eiropas Ekonomisko interešu grupa',
          abbreviations: ['EEIG'],
        },
      },
    },
    AZTM: {
      active: true,
      languages: {
        lv: {
          label: 'Eiropas komercsabiedrība',
          abbreviations: ['SE'],
        },
      },
    },
    BS22: {
      active: true,
      languages: {
        lv: {
          label: 'Individuālais komersants',
          abbreviations: ['IK'],
        },
      },
    },
    ES2D: {
      active: true,
      languages: {
        lv: {
          label: 'Sabiedrība ar ierobežotu atbildību',
          abbreviations: ['SIA'],
        },
      },
    },
    VJBO: {
      active: true,
      languages: {
        lv: {
          label: 'Akciju sabiedrība',
          abbreviations: ['AS'],
        },
      },
    },
  },
  LS: {
    CD8F: {
      active: true,
      languages: {
        en: {
          label: 'Non-profit Company',
          abbreviations: [],
        },
      },
    },
    K6G7: {
      active: true,
      languages: {
        en: {
          label: 'Public Company',
          abbreviations: [],
        },
      },
    },
    S02Y: {
      active: true,
      languages: {
        en: {
          label: 'External Company',
          abbreviations: [],
        },
      },
    },
    S779: {
      active: true,
      languages: {
        en: {
          label: 'Private Company',
          abbreviations: [],
        },
      },
    },
  },
  LI: {
    '12MV': {
      active: true,
      languages: {
        de: {
          label: 'Kommanditaktiengesellschaft',
          abbreviations: [],
        },
      },
    },
    '1DGT': {
      active: true,
      languages: {
        de: {
          label: 'Treuunternehmen',
          abbreviations: ['Trust reg.'],
        },
      },
    },
    '1SOY': {
      active: true,
      languages: {
        de: {
          label: 'Europäische Genossenschaft',
          abbreviations: ['SCE'],
        },
      },
    },
    '32HC': {
      active: true,
      languages: {
        de: {
          label: 'Verein',
          abbreviations: ['e.V.'],
        },
      },
    },
    '4RPP': {
      active: true,
      languages: {
        de: {
          label: 'Kollektivgesellschaft mit beschränkter Haftung',
          abbreviations: [],
        },
      },
    },
    '53QF': {
      active: true,
      languages: {
        de: {
          label: 'Treuhänderschaft',
          abbreviations: [],
        },
      },
    },
    '7RRP': {
      active: true,
      languages: {
        de: {
          label: 'Aktiengesellschaft',
          abbreviations: ['AG'],
        },
      },
    },
    ANSR: {
      active: true,
      languages: {
        de: {
          label: 'Kommanditgesellschaft',
          abbreviations: ['KG'],
        },
      },
    },
    BBB8: {
      active: true,
      languages: {
        de: {
          label: 'Kommanditärengesellschaft',
          abbreviations: [],
        },
      },
    },
    BSZ8: {
      active: true,
      languages: {
        de: {
          label: 'Stiftung',
          abbreviations: [],
        },
      },
    },
    EV7F: {
      active: true,
      languages: {
        de: {
          label: 'Einzelfirma',
          abbreviations: [],
        },
      },
    },
    IF49: {
      active: true,
      languages: {
        de: {
          label: 'Genossenschaft',
          abbreviations: ['eG', 'e.Gen.'],
        },
      },
    },
    K98U: {
      active: true,
      languages: {
        de: {
          label: 'Europäische Wirtschaftliche Interessenvereinigung',
          abbreviations: ['EWIV'],
        },
      },
    },
    NDID: {
      active: true,
      languages: {
        de: {
          label: 'Kollektivgesellschaft',
          abbreviations: [],
        },
      },
    },
    PZV3: {
      active: true,
      languages: {
        de: {
          label: 'Gemeinderschaft',
          abbreviations: [],
        },
      },
    },
    TMU1: {
      active: true,
      languages: {
        de: {
          label: 'Anstalt',
          abbreviations: [],
        },
      },
    },
    TV8Y: {
      active: true,
      languages: {
        de: {
          label: 'Kollektivtreuhänderschaft',
          abbreviations: [],
        },
      },
    },
    W6JC: {
      active: true,
      languages: {
        de: {
          label: 'Personengesellschaft',
          abbreviations: [],
        },
      },
    },
    WAK8: {
      active: true,
      languages: {
        de: {
          label: 'Europäische Gesellschaft',
          abbreviations: ['SE'],
        },
      },
    },
    Y8LH: {
      active: true,
      languages: {
        de: {
          label: 'Gesellschaft mit beschränkter Haftung',
          abbreviations: ['GmbH', 'Ges.m.b.H.'],
        },
      },
    },
  },
  LT: {
    '13T9': {
      active: true,
      languages: {
        lt: {
          label: 'Europos bendrovės',
          abbreviations: ['EB'],
        },
      },
    },
    '4ZF3': {
      active: true,
      languages: {
        lt: {
          label: 'Valstybės įmonės',
          abbreviations: ['VI'],
        },
      },
    },
    '5BY2': {
      active: true,
      languages: {
        lt: {
          label: 'Europos kooperatinės bendrovės',
          abbreviations: ['EKB'],
        },
      },
    },
    '5CIE': {
      active: true,
      languages: {
        lt: {
          label: 'Advokatų profesinės bendrijos',
          abbreviations: ['APB'],
        },
      },
    },
    '5TA8': {
      active: true,
      languages: {
        lt: {
          label: 'Šeimynos',
          abbreviations: ['S'],
        },
      },
    },
    '6JDN': {
      active: true,
      languages: {
        lt: {
          label: 'Profesinės sąjungos ir jų susivienijimai',
          abbreviations: ['PS'],
        },
      },
    },
    '81KA': {
      active: true,
      languages: {
        lt: {
          label: 'Akcinės bendrovės',
          abbreviations: ['AB'],
        },
      },
    },
    A2GC: {
      active: true,
      languages: {
        lt: {
          label: 'Religines bendruomenes, bendrijos ir centrai',
          abbreviations: ['RB'],
        },
      },
    },
    A338: {
      active: true,
      languages: {
        lt: {
          label: 'Individualios įmonės',
          abbreviations: ['II'],
        },
      },
    },
    BGPJ: {
      active: true,
      languages: {
        lt: {
          label: 'Europos ekonominių interesų grupės',
          abbreviations: ['EEIG'],
        },
      },
    },
    BPLS: {
      active: true,
      languages: {
        lt: {
          label: 'Uždarosios akcinės bendrovės',
          abbreviations: ['UAB'],
        },
      },
    },
    DLCX: {
      active: true,
      languages: {
        lt: {
          label: 'Tikrosios ūkinės bendrijos',
          abbreviations: ['TUB'],
        },
      },
    },
    E4HU: {
      active: true,
      languages: {
        lt: {
          label: 'Lietuvos prekybos, pramonės ir amatų rūmų asociacija',
          abbreviations: ['LPRA'],
        },
      },
    },
    F2TQ: {
      active: true,
      languages: {
        lt: {
          label: 'Tradicinės religinės bendruomenės ar bendrijos',
          abbreviations: ['TR'],
        },
      },
    },
    F2ZF: {
      active: true,
      languages: {
        lt: {
          label: 'Asociacijos',
          abbreviations: [],
        },
      },
    },
    HGMH: {
      active: true,
      languages: {
        lt: {
          label: 'Labdaros ir paramos fondai',
          abbreviations: ['LF'],
        },
      },
    },
    HJ1Y: {
      active: true,
      languages: {
        lt: {
          label: 'Bendrijos',
          abbreviations: ['BN'],
        },
      },
    },
    K4GR: {
      active: true,
      languages: {
        lt: {
          label: 'Biudžetinės įstaigos',
          abbreviations: ['BI'],
        },
      },
    },
    KWBA: {
      active: true,
      languages: {
        lt: {
          label: 'Viešosios įstaigos',
          abbreviations: ['VS'],
        },
      },
    },
    LUGM: {
      active: true,
      languages: {
        lt: {
          label: 'Kooperatinės bendrovės (kooperatyvai)',
          abbreviations: ['KO'],
        },
      },
    },
    LUOA: {
      active: true,
      languages: {
        lt: {
          label: 'Komanditinės ūkinės bendrijos',
          abbreviations: ['KB'],
        },
      },
    },
    NVPY: {
      active: true,
      languages: {
        lt: {
          label: 'Privačių detektyvų bendrijos',
          abbreviations: ['PDB'],
        },
      },
    },
    Q4A3: {
      active: true,
      languages: {
        lt: {
          label: 'Prekybos, pramonės ir amatų rūmai',
          abbreviations: ['PER'],
        },
      },
    },
    Q8UI: {
      active: true,
      languages: {
        lt: {
          label: 'Nuolatinės arbitražo institucijos',
          abbreviations: ['NA'],
        },
      },
    },
    QG9Y: {
      active: true,
      languages: {
        lt: {
          label: 'Sodininkų bendrijos',
          abbreviations: ['SD'],
        },
      },
    },
    QRXD: {
      active: true,
      languages: {
        lt: {
          label: 'Europos teritorinio bendradarbiavimo grupės',
          abbreviations: ['ETBG'],
        },
      },
    },
    SFK9: {
      active: true,
      languages: {
        lt: {
          label: 'Bendras valdymo ir pranešimų centras',
          abbreviations: ['CRC'],
        },
      },
    },
    SFYA: {
      active: true,
      languages: {
        lt: {
          label: 'Mažosios bendrijos',
          abbreviations: ['MB'],
        },
      },
    },
    UHNL: {
      active: true,
      languages: {
        lt: {
          label: 'Žemės ūkio bendrovės',
          abbreviations: ['ZUB'],
        },
      },
    },
    WQRG: {
      active: true,
      languages: {
        lt: {
          label: 'Centrinis bankas',
          abbreviations: ['CB'],
        },
      },
    },
    X8J8: {
      active: true,
      languages: {
        lt: {
          label: 'Politinės partijos',
          abbreviations: ['PP'],
        },
      },
    },
    YRXK: {
      active: true,
      languages: {
        lt: {
          label: 'Savivaldybių įmonės',
          abbreviations: ['SI'],
        },
      },
    },
  },
  LU: {
    '2IGL': {
      active: true,
      languages: {
        fr: {
          label: 'Entreprise individuelle',
          abbreviations: ['EI'],
        },
      },
    },
    '2JEI': {
      active: true,
      languages: {
        fr: {
          label: 'Association sans but lucratif',
          abbreviations: ['ASBL'],
        },
      },
    },
    '2S2U': {
      active: true,
      languages: {
        fr: {
          label: "Association d'épargne pension",
          abbreviations: ['ASSEP'],
        },
      },
    },
    '5DWL': {
      active: false,
      languages: {
        fr: {
          label: 'Association momentanée',
          abbreviations: ['AM'],
        },
      },
    },
    '5GGB': {
      active: true,
      languages: {
        fr: {
          label: 'Société anonyme',
          abbreviations: ['SA'],
        },
      },
    },
    '63P9': {
      active: true,
      languages: {
        fr: {
          label: 'Société en commandite simple',
          abbreviations: ['SECS'],
        },
      },
    },
    '68J6': {
      active: true,
      languages: {
        fr: {
          label: 'Association agricole',
          abbreviations: ['AA'],
        },
      },
    },
    '7SIZ': {
      active: true,
      languages: {
        fr: {
          label: 'Mutuelle',
          abbreviations: [],
        },
      },
    },
    '81G5': {
      active: true,
      languages: {
        fr: {
          label: 'Société en commandite par actions',
          abbreviations: ['SECA'],
        },
      },
    },
    '9C91': {
      active: true,
      languages: {
        fr: {
          label: 'Société d’épargne-pension à capital variable',
          abbreviations: ['SEPCAV'],
        },
      },
    },
    AIR5: {
      active: true,
      languages: {
        fr: {
          label: 'Fond commun de placement',
          abbreviations: ['FCP'],
        },
      },
    },
    ATQY: {
      active: true,
      languages: {
        fr: {
          label: 'Société en nom collectif',
          abbreviations: ['SENC'],
        },
      },
    },
    BEAN: {
      active: true,
      languages: {
        fr: {
          label: "Société d'investissement à capital fixe",
          abbreviations: ['SICAF'],
        },
      },
    },
    BKAB: {
      active: true,
      languages: {
        fr: {
          label: "Association d'assurances mutuelles",
          abbreviations: ['AAM'],
        },
      },
    },
    DVXS: {
      active: true,
      languages: {
        fr: {
          label: 'Société à responsabilité limitée',
          abbreviations: ['SARL'],
        },
      },
    },
    EUT4: {
      active: true,
      languages: {
        fr: {
          label: 'Société à responsabilité limitée simplifiée',
          abbreviations: ['S.à r.l.-S'],
        },
      },
    },
    FG84: {
      active: true,
      languages: {
        fr: {
          label: 'Societas Cooperativa Europaea',
          abbreviations: ['SCE'],
        },
      },
    },
    HHR4: {
      active: true,
      languages: {
        fr: {
          label: 'Société par actions simplifiée',
          abbreviations: ['S.A.S.'],
        },
      },
    },
    JIWD: {
      active: true,
      languages: {
        fr: {
          label:
            "Autres personnes morales dont l'immatriculation est prévue par l'article 1 de la loi modifiée du 19 décembre 2002 concernant le registre de commerce et des sociétés ainsi que la comptabilité et les comptes annuels des entreprises",
          abbreviations: ['OTH'],
        },
      },
    },
    LCR0: {
      active: true,
      languages: {
        fr: {
          label: "Groupement d'intérêt économique",
          abbreviations: ['GIE'],
        },
      },
    },
    SQ1A: {
      active: true,
      languages: {
        fr: {
          label: 'Société civile',
          abbreviations: ['SCI'],
        },
      },
    },
    STBC: {
      active: true,
      languages: {
        fr: {
          label: 'Société coopérative organisée sous forme de société anonyme',
          abbreviations: [],
        },
      },
    },
    U8KA: {
      active: true,
      languages: {
        fr: {
          label: 'Société en commandite spéciale',
          abbreviations: ['SECSP'],
        },
      },
    },
    UDY2: {
      active: true,
      languages: {
        fr: {
          label: "Société d'investissement à capital variable",
          abbreviations: ['SICAV'],
        },
      },
    },
    V19Y: {
      active: true,
      languages: {
        fr: {
          label: 'Fondation',
          abbreviations: ['FON'],
        },
      },
    },
    V5OS: {
      active: true,
      languages: {
        fr: {
          label: 'Société coopérative',
          abbreviations: ['SC'],
        },
      },
    },
    V7QY: {
      active: true,
      languages: {
        fr: {
          label: 'Groupement européen d’intérêt économique',
          abbreviations: ['GEIE'],
        },
      },
    },
    WCEP: {
      active: true,
      languages: {
        fr: {
          label: 'Société Européenne',
          abbreviations: ['SE'],
        },
      },
    },
    ZFFA: {
      active: true,
      languages: {
        fr: {
          label: 'Etablissement public',
          abbreviations: ['EP'],
        },
      },
    },
  },
  MY: {
    '7OYN': {
      active: true,
      languages: {
        en: {
          label: 'Public Company',
          abbreviations: ['Bhd', 'Ltd'],
        },
        ms: {
          label: 'Berhad',
          abbreviations: ['Bhd', 'Ltd'],
        },
      },
    },
    SP51: {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    SV3F: {
      active: true,
      languages: {
        en: {
          label: 'Business',
          abbreviations: [],
        },
      },
    },
    XEOV: {
      active: true,
      languages: {
        en: {
          label: 'Private Company',
          abbreviations: ['Sdn Bhd', 'Pte. Ltd'],
        },
        ms: {
          label: 'Sendirian Berhad',
          abbreviations: ['Sdn Bhd', 'Pte. Ltd'],
        },
      },
    },
    '2SPI': {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Islamic Limited Partnership',
          abbreviations: [],
        },
      },
    },
    '6HT0': {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Limited Partnership',
          abbreviations: [],
        },
      },
    },
    '95AW': {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Islamic Charitable Trust',
          abbreviations: [],
        },
      },
    },
    JH78: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Company (Limited By Guarantee)',
          abbreviations: [],
        },
      },
    },
    LA66: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Islamic Other Trust',
          abbreviations: [],
        },
      },
    },
    MEHL: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Islamic Recognized Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    NO8C: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Foreign Company',
          abbreviations: [],
        },
      },
    },
    NY3P: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Islamic Special Trust',
          abbreviations: [],
        },
      },
    },
    OO14: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Islamic Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    P0LR: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Company (Unlimited)',
          abbreviations: [],
        },
      },
    },
    P0TZ: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Limited Liability Partnerships',
          abbreviations: [],
        },
      },
    },
    PBQH: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Trust',
          abbreviations: [],
        },
      },
    },
    PWX8: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Islamic Foundation',
          abbreviations: [],
        },
      },
    },
    QOO6: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Protected Cell Company',
          abbreviations: [],
        },
      },
    },
    S7R4: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Pre-Incorporated Company',
          abbreviations: [],
        },
      },
    },
    SP0A: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Foundation',
          abbreviations: [],
        },
      },
    },
    T5HS: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Isalmic Trust',
          abbreviations: [],
        },
      },
    },
    T635: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Islamic Spendthrift/Protective Trust',
          abbreviations: [],
        },
      },
    },
    TGWE: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Islamic Purpose Trust',
          abbreviations: [],
        },
      },
    },
    TXCW: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Recognized Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    ZWYK: {
      active: true,
      subdivision: 'MY-15',
      languages: {
        en: {
          label: 'Labuan Company (Limited By Share)',
          abbreviations: [],
        },
      },
    },
  },
  MT: {
    '3U3Y': {
      active: true,
      languages: {
        en: {
          label: 'Foundation',
          abbreviations: [],
        },
      },
    },
    '9QHJ': {
      active: true,
      languages: {
        en: {
          label: 'Government entity',
          abbreviations: [],
        },
      },
    },
    BVJ0: {
      active: true,
      languages: {
        en: {
          label: 'Partnership en commendite or limited partnership',
          abbreviations: ['Limited Partnership', 'LP'],
        },
        mt: {
          label: 'Soċjetà in akkomandita jew soċjetà limitata',
          abbreviations: ['Limited Partnership', 'LP'],
        },
      },
    },
    C061: {
      active: true,
      languages: {
        en: {
          label: 'Public Limited Liability Company',
          abbreviations: ['PLC'],
        },
        mt: {
          label: 'Kumpanija pubblika',
          abbreviations: ['PLC'],
        },
      },
    },
    CR7N: {
      active: true,
      languages: {
        en: {
          label: 'European Company',
          abbreviations: ['SE'],
        },
        mt: {
          label: 'Societas Europaea',
          abbreviations: ['SE'],
        },
      },
    },
    DJ2D: {
      active: true,
      languages: {
        en: {
          label: 'Sole trader',
          abbreviations: [],
        },
      },
    },
    F5X7: {
      active: true,
      languages: {
        en: {
          label: 'Cooperative',
          abbreviations: [],
        },
      },
    },
    J4S1: {
      active: true,
      languages: {
        en: {
          label: 'Association',
          abbreviations: [],
        },
      },
    },
    JOZN: {
      active: true,
      languages: {
        en: {
          label: 'Partnership en nom collectif',
          abbreviations: [],
        },
        mt: {
          label: 'Soċjetà f’isem kollettiv',
          abbreviations: [],
        },
      },
    },
    V89C: {
      active: true,
      languages: {
        en: {
          label: 'Private Limited Liability Company',
          abbreviations: ['Limited', 'Ltd'],
        },
        mt: {
          label: 'Kumpanija privata',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    YB0U: {
      active: true,
      languages: {
        en: {
          label: 'European Economic Interest Grouping',
          abbreviations: ['EEIG'],
        },
      },
    },
  },
  MH: {
    DSII: {
      active: true,
      languages: {
        en: {
          label: 'Corporation',
          abbreviations: [],
        },
      },
    },
    EZL8: {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    S69C: {
      active: true,
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    UW1C: {
      active: true,
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
  },
  MU: {
    '4AJY': {
      active: true,
      languages: {
        en: {
          label: 'Business',
          abbreviations: [],
        },
      },
    },
    '6M6Z': {
      active: true,
      languages: {
        en: {
          label: 'Public Company Limited By Guarantee',
          abbreviations: ['LTD', 'LTEE', 'PC', 'PLC'],
        },
      },
    },
    AOS4: {
      active: true,
      languages: {
        en: {
          label: 'Private Company Limited By Guarantee',
          abbreviations: ['LTD', 'LTEE', 'PLC', 'PT'],
        },
      },
    },
    B0LD: {
      active: true,
      languages: {
        en: {
          label: 'Ministries And Parastal Bodies',
          abbreviations: [],
        },
      },
    },
    BVPF: {
      active: true,
      languages: {
        en: {
          label: 'Cooperative',
          abbreviations: ['COOP'],
        },
      },
    },
    G7H0: {
      active: true,
      languages: {
        en: {
          label: 'Private Company',
          abbreviations: ['LTD', 'LTEE', 'PLC', 'PT'],
        },
      },
    },
    J76S: {
      active: true,
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    JWWT: {
      active: true,
      languages: {
        en: {
          label: 'Foundation',
          abbreviations: [],
        },
      },
    },
    O786: {
      active: true,
      languages: {
        fr: {
          label: 'Société',
          abbreviations: ['STE'],
        },
      },
    },
    RJYT: {
      active: true,
      languages: {
        en: {
          label: 'Trade Union',
          abbreviations: ['TU'],
        },
      },
    },
    RTVE: {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    S2J1: {
      active: false,
      languages: {
        en: {
          label: 'Others',
          abbreviations: [],
        },
      },
    },
    XXCZ: {
      active: true,
      languages: {
        en: {
          label: 'Public company limited by shares',
          abbreviations: ['LTD', 'LTEE', 'PC', 'PLC'],
        },
      },
    },
    ZTUI: {
      active: true,
      languages: {
        en: {
          label: 'Association',
          abbreviations: [],
        },
      },
    },
  },
  MX: {
    '23XJ': {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, sociedad de información crediticia',
          abbreviations: [],
        },
      },
    },
    '2LNV': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima de capital variable, institución de seguros',
          abbreviations: [],
        },
      },
    },
    '2NAI': {
      active: true,
      languages: {
        es: {
          label: 'Comunidad',
          abbreviations: [],
        },
      },
    },
    '2RVP': {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima promotora de inversión de capital variable, sociedad financiera de objeto múltiple, entidad no regulada',
          abbreviations: ['S.A.P.I. DE C.V., SOFOM E.N.R.'],
        },
      },
    },
    '31N9': {
      active: true,
      languages: {
        es: {
          label: 'Partido político',
          abbreviations: [],
        },
      },
    },
    '3WVI': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Responsabilidad Limitada Microindustrial',
          abbreviations: ['S. DE R.L. MI'],
        },
      },
    },
    '449I': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de responsabilidad limitada',
          abbreviations: ['S. de R. L.'],
        },
      },
    },
    '4HBI': {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad cooperativa de ahorro y préstamo de capital variable',
          abbreviations: ['S.C. de A. P. de C. V.'],
        },
      },
    },
    '5AWU': {
      active: true,
      languages: {
        es: {
          label: 'Asociación civil',
          abbreviations: ['A. C.'],
        },
      },
    },
    '5K70': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima bursátil de capital variable, casa de bolsa',
          abbreviations: [],
        },
      },
    },
    '6EYT': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad por acciones simplificada de capital variable',
          abbreviations: ['S. A. S. de C. V.'],
        },
      },
    },
    '761Z': {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad de producción rural de responsabilidad limitada de capital variable',
          abbreviations: ['S.P.R. DE R.L. DE C.V.'],
        },
      },
    },
    '776G': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de producción rural de responsabilidad ilimitada',
          abbreviations: [],
        },
      },
    },
    '784B': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima de capital variable, sociedad controladora',
          abbreviations: [],
        },
      },
    },
    '7G15': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Nacional de Crédito',
          abbreviations: ['S.N.C.'],
        },
      },
    },
    '7H63': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad civil',
          abbreviations: ['S. C.'],
        },
      },
    },
    '7L83': {
      active: true,
      languages: {
        es: {
          label: 'Unión ganadera regional especializada',
          abbreviations: [],
        },
      },
    },
    '7PKK': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en comandita simple de capital variable',
          abbreviations: ['S. en C. de C. V.'],
        },
      },
    },
    '8AGD': {
      active: true,
      languages: {
        es: {
          label: 'Unión ganadera regional general',
          abbreviations: [],
        },
      },
    },
    '8M3D': {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad cooperativa de productores de bienes y/o servicios de capital variable',
          abbreviations: [],
        },
      },
    },
    '8MY7': {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, valuadora de acciones de fondos de inversión',
          abbreviations: [],
        },
      },
    },
    '8QZA': {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad cooperativa de responsabilidad limitada de capital variable',
          abbreviations: ['S.C. DE R.L. DE C.V.'],
        },
      },
    },
    '8RRB': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad cooperativa de ahorro y préstamo',
          abbreviations: ['S.C. de A. P.'],
        },
      },
    },
    '8ZUV': {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima, sociedad financiera de objeto múltiple, entidad regulada',
          abbreviations: ['S.A., SOFOM E.R.'],
        },
      },
    },
    '96OC': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad cooperativa',
          abbreviations: [],
        },
      },
    },
    A2A8: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en comandita por acciones',
          abbreviations: ['S. en C. por A.'],
        },
      },
    },
    ANXC: {
      active: true,
      languages: {
        es: {
          label: 'Federación de sindicatos',
          abbreviations: [],
        },
      },
    },
    AOKU: {
      active: true,
      languages: {
        es: {
          label: 'Unión de ejidos',
          abbreviations: [],
        },
      },
    },
    B3WQ: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima de capital variable, unión de crédito',
          abbreviations: [],
        },
      },
    },
    B8CE: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima',
          abbreviations: ['S. A.'],
        },
      },
    },
    BFIV: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima, casa de cambio',
          abbreviations: [],
        },
      },
    },
    BOF1: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en nombre colectivo',
          abbreviations: [],
        },
      },
    },
    C4Z4: {
      active: true,
      languages: {
        es: {
          label: 'Asociación rural de interés colectivo',
          abbreviations: [],
        },
      },
    },
    CAF9: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima, centro cambiario',
          abbreviations: [],
        },
      },
    },
    COVJ: {
      active: true,
      languages: {
        es: {
          label: 'Organismo de integración financiera rural',
          abbreviations: [],
        },
      },
    },
    CU5R: {
      active: true,
      languages: {
        es: {
          label: 'Asociación ganadera local general',
          abbreviations: [],
        },
      },
    },
    CU68: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad cooperativa limitada de capital variable',
          abbreviations: ['S.C.L. de C.V.'],
        },
      },
    },
    DBU3: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima  de capital variable, financiera comunitaria',
          abbreviations: [],
        },
      },
    },
    DHY2: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima financiera comunitaria',
          abbreviations: [],
        },
      },
    },
    DNF1: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima, sociedad financiera de objeto múltiple, entidad no regulada',
          abbreviations: ['S.A., SOFOM E.N.R.'],
        },
      },
    },
    DU8H: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad cooperativa de consumidores de bienes y/o servicios de capital variable',
          abbreviations: [],
        },
      },
    },
    E0YZ: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de producción rural de responsabilidad suplementada',
          abbreviations: [],
        },
      },
    },
    EHWD: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, de inversión especializada de fondos para el retiro',
          abbreviations: ['S. A. de C.V., Siefore'],
        },
      },
    },
    F3L5: {
      active: true,
      languages: {
        es: {
          label: 'Fondos de Aseguramiento Agropecuario y Rural',
          abbreviations: [],
        },
      },
    },
    FVTS: {
      active: true,
      languages: {
        es: {
          label: 'Unión de sociedades de producción rural',
          abbreviations: [],
        },
      },
    },
    G3JV: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, operadora de fondos de inversión',
          abbreviations: [],
        },
      },
    },
    G522: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad cooperativa de consumidores de bienes y/o servicios',
          abbreviations: [],
        },
      },
    },
    G73Q: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, contraparte central de valores',
          abbreviations: [],
        },
      },
    },
    GNNT: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, administradora de fondos para el retiro',
          abbreviations: ['S. A. de C.V., Afore'],
        },
      },
    },
    GW1T: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima bursátil',
          abbreviations: ['S.A.B.'],
        },
      },
    },
    GXBE: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima promotora de inversión de capital variable, sociedad financiera de objeto múltiple, entidad regulada',
          abbreviations: ['S.A. P.I. de C.V. , SOFOM E.R.'],
        },
      },
    },
    H725: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, fondo de inversión de objeto limitado',
          abbreviations: ['S. A. de C. V., F. I. de O. L.'],
        },
      },
    },
    HKWO: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, sociedad financiera de objeto múltiple, entidad no regulada',
          abbreviations: ['S.A. de C.V., SOFOM E.N.R.'],
        },
      },
    },
    ICXT: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, institución para el depósito de valores',
          abbreviations: [],
        },
      },
    },
    IWNQ: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, institución de financiamiento colectivo',
          abbreviations: [],
        },
      },
    },
    JGV1: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima de capital variable',
          abbreviations: ['S. A. de C. V.'],
        },
      },
    },
    JN6Y: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad cooperativa de capital variable',
          abbreviations: [],
        },
      },
    },
    JRAQ: {
      active: true,
      languages: {
        es: {
          label: 'Agrupaciones financieras',
          abbreviations: ['A.F.'],
        },
      },
    },
    JSTL: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de solidaridad social',
          abbreviations: ['S. de S. S.'],
        },
      },
    },
    JZ1I: {
      active: true,
      languages: {
        es: {
          label: 'Sindicato',
          abbreviations: [],
        },
      },
    },
    L2MQ: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad de responsabilidad limitada de interés público de capital variable',
          abbreviations: ['S. de R. L. de I. P. de C. V.'],
        },
      },
    },
    L9JC: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima bursátil de capital variable',
          abbreviations: ['S.A.B. de C.V.'],
        },
      },
    },
    LBPW: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima  de capital variable, financiera popular',
          abbreviations: [],
        },
      },
    },
    LJTR: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad por acciones simplificada',
          abbreviations: ['S. A. S.'],
        },
      },
    },
    LOB9: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad propietaria de tierras agrícolas, ganaderas o forestales',
          abbreviations: [],
        },
      },
    },
    LVRX: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima, almacén general de depósito, organización auxiliar del crédito',
          abbreviations: [],
        },
      },
    },
    M0SL: {
      active: true,
      languages: {
        es: {
          label: 'Municipio',
          abbreviations: ['Mpo.'],
        },
      },
    },
    M44Q: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima de capital variable, centro cambiario',
          abbreviations: [],
        },
      },
    },
    MAM6: {
      active: true,
      languages: {
        es: {
          label: 'Institución de asistencia privada',
          abbreviations: ['I.A.P.'],
        },
      },
    },
    MB35: {
      active: true,
      languages: {
        es: {
          label: 'Ejido',
          abbreviations: [],
        },
      },
    },
    N0JF: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima, bolsa de valores',
          abbreviations: [],
        },
      },
    },
    N124: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, institución de fondos de pago electrónico',
          abbreviations: [],
        },
      },
    },
    NA09: {
      active: true,
      languages: {
        es: {
          label: 'Asociación religiosa',
          abbreviations: [],
        },
      },
    },
    NHBK: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, fondo de inversión de capitales',
          abbreviations: ['S. A. de C. V., F. I. de C.'],
        },
      },
    },
    NSZI: {
      active: true,
      languages: {
        es: {
          label: 'Unidad agrícola industrial de la mujer',
          abbreviations: ['UAIM'],
        },
      },
    },
    O15R: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima de capital variable, casa de cambio',
          abbreviations: [],
        },
      },
    },
    OZ3O: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima promotora de inversión bursátil',
          abbreviations: ['S.A. P.I. B.'],
        },
      },
    },
    P28E: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, sociedad financiera de objeto múltiple, entidad regulada',
          abbreviations: ['S.A. de C.V., SOFOM E.R.'],
        },
      },
    },
    P7VS: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima institución de fianzas',
          abbreviations: [],
        },
      },
    },
    P8D7: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima institución de banca múltiple',
          abbreviations: [],
        },
      },
    },
    PG49: {
      active: true,
      languages: {
        es: {
          label: 'Confederación de sindicatos',
          abbreviations: [],
        },
      },
    },
    Q7WY: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, almacén general de depósito, organización auxiliar del crédito',
          abbreviations: [],
        },
      },
    },
    QAUY: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de producción rural de responsabilidad limitada',
          abbreviations: ['SPR'],
        },
      },
    },
    QM7Z: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima de capital variable, casa de bolsa',
          abbreviations: [],
        },
      },
    },
    QZB4: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima bursátil de capital variable, bolsa de valores',
          abbreviations: [],
        },
      },
    },
    R8PY: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima de capital variable, bolsa de valores',
          abbreviations: [],
        },
      },
    },
    RCE0: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, fondo de inversión de renta variable',
          abbreviations: ['S. A. de C. V., F. I. de R. V.'],
        },
      },
    },
    RCJS: {
      active: true,
      languages: {
        es: {
          label:
            'Corporaciones de carácter público reconocidos por la legislación mexicana',
          abbreviations: [],
        },
      },
    },
    RKLI: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima, sociedad de información crediticia',
          abbreviations: [],
        },
      },
    },
    RQDD: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima bursátil, sociedad financiera de objeto múltiple, entidad regulada',
          abbreviations: ['S.A.B. SOFOM E.R.'],
        },
      },
    },
    RR3L: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima promotora de inversión bursátil de capital variable',
          abbreviations: ['S.A.P.I.B. de C.V.'],
        },
      },
    },
    S6M8: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad nacional de crédito institución de banca de desarrollo',
          abbreviations: [],
        },
      },
    },
    S8DM: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima institución de seguros',
          abbreviations: [],
        },
      },
    },
    SKO4: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad mutualista',
          abbreviations: [],
        },
      },
    },
    TPJZ: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima promotora de inversión',
          abbreviations: ['S.A. P.I.'],
        },
      },
    },
    TTIF: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima bursátil de capital variable, sociedad financiera de objeto múltiple, entidad no regulada',
          abbreviations: ['S.A.B. DE C.V., SOFOM E.N.R.'],
        },
      },
    },
    TYW0: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima bursátil de capital variable, sociedad controladora',
          abbreviations: [],
        },
      },
    },
    U77P: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima de capital variable, institución de fianzas',
          abbreviations: [],
        },
      },
    },
    U901: {
      active: true,
      languages: {
        es: {
          label: 'Instituciones de Seguros',
          abbreviations: [],
        },
      },
    },
    UBV0: {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad anónima de capital variable, fondo de inversión en instrumentos de deuda',
          abbreviations: ['S. A. de C. V., F. I. en I. D.'],
        },
      },
    },
    VATV: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima promotora de inversión de capital variable',
          abbreviations: ['S.A. P.I. de C.V.'],
        },
      },
    },
    VIOQ: {
      active: true,
      languages: {
        es: {
          label: 'Estado',
          abbreviations: ['Edo.'],
        },
      },
    },
    VN3F: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad cooperativa de productores de bienes y/o servicios',
          abbreviations: [],
        },
      },
    },
    W9WS: {
      active: true,
      languages: {
        es: {
          label: 'Empresa productiva del estado',
          abbreviations: ['E.P.E.'],
        },
      },
    },
    X9J8: {
      active: true,
      languages: {
        es: {
          label: 'Asociación ganadera local especializada',
          abbreviations: [],
        },
      },
    },
    XDGC: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad cooperativa limitada',
          abbreviations: ['S.C.L.'],
        },
      },
    },
    XEN5: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en comandita simple',
          abbreviations: ['S. en C.'],
        },
      },
    },
    XLVZ: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de responsabilidad limitada de capital variable',
          abbreviations: ['S. de R. L. de C. V.'],
        },
      },
    },
    XSZY: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad anónima financiera popular',
          abbreviations: [],
        },
      },
    },
    YRI0: {
      active: true,
      languages: {
        es: {
          label: 'Fideicomiso público de fomento económico',
          abbreviations: [],
        },
      },
    },
    ZAIS: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en nombre colectivo de capital variable',
          abbreviations: [],
        },
      },
    },
    ZXVG: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en comandita por acciones de capital variable',
          abbreviations: ['S. en C. por A. de C. V.'],
        },
      },
    },
  },
  MC: {
    '528Z': {
      active: true,
      languages: {
        fr: {
          label: 'Société en Commandite Simple',
          abbreviations: ['SCS'],
        },
      },
    },
    CWTQ: {
      active: true,
      languages: {
        fr: {
          label: 'Société Anonyme Monégasque',
          abbreviations: ['SAM'],
        },
      },
    },
    DA06: {
      active: true,
      languages: {
        fr: {
          label: 'Société à Responsabilité Limitée',
          abbreviations: ['SARL'],
        },
      },
    },
    GWZF: {
      active: true,
      languages: {
        fr: {
          label: 'Société Civile Particulière',
          abbreviations: ['SCP'],
        },
      },
    },
    TU6A: {
      active: true,
      languages: {
        fr: {
          label: 'Société en Nom Collectif',
          abbreviations: ['SNC'],
        },
      },
    },
    X7W6: {
      active: true,
      languages: {
        fr: {
          label: 'Entreprise en Nom Personnel',
          abbreviations: [],
        },
      },
    },
  },
  MM: {
    '3FI5': {
      active: true,
      languages: {
        my: {
          label: 'ခံ၀န်ချက်အားဖြင့် တာ၀န်ကန့်သတ်ထားသည့်ကုမ္ပဏီ၊',
          abbreviations: [],
        },
      },
    },
    '478A': {
      active: true,
      languages: {
        my: {
          label:
            'အစုအားဖြင့်တာ၀န်ကန့်သတ်ထားသည့်အများနှင့် မသက်ဆိုင်သည့်ကုမ္ပဏီ၊',
          abbreviations: [],
        },
      },
    },
    CPNU: {
      active: true,
      languages: {
        my: {
          label: 'စီးပွားရေးလုပ်ငန်းအသင်းအဖွဲ့၊',
          abbreviations: [],
        },
      },
    },
    FJK0: {
      active: true,
      languages: {
        my: {
          label:
            '၁၉၅၀ ခုနှစ် အထူးကုမ္ပဏီအက်ဥပဒေအရ အစုအားဖြင့်တာ၀န်ကန့်သတ်ထားသည့် အများနှင့် သက်ဆိုင်သည့်ကုမ္ပဏီ၊',
          abbreviations: [],
        },
      },
    },
    G54B: {
      active: true,
      languages: {
        my: {
          label: 'တာ၀န်ကန့်သတ်မထားသည့်ကုမ္ပဏီ၊',
          abbreviations: [],
        },
      },
    },
    QUC7: {
      active: true,
      languages: {
        my: {
          label:
            'အစုအားဖြင့်တာ၀န်ကန့်သတ်ထားသည့်အများနှင့် သက်ဆိုင်သည့်ကုမ္ပဏီ၊',
          abbreviations: [],
        },
      },
    },
    T3FE: {
      active: true,
      languages: {
        my: {
          label:
            '၁၉၅၀ ခုနှစ် အထူးကုမ္ပဏီအက်ဥပဒေအရ အစုအားဖြင့်တာ၀န်ကန့်သတ်ထားသည့်အများနှင့် မသက်ဆိုင်သည့်ကုမ္ပဏီ၊',
          abbreviations: [],
        },
      },
    },
  },
  NL: {
    '33MN': {
      active: true,
      languages: {
        nl: {
          label: 'Vereniging met volledige rechtsbevoegdheid',
          abbreviations: [],
        },
      },
    },
    '4QXM': {
      active: true,
      languages: {
        nl: {
          label: 'Eenmanszaak',
          abbreviations: [],
        },
      },
    },
    '54M6': {
      active: true,
      languages: {
        nl: {
          label: 'Besloten vennootschap met beperkte aansprakelijkheid',
          abbreviations: ['BV'],
        },
      },
    },
    '5WU6': {
      active: true,
      languages: {
        nl: {
          label: 'Europees Economisch Samenwerkingsverband',
          abbreviations: ['EESV'],
        },
      },
    },
    '62Y3': {
      active: true,
      languages: {
        nl: {
          label: 'Vennootschap onder firma',
          abbreviations: ['VOF'],
        },
      },
    },
    '8VFX': {
      active: true,
      languages: {
        nl: {
          label: 'Vereniging met beperkte rechtsbevoegdheid',
          abbreviations: [],
        },
      },
    },
    '9AAK': {
      active: true,
      languages: {
        nl: {
          label: 'Maatschap',
          abbreviations: [],
        },
      },
    },
    A0W7: {
      active: true,
      languages: {
        nl: {
          label: 'Publiekrechtelijke rechtspersoon',
          abbreviations: [],
        },
      },
    },
    B5PM: {
      active: true,
      languages: {
        nl: {
          label: 'Naamloze vennootschap',
          abbreviations: ['NV'],
        },
      },
    },
    BBEB: {
      active: true,
      languages: {
        nl: {
          label: 'Europese naamloze vennootschap (Societas Europaea)',
          abbreviations: ['SE'],
        },
      },
    },
    CODH: {
      active: true,
      languages: {
        nl: {
          label: 'Commanditaire vennootschap',
          abbreviations: ['CV'],
        },
      },
    },
    DEO1: {
      active: true,
      languages: {
        nl: {
          label: 'Onderlinge waarborgmaatschappij',
          abbreviations: ['OWM'],
        },
      },
    },
    EZQW: {
      active: true,
      languages: {
        nl: {
          label: 'Rechtspersoon in oprichting',
          abbreviations: ['RP io'],
        },
      },
    },
    GNXT: {
      active: true,
      languages: {
        nl: {
          label: 'Vereniging van eigenaars',
          abbreviations: ['VVE'],
        },
      },
    },
    JHK5: {
      active: true,
      languages: {
        nl: {
          label: 'Fonds voor gemene rekening',
          abbreviations: [],
        },
      },
    },
    L7HX: {
      active: true,
      languages: {
        nl: {
          label: 'Kerkgenootschap',
          abbreviations: [],
        },
      },
    },
    M1IZ: {
      active: true,
      languages: {
        nl: {
          label: 'Overige Privaatrechtelijke Rechtspersoon',
          abbreviations: [],
        },
      },
    },
    NFFH: {
      active: true,
      languages: {
        nl: {
          label: 'Coöperatie',
          abbreviations: ['coöp'],
        },
      },
    },
    UNJ2: {
      active: true,
      languages: {
        nl: {
          label: 'Rederij',
          abbreviations: [],
        },
      },
    },
    V44D: {
      active: true,
      languages: {
        nl: {
          label: 'Stichting',
          abbreviations: [],
        },
      },
    },
    Y3ZB: {
      active: true,
      languages: {
        nl: {
          label: 'Societas Cooperativa Europaea',
          abbreviations: ['SCE'],
        },
      },
    },
  },
  NZ: {
    '4LEA': {
      active: true,
      languages: {
        en: {
          label: 'Unlimited Liability Company',
          abbreviations: ['Ultd', 'Unltd'],
        },
      },
    },
    F7KI: {
      active: true,
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    P2R9: {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    Q4BE: {
      active: true,
      languages: {
        en: {
          label: 'Government entity',
          abbreviations: [],
        },
      },
    },
    Z6ZU: {
      active: true,
      languages: {
        en: {
          label: 'Cooperative Company',
          abbreviations: ['COOP'],
        },
      },
    },
  },
  MK: {
    '149O': {
      active: true,
      languages: {
        mk: {
          label: 'Командитно друштво со акции',
          abbreviations: ['KDA'],
        },
      },
    },
    DTIU: {
      active: true,
      languages: {
        mk: {
          label: 'Акционерско друштво',
          abbreviations: ['AD'],
        },
      },
    },
    HEXO: {
      active: true,
      languages: {
        mk: {
          label: 'Јавно трговско друштво',
          abbreviations: ['JTD'],
        },
      },
    },
    JCK1: {
      active: true,
      languages: {
        mk: {
          label: 'Стопанска интересна заедница',
          abbreviations: ['SIZ'],
        },
      },
    },
    KHAB: {
      active: true,
      languages: {
        mk: {
          label: 'Друштво со ограничена одговрност',
          abbreviations: ['DOO'],
        },
      },
    },
    KXDY: {
      active: true,
      languages: {
        mk: {
          label:
            'Подрушница на странско трговско друштво, односно на странски трговрец поединец',
          abbreviations: [],
        },
      },
    },
    VPFY: {
      active: true,
      languages: {
        mk: {
          label: 'Трговец поединец',
          abbreviations: ['TP'],
        },
      },
    },
    XH7Z: {
      active: true,
      languages: {
        mk: {
          label: 'Командитно друштво',
          abbreviations: ['KD'],
        },
      },
    },
  },
  NO: {
    '326Y': {
      active: true,
      languages: {
        no: {
          label: 'Ansvarlig selskap',
          abbreviations: ['ANS'],
        },
      },
    },
    '3C7U': {
      active: true,
      languages: {
        no: {
          label: 'Stiftelse',
          abbreviations: [],
        },
      },
    },
    '3L58': {
      active: true,
      languages: {
        no: {
          label: 'Kommunalt foretak',
          abbreviations: ['KF'],
        },
      },
    },
    '4ZRR': {
      active: false,
      languages: {
        no: {
          label: 'Norskregistrert utenlandsk foretak',
          abbreviations: ['NUF'],
        },
      },
    },
    '50TD': {
      active: true,
      languages: {
        no: {
          label: 'Statsforetak',
          abbreviations: ['SF'],
        },
      },
    },
    '5ZTZ': {
      active: true,
      languages: {
        no: {
          label: 'Fylkeskommunalt foretak',
          abbreviations: ['FKF'],
        },
      },
    },
    '8S9H': {
      active: true,
      languages: {
        no: {
          label: 'Gjensidig forsikringsselskap',
          abbreviations: [],
        },
      },
    },
    '9DI1': {
      active: true,
      languages: {
        no: {
          label: 'Boligbyggelag',
          abbreviations: ['BBL'],
        },
      },
    },
    AEV1: {
      active: true,
      languages: {
        no: {
          label: 'Partrederi',
          abbreviations: [],
        },
      },
    },
    BJ65: {
      active: true,
      languages: {
        no: {
          label: 'Pensjonskasse',
          abbreviations: [],
        },
      },
    },
    CF5L: {
      active: true,
      languages: {
        no: {
          label: 'Ansvarlig selskap, delt ansvar',
          abbreviations: ['DA'],
        },
      },
    },
    DRPL: {
      active: true,
      languages: {
        no: {
          label: 'Europeisk økonomisk foretaksgruppe',
          abbreviations: ['EØFG'],
        },
      },
    },
    EXD7: {
      active: true,
      languages: {
        no: {
          label: 'Enkeltpersonforetak',
          abbreviations: ['ENK'],
        },
      },
    },
    FSBD: {
      active: true,
      languages: {
        no: {
          label: 'Forening',
          abbreviations: [],
        },
      },
    },
    GYY6: {
      active: false,
      languages: {
        no: {
          label: 'Annen juridisk person',
          abbreviations: [],
        },
      },
    },
    IQGE: {
      active: true,
      languages: {
        no: {
          label: 'Allmennaksjeselskap',
          abbreviations: ['ASA'],
        },
      },
    },
    K5P8: {
      active: true,
      languages: {
        no: {
          label: 'Samvirkeforetak',
          abbreviations: ['SA'],
        },
      },
    },
    KX7D: {
      active: true,
      languages: {
        no: {
          label: 'Fylkeskommune',
          abbreviations: [],
        },
      },
    },
    LJJW: {
      active: true,
      languages: {
        no: {
          label: 'Verdipapirfond',
          abbreviations: [],
        },
      },
    },
    M9IQ: {
      active: true,
      languages: {
        no: {
          label: 'Kommandittselskap',
          abbreviations: ['KS'],
        },
      },
    },
    O0EU: {
      active: true,
      languages: {
        no: {
          label: 'Borettslag',
          abbreviations: ['BRL'],
        },
      },
    },
    O7LB: {
      active: true,
      languages: {
        no: {
          label: 'Europeisk samvirkeforetak',
          abbreviations: ['SCE'],
        },
      },
    },
    PB3V: {
      active: true,
      languages: {
        no: {
          label: 'Konkursbo',
          abbreviations: [],
        },
      },
    },
    Q0Q1: {
      active: true,
      languages: {
        no: {
          label: 'Selskap med begrenset ansvar',
          abbreviations: ['BA'],
        },
      },
    },
    R71C: {
      active: true,
      languages: {
        no: {
          label: 'Sparebank',
          abbreviations: [],
        },
      },
    },
    V06W: {
      active: true,
      languages: {
        no: {
          label: 'Europeisk selskap',
          abbreviations: ['SE'],
        },
      },
    },
    YI42: {
      active: true,
      languages: {
        no: {
          label: 'Aksjeselskap',
          abbreviations: ['AS'],
        },
      },
    },
    YTMC: {
      active: true,
      languages: {
        no: {
          label: 'Interkommunalt selskap',
          abbreviations: ['IKS'],
        },
      },
    },
    ZQ0Q: {
      active: true,
      languages: {
        no: {
          label: 'Eierseksjonssameie',
          abbreviations: [],
        },
      },
    },
  },
  PK: {
    '4XMS': {
      active: true,
      languages: {
        en: {
          label: 'Private Limited Company (multi member)',
          abbreviations: ['Pvt. Ltd.'],
        },
      },
    },
    '7IYW': {
      active: true,
      languages: {
        en: {
          label: 'Company Limited by Guarantee (having share capital)',
          abbreviations: ['(Guarantee) Ltd.'],
        },
      },
    },
    '88OX': {
      active: true,
      languages: {
        en: {
          label: 'Private Limited Company (single member)',
          abbreviations: ['SMC'],
        },
      },
    },
    LH0Q: {
      active: true,
      languages: {
        en: {
          label: 'Unlimited Company',
          abbreviations: ['Ultd', 'Unlimited', 'Unltd'],
        },
      },
    },
    MOI8: {
      active: true,
      languages: {
        en: {
          label: 'Public Limited Company (not-for profit association)',
          abbreviations: [],
        },
      },
    },
    QR25: {
      active: true,
      languages: {
        en: {
          label: 'Company Limited by Guarantee (without share capital)',
          abbreviations: ['(Guarantee) Ltd.'],
        },
      },
    },
    RKYF: {
      active: true,
      languages: {
        en: {
          label: 'Public Limited Company (unlisted)',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    VQV6: {
      active: true,
      languages: {
        en: {
          label: 'Public Limited Company (listed)',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    XBK3: {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
  },
  PA: {
    '6TPA': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anónima',
          abbreviations: ['S.A.'],
        },
      },
    },
    BSN7: {
      active: true,
      languages: {
        es: {
          label: 'Asociación',
          abbreviations: [],
        },
      },
    },
    GDT9: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Civil',
          abbreviations: ['S.C.'],
        },
      },
    },
    JS13: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Responsabilidad Limitada',
          abbreviations: ['S.R.L.'],
        },
      },
    },
    PY5Y: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita por acciones',
          abbreviations: [],
        },
      },
    },
    UNCO: {
      active: true,
      languages: {
        es: {
          label: 'Fundación de Interés Privado',
          abbreviations: ['F.I.P.'],
        },
      },
    },
    V5VG: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita simple',
          abbreviations: [],
        },
      },
    },
    VIMA: {
      active: true,
      languages: {
        es: {
          label: 'Micro-empresa de Responsabilidad Limitada',
          abbreviations: ['M.R.L.'],
        },
      },
    },
  },
  PG: {
    '6UED': {
      active: true,
      languages: {
        en: {
          label: 'Local Company',
          abbreviations: [],
        },
      },
    },
    WHCV: {
      active: true,
      languages: {
        en: {
          label: 'Foreign Enterprise',
          abbreviations: [],
        },
      },
    },
    ZE1G: {
      active: true,
      languages: {
        en: {
          label: 'Overseas Company',
          abbreviations: [],
        },
      },
    },
  },
  PY: {
    '48X2': {
      active: true,
      languages: {
        es: {
          label: 'Empresa Unipersonal De Responsabilidad Limitada',
          abbreviations: ['E.I.R.L'],
        },
      },
    },
    '4QBB': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad En Comandita Simple',
          abbreviations: ['S.C'],
        },
      },
    },
    '78SG': {
      active: true,
      languages: {
        es: {
          label: 'Empresa Unipersonal',
          abbreviations: ['E.U'],
        },
      },
    },
    IJAO: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anonima',
          abbreviations: ['S.A.'],
        },
      },
    },
    K08V: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad De Responsabilidad Limitada',
          abbreviations: ['S.R.L'],
        },
      },
    },
    LNG8: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad En Comandita Por Acciones',
          abbreviations: ['S.C.A'],
        },
      },
    },
  },
  PE: {
    '1MQ6': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita por Acciones',
          abbreviations: ['S. en C. por A.'],
        },
      },
    },
    '37G2': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad por Acciones Cerrada Simplificada',
          abbreviations: ['S.A.C.S.'],
        },
      },
    },
    '3LHF': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Colectiva',
          abbreviations: ['S.C.'],
        },
      },
    },
    '4LCX': {
      active: true,
      languages: {
        es: {
          label: 'Empresas de Derecho Público',
          abbreviations: [],
        },
      },
    },
    '649C': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Civil de Responsabilidad Limitada',
          abbreviations: ['S. Civil de R. L.'],
        },
      },
    },
    '73C0': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Comercial de Responsabilidad Limitada',
          abbreviations: ['SRL'],
        },
      },
    },
    AABQ: {
      active: true,
      languages: {
        es: {
          label: 'Empresas Multicomunales',
          abbreviations: [],
        },
      },
    },
    CHX6: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anónima Cerrada',
          abbreviations: ['SAC'],
        },
      },
    },
    H8G2: {
      active: true,
      languages: {
        es: {
          label: 'Empresa Individual de Responsabilidad Limitada',
          abbreviations: ['EIRL'],
        },
      },
    },
    I695: {
      active: true,
      languages: {
        es: {
          label: 'Socieda Anónima',
          abbreviations: ['SA'],
        },
      },
    },
    P53M: {
      active: true,
      languages: {
        es: {
          label: 'Cooperativas',
          abbreviations: [],
        },
      },
    },
    PKRY: {
      active: true,
      languages: {
        es: {
          label: 'Socieda Anónima Abierta',
          abbreviations: ['SAA'],
        },
      },
    },
    QQWG: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Civil',
          abbreviations: ['S. Civil'],
        },
      },
    },
    RFJT: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad en Comandita Simple',
          abbreviations: ['S. en C.'],
        },
      },
    },
    YMBC: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad legal',
          abbreviations: [],
        },
      },
    },
  },
  PH: {
    '76ME': {
      active: true,
      languages: {
        en: {
          label: 'Nonstock corporation',
          abbreviations: [],
        },
      },
    },
    IODM: {
      active: true,
      languages: {
        en: {
          label: 'Educational corporation',
          abbreviations: [],
        },
      },
    },
    KJOW: {
      active: true,
      languages: {
        en: {
          label: 'One person corporation',
          abbreviations: ['OPC'],
        },
      },
    },
    SPX9: {
      active: true,
      languages: {
        en: {
          label: 'Close corporation',
          abbreviations: [],
        },
      },
    },
    WHGH: {
      active: true,
      languages: {
        en: {
          label: 'Stock corporation',
          abbreviations: ['Inc.'],
        },
      },
    },
    ZJEX: {
      active: true,
      languages: {
        en: {
          label: 'Religious corporation',
          abbreviations: [],
        },
      },
    },
  },
  PL: {
    '13ZV': {
      active: true,
      languages: {
        pl: {
          label: 'Samodzielny publiczny zakład opieki zdrowotnej',
          abbreviations: [],
        },
      },
    },
    '3BJG': {
      active: true,
      languages: {
        pl: {
          label: 'Spółka partnerska',
          abbreviations: ['sp.p.'],
        },
      },
    },
    '5F76': {
      active: true,
      languages: {
        pl: {
          label: 'Cechy i izby rzemieślnicze, izby gospodarcze',
          abbreviations: [],
        },
      },
    },
    '60BG': {
      active: true,
      languages: {
        pl: {
          label:
            'Organy władzy, administracji rządowej, kontroli państwowej i ochrony prawa oraz sądy i trybunały',
          abbreviations: [],
        },
      },
    },
    '629I': {
      active: true,
      languages: {
        pl: {
          label: 'Spółka jawna',
          abbreviations: ['s.j.', 'Sp.j.'],
        },
      },
    },
    '6LUM': {
      active: true,
      languages: {
        pl: {
          label: 'Główny oddział zagranicznego zakładu reasekuracji',
          abbreviations: [],
        },
      },
    },
    '6OYI': {
      active: true,
      languages: {
        pl: {
          label: 'Zrzeszenie',
          abbreviations: [],
        },
      },
    },
    '85PM': {
      active: true,
      languages: {
        pl: {
          label: 'Europejskie Zgrupowanie Interesów Gospodarczych',
          abbreviations: ['EZIG'],
        },
      },
    },
    '8TOF': {
      active: true,
      languages: {
        pl: {
          label: 'Spółdzielnia',
          abbreviations: [],
        },
      },
    },
    '96XK': {
      active: true,
      languages: {
        pl: {
          label: 'Fundacja',
          abbreviations: [],
        },
      },
    },
    AL9T: {
      active: true,
      languages: {
        pl: {
          label: 'Samorządowe jednostki organizacyjne',
          abbreviations: [],
        },
      },
    },
    B21W: {
      active: true,
      languages: {
        pl: {
          label: 'Prosta spółka akcyjna',
          abbreviations: ['PSA'],
        },
      },
    },
    BSJT: {
      active: true,
      languages: {
        pl: {
          label: 'Spółka komandytowa',
          abbreviations: ['sp.k.'],
        },
      },
    },
    CY1M: {
      active: true,
      languages: {
        pl: {
          label: 'Instytucje gospodarki budżetowej',
          abbreviations: [],
        },
      },
    },
    EU0T: {
      active: true,
      languages: {
        pl: {
          label: 'Towarzystwo reasekuracji wzajemnej',
          abbreviations: [],
        },
      },
    },
    F21U: {
      active: true,
      languages: {
        pl: {
          label: 'Skarb Państwa',
          abbreviations: [],
        },
      },
    },
    FANM: {
      active: true,
      languages: {
        pl: {
          label: 'Kółka rolnicze',
          abbreviations: [],
        },
      },
    },
    FJ0E: {
      active: true,
      languages: {
        pl: {
          label: 'Spółka akcyjna',
          abbreviations: ['S.A.'],
        },
      },
    },
    FQ5Y: {
      active: true,
      languages: {
        pl: {
          label: 'Organizacje społeczne i zawodowe',
          abbreviations: [],
        },
      },
    },
    GZE5: {
      active: true,
      languages: {
        pl: {
          label: 'Wspólnota mieszkaniowa',
          abbreviations: [],
        },
      },
    },
    H7OD: {
      active: true,
      languages: {
        pl: {
          label: 'Spółdzielcza kasa oszczędnościowo-kredytowa',
          abbreviations: [],
        },
      },
    },
    HOT8: {
      active: true,
      languages: {
        pl: {
          label: 'Partie polityczne',
          abbreviations: [],
        },
      },
    },
    J3A3: {
      active: true,
      languages: {
        pl: {
          label: 'Spółka europejska',
          abbreviations: ['SE'],
        },
      },
    },
    JCKO: {
      active: true,
      languages: {
        pl: {
          label: 'Państwowe jednostki organizacyjne',
          abbreviations: [],
        },
      },
    },
    KM66: {
      active: true,
      languages: {
        pl: {
          label: 'Instytuty badawcze',
          abbreviations: [],
        },
      },
    },
    LT9U: {
      active: true,
      languages: {
        pl: {
          label: 'Związek zawodowy',
          abbreviations: [],
        },
      },
    },
    O7XB: {
      active: true,
      languages: {
        pl: {
          label: 'Spółka z ograniczoną odpowiedzialnością',
          abbreviations: ['sp. z o.o.'],
        },
      },
    },
    OMX0: {
      active: true,
      languages: {
        pl: {
          label: 'Spółka komandytowo-akcyjna',
          abbreviations: ['S.K.A.'],
        },
      },
    },
    P1L1: {
      active: true,
      languages: {
        pl: {
          label: 'Główny oddział zagranicznego zakładu ubezpieczeń',
          abbreviations: [],
        },
      },
    },
    QUX1: {
      active: true,
      languages: {
        pl: {
          label: 'Otwarty fundusz emerytalny',
          abbreviations: ['OFE'],
        },
      },
    },
    QYL4: {
      active: true,
      languages: {
        pl: {
          label: 'Placówki systemu oświaty',
          abbreviations: [],
        },
      },
    },
    RBHP: {
      active: true,
      languages: {
        pl: {
          label: 'Fundusz inwestycyjny',
          abbreviations: [],
        },
      },
    },
    RUCO: {
      active: false,
      languages: {
        pl: {
          label: 'Oddział przedsiębiorcy zagranicznego',
          abbreviations: [],
        },
      },
    },
    SMIS: {
      active: true,
      languages: {
        pl: {
          label: 'Przedsiębiorstwo państwowe',
          abbreviations: [],
        },
      },
    },
    SP4S: {
      active: true,
      languages: {
        pl: {
          label: 'Kościoł i związki wyznaniowe',
          abbreviations: [],
        },
      },
    },
    SVA3: {
      active: true,
      languages: {
        pl: {
          label:
            'Fundusze inne niż inwestycyjne i inne niż otwarte fundusze emerytalne',
          abbreviations: [],
        },
      },
    },
    T7PB: {
      active: true,
      languages: {
        pl: {
          label: 'Wspólnoty samorządowe',
          abbreviations: [],
        },
      },
    },
    WNX1: {
      active: true,
      languages: {
        pl: {
          label: 'Towarzystwo ubezpieczeń wzajemnych',
          abbreviations: ['TUW'],
        },
      },
    },
    WOK7: {
      active: true,
      languages: {
        pl: {
          label: 'Związki inne niż zawodowe',
          abbreviations: [],
        },
      },
    },
    WUJ2: {
      active: true,
      languages: {
        pl: {
          label: 'Uczelnia',
          abbreviations: [],
        },
      },
    },
    YLZL: {
      active: true,
      languages: {
        pl: {
          label: 'Spółka cywilna',
          abbreviations: ['s.c.'],
        },
      },
    },
    ZVVM: {
      active: true,
      languages: {
        pl: {
          label: 'Osoby fizyczne prowadzące działalność gospodarczą',
          abbreviations: [],
        },
      },
    },
    ZZKE: {
      active: true,
      languages: {
        pl: {
          label: 'Stowarzyszenie i związki stowarzyszeń',
          abbreviations: [],
        },
      },
    },
  },
  PT: {
    '1HGD': {
      active: true,
      languages: {
        pt: {
          label: 'Cooperativa',
          abbreviations: [],
        },
      },
    },
    '5KVH': {
      active: true,
      languages: {
        pt: {
          label: 'Cooperativa de 2º Grau',
          abbreviations: [],
        },
      },
    },
    '68PD': {
      active: false,
      languages: {
        pt: {
          label: 'Representação Permanente',
          abbreviations: [],
        },
      },
    },
    '6IK8': {
      active: true,
      languages: {
        pt: {
          label: 'Entidade Empresarial Intermunicipal',
          abbreviations: [],
        },
      },
    },
    '6L6P': {
      active: true,
      languages: {
        pt: {
          label: 'Fundo',
          abbreviations: [],
        },
      },
    },
    '99JD': {
      active: true,
      languages: {
        pt: {
          label: 'Agrupamento Europeu de Interesse Económico',
          abbreviations: ['AEIE'],
        },
      },
    },
    A8CT: {
      active: true,
      languages: {
        pt: {
          label: 'Entidade Pública Empresarial',
          abbreviations: [],
        },
      },
    },
    ALPT: {
      active: true,
      languages: {
        pt: {
          label: 'Associação',
          abbreviations: [],
        },
      },
    },
    D7OA: {
      active: true,
      languages: {
        pt: {
          label: 'Entidade Empresarial Municipal',
          abbreviations: [],
        },
      },
    },
    DFE5: {
      active: true,
      languages: {
        pt: {
          label: 'Sociedade Anónima',
          abbreviations: [],
        },
      },
    },
    IX01: {
      active: true,
      languages: {
        pt: {
          label: 'Empresa Intermunicipal',
          abbreviations: [],
        },
      },
    },
    KUUV: {
      active: true,
      languages: {
        pt: {
          label: 'Organismo da Administração Pública',
          abbreviations: [],
        },
      },
    },
    MFHR: {
      active: true,
      languages: {
        pt: {
          label: 'Sociedade Anónima Europeia',
          abbreviations: ['SE'],
        },
      },
    },
    N66B: {
      active: true,
      languages: {
        pt: {
          label: 'Sociedade em Nome Coletivo',
          abbreviations: [],
        },
      },
    },
    NIQY: {
      active: true,
      languages: {
        pt: {
          label: 'Entidade Empresarial Metropolitana',
          abbreviations: [],
        },
      },
    },
    OXUC: {
      active: true,
      languages: {
        pt: {
          label: 'Sociedade em Comandita',
          abbreviations: [],
        },
      },
    },
    P5S3: {
      active: true,
      languages: {
        pt: {
          label: 'Pessoa Coletiva de Direito Público',
          abbreviations: [],
        },
      },
    },
    PIDC: {
      active: true,
      languages: {
        pt: {
          label: 'Empresa Municipal',
          abbreviations: [],
        },
      },
    },
    QFXD: {
      active: true,
      languages: {
        pt: {
          label: 'Pessoa Coletiva Internacional',
          abbreviations: [],
        },
      },
    },
    USOG: {
      active: true,
      languages: {
        pt: {
          label: 'Sociedade por Quotas',
          abbreviations: [],
        },
      },
    },
    V6YL: {
      active: true,
      languages: {
        pt: {
          label: 'Societas Cooperativa Europaea',
          abbreviations: ['SCE'],
        },
      },
    },
    VALH: {
      active: true,
      languages: {
        pt: {
          label: 'Empresário em Nome Individual',
          abbreviations: [],
        },
      },
    },
    VF4C: {
      active: true,
      languages: {
        pt: {
          label: 'Sociedade Unipessoal por Quotas',
          abbreviations: [],
        },
      },
    },
    W9W3: {
      active: true,
      languages: {
        pt: {
          label: 'Sociedade Anónima Desportiva',
          abbreviations: [],
        },
      },
    },
    XD16: {
      active: true,
      languages: {
        pt: {
          label: 'Empresa Metropolitana',
          abbreviations: [],
        },
      },
    },
    XMXM: {
      active: false,
      languages: {
        pt: {
          label: 'Fundo',
          abbreviations: [],
        },
      },
    },
    YMLD: {
      active: true,
      languages: {
        pt: {
          label: 'Agrupamento Complementar de Empresas',
          abbreviations: [],
        },
      },
    },
    Z0NE: {
      active: true,
      languages: {
        pt: {
          label: 'Fundação',
          abbreviations: [],
        },
      },
    },
    ZILA: {
      active: true,
      languages: {
        pt: {
          label: 'Estabelecimento Individual de Responsabilidade Limitada',
          abbreviations: [],
        },
      },
    },
    ZSWE: {
      active: true,
      languages: {
        pt: {
          label: 'Empresa Regional',
          abbreviations: [],
        },
      },
    },
    IKBN: {
      active: true,
      subdivision: 'PT-30',
      languages: {
        pt: {
          label: 'Trust',
          abbreviations: [],
        },
      },
    },
    Z7ZX: {
      active: true,
      subdivision: 'PT-30',
      languages: {
        pt: {
          label: 'Sucursal Financeira Exterior',
          abbreviations: [],
        },
      },
    },
  },
  PR: {
    '194I': {
      active: false,
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: [],
        },
        es: {
          label: 'Corporación Especial para el Desarrollo Municipal',
          abbreviations: [],
        },
      },
    },
    '1TG4': {
      active: true,
      languages: {
        en: {
          label: 'Low Profit LLC',
          abbreviations: [],
        },
        es: {
          label: 'Compañía de Responsabilidad Limitada con Fin Social',
          abbreviations: [],
        },
      },
    },
    '35RF': {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
        es: {
          label: 'Compañía de Responsabilidad Limitada',
          abbreviations: [],
        },
      },
    },
    '3QX8': {
      active: false,
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
        es: {
          label: 'Cooperative de Juvenil',
          abbreviations: [],
        },
      },
    },
    '4XY9': {
      active: false,
      languages: {
        en: {
          label: 'Trust',
          abbreviations: [],
        },
        es: {
          label: 'Entidad Financiera Internacional (Corporación)',
          abbreviations: [],
        },
      },
    },
    '6DE6': {
      active: false,
      languages: {
        en: {
          label: 'Close Corporation',
          abbreviations: [],
        },
        es: {
          label: 'Centro Bancario Internacional (Corporación)',
          abbreviations: [],
        },
      },
    },
    '7JAI': {
      active: false,
      languages: {
        en: {
          label: 'Special Employee Owned Corporation',
          abbreviations: [],
        },
        es: {
          label: 'Empressa Municipal',
          abbreviations: [],
        },
      },
    },
    '81YI': {
      active: false,
      languages: {
        en: {
          label: 'International Financial Entity (LLC)',
          abbreviations: [],
        },
        es: {
          label: 'Cooperative de Trabajadores',
          abbreviations: [],
        },
      },
    },
    '87N3': {
      active: true,
      languages: {
        es: {
          label: 'Cooperativa de Consumo',
          abbreviations: [],
        },
        en: {
          label: 'Consumer Cooperative',
          abbreviations: [],
        },
      },
    },
    '9EGO': {
      active: true,
      languages: {
        en: {
          label: 'Bank (LLC)',
          abbreviations: [],
        },
        es: {
          label: 'Banco (CRL)',
          abbreviations: [],
        },
      },
    },
    A4MM: {
      active: false,
      languages: {
        en: {
          label: 'International Banking Center (Corporation)',
          abbreviations: [],
        },
        es: {
          label: 'Compañía de Seguros',
          abbreviations: [],
        },
      },
    },
    BQ6L: {
      active: false,
      languages: {
        en: {
          label: 'Sponsored By Municipal Corporation',
          abbreviations: [],
        },
        es: {
          label: 'Entidad Financiera Internacional (CRL)',
          abbreviations: [],
        },
      },
    },
    C907: {
      active: false,
      languages: {
        en: {
          label: 'Youth Cooperative',
          abbreviations: [],
        },
        es: {
          label: 'Sociedad de Responsabilidad Limitada',
          abbreviations: [],
        },
      },
    },
    D5L6: {
      active: false,
      languages: {
        en: {
          label: 'Consumer Cooperative',
          abbreviations: [],
        },
        es: {
          label: 'Centro Bancario Internacional (CRL)',
          abbreviations: [],
        },
      },
    },
    D8XQ: {
      active: true,
      languages: {
        en: {
          label: 'Municipal Enterprise',
          abbreviations: [],
        },
        es: {
          label: 'Empressa Municipal',
          abbreviations: [],
        },
      },
    },
    DE7H: {
      active: true,
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: [],
        },
        es: {
          label: 'Corporación Professional',
          abbreviations: [],
        },
      },
    },
    E85L: {
      active: false,
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
        es: {
          label: 'Corporación',
          abbreviations: [],
        },
      },
    },
    EQQP: {
      active: true,
      languages: {
        en: {
          label: 'Special Employee Owned Corporation',
          abbreviations: [],
        },
        es: {
          label: 'Corporación Especial Propiedad de Trabajadores',
          abbreviations: [],
        },
      },
    },
    ERUM: {
      active: false,
      languages: {
        en: {
          label: 'Public Benefit Corporation',
          abbreviations: [],
        },
        es: {
          label: 'Corporación Especial Propiedad de Trabajadores',
          abbreviations: [],
        },
      },
    },
    GCP3: {
      active: true,
      languages: {
        en: {
          label: 'International Financial Entity (LLC)',
          abbreviations: [],
        },
        es: {
          label: 'Entidad Financiera Internacional (CRL)',
          abbreviations: [],
        },
      },
    },
    GL33: {
      active: true,
      languages: {
        es: {
          label: 'Centro Bancario Internacional (Corporación)',
          abbreviations: [],
        },
        en: {
          label: 'International Banking Center (Corporation)',
          abbreviations: [],
        },
      },
    },
    GRH5: {
      active: true,
      languages: {
        en: {
          label: 'Workers Cooperative',
          abbreviations: [],
        },
        es: {
          label: 'Cooperativa de Trabajadores',
          abbreviations: [],
        },
      },
    },
    I1WG: {
      active: false,
      languages: {
        en: {
          label: 'Municipal Enterprise',
          abbreviations: [],
        },
        es: {
          label: 'Corporación de Beneficio Social',
          abbreviations: [],
        },
      },
    },
    I6FV: {
      active: true,
      languages: {
        en: {
          label: 'Savings & Credit Cooperative',
          abbreviations: [],
        },
        es: {
          label: 'Cooperativa de Ahorro y Crédito',
          abbreviations: [],
        },
      },
    },
    INDH: {
      active: false,
      languages: {
        en: {
          label: 'Corporation',
          abbreviations: [],
        },
        es: {
          label: 'Compañía de Responsabilidad Limitada',
          abbreviations: [],
        },
      },
    },
    JJ1V: {
      active: true,
      languages: {
        en: {
          label: 'Trust',
          abbreviations: [],
        },
        es: {
          label: 'Fideicomiso',
          abbreviations: [],
        },
      },
    },
    ME4Y: {
      active: true,
      languages: {
        en: {
          label: 'Public Benefit Corporation',
          abbreviations: [],
        },
        es: {
          label: 'Corporación de Beneficio Social',
          abbreviations: [],
        },
      },
    },
    O2JM: {
      active: true,
      languages: {
        en: {
          label: 'Youth Cooperative',
          abbreviations: [],
        },
        es: {
          label: 'Cooperativa de Juvenil',
          abbreviations: [],
        },
      },
    },
    O4QG: {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
        es: {
          label: 'Sociedad de Responsabilidad Limitada',
          abbreviations: [],
        },
      },
    },
    O8XV: {
      active: true,
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    RA5B: {
      active: true,
      languages: {
        en: {
          label: 'International Banking Center (LLC)',
          abbreviations: [],
        },
        es: {
          label: 'Centro Bancario Internacional (CRL)',
          abbreviations: [],
        },
      },
    },
    SOQ1: {
      active: false,
      languages: {
        en: {
          label: 'Workers Cooperative',
          abbreviations: [],
        },
        es: {
          label: 'Fideicomiso',
          abbreviations: [],
        },
      },
    },
    SQXC: {
      active: false,
      languages: {
        en: {
          label: 'Insurance Company',
          abbreviations: [],
        },
        es: {
          label: 'Compañía de Responsabilidad Limitada con Fin Social',
          abbreviations: [],
        },
      },
    },
    T2JS: {
      active: true,
      languages: {
        en: {
          label: 'Close Corporation',
          abbreviations: [],
        },
        es: {
          label: 'Corporación Intima',
          abbreviations: [],
        },
      },
    },
    TEGV: {
      active: true,
      languages: {
        en: {
          label: 'Special Corporation for Municipal Development',
          abbreviations: [],
        },
        es: {
          label: 'Corporación Especial para el Desarrollo Municipal',
          abbreviations: [],
        },
      },
    },
    TPFL: {
      active: true,
      languages: {
        en: {
          label: 'Bank (Corporation)',
          abbreviations: [],
        },
        es: {
          label: 'Banco (Corporación)',
          abbreviations: [],
        },
      },
    },
    UL6C: {
      active: false,
      languages: {
        en: {
          label: 'Savings & Credit Cooperative',
          abbreviations: [],
        },
        es: {
          label: 'Corporación Intima',
          abbreviations: [],
        },
      },
    },
    VKSV: {
      active: true,
      languages: {
        en: {
          label: 'Insurance Company',
          abbreviations: [],
        },
        es: {
          label: 'Compañía de Seguros',
          abbreviations: [],
        },
      },
    },
    W6NI: {
      active: true,
      languages: {
        en: {
          label: 'International Financial Entity (Corporation)',
          abbreviations: [],
        },
        es: {
          label: 'Entidad Financiera Internacional (Corporación)',
          abbreviations: [],
        },
      },
    },
    XK6L: {
      active: false,
      languages: {
        en: {
          label: 'International Financial Entity (Corporation)',
          abbreviations: [],
        },
        es: {
          label: 'Cooperative de Consumo',
          abbreviations: [],
        },
      },
    },
    XUYT: {
      active: false,
      languages: {
        en: {
          label: 'International Banking Center (LLC)',
          abbreviations: [],
        },
        es: {
          label: 'Cooperative de Ahorro y Crédito',
          abbreviations: [],
        },
      },
    },
    Y21X: {
      active: true,
      languages: {
        en: {
          label: 'Sponsored By Municipal Corporation',
          abbreviations: [],
        },
        es: {
          label: 'Corporación Auspiciada Por Municipios',
          abbreviations: [],
        },
      },
    },
    Y3T2: {
      active: false,
      languages: {
        en: {
          label: 'Special Corporation for Municipal Development',
          abbreviations: [],
        },
        es: {
          label: 'Corporación Professional',
          abbreviations: [],
        },
      },
    },
    Y7LW: {
      active: false,
      languages: {
        en: {
          label: 'Low Profit LLC',
          abbreviations: [],
        },
        es: {
          label: 'Corporación Auspiciada Por Municipios',
          abbreviations: [],
        },
      },
    },
    YS16: {
      active: true,
      languages: {
        en: {
          label: 'Corporation',
          abbreviations: [],
        },
        es: {
          label: 'Corporación',
          abbreviations: [],
        },
      },
    },
  },
  QA: {
    ADV0: {
      active: true,
      languages: {
        ar: {
          label: 'الشركة ذات المسؤولية المحدودة',
          abbreviations: ['ذ.م.م'],
        },
      },
    },
    B4L0: {
      active: true,
      languages: {
        ar: {
          label: 'شركة المحاصة',
          abbreviations: [],
        },
      },
    },
    KHBL: {
      active: true,
      languages: {
        ar: {
          label: 'شركة التوصية البسيطة',
          abbreviations: [],
        },
      },
    },
    OR18: {
      active: true,
      languages: {
        ar: {
          label: 'شركة التضامن',
          abbreviations: [],
        },
      },
    },
    QZ84: {
      active: true,
      languages: {
        ar: {
          label: 'شركة المساهمة العامة',
          abbreviations: ['ش.م.ع'],
        },
      },
    },
    RN1W: {
      active: true,
      languages: {
        ar: {
          label: 'شركة التوصية بالأسهم',
          abbreviations: [],
        },
      },
    },
    W50Q: {
      active: true,
      languages: {
        ar: {
          label: 'شركة المساهمة الخاصة',
          abbreviations: ['ش.م.خ'],
        },
      },
    },
  },
  RO: {
    '1CDX': {
      active: true,
      languages: {
        ro: {
          label: 'Societate europeană',
          abbreviations: ['SE'],
        },
      },
    },
    '37II': {
      active: true,
      languages: {
        ro: {
          label: 'Cooperativă meșteșugărească',
          abbreviations: [],
        },
      },
    },
    '4V0A': {
      active: true,
      languages: {
        ro: {
          label: 'Grupul european de interes economic',
          abbreviations: ['GEIE'],
        },
      },
    },
    '5NCK': {
      active: true,
      languages: {
        ro: {
          label: 'Organizație non-guvernamentală',
          abbreviations: ['ONG'],
        },
      },
    },
    '7B9H': {
      active: true,
      languages: {
        ro: {
          label: 'Societate cooperativă',
          abbreviations: [],
        },
      },
    },
    '7W9B': {
      active: true,
      languages: {
        ro: {
          label:
            'Organizații cooperatiste de credit și casele centrale ale acestora',
          abbreviations: [],
        },
      },
    },
    '85K5': {
      active: true,
      languages: {
        ro: {
          label: 'Reprezentanta',
          abbreviations: [],
        },
      },
    },
    '8FD2': {
      active: true,
      languages: {
        ro: {
          label: 'Cooperativă de consum',
          abbreviations: [],
        },
      },
    },
    AI01: {
      active: true,
      languages: {
        ro: {
          label: 'Persoana fizica independentă',
          abbreviations: ['PFI'],
        },
      },
    },
    ANDT: {
      active: true,
      languages: {
        ro: {
          label: 'Societate pe acţiuni',
          abbreviations: ['SA'],
        },
      },
    },
    CTBD: {
      active: true,
      languages: {
        ro: {
          label: 'Alte forme de proprietate',
          abbreviations: [],
        },
      },
    },
    CUGP: {
      active: true,
      languages: {
        ro: {
          label: 'Regie autonomă',
          abbreviations: ['RA'],
        },
      },
    },
    DUGD: {
      active: true,
      languages: {
        ro: {
          label: 'Intreprindere individuala',
          abbreviations: ['II'],
        },
      },
    },
    EFBR: {
      active: true,
      languages: {
        ro: {
          label: 'Grupul de interes economic',
          abbreviations: ['GIE'],
        },
      },
    },
    F0BK: {
      active: true,
      languages: {
        ro: {
          label: 'Societate agricolă',
          abbreviations: [],
        },
      },
    },
    F68H: {
      active: true,
      languages: {
        ro: {
          label: 'Societate în nume colectiv',
          abbreviations: ['SNC'],
        },
      },
    },
    FJQ8: {
      active: true,
      languages: {
        ro: {
          label: 'Persoana fizica autorizata',
          abbreviations: ['PFA'],
        },
      },
    },
    GT4V: {
      active: true,
      languages: {
        ro: {
          label: 'Cooperativă de credit',
          abbreviations: [],
        },
      },
    },
    I15K: {
      active: true,
      languages: {
        ro: {
          label: 'Cooperativă agricolă',
          abbreviations: [],
        },
      },
    },
    I9BB: {
      active: false,
      languages: {
        ro: {
          label: 'Sucursala',
          abbreviations: [],
        },
      },
    },
    NFRJ: {
      active: true,
      languages: {
        ro: {
          label: 'Reprezentant fiscal',
          abbreviations: [],
        },
      },
    },
    SWMK: {
      active: true,
      languages: {
        ro: {
          label: 'Societate în comandită pe acţiuni',
          abbreviations: ['SCA'],
        },
      },
    },
    TH8A: {
      active: true,
      languages: {
        ro: {
          label: 'Asociatie familiala',
          abbreviations: ['AF'],
        },
      },
    },
    UWEE: {
      active: true,
      languages: {
        ro: {
          label: 'Societate Cooperativă Europeană',
          abbreviations: ['SCE'],
        },
      },
    },
    V0FL: {
      active: true,
      languages: {
        ro: {
          label: 'Societate în comandită simplă',
          abbreviations: ['SCS'],
        },
      },
    },
    XHN1: {
      active: true,
      languages: {
        ro: {
          label: 'Societate cu răspundere limitată',
          abbreviations: ['SRL'],
        },
      },
    },
  },
  RU: {
    '15A2': {
      active: true,
      languages: {
        ru: {
          label:
            'Объединения (ассоциации и союзы) благотворительных организаций',
          abbreviations: [],
        },
      },
    },
    '17R7': {
      active: true,
      languages: {
        ru: {
          label: 'Общества с ограниченной ответственностью',
          abbreviations: [],
        },
      },
    },
    '1MJ0': {
      active: true,
      languages: {
        ru: {
          label: 'Крестьянские (фермерские) хозяйства',
          abbreviations: [],
        },
      },
    },
    '1RJ2': {
      active: true,
      languages: {
        ru: {
          label: 'Автономные некоммерческие организации',
          abbreviations: [],
        },
      },
    },
    '1U7Y': {
      active: true,
      languages: {
        ru: {
          label: 'Благотворительные учреждения',
          abbreviations: [],
        },
      },
    },
    '24TU': {
      active: true,
      languages: {
        ru: {
          label: 'Союзы (ассоциации) общественных объединений',
          abbreviations: [],
        },
      },
    },
    '2H36': {
      active: true,
      languages: {
        ru: {
          label: 'Союзы (ассоциации) кооперативов',
          abbreviations: [],
        },
      },
    },
    '2OTW': {
      active: true,
      languages: {
        ru: {
          label: 'Муниципальные автономные учреждения',
          abbreviations: [],
        },
      },
    },
    '2R46': {
      active: true,
      languages: {
        ru: {
          label: 'Товарищества собственников жилья',
          abbreviations: [],
        },
      },
    },
    '37YG': {
      active: true,
      languages: {
        ru: {
          label: 'Федеральные казенные предприятия',
          abbreviations: [],
        },
      },
    },
    '3AMJ': {
      active: true,
      languages: {
        ru: {
          label: 'Сельскохозяйственные производственные кооперативы',
          abbreviations: [],
        },
      },
    },
    '3EAX': {
      active: true,
      languages: {
        ru: {
          label:
            'Производственные кооперативы (кроме сельскохозяйственных производственных кооперативов)',
          abbreviations: [],
        },
      },
    },
    '3F98': {
      active: true,
      languages: {
        ru: {
          label: 'Учреждения',
          abbreviations: [],
        },
      },
    },
    '3TOV': {
      active: true,
      languages: {
        ru: {
          label: 'Профсоюзные организации',
          abbreviations: [],
        },
      },
    },
    '3U8X': {
      active: true,
      languages: {
        ru: {
          label:
            'Прочие юридические лица, являющиеся коммерческими организациями',
          abbreviations: [],
        },
      },
    },
    '4PZX': {
      active: true,
      languages: {
        ru: {
          label: 'Учреждения, созданные субъектом Российской Федерации',
          abbreviations: [],
        },
      },
    },
    '4TYO': {
      active: true,
      languages: {
        ru: {
          label: 'Публичные акционерные общества',
          abbreviations: [],
        },
      },
    },
    '4VTZ': {
      active: true,
      languages: {
        ru: {
          label: 'Ассоциации (союзы)',
          abbreviations: [],
        },
      },
    },
    '5VMR': {
      active: true,
      languages: {
        ru: {
          label: 'Адвокаты, учредившие адвокатский кабинет',
          abbreviations: [],
        },
      },
    },
    '6H83': {
      active: true,
      languages: {
        ru: {
          label:
            'Сельскохозяйственные потребительские животноводческие кооперативы',
          abbreviations: [],
        },
      },
    },
    '8B9A': {
      active: true,
      languages: {
        ru: {
          label: 'Жилищные или жилищно-строительные кооперативы',
          abbreviations: [],
        },
      },
    },
    '8JWV': {
      active: true,
      languages: {
        ru: {
          label: 'Государственные академии наук',
          abbreviations: [],
        },
      },
    },
    '8MQM': {
      active: true,
      languages: {
        ru: {
          label:
            'Государственные бюджетные учреждения субъектов Российской Федерации',
          abbreviations: [],
        },
      },
    },
    '8NF7': {
      active: true,
      languages: {
        ru: {
          label: 'Федеральные государственные бюджетные учреждения',
          abbreviations: [],
        },
      },
    },
    '8NZE': {
      active: true,
      languages: {
        ru: {
          label:
            'Садоводческие, огороднические или дачные потребительские кооперативы',
          abbreviations: [],
        },
      },
    },
    '8RIH': {
      active: true,
      languages: {
        ru: {
          label: 'Публично-правовые компании',
          abbreviations: [],
        },
      },
    },
    '8XDD': {
      active: true,
      languages: {
        ru: {
          label:
            'Советы муниципальных образований субъектов Российской Федерации',
          abbreviations: [],
        },
      },
    },
    '9M15': {
      active: true,
      languages: {
        ru: {
          label: 'Центральный банк',
          abbreviations: [],
        },
      },
    },
    '9RQZ': {
      active: true,
      languages: {
        ru: {
          label:
            'Государственные унитарные предприятия субъектов Российской Федерации',
          abbreviations: [],
        },
      },
    },
    AS78: {
      active: true,
      languages: {
        ru: {
          label: 'Адвокатские бюро',
          abbreviations: [],
        },
      },
    },
    B5GH: {
      active: true,
      languages: {
        ru: {
          label:
            'Казачьи общества, внесенные в государственный реестр казачьих обществ в Российской Федерации',
          abbreviations: [],
        },
      },
    },
    BLVV: {
      active: true,
      languages: {
        ru: {
          label: 'Кредитные потребительские кооперативы',
          abbreviations: [],
        },
      },
    },
    BQ3A: {
      active: true,
      languages: {
        ru: {
          label: 'Гаражные и гаражно-строительные кооперативы',
          abbreviations: [],
        },
      },
    },
    BZQL: {
      active: true,
      languages: {
        ru: {
          label:
            'Организационно-правовые формы для деятельности граждан (физических лиц)',
          abbreviations: [],
        },
      },
    },
    C3RQ: {
      active: true,
      languages: {
        ru: {
          label:
            'Организационно-правовые формы юридических лиц, являющихся некоммерческими корпоративными организациями',
          abbreviations: [],
        },
      },
    },
    C7TI: {
      active: true,
      languages: {
        ru: {
          label:
            'Ассоциации (союзы) садоводческих, огороднических и дачных некоммерческих объединений',
          abbreviations: [],
        },
      },
    },
    CKTA: {
      active: true,
      languages: {
        ru: {
          label: 'Некоммерческие партнерства',
          abbreviations: [],
        },
      },
    },
    CN7I: {
      active: true,
      languages: {
        ru: {
          label: 'Фонды проката',
          abbreviations: [],
        },
      },
    },
    D094: {
      active: true,
      languages: {
        ru: {
          label: 'Экологические фонды',
          abbreviations: [],
        },
      },
    },
    D84J: {
      active: true,
      languages: {
        ru: {
          label: 'Общественные организации',
          abbreviations: [],
        },
      },
    },
    DO25: {
      active: true,
      languages: {
        ru: {
          label: 'Государственные компании',
          abbreviations: [],
        },
      },
    },
    DZSY: {
      active: true,
      languages: {
        ru: {
          label: 'Казенные предприятия субъектов Российской Федерации',
          abbreviations: [],
        },
      },
    },
    E0VI: {
      active: true,
      languages: {
        ru: {
          label: 'Государственные корпорации',
          abbreviations: [],
        },
      },
    },
    EH3M: {
      active: true,
      languages: {
        ru: {
          label: 'Общественные фонды',
          abbreviations: [],
        },
      },
    },
    EWQF: {
      active: true,
      languages: {
        ru: {
          label:
            'Организационно-правовые формы для коммерческой деятельности граждан',
          abbreviations: [],
        },
      },
    },
    FWGK: {
      active: true,
      languages: {
        ru: {
          label: 'Муниципальные бюджетные учреждения',
          abbreviations: [],
        },
      },
    },
    FZKX: {
      active: true,
      languages: {
        ru: {
          label: 'Производственные кооперативы (артели)',
          abbreviations: [],
        },
      },
    },
    G2CW: {
      active: true,
      languages: {
        ru: {
          label: 'Территориальные общественные самоуправления',
          abbreviations: [],
        },
      },
    },
    GHC5: {
      active: true,
      languages: {
        ru: {
          label:
            'Сельскохозяйственные потребительские огороднические кооперативы',
          abbreviations: [],
        },
      },
    },
    GQRJ: {
      active: true,
      languages: {
        ru: {
          label: 'Учреждения, созданные Российской Федерацией',
          abbreviations: [],
        },
      },
    },
    GWHK: {
      active: true,
      languages: {
        ru: {
          label: 'Общины коренных малочисленных народов Российской Федерации',
          abbreviations: [],
        },
      },
    },
    GZF9: {
      active: true,
      languages: {
        ru: {
          label:
            'Структурные подразделения обособленных подразделений юридических лиц',
          abbreviations: [],
        },
      },
    },
    H2AF: {
      active: true,
      languages: {
        ru: {
          label: 'Товарищества собственников недвижимости',
          abbreviations: [],
        },
      },
    },
    H2P4: {
      active: true,
      languages: {
        ru: {
          label: 'Кредитные кооперативы второго уровня',
          abbreviations: [],
        },
      },
    },
    H4NY: {
      active: true,
      languages: {
        ru: {
          label: 'Адвокатские палаты',
          abbreviations: [],
        },
      },
    },
    HKKL: {
      active: true,
      languages: {
        ru: {
          label: 'Федеральные государственные автономные учреждения',
          abbreviations: [],
        },
      },
    },
    HUET: {
      active: true,
      languages: {
        ru: {
          label: 'Религиозные организации',
          abbreviations: [],
        },
      },
    },
    HUR1: {
      active: true,
      languages: {
        ru: {
          label:
            'Сельскохозяйственные потребительские обслуживающие кооперативы',
          abbreviations: [],
        },
      },
    },
    I9O1: {
      active: true,
      languages: {
        ru: {
          label:
            'Сельскохозяйственные потребительские перерабатывающие кооперативы',
          abbreviations: [],
        },
      },
    },
    I9V2: {
      active: true,
      languages: {
        ru: {
          label:
            'Организационно-правовые формы юридических лиц, являющихся некоммерческими унитарными организациями',
          abbreviations: [],
        },
      },
    },
    IBSS: {
      active: true,
      languages: {
        ru: {
          label:
            'Сельскохозяйственные потребительские снабженческие кооперативы',
          abbreviations: [],
        },
      },
    },
    IC46: {
      active: true,
      languages: {
        ru: {
          label: 'Сельскохозяйственные артели (колхозы)',
          abbreviations: [],
        },
      },
    },
    ILY0: {
      active: true,
      languages: {
        ru: {
          label: 'Саморегулируемые организации',
          abbreviations: [],
        },
      },
    },
    J18N: {
      active: true,
      languages: {
        ru: {
          label: 'Товарищества на вере (коммандитные товарищества)',
          abbreviations: [],
        },
      },
    },
    J7NW: {
      active: true,
      languages: {
        ru: {
          label: 'Простые товарищества',
          abbreviations: [],
        },
      },
    },
    JPMQ: {
      active: true,
      languages: {
        ru: {
          label:
            'Организационно-правовые формы организаций, созданных без прав юридического лица',
          abbreviations: [],
        },
      },
    },
    JZBN: {
      active: true,
      languages: {
        ru: {
          label: 'Непубличные акционерные общества',
          abbreviations: [],
        },
      },
    },
    KLA2: {
      active: true,
      languages: {
        ru: {
          label: 'Хозяйственные товарищества',
          abbreviations: [],
        },
      },
    },
    KOYR: {
      active: true,
      languages: {
        ru: {
          label: 'Главы крестьянских (фермерских) хозяйств',
          abbreviations: [],
        },
      },
    },
    KVSH: {
      active: true,
      languages: {
        ru: {
          label: 'Органы общественной самодеятельности',
          abbreviations: [],
        },
      },
    },
    KZC6: {
      active: true,
      languages: {
        ru: {
          label: 'Фонды',
          abbreviations: [],
        },
      },
    },
    LLL8: {
      active: true,
      languages: {
        ru: {
          label:
            'Отделения иностранных некоммерческих неправительственных организаций',
          abbreviations: [],
        },
      },
    },
    LYTH: {
      active: true,
      languages: {
        ru: {
          label: 'Благотворительные фонды',
          abbreviations: [],
        },
      },
    },
    MG22: {
      active: true,
      languages: {
        ru: {
          label:
            'Государственные автономные учреждения субъектов Российской Федерации',
          abbreviations: [],
        },
      },
    },
    MT3A: {
      active: true,
      languages: {
        ru: {
          label: 'Открытое акционерное общество',
          abbreviations: [],
        },
      },
    },
    MV1C: {
      active: true,
      languages: {
        ru: {
          label: 'Потребительские общества',
          abbreviations: [],
        },
      },
    },
    MVSF: {
      active: true,
      languages: {
        ru: {
          label: 'Объединения фермерских хозяйств',
          abbreviations: [],
        },
      },
    },
    NRK9: {
      active: true,
      languages: {
        ru: {
          label: 'Общественные учреждения',
          abbreviations: [],
        },
      },
    },
    NZ85: {
      active: true,
      languages: {
        ru: {
          label: 'Политические партии',
          abbreviations: [],
        },
      },
    },
    O1KO: {
      active: true,
      languages: {
        ru: {
          label:
            'Сельскохозяйственные потребительские сбытовые (торговые) кооперативы',
          abbreviations: [],
        },
      },
    },
    OCIS: {
      active: true,
      languages: {
        ru: {
          label: 'Федеральные государственные унитарные предприятия',
          abbreviations: [],
        },
      },
    },
    OPLQ: {
      active: true,
      languages: {
        ru: {
          label: 'Представительства юридических лиц',
          abbreviations: [],
        },
      },
    },
    OVLN: {
      active: true,
      languages: {
        ru: {
          label:
            'Унитарные предприятия, основанные на праве оперативного управления (казенные предприятия)',
          abbreviations: [],
        },
      },
    },
    P9CF: {
      active: true,
      languages: {
        ru: {
          label: 'Индивидуальные предприниматели',
          abbreviations: [],
        },
      },
    },
    PA5X: {
      active: true,
      languages: {
        ru: {
          label:
            'Ассоциации (союзы) экономического взаимодействия субъектов Российской Федерации',
          abbreviations: [],
        },
      },
    },
    PDYW: {
      active: true,
      languages: {
        ru: {
          label:
            'Сельскохозяйственные потребительские садоводческие кооперативы',
          abbreviations: [],
        },
      },
    },
    PJRZ: {
      active: true,
      languages: {
        ru: {
          label: 'Нотариальные палаты',
          abbreviations: [],
        },
      },
    },
    Q9FA: {
      active: true,
      languages: {
        ru: {
          label: 'Межправительственные международные организации',
          abbreviations: [],
        },
      },
    },
    QCRH: {
      active: true,
      languages: {
        ru: {
          label: 'Хозяйственные общества',
          abbreviations: [],
        },
      },
    },
    QFGM: {
      active: true,
      languages: {
        ru: {
          label: 'Потребительские кооперативы',
          abbreviations: [],
        },
      },
    },
    QKFU: {
      active: true,
      languages: {
        ru: {
          label:
            'Учреждения, созданные муниципальным образованием (муниципальные учреждения)',
          abbreviations: [],
        },
      },
    },
    QMEH: {
      active: true,
      languages: {
        ru: {
          label: 'Общества взаимного страхования',
          abbreviations: [],
        },
      },
    },
    QQS1: {
      active: true,
      languages: {
        ru: {
          label:
            'Организационно-правовые формы международных организаций, осуществляющих деятельность на территории российской федерации',
          abbreviations: [],
        },
      },
    },
    QSXT: {
      active: true,
      languages: {
        ru: {
          label: 'Нотариусы, занимающиеся частной практикой',
          abbreviations: [],
        },
      },
    },
    QUMQ: {
      active: true,
      languages: {
        ru: {
          label:
            'Унитарные предприятия, основанные на праве хозяйственного ведения',
          abbreviations: [],
        },
      },
    },
    R71T: {
      active: true,
      languages: {
        ru: {
          label: 'Акционерные общества',
          abbreviations: [],
        },
      },
    },
    RJUK: {
      active: true,
      languages: {
        ru: {
          label:
            'Садоводческие, огороднические или дачные некоммерческие товарищества',
          abbreviations: [],
        },
      },
    },
    SDVV: {
      active: true,
      languages: {
        ru: {
          label: 'Объединения работодателей',
          abbreviations: [],
        },
      },
    },
    SIPP: {
      active: true,
      languages: {
        ru: {
          label:
            'Организационно-правовые формы для деятельности граждан, не отнесенной к предпринимательству',
          abbreviations: [],
        },
      },
    },
    TLDB: {
      active: true,
      languages: {
        ru: {
          label: 'Союзы потребительских обществ',
          abbreviations: [],
        },
      },
    },
    TMIG: {
      active: true,
      languages: {
        ru: {
          label: 'Федеральные государственные казенные учреждения',
          abbreviations: [],
        },
      },
    },
    UTBN: {
      active: true,
      languages: {
        ru: {
          label: 'Коллегии адвокатов',
          abbreviations: [],
        },
      },
    },
    UY49: {
      active: true,
      languages: {
        ru: {
          label:
            'Районные суды, городские суды, межрайонные суды (районные суды)',
          abbreviations: [],
        },
      },
    },
    VA0A: {
      active: true,
      languages: {
        ru: {
          label: 'Рыболовецкие артели (колхозы)',
          abbreviations: [],
        },
      },
    },
    VAB6: {
      active: true,
      languages: {
        ru: {
          label: 'Обособленные подразделения юридических лиц',
          abbreviations: [],
        },
      },
    },
    VE1P: {
      active: true,
      languages: {
        ru: {
          label:
            'Организационно-правовые формы юридических лиц, являющихся некоммерческими корпоративными организациями',
          abbreviations: [],
        },
      },
    },
    VEOU: {
      active: true,
      languages: {
        ru: {
          label: 'Унитарные предприятия',
          abbreviations: [],
        },
      },
    },
    VEX5: {
      active: true,
      languages: {
        ru: {
          label: 'Муниципальные казенные учреждения',
          abbreviations: [],
        },
      },
    },
    VIGZ: {
      active: true,
      languages: {
        ru: {
          label: 'Филиалы юридических лиц',
          abbreviations: [],
        },
      },
    },
    VOUU: {
      active: true,
      languages: {
        ru: {
          label:
            'Организационно-правовые формы юридических лиц, являющихся коммерческими унитарными организациями',
          abbreviations: [],
        },
      },
    },
    WJXS: {
      active: true,
      languages: {
        ru: {
          label: 'Жилищные накопительные кооперативы',
          abbreviations: [],
        },
      },
    },
    WYNO: {
      active: true,
      languages: {
        ru: {
          label: 'Союзы (ассоциации) кредитных кооперативов',
          abbreviations: [],
        },
      },
    },
    XBRI: {
      active: true,
      languages: {
        ru: {
          label: 'Неправительственные международные организации',
          abbreviations: [],
        },
      },
    },
    XIGI: {
      active: true,
      languages: {
        ru: {
          label: 'Муниципальные казенные предприятия',
          abbreviations: [],
        },
      },
    },
    XINV: {
      active: true,
      languages: {
        ru: {
          label: 'Кооперативные хозяйства (коопхозы)',
          abbreviations: [],
        },
      },
    },
    XJJR: {
      active: true,
      languages: {
        ru: {
          label: 'Союзы (ассоциации) общин малочисленных народов',
          abbreviations: [],
        },
      },
    },
    XNKN: {
      active: true,
      languages: {
        ru: {
          label: 'Кредитные потребительские кооперативы граждан',
          abbreviations: [],
        },
      },
    },
    YA7H: {
      active: true,
      languages: {
        ru: {
          label: 'Частные учреждения',
          abbreviations: [],
        },
      },
    },
    YGHZ: {
      active: true,
      languages: {
        ru: {
          label: 'Паевые инвестиционные фонды',
          abbreviations: [],
        },
      },
    },
    YJ6A: {
      active: true,
      languages: {
        ru: {
          label: 'Общественные движения',
          abbreviations: [],
        },
      },
    },
    Z2AQ: {
      active: true,
      languages: {
        ru: {
          label: 'Негосударственные пенсионные фонды',
          abbreviations: [],
        },
      },
    },
    Z3SH: {
      active: true,
      languages: {
        ru: {
          label: 'Муниципальные унитарные предприятия',
          abbreviations: [],
        },
      },
    },
    Z3Y0: {
      active: true,
      languages: {
        ru: {
          label:
            'Садоводческие, огороднические или дачные некоммерческие партнерства',
          abbreviations: [],
        },
      },
    },
    ZGYA: {
      active: true,
      languages: {
        ru: {
          label: 'Торгово-промышленные палаты',
          abbreviations: [],
        },
      },
    },
    ZH3O: {
      active: true,
      languages: {
        ru: {
          label: 'Хозяйственные партнерства',
          abbreviations: [],
        },
      },
    },
    ZKAF: {
      active: true,
      languages: {
        ru: {
          label: 'Полные товарищества',
          abbreviations: [],
        },
      },
    },
    ZNHF: {
      active: true,
      languages: {
        ru: {
          label:
            'Государственные казенные учреждения субъектов Российской Федерации',
          abbreviations: [],
        },
      },
    },
  },
  KN: {
    '29OB': {
      active: true,
      languages: {
        en: {
          label: 'Foundation',
          abbreviations: [],
        },
      },
    },
    AHRM: {
      active: true,
      languages: {
        en: {
          label: 'Limited partnership',
          abbreviations: [],
        },
      },
    },
    I93O: {
      active: true,
      languages: {
        en: {
          label: 'Public company',
          abbreviations: [],
        },
      },
    },
    KYOI: {
      active: true,
      languages: {
        en: {
          label: 'Exempt limited partnership',
          abbreviations: [],
        },
      },
    },
    WFYL: {
      active: true,
      languages: {
        en: {
          label: 'Private company',
          abbreviations: [],
        },
      },
    },
    ZJZB: {
      active: true,
      languages: {
        en: {
          label: 'Exempt private company',
          abbreviations: [],
        },
      },
    },
    '2F0A': {
      active: true,
      subdivision: 'KN-N',
      languages: {
        en: {
          label: 'Limited liability company',
          abbreviations: ['LC', 'LLC'],
        },
      },
    },
    '4EP1': {
      active: true,
      subdivision: 'KN-N',
      languages: {
        en: {
          label: 'Multiform foundation',
          abbreviations: [],
        },
      },
    },
    '7Z3M': {
      active: true,
      subdivision: 'KN-N',
      languages: {
        en: {
          label: 'Public company',
          abbreviations: [],
        },
      },
    },
    BXZH: {
      active: true,
      subdivision: 'KN-N',
      languages: {
        en: {
          label: 'Limited partnership',
          abbreviations: [],
        },
      },
    },
    EF4Y: {
      active: true,
      subdivision: 'KN-N',
      languages: {
        en: {
          label: 'Foundation',
          abbreviations: [],
        },
      },
    },
    H64R: {
      active: true,
      subdivision: 'KN-N',
      languages: {
        en: {
          label: 'Private company',
          abbreviations: [],
        },
      },
    },
    HW77: {
      active: true,
      subdivision: 'KN-N',
      languages: {
        en: {
          label: 'International Business Company',
          abbreviations: ['IBC'],
        },
      },
    },
    I03S: {
      active: true,
      subdivision: 'KN-N',
      languages: {
        en: {
          label: 'International exempt trust',
          abbreviations: [],
        },
      },
    },
    I8G4: {
      active: true,
      subdivision: 'KN-N',
      languages: {
        en: {
          label: 'Exempt private company',
          abbreviations: [],
        },
      },
    },
    OTE3: {
      active: true,
      subdivision: 'KN-N',
      languages: {
        en: {
          label: 'Exempt limited partnership',
          abbreviations: [],
        },
      },
    },
  },
  VC: {
    '10ST': {
      active: true,
      languages: {
        en: {
          label: 'Association',
          abbreviations: [],
        },
      },
    },
    '1PWF': {
      active: true,
      languages: {
        en: {
          label: 'Public company',
          abbreviations: [],
        },
      },
    },
    '3QSG': {
      active: true,
      languages: {
        en: {
          label: 'International business company - limited duration company',
          abbreviations: ['(LDC) Limited', '(LDC) Ltd', 'LDC'],
        },
      },
    },
    '5EKE': {
      active: true,
      languages: {
        en: {
          label: 'International business company - company limited by shares',
          abbreviations: ['Corp', 'Inc', 'Ltd'],
        },
      },
    },
    ABII: {
      active: true,
      languages: {
        en: {
          label:
            'International business company - unlimited company not authorised to issue shares',
          abbreviations: ['Unltd'],
        },
      },
    },
    FG2L: {
      active: true,
      languages: {
        en: {
          label: 'Company',
          abbreviations: ['Corp', 'Inc', 'Ltd'],
        },
      },
    },
    I9K6: {
      active: true,
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
    LCVA: {
      active: true,
      languages: {
        en: {
          label:
            'International business company - company limited by guarantee not authorised to issue shares',
          abbreviations: ['Corp', 'Inc', 'Ltd'],
        },
      },
    },
    QYZD: {
      active: true,
      languages: {
        en: {
          label: 'Sole proprietorship',
          abbreviations: [],
        },
      },
    },
    REVF: {
      active: true,
      languages: {
        en: {
          label:
            'International business company - company limited by guarantee authorised to issue shares',
          abbreviations: ['Corp', 'Inc', 'Ltd'],
        },
      },
    },
    RY5B: {
      active: true,
      languages: {
        en: {
          label:
            'International business company - unlimited company authorised to issue shares',
          abbreviations: ['Unltd'],
        },
      },
    },
    S1OK: {
      active: true,
      languages: {
        en: {
          label: 'Non-profit company',
          abbreviations: ['corp.', 'inc.'],
        },
      },
    },
    U5AR: {
      active: true,
      languages: {
        en: {
          label: 'Statutory company',
          abbreviations: [],
        },
      },
    },
    XY6R: {
      active: true,
      languages: {
        en: {
          label: 'Co-operative society',
          abbreviations: [],
        },
      },
    },
    YN9Y: {
      active: true,
      languages: {
        en: {
          label:
            'International business company - company limited by shares - segregated cell company',
          abbreviations: ['SCC Limited', 'SCC Ltd'],
        },
      },
    },
  },
  WS: {
    '1RPE': {
      active: true,
      languages: {
        en: {
          label: 'Charitable trust',
          abbreviations: [],
        },
      },
    },
    '7WL9': {
      active: true,
      languages: {
        en: {
          label: 'Public limited company',
          abbreviations: [],
        },
      },
    },
    BCM3: {
      active: true,
      languages: {
        en: {
          label: 'Credit Union',
          abbreviations: [],
        },
      },
    },
    M6YY: {
      active: true,
      languages: {
        en: {
          label: 'Private limited company',
          abbreviations: [],
        },
      },
    },
    QWFD: {
      active: true,
      languages: {
        en: {
          label: 'Overseas company',
          abbreviations: [],
        },
      },
    },
    SXY3: {
      active: true,
      languages: {
        en: {
          label: 'Incorporated society',
          abbreviations: [],
        },
      },
    },
    TOMA: {
      active: true,
      languages: {
        en: {
          label: 'Co-operative society',
          abbreviations: [],
        },
      },
    },
  },
  SA: {
    '78VH': {
      active: true,
      languages: {
        ar: {
          label: 'شركة مساهمة',
          abbreviations: [],
        },
      },
    },
    B3JS: {
      active: true,
      languages: {
        ar: {
          label: 'شركات  اشخاص',
          abbreviations: [],
        },
      },
    },
    DW9N: {
      active: true,
      languages: {
        ar: {
          label: 'شركة توصية بالأسهم',
          abbreviations: [],
        },
      },
    },
    N10C: {
      active: true,
      languages: {
        ar: {
          label: 'شركات ذات رأس مال قابل للتغيير',
          abbreviations: [],
        },
      },
    },
    PT6M: {
      active: true,
      languages: {
        ar: {
          label: 'شركات أموال',
          abbreviations: [],
        },
      },
    },
    T2NA: {
      active: true,
      languages: {
        ar: {
          label: 'شركة التضامن',
          abbreviations: [],
        },
      },
    },
    TTE8: {
      active: true,
      languages: {
        ar: {
          label: 'شركه ذات مسؤولية محدودة',
          abbreviations: [],
        },
      },
    },
    WHCI: {
      active: true,
      languages: {
        ar: {
          label: 'شركه توصية بسيطة',
          abbreviations: [],
        },
      },
    },
    YVGA: {
      active: true,
      languages: {
        ar: {
          label: 'شركة محاصة',
          abbreviations: [],
        },
      },
    },
    Z9IE: {
      active: false,
      languages: {
        ar: {
          label: 'شركات أجنبية',
          abbreviations: [],
        },
      },
    },
  },
  RS: {
    '6UPM': {
      active: true,
      languages: {
        sr: {
          label: 'Задружни савез',
          abbreviations: [],
        },
      },
    },
    '73PZ': {
      active: true,
      languages: {
        sr: {
          label: 'Командитно друштво',
          abbreviations: ['кд'],
        },
      },
    },
    '88TX': {
      active: true,
      languages: {
        sr: {
          label: 'Друштвено предузеће',
          abbreviations: ['ДП'],
        },
      },
    },
    '9O67': {
      active: true,
      languages: {
        sr: {
          label: 'Предузетник',
          abbreviations: ['ПР'],
        },
      },
    },
    DEF6: {
      active: true,
      languages: {
        sr: {
          label: 'Јавно предузеће',
          abbreviations: ['ЈП'],
        },
      },
    },
    E7W8: {
      active: true,
      languages: {
        sr: {
          label: 'Задруга',
          abbreviations: [],
        },
      },
    },
    KIU5: {
      active: true,
      languages: {
        sr: {
          label: 'Друштво са ограниченом одговорношћу',
          abbreviations: ['доо'],
        },
      },
    },
    YVPW: {
      active: true,
      languages: {
        sr: {
          label: 'Акционарско друштво',
          abbreviations: ['ад'],
        },
      },
    },
    ZPOY: {
      active: true,
      languages: {
        sr: {
          label: 'Ортачко друштво',
          abbreviations: ['од'],
        },
      },
    },
  },
  SC: {
    '3YUS': {
      active: true,
      languages: {
        en: {
          label: 'Foundation',
          abbreviations: [],
        },
      },
    },
    '6MS4': {
      active: true,
      languages: {
        en: {
          label: 'Company Limited by Shares',
          abbreviations: [],
        },
      },
    },
    '7QEH': {
      active: true,
      languages: {
        en: {
          label: 'International Business Company - Company Limited by Shares',
          abbreviations: ['IBC'],
        },
      },
    },
    '7XUS': {
      active: true,
      languages: {
        en: {
          label: 'Special License Company',
          abbreviations: ['CSL'],
        },
      },
    },
    BB5Y: {
      active: true,
      languages: {
        en: {
          label: 'International Trust',
          abbreviations: [],
        },
      },
    },
    CDYY: {
      active: true,
      languages: {
        en: {
          label: 'Company Limited by Guarantee',
          abbreviations: [],
        },
      },
    },
    E3YL: {
      active: true,
      languages: {
        en: {
          label: 'Company Limited by Shares and Guarantee',
          abbreviations: [],
        },
      },
    },
    G6M8: {
      active: true,
      languages: {
        en: {
          label: 'International Business Company - Protected Cell Company',
          abbreviations: ['IBC'],
        },
      },
    },
    H35I: {
      active: true,
      languages: {
        en: {
          label: 'Public Company',
          abbreviations: [],
        },
      },
    },
    H987: {
      active: true,
      languages: {
        en: {
          label: 'Proprietary Company',
          abbreviations: [],
        },
      },
    },
    KGUS: {
      active: true,
      languages: {
        en: {
          label:
            'International Business Company - Company Limited by Shares and Guarantee',
          abbreviations: ['IBC'],
        },
      },
    },
    KOFC: {
      active: true,
      languages: {
        en: {
          label:
            'International Business Company - Company Limited by Guarantee',
          abbreviations: ['IBC'],
        },
      },
    },
    P3YJ: {
      active: true,
      languages: {
        en: {
          label: 'Unlimited Company',
          abbreviations: [],
        },
      },
    },
    Q9VK: {
      active: true,
      languages: {
        en: {
          label: 'Protected Cell Company',
          abbreviations: ['PCC'],
        },
      },
    },
    VA1X: {
      active: true,
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    WKFR: {
      active: true,
      languages: {
        en: {
          label: 'International Business Company - Limited Life Company',
          abbreviations: ['IBC'],
        },
      },
    },
  },
  SG: {
    '17FJ': {
      active: true,
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    '2PHU': {
      active: true,
      languages: {
        en: {
          label: 'Business',
          abbreviations: [],
        },
      },
    },
    '5SGV': {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    KEMH: {
      active: false,
      languages: {
        en: {
          label: 'Company (Foreign Branch)',
          abbreviations: [],
        },
      },
    },
    LWXI: {
      active: true,
      languages: {
        en: {
          label: 'Company (Local)',
          abbreviations: ['Limited', 'Ltd', 'Pte Ltd'],
        },
      },
    },
  },
  SX: {
    '1CSZ': {
      active: true,
      languages: {
        nl: {
          label: 'Vereniging',
          abbreviations: [],
        },
      },
    },
    '2CC3': {
      active: true,
      languages: {
        nl: {
          label: 'Besloten vennootschap',
          abbreviations: ['BV'],
        },
      },
    },
    '2UBX': {
      active: true,
      languages: {
        nl: {
          label: 'Commanditaire vennootschap op aandelen',
          abbreviations: [],
        },
      },
    },
    '52AV': {
      active: true,
      languages: {
        nl: {
          label: 'Stichting particulier fonds',
          abbreviations: ['SPF'],
        },
      },
    },
    '66T3': {
      active: true,
      languages: {
        nl: {
          label: 'Eenmanszaak',
          abbreviations: [],
        },
      },
    },
    '8W32': {
      active: true,
      languages: {
        nl: {
          label: 'Openbare vennootschap',
          abbreviations: [],
        },
      },
    },
    B4OI: {
      active: true,
      languages: {
        nl: {
          label: 'Onderlinge waarborgmaatschappij',
          abbreviations: ['OWM'],
        },
      },
    },
    FBX9: {
      active: true,
      languages: {
        nl: {
          label: 'Aandeelhouder-bestuurde vennootschap',
          abbreviations: ['ABV'],
        },
      },
    },
    FI9R: {
      active: true,
      languages: {
        nl: {
          label: 'Stichting',
          abbreviations: [],
        },
      },
    },
    NWT1: {
      active: true,
      languages: {
        nl: {
          label: 'Coöperatie',
          abbreviations: [],
        },
      },
    },
    SXX9: {
      active: true,
      languages: {
        nl: {
          label: 'Naamloze vennootschap',
          abbreviations: ['NV'],
        },
      },
    },
    YXX0: {
      active: true,
      languages: {
        nl: {
          label: 'Commanditaire vennootschap',
          abbreviations: ['CV'],
        },
      },
    },
  },
  SK: {
    '14NU': {
      active: true,
      languages: {
        sk: {
          label: 'Rozpočtové a príspevkové organizácie',
          abbreviations: [],
        },
      },
    },
    '189Q': {
      active: true,
      languages: {
        sk: {
          label: 'Špecializovaná organizačná jednotka ČSD',
          abbreviations: ['Špec.org.jednotka ČSD'],
        },
      },
    },
    '1CSW': {
      active: true,
      languages: {
        sk: {
          label: 'Obecný podnik',
          abbreviations: [],
        },
      },
    },
    '1GLU': {
      active: true,
      languages: {
        sk: {
          label: 'Jednotka železničného správneho úradu',
          abbreviations: ['Jednot.žel.správ.úradu'],
        },
      },
    },
    '1HEP': {
      active: true,
      languages: {
        sk: {
          label: 'Rozpočtová organizácia',
          abbreviations: [],
        },
      },
    },
    '1K73': {
      active: true,
      languages: {
        sk: {
          label: 'Zahraničná osoba, právnická osoba so sídlom mimo územia SR',
          abbreviations: ['Zahranič.osoba,právnická'],
        },
      },
    },
    '1W8B': {
      active: true,
      languages: {
        sk: {
          label: 'Zahraničná osoba',
          abbreviations: [],
        },
      },
    },
    '2EEG': {
      active: true,
      languages: {
        sk: {
          label: 'Akciová spoločnosť',
          abbreviations: ['Akc. spol.'],
        },
      },
    },
    '2KMA': {
      active: true,
      languages: {
        sk: {
          label: 'Štátny podnik v oddieli Pšn',
          abbreviations: [],
        },
      },
    },
    '2XNE': {
      active: true,
      languages: {
        sk: {
          label: 'Komoditná burza',
          abbreviations: [],
        },
      },
    },
    '3P3W': {
      active: true,
      languages: {
        sk: {
          label: 'Družstevný podnik (s jedným zakladateľom)',
          abbreviations: [],
        },
      },
    },
    '43MZ': {
      active: true,
      languages: {
        sk: {
          label: 'Príspevková organizácia',
          abbreviations: [],
        },
      },
    },
    '46CD': {
      active: true,
      languages: {
        sk: {
          label: 'Pobočka sporiteľne',
          abbreviations: [],
        },
      },
    },
    '4CKX': {
      active: true,
      languages: {
        sk: {
          label: 'Krajský úrad',
          abbreviations: [],
        },
      },
    },
    '4GX1': {
      active: true,
      languages: {
        sk: {
          label: 'Národný výbor',
          abbreviations: [],
        },
      },
    },
    '5AM3': {
      active: true,
      languages: {
        sk: {
          label: 'Zastupiteľské orgány iných štátov',
          abbreviations: ['Zastup.org.iných štátov'],
        },
      },
    },
    '5J5Y': {
      active: true,
      languages: {
        sk: {
          label: 'Verejná obchodná spoločnosť',
          abbreviations: ['Ver. obch. spol.'],
        },
      },
    },
    '5YBL': {
      active: true,
      languages: {
        sk: {
          label: 'Stavovská organizácia - profesná komora',
          abbreviations: [],
        },
      },
    },
    '5Z8W': {
      active: true,
      languages: {
        sk: {
          label: 'Samostatne hospodáriaci roľník zapísaný v obchodnom registri',
          abbreviations: ['SHR roľník v OR'],
        },
      },
    },
    '6R72': {
      active: true,
      languages: {
        sk: {
          label:
            'Samostatne hospodáriaci roľník nezapísaný v obchodnom registri',
          abbreviations: ['SHR roľník'],
        },
      },
    },
    '72R7': {
      active: true,
      languages: {
        sk: {
          label: 'Stredná škola',
          abbreviations: [],
        },
      },
    },
    '73MQ': {
      active: true,
      languages: {
        sk: {
          label: 'Samosprávny kraj (úrad samosprávneho kraja)',
          abbreviations: [],
        },
      },
    },
    '7EG2': {
      active: true,
      languages: {
        sk: {
          label: 'Fondy',
          abbreviations: [],
        },
      },
    },
    '7O89': {
      active: true,
      languages: {
        sk: {
          label: 'Európske družstvo',
          abbreviations: ['SCE'],
        },
      },
    },
    '7QSE': {
      active: false,
      languages: {
        sk: {
          label: 'Zastúpenie zahraničnej právnickej osoby',
          abbreviations: ['Zastúp.zahr.práv.osoby'],
        },
      },
    },
    '8KHD': {
      active: true,
      languages: {
        sk: {
          label: 'Jednotka zboru ozbrojenej ochrany železníc',
          abbreviations: ['Jed.zboru ochrany žel.'],
        },
      },
    },
    '8RE3': {
      active: true,
      languages: {
        sk: {
          label: 'Družstevný podnik poľnohospodársky',
          abbreviations: ['Družstevný podnik poľ.'],
        },
      },
    },
    '8UE6': {
      active: true,
      languages: {
        sk: {
          label: 'Organizačná jednotka politickej strany, politického hnutia',
          abbreviations: ['Org.jedn.pol.strany,hn.'],
        },
      },
    },
    '90YN': {
      active: true,
      languages: {
        sk: {
          label: 'Sociálna a zdravotné poisťovne',
          abbreviations: ['Sociál.,zdrav.poisťovňa'],
        },
      },
    },
    '93WZ': {
      active: true,
      languages: {
        sk: {
          label:
            'Podnikateľ-fyzická osoba-zapís.v OR-podnikajúca súčasne ako sam.hosp.roľník',
          abbreviations: ['Živ. a SHR roľník v OR'],
        },
      },
    },
    '95MS': {
      active: true,
      languages: {
        sk: {
          label:
            'Slobodné povolanie-fyzická osoba podnikajúca na základe iného ako živnostenského zákona',
          abbreviations: ['FO-slob.povolanie'],
        },
      },
    },
    '9L9V': {
      active: true,
      languages: {
        sk: {
          label: 'Poľnohospodárske družstvo',
          abbreviations: ['Poľnohospodár.družstvo'],
        },
      },
    },
    '9NSV': {
      active: true,
      languages: {
        sk: {
          label: 'Neinvestičný fond',
          abbreviations: [],
        },
      },
    },
    AGSR: {
      active: true,
      languages: {
        sk: {
          label: 'Jednotka štátnej železnično - technickej inšpekcie',
          abbreviations: ['Jedn.štát.žel.tech.inš.'],
        },
      },
    },
    BKEB: {
      active: true,
      languages: {
        sk: {
          label: 'Oblastný závod poisťovne',
          abbreviations: [],
        },
      },
    },
    BUMI: {
      active: true,
      languages: {
        sk: {
          label: 'Európska spoločnosť',
          abbreviations: ['SE'],
        },
      },
    },
    C4PZ: {
      active: true,
      languages: {
        sk: {
          label: 'Podnikateľ-fyzická osoba-nezapísaný v obchodnom registri',
          abbreviations: ['Živnostník'],
        },
      },
    },
    CS8B: {
      active: true,
      languages: {
        sk: {
          label: 'Štátna hospodárska organizácia riadená okresným úradom',
          abbreviations: ['Štát.hosp.org.riad.okr.'],
        },
      },
    },
    D18J: {
      active: true,
      languages: {
        sk: {
          label: 'Jednoduchá spoločnosť na akcie',
          abbreviations: ['Jednoduchá spol. na akcie'],
        },
      },
    },
    DAQC: {
      active: true,
      languages: {
        sk: {
          label: 'Základná škola',
          abbreviations: [],
        },
      },
    },
    E1VK: {
      active: true,
      languages: {
        sk: {
          label: 'Medzinárodné organizácie a združenia',
          abbreviations: ['Medzinár. org. a združ.'],
        },
      },
    },
    E4CI: {
      active: true,
      languages: {
        sk: {
          label: 'Bytové družstvo',
          abbreviations: [],
        },
      },
    },
    E9SH: {
      active: true,
      languages: {
        sk: {
          label: 'Zahraničná osoba, fyzická osoba s bydliskom mimo územia SR',
          abbreviations: ['Zahranič.osoba,fyzická'],
        },
      },
    },
    ED84: {
      active: true,
      languages: {
        sk: {
          label: 'Poisťovací spolok',
          abbreviations: [],
        },
      },
    },
    ER02: {
      active: true,
      languages: {
        sk: {
          label: 'Organizačná jednotka združenia',
          abbreviations: ['Org.jednotka združenia'],
        },
      },
    },
    F560: {
      active: true,
      languages: {
        sk: {
          label: 'Spoločná záujmová organizácia družstiev',
          abbreviations: ['Spoločná záuj.org.druž.'],
        },
      },
    },
    FDVU: {
      active: true,
      languages: {
        sk: {
          label:
            'Fyzická osoba-príležitostne činná-zapísaná v registri daňového informačného systému',
          abbreviations: ['FO v RDIS'],
        },
      },
    },
    FMUC: {
      active: true,
      languages: {
        sk: {
          label: 'Iné pracovisko vysokej školy/fakulty',
          abbreviations: ['Iné prac.vysokej školy'],
        },
      },
    },
    FQRE: {
      active: true,
      languages: {
        sk: {
          label: 'Účelová zahranično - obchodná organizácia',
          abbreviations: ['Účelová zahr.-obch.org.'],
        },
      },
    },
    GL07: {
      active: true,
      languages: {
        sk: {
          label: 'Poisťovňa - akciová spoločnosť',
          abbreviations: ['Poisťovna - a. s.'],
        },
      },
    },
    GY5R: {
      active: true,
      languages: {
        sk: {
          label: 'Cirkevná organizácia',
          abbreviations: [],
        },
      },
    },
    HZG7: {
      active: true,
      languages: {
        sk: {
          label: 'Vysoká škola',
          abbreviations: [],
        },
      },
    },
    HZI2: {
      active: true,
      languages: {
        sk: {
          label: 'Banka-štátny peňažný ústav',
          abbreviations: ['Banka-štát.peňaž.ústav'],
        },
      },
    },
    I7AS: {
      active: true,
      languages: {
        sk: {
          label: 'Družstvo',
          abbreviations: [],
        },
      },
    },
    ISCZ: {
      active: true,
      languages: {
        sk: {
          label: 'Doplnková dôchodková poisťovňa',
          abbreviations: ['Doplnková dôchod.poisť.'],
        },
      },
    },
    IW8Z: {
      active: true,
      languages: {
        sk: {
          label: 'Výrobné družstvo',
          abbreviations: [],
        },
      },
    },
    J8DW: {
      active: true,
      languages: {
        sk: {
          label:
            'Podnik zahraničnej osoby (organizačná zložka podniku zahraničnej osoby)',
          abbreviations: ['Podnik zahr. osoby, org. zložka'],
        },
      },
    },
    JKC5: {
      active: true,
      languages: {
        sk: {
          label: 'Podnik alebo hospodárske zariadenie združenia',
          abbreviations: ['Podnik alebo hosp.zar.'],
        },
      },
    },
    KB52: {
      active: true,
      languages: {
        sk: {
          label: 'Komanditná spoločnosť',
          abbreviations: ['Kom. spol.'],
        },
      },
    },
    KVQU: {
      active: true,
      languages: {
        sk: {
          label: 'Združenie medzinárodného obchodu',
          abbreviations: ['Združ.medzinár.obchodu'],
        },
      },
    },
    KWFE: {
      active: true,
      languages: {
        sk: {
          label: 'Komora (s výnimkou profesných komôr)',
          abbreviations: [],
        },
      },
    },
    KZ3R: {
      active: true,
      languages: {
        sk: {
          label: 'Poisťovňa - štátny podnik',
          abbreviations: ['Poisťovňa - š. p.'],
        },
      },
    },
    L1M7: {
      active: true,
      languages: {
        sk: {
          label: 'Fakulta vysokej školy',
          abbreviations: [],
        },
      },
    },
    L9WT: {
      active: true,
      languages: {
        sk: {
          label: 'Obec (obecný úrad), mesto (mestský úrad)',
          abbreviations: ['Obec, mesto (o.,m.úrad)'],
        },
      },
    },
    MSGT: {
      active: true,
      languages: {
        sk: {
          label:
            'Slobodné povolanie-fyzická osoba podnikajúca na základe iného ako živnostenského zákona zapísaná v obchodnom registri',
          abbreviations: ['FO-slob.povolanie v OR'],
        },
      },
    },
    MY1S: {
      active: true,
      languages: {
        sk: {
          label:
            'Odštepný závod alebo iná organizačná zložka podniku zapisujúca sa do obchodného registra',
          abbreviations: ['Odštepný závod v OR'],
        },
      },
    },
    N5MX: {
      active: true,
      languages: {
        sk: {
          label: 'Samostatne podnikajúca fyzická osoba',
          abbreviations: ['Samostatne podnikajúca FO'],
        },
      },
    },
    N7I1: {
      active: true,
      languages: {
        sk: {
          label:
            'Organizačná zložka príspevkovej organizácie s odvodenou právnou subjektivitou',
          abbreviations: ['Org.zložka prísp.org.'],
        },
      },
    },
    N9QW: {
      active: true,
      languages: {
        sk: {
          label: 'Pobočka štátneho peňažného ústavu',
          abbreviations: ['Pobočka štát.peňaž.úst.'],
        },
      },
    },
    NC88: {
      active: true,
      languages: {
        sk: {
          label: 'Účelová organizačná jednotka ČSD',
          abbreviations: ['Účelová org. jedn. ČSD'],
        },
      },
    },
    NL31: {
      active: true,
      languages: {
        sk: {
          label: 'Spoločný podnik (s viacerými zakladateľmi)',
          abbreviations: [],
        },
      },
    },
    NLI7: {
      active: true,
      languages: {
        sk: {
          label: 'Sporiteľna',
          abbreviations: [],
        },
      },
    },
    NO20: {
      active: true,
      languages: {
        sk: {
          label: 'Zatiaľ neurčené',
          abbreviations: [],
        },
      },
    },
    O0Y2: {
      active: true,
      languages: {
        sk: {
          label: 'Nešpecifikovaná právna forma',
          abbreviations: [],
        },
      },
    },
    O7TC: {
      active: true,
      languages: {
        sk: {
          label: 'Spoločný podnik',
          abbreviations: [],
        },
      },
    },
    OKAZ: {
      active: true,
      languages: {
        sk: {
          label: 'Obecný úrad',
          abbreviations: [],
        },
      },
    },
    P6XJ: {
      active: true,
      languages: {
        sk: {
          label: 'Podnik alebo hospodárske zariadenie politickej strany',
          abbreviations: ['Podnik alebo hosp.zar.'],
        },
      },
    },
    PX29: {
      active: true,
      languages: {
        sk: {
          label: 'Iná právnicka osoba',
          abbreviations: [],
        },
      },
    },
    QACV: {
      active: true,
      languages: {
        sk: {
          label: 'Spotrebné družstvo',
          abbreviations: [],
        },
      },
    },
    QCJ9: {
      active: true,
      languages: {
        sk: {
          label: 'Spoločnosť komanditná na akcie',
          abbreviations: ['Spol. kom. na akcie'],
        },
      },
    },
    R9GT: {
      active: true,
      languages: {
        sk: {
          label: 'Samostatná drobná prevádzkareň obecného úradu',
          abbreviations: ['Samost. prevádzkareň OÚ'],
        },
      },
    },
    RF3D: {
      active: true,
      languages: {
        sk: {
          label: 'Združenie (zväz, spolok, spoločnosť, klub ai.)',
          abbreviations: [],
        },
      },
    },
    S5E1: {
      active: true,
      languages: {
        sk: {
          label: 'Miestna jednotka bez právnej spôsobilosti',
          abbreviations: [],
        },
      },
    },
    SIRY: {
      active: true,
      languages: {
        sk: {
          label: 'Záujmové združenie právnických osôb',
          abbreviations: ['Záujm. združ. práv.osôb'],
        },
      },
    },
    SMUS: {
      active: true,
      languages: {
        sk: {
          label: 'Záujmové združenie',
          abbreviations: [],
        },
      },
    },
    SPIE: {
      active: true,
      languages: {
        sk: {
          label: 'Podnikateľ-fyzická osoba-zapísaný v obchodnom registri',
          abbreviations: ['Živnostník v OR'],
        },
      },
    },
    SQ4I: {
      active: true,
      languages: {
        sk: {
          label:
            'Podnikateľ-fyzická osoba-nezapís.v OR-podnikajúca súčasne ako osoba so slobodným povolaním',
          abbreviations: ['Živ.a sl.povolanie'],
        },
      },
    },
    SQFW: {
      active: true,
      languages: {
        sk: {
          label: 'Iné družstvo',
          abbreviations: [],
        },
      },
    },
    STUP: {
      active: true,
      languages: {
        sk: {
          label: 'Národná banka Slovenska',
          abbreviations: ['NBS'],
        },
      },
    },
    SUH3: {
      active: true,
      languages: {
        sk: {
          label: 'Záujmová organizácia družstiev',
          abbreviations: ['Záujmová org.družstiev'],
        },
      },
    },
    T0KQ: {
      active: true,
      languages: {
        sk: {
          label: 'Svojpomocné poľnohospodárske družstvo',
          abbreviations: ['Svojpomoc.poľn.družstvo'],
        },
      },
    },
    TAV3: {
      active: true,
      languages: {
        sk: {
          label: 'Iná organizácia verejnej správy',
          abbreviations: ['Iná org.verejnej správy'],
        },
      },
    },
    TG3X: {
      active: true,
      languages: {
        sk: {
          label:
            'Podnikateľ-fyzická osoba-nezapís.v OR-podnikajúca súčasne ako sam.hosp.roľník',
          abbreviations: ['Živ. a SHR roľník'],
        },
      },
    },
    U3QQ: {
      active: true,
      languages: {
        sk: {
          label: 'Banka - akciová spoločnosť',
          abbreviations: ['Banka - a. s.'],
        },
      },
    },
    U5IM: {
      active: true,
      languages: {
        sk: {
          label: 'Železnice SR',
          abbreviations: [],
        },
      },
    },
    U7QK: {
      active: true,
      languages: {
        sk: {
          label: 'Nadácia',
          abbreviations: [],
        },
      },
    },
    UCTO: {
      active: true,
      languages: {
        sk: {
          label: 'Oblastná organizačná jednotka ČSD',
          abbreviations: ['Obl.org.jednotka ČSD'],
        },
      },
    },
    VATN: {
      active: true,
      languages: {
        sk: {
          label: 'Európske zoskupenie územnej spolupráce',
          abbreviations: ['Európ.zoskup.územ.spol'],
        },
      },
    },
    VRJP: {
      active: true,
      languages: {
        sk: {
          label: 'Nezisková organizácia poskytujúca všeobecne prospešné služby',
          abbreviations: ['Nezisk.org.poskyt.všeob.prosp.služby'],
        },
      },
    },
    VSC1: {
      active: true,
      languages: {
        sk: {
          label:
            'Zahraničné kultúrne, informačné stredisko, rozhlasová, tlačová a televízna agentúra',
          abbreviations: ['Zahr.kul.,inf.strediská'],
        },
      },
    },
    VSZS: {
      active: true,
      languages: {
        sk: {
          label: 'Spoločnosť s ručením obmedzeným',
          abbreviations: ['Spol. s r. o.'],
        },
      },
    },
    WQCR: {
      active: true,
      languages: {
        sk: {
          label:
            'Podnikateľ-fyzická osoba-zapís.v OR-podnikajúca súčasne ako osoba so slobodným povolaním',
          abbreviations: ['Živ.a sl.povolanie v OR'],
        },
      },
    },
    XLXU: {
      active: true,
      languages: {
        sk: {
          label: 'Politická strana, politické hnutie',
          abbreviations: [],
        },
      },
    },
    Y1X5: {
      active: true,
      languages: {
        sk: {
          label: 'Štátny podnik',
          abbreviations: [],
        },
      },
    },
    Y45Q: {
      active: true,
      languages: {
        sk: {
          label: 'Podnik zahraničného obchodu',
          abbreviations: ['PZO'],
        },
      },
    },
    YB59: {
      active: true,
      languages: {
        sk: {
          label: 'Podnik so zahraničnou majetkovou účasťou',
          abbreviations: ['Podnik so zahr.maj.úč.'],
        },
      },
    },
    YF99: {
      active: true,
      languages: {
        sk: {
          label: 'Verejnoprávna inštitúcia',
          abbreviations: ['Verejnopráv.inštitúcia'],
        },
      },
    },
    YGN4: {
      active: true,
      languages: {
        sk: {
          label: 'Organizačná zložka podniku',
          abbreviations: [],
        },
      },
    },
    YRIU: {
      active: true,
      languages: {
        sk: {
          label: 'Nezisková organizácia',
          abbreviations: [],
        },
      },
    },
    YVE8: {
      active: true,
      languages: {
        sk: {
          label: 'Európske zoskupenie hospodárskych záujmov',
          abbreviations: ['EZHZ', 'Európ.zoskup.hosp.záujm.'],
        },
      },
    },
    YVWB: {
      active: true,
      languages: {
        sk: {
          label: 'Záujmové združenie fyzických osôb bez právnej spôsobilosti',
          abbreviations: ['Záujmové združ.fyz.osôb'],
        },
      },
    },
    ZG2I: {
      active: true,
      languages: {
        sk: {
          label: 'Spoločenstvá vlastníkov pozemkov, bytov a pod.',
          abbreviations: ['Spoločenstvá vlastníkov'],
        },
      },
    },
  },
  SI: {
    '14AT': {
      active: true,
      languages: {
        sl: {
          label: 'Javna agencija',
          abbreviations: [],
        },
      },
    },
    '1OR3': {
      active: true,
      languages: {
        sl: {
          label: 'Delniška družba',
          abbreviations: ['d.d.'],
        },
      },
    },
    '2CTG': {
      active: true,
      languages: {
        sl: {
          label: 'Zadruga',
          abbreviations: [],
        },
      },
    },
    '34PA': {
      active: true,
      languages: {
        sl: {
          label: 'Centralna banka',
          abbreviations: [],
        },
      },
    },
    '4A8T': {
      active: true,
      languages: {
        sl: {
          label: 'Evropska delniška družba',
          abbreviations: ['SE'],
        },
      },
    },
    '5LXY': {
      active: true,
      languages: {
        sl: {
          label: 'Verska skupnost in podobne verske organizacije',
          abbreviations: [],
        },
      },
    },
    '6MPY': {
      active: true,
      languages: {
        sl: {
          label: 'Ustanova',
          abbreviations: [],
        },
      },
    },
    '8ER6': {
      active: true,
      languages: {
        sl: {
          label: 'Stanovanjska zadruga',
          abbreviations: [],
        },
      },
    },
    D64E: {
      active: true,
      languages: {
        sl: {
          label: 'Gospodarska zbornica',
          abbreviations: [],
        },
      },
    },
    E01X: {
      active: true,
      languages: {
        sl: {
          label: 'Zadruga v zasebni lasti',
          abbreviations: [],
        },
      },
    },
    HJCS: {
      active: true,
      languages: {
        sl: {
          label: 'Društvo, zveza društev',
          abbreviations: [],
        },
      },
    },
    I7MN: {
      active: true,
      languages: {
        sl: {
          label: 'Javno podjetje',
          abbreviations: [],
        },
      },
    },
    ICQT: {
      active: true,
      languages: {
        sl: {
          label: 'Družba za vzajemno zavarovanje',
          abbreviations: ['d.v.z.'],
        },
      },
    },
    JQA2: {
      active: true,
      languages: {
        sl: {
          label: 'Kmetijska zadruga',
          abbreviations: [],
        },
      },
    },
    KBKD: {
      active: true,
      languages: {
        sl: {
          label: 'Družba z omejeno odgovornostjo',
          abbreviations: ['d.o.o.'],
        },
      },
    },
    KH4O: {
      active: true,
      languages: {
        sl: {
          label: 'Skupnost lastnikov stanovanj',
          abbreviations: [],
        },
      },
    },
    LNYR: {
      active: true,
      languages: {
        sl: {
          label: 'Obrtna zadruga',
          abbreviations: [],
        },
      },
    },
    M84A: {
      active: true,
      languages: {
        sl: {
          label: 'Sklad',
          abbreviations: [],
        },
      },
    },
    OPDJ: {
      active: true,
      languages: {
        sl: {
          label: 'Komanditna družba',
          abbreviations: ['k.d.'],
        },
      },
    },
    Q2EV: {
      active: true,
      languages: {
        sl: {
          label: 'Evropsko gospodarsko interesno združenje',
          abbreviations: ['EGIZ'],
        },
      },
    },
    QUEA: {
      active: true,
      languages: {
        sl: {
          label: 'Tuja pravna oseba po ZZK-1',
          abbreviations: [],
        },
      },
    },
    QW8S: {
      active: true,
      languages: {
        sl: {
          label: 'Samostojni podjetnik posameznik',
          abbreviations: ['s.p.'],
        },
      },
    },
    QYQ5: {
      active: true,
      languages: {
        sl: {
          label: 'Družbeno podjetje',
          abbreviations: [],
        },
      },
    },
    RAX7: {
      active: true,
      languages: {
        sl: {
          label: 'Zadruga z omejeno odgovornostjo',
          abbreviations: ['z.o.o.'],
        },
      },
    },
    RG9Z: {
      active: true,
      languages: {
        si: {
          label: 'Societas Cooperativa Europaea',
          abbreviations: ['SCE'],
        },
      },
    },
    S1UI: {
      active: true,
      languages: {
        sl: {
          label: 'Civilna odvetniška družba',
          abbreviations: [],
        },
      },
    },
    SD81: {
      active: true,
      languages: {
        sl: {
          label: 'Družba z neomejeno odgovornostjo',
          abbreviations: ['d.n.o.'],
        },
      },
    },
    TMVE: {
      active: true,
      languages: {
        sl: {
          label: 'Zadruga brez odgovornosti',
          abbreviations: ['z.b.o.'],
        },
      },
    },
    UDQJ: {
      active: true,
      languages: {
        sl: {
          label: 'Gospodarsko interesno združenje',
          abbreviations: ['GIZ'],
        },
      },
    },
    UESF: {
      active: true,
      languages: {
        sl: {
          label: 'Javni sklad',
          abbreviations: [],
        },
      },
    },
    UG0E: {
      active: true,
      languages: {
        sl: {
          label: 'Dobrodelna organizacija',
          abbreviations: [],
        },
      },
    },
    WZ78: {
      active: true,
      languages: {
        sl: {
          label: 'Komanditna delniška družba',
          abbreviations: ['k.d.d.'],
        },
      },
    },
    X94Z: {
      active: true,
      languages: {
        sl: {
          label: 'Republika Slovenija',
          abbreviations: [],
        },
      },
    },
  },
  SB: {
    '8PIA': {
      active: true,
      languages: {
        en: {
          label: 'Private Company',
          abbreviations: [],
        },
      },
    },
    A7VA: {
      active: true,
      languages: {
        en: {
          label: 'Community Company',
          abbreviations: [],
        },
      },
    },
    YSBJ: {
      active: true,
      languages: {
        en: {
          label: 'Overseas Company',
          abbreviations: [],
        },
      },
    },
    Z4ZP: {
      active: true,
      languages: {
        en: {
          label: 'Public Company',
          abbreviations: [],
        },
      },
    },
  },
  ZA: {
    '3QSR': {
      active: true,
      languages: {
        en: {
          label: 'Pension fund',
          abbreviations: [],
        },
      },
    },
    '4YUU': {
      active: true,
      languages: {
        en: {
          label: 'Close Corporation',
          abbreviations: ['CC'],
        },
      },
    },
    CXWJ: {
      active: true,
      languages: {
        en: {
          label: 'Co-operatives (Secondary)',
          abbreviations: [],
        },
      },
    },
    GQVQ: {
      active: true,
      languages: {
        en: {
          label: 'Private Company',
          abbreviations: ['Pty Ltd'],
        },
      },
    },
    J7L0: {
      active: true,
      languages: {
        en: {
          label: 'Non-Profit Company',
          abbreviations: ['NPC'],
        },
      },
    },
    MZT6: {
      active: true,
      languages: {
        en: {
          label: 'Co-operatives (Primary)',
          abbreviations: [],
        },
      },
    },
    R155: {
      active: true,
      languages: {
        en: {
          label: 'State Owned Company',
          abbreviations: ['SOC'],
        },
      },
    },
    R59V: {
      active: false,
      languages: {
        en: {
          label: 'External Company',
          abbreviations: [],
        },
      },
    },
    U89P: {
      active: true,
      languages: {
        en: {
          label: 'Personal Liability Company',
          abbreviations: ['Inc'],
        },
      },
    },
    XE4Z: {
      active: true,
      languages: {
        en: {
          label: 'Public Company',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    ZE81: {
      active: true,
      languages: {
        en: {
          label: 'Co-operatives (Tertiary)',
          abbreviations: [],
        },
      },
    },
  },
  ES: {
    '1G29': {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad Limitada Laboral (o Sociedad de Responsabilidad Limitada laboral)',
          abbreviations: ['S.L.L.', 'S.R.L.L.'],
        },
      },
    },
    '1QU8': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Cooperativa',
          abbreviations: ['S.Coop'],
        },
      },
    },
    '1SL4': {
      active: true,
      languages: {
        es: {
          label: 'Empresario Individual',
          abbreviations: [],
        },
      },
    },
    '1ZHJ': {
      active: true,
      languages: {
        es: {
          label:
            'Sociedad Colectiva Profesional (o Sociedad regular colectiva profesional)',
          abbreviations: ['S.C.P.', 'S.R.C.P.'],
        },
      },
    },
    '4S57': {
      active: true,
      languages: {
        es: {
          label: 'Caja de Ahorros',
          abbreviations: [],
        },
      },
    },
    '4SJR': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Agraría de Trasformación',
          abbreviations: ['S.A.T.'],
        },
      },
    },
    '5RDO': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anonima',
          abbreviations: ['S.A.'],
        },
      },
    },
    '7U8O': {
      active: true,
      languages: {
        es: {
          label: 'Sociedades de Inversion Inmobiliaria',
          abbreviations: ['S.I.I.'],
        },
      },
    },
    '8EHB': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Inversión de Capital Variable',
          abbreviations: ['SICAV'],
        },
      },
    },
    '956I': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Limitada de nueva empresa',
          abbreviations: ['S.L.N.E.'],
        },
      },
    },
    '9FPZ': {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anonima Europea',
          abbreviations: ['S.E.'],
        },
      },
    },
    A0J6: {
      active: true,
      languages: {
        es: {
          label: 'Asociación',
          abbreviations: [],
        },
      },
    },
    A97B: {
      active: true,
      languages: {
        es: {
          label: 'Mutualidad de Prevision Social',
          abbreviations: ['M.P.S.'],
        },
      },
    },
    AJ9U: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anonima Profesional',
          abbreviations: ['S.A.P.'],
        },
      },
    },
    ARDP: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Civil Profesional',
          abbreviations: [],
        },
      },
    },
    AXS5: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Capital-Riesgo',
          abbreviations: ['SCR'],
        },
      },
    },
    B0V5: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Cooperativa Profesional',
          abbreviations: ['S.Coop.P.'],
        },
      },
    },
    BI3B: {
      active: true,
      languages: {
        es: {
          label: 'Agrupacion Europea de Interes Economico',
          abbreviations: ['A.E.I.E.'],
        },
      },
    },
    CUIH: {
      active: true,
      languages: {
        es: {
          label: 'Mutua',
          abbreviations: [],
        },
      },
    },
    DDES: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Capital-Riesgo-Pyme',
          abbreviations: ['SCR-Pyme'],
        },
      },
    },
    DP3Q: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Responsabilidad Limitada',
          abbreviations: ['S.L.', 'S.R.L.'],
        },
      },
    },
    FCJF: {
      active: true,
      languages: {
        es: {
          label: 'Fondo de Inversion en activos del Mercado Monetario',
          abbreviations: ['F.I.A.M.M.'],
        },
      },
    },
    FH4R: {
      active: true,
      languages: {
        es: {
          label: 'Fondo de Pensiones',
          abbreviations: ['F.P.'],
        },
      },
    },
    GJL1: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Comanditaria por Acciones',
          abbreviations: ['S.Com. p. A.'],
        },
      },
    },
    GJTL: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Comanditaria por Acciones Profesional',
          abbreviations: ['S.Com:p.A.P.'],
        },
      },
    },
    HRQA: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Cooperativa Europea',
          abbreviations: ['SCE', 'S. Coop. E.'],
        },
      },
    },
    I2WU: {
      active: true,
      languages: {
        es: {
          label: 'Agrupacion de Interes Economico',
          abbreviations: ['A.I.E.'],
        },
      },
    },
    IAS6: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad de Garantia Reciproca',
          abbreviations: ['S.G.R.'],
        },
      },
    },
    IT6N: {
      active: true,
      languages: {
        es: {
          label: 'Emprendedor de Responsabilidad Limitada',
          abbreviations: ['E.R.L.'],
        },
      },
    },
    JB2M: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Limitada Profesional',
          abbreviations: ['S.L.P.', 'S.R.L.P.'],
        },
      },
    },
    JTV5: {
      active: true,
      languages: {
        es: {
          label: 'Fondo de Capital-Riesgo',
          abbreviations: ['FCR'],
        },
      },
    },
    K0RI: {
      active: true,
      languages: {
        es: {
          label: 'Institucion de Inversion Colectiva',
          abbreviations: ['IIC'],
        },
      },
    },
    K6L9: {
      active: false,
      languages: {
        es: {
          label: 'Sociedad Civil Profesional',
          abbreviations: [],
        },
      },
    },
    MDOL: {
      active: true,
      languages: {
        es: {
          label: 'Fundación',
          abbreviations: [],
        },
      },
    },
    QMUM: {
      active: true,
      languages: {
        es: {
          label: 'Fondos de Inversion Inmobiliaria',
          abbreviations: ['F.I.I.'],
        },
      },
    },
    R2L8: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Anonima Laboral',
          abbreviations: ['S.A.L.'],
        },
      },
    },
    R6UT: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Limitada Unipersonal',
          abbreviations: ['SLU'],
        },
      },
    },
    S0Z5: {
      active: true,
      languages: {
        es: {
          label: 'Fondo de Inversion',
          abbreviations: ['F.I.'],
        },
      },
    },
    S6MS: {
      active: true,
      languages: {
        es: {
          label: 'Congregación',
          abbreviations: [],
        },
      },
    },
    S6X7: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Colectiva',
          abbreviations: ['S.C.', 'S.R.C.'],
        },
      },
    },
    SS0L: {
      active: true,
      languages: {
        es: {
          label: 'Cooperativa de Credito',
          abbreviations: [],
        },
      },
    },
    TDD5: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Comanditaria Simple',
          abbreviations: ['S. Com.', 'S. en C.'],
        },
      },
    },
    TLCJ: {
      active: true,
      languages: {
        es: {
          label: 'Junta de compensación',
          abbreviations: [],
        },
      },
    },
    TUHS: {
      active: true,
      languages: {
        es: {
          label: 'Corporación de Derecho Público',
          abbreviations: [],
        },
      },
    },
    UJ35: {
      active: true,
      languages: {
        es: {
          label: 'Fondo de Inversion Mobiliaria',
          abbreviations: ['F.I.M.'],
        },
      },
    },
    VFIU: {
      active: true,
      languages: {
        es: {
          label: 'Sociedad Comanditaria Simple Profesional',
          abbreviations: ['S. en C.P.', 'S.Com.P.'],
        },
      },
    },
    XYGP: {
      active: true,
      languages: {
        es: {
          label: 'Fondo de Capital-Riesgo-Pyme',
          abbreviations: ['FCR-Pyme'],
        },
      },
    },
  },
  SR: {
    '8MS6': {
      active: true,
      languages: {
        nl: {
          label: 'Stichting',
          abbreviations: [],
        },
      },
    },
    K4ZA: {
      active: true,
      languages: {
        nl: {
          label: 'Cooperatieve Vereniging',
          abbreviations: [],
        },
      },
    },
    KJZ3: {
      active: false,
      languages: {
        nl: {
          label: 'Filiaal of Bijkantoor',
          abbreviations: [],
        },
      },
    },
    OBTO: {
      active: true,
      languages: {
        nl: {
          label:
            'Commanditaire vennootschap (op aandelen) met een beherende vennoot',
          abbreviations: ['CV'],
        },
      },
    },
    QPC9: {
      active: true,
      languages: {
        nl: {
          label: 'Vereniging',
          abbreviations: [],
        },
      },
    },
    QWWY: {
      active: true,
      languages: {
        nl: {
          label:
            'Commanditaire vennootschap (op aandelen) met meer dan een beherende vennoot',
          abbreviations: ['CV'],
        },
      },
    },
    R6BI: {
      active: true,
      languages: {
        nl: {
          label: 'Eenmanszaak',
          abbreviations: [],
        },
      },
    },
    TCVB: {
      active: true,
      languages: {
        nl: {
          label: 'Naamloze Vennootschap / Limited Company by Shares',
          abbreviations: ['NV'],
        },
      },
    },
    WBWC: {
      active: true,
      languages: {
        nl: {
          label: 'Vennootschap onder een firma',
          abbreviations: ['VOF'],
        },
      },
    },
  },
  SE: {
    '1TN0': {
      active: true,
      languages: {
        sv: {
          label: 'Ideell förening (som bedriver näringsverksamhet)',
          abbreviations: [],
        },
      },
    },
    '27AW': {
      active: true,
      languages: {
        sv: {
          label: 'Offentlig enhet',
          abbreviations: [],
        },
      },
    },
    '2UAX': {
      active: true,
      languages: {
        sv: {
          label: 'Trossamfund (som bedriver näringsverksamhet)',
          abbreviations: ['TSF'],
        },
      },
    },
    '381R': {
      active: true,
      languages: {
        sv: {
          label: 'Medlemsbank',
          abbreviations: ['MB'],
        },
      },
    },
    '44CQ': {
      active: true,
      languages: {
        sv: {
          label: 'Samfallighetsförening',
          abbreviations: [],
        },
      },
    },
    '54P7': {
      active: true,
      languages: {
        sv: {
          label: 'Europabolag',
          abbreviations: ['SE'],
        },
      },
    },
    '9YIP': {
      active: true,
      languages: {
        sv: {
          label: 'Europakooperativ',
          abbreviations: ['SCE'],
        },
      },
    },
    AZTO: {
      active: true,
      languages: {
        sv: {
          label: 'Sambruksförening',
          abbreviations: ['SF'],
        },
      },
    },
    BEAY: {
      active: true,
      languages: {
        sv: {
          label: 'Handelsbolag',
          abbreviations: ['HB'],
        },
      },
    },
    BYQJ: {
      active: true,
      languages: {
        sv: {
          label: 'Bankaktiebolag',
          abbreviations: ['BAB'],
        },
      },
    },
    C61P: {
      active: true,
      languages: {
        sv: {
          label: 'Ekonomisk förening',
          abbreviations: ['Ek. för.'],
        },
      },
    },
    CX05: {
      active: true,
      languages: {
        sv: {
          label: 'Kommanditbolag',
          abbreviations: ['KB'],
        },
      },
    },
    E9BI: {
      active: true,
      languages: {
        sv: {
          label: 'Stiftelse',
          abbreviations: [],
        },
      },
    },
    G04R: {
      active: true,
      languages: {
        sv: {
          label: 'Sparbank',
          abbreviations: ['SB'],
        },
      },
    },
    M0Y0: {
      active: true,
      languages: {
        sv: {
          label: 'Försäkringsförening',
          abbreviations: ['FOF'],
        },
      },
    },
    O1QI: {
      active: true,
      languages: {
        sv: {
          label: 'Ömsesidigt försäkringsbolag',
          abbreviations: ['OFB'],
        },
      },
    },
    OJ9I: {
      active: true,
      languages: {
        sv: {
          label: 'Försäkringsaktiebolag',
          abbreviations: ['FAB'],
        },
      },
    },
    PDQ0: {
      active: true,
      languages: {
        sv: {
          label: 'Kooperativ hyresrättsförening',
          abbreviations: ['KHF'],
        },
      },
    },
    RLJO: {
      active: true,
      languages: {
        sv: {
          label: 'Europeisk ekonomisk intressegruppering',
          abbreviations: ['EEIG'],
        },
      },
    },
    RYFP: {
      active: true,
      languages: {
        sv: {
          label: 'Europeisk gruppering för territoriellt samarbete',
          abbreviations: ['EGTS'],
        },
      },
    },
    SSOM: {
      active: true,
      languages: {
        sv: {
          label: 'Bostadsrättsförening',
          abbreviations: ['BRF'],
        },
      },
    },
    UKOL: {
      active: true,
      languages: {
        sv: {
          label: 'Enkelt bolag',
          abbreviations: [],
        },
      },
    },
    WZDB: {
      active: true,
      languages: {
        sv: {
          label: 'Bostadsförening',
          abbreviations: [],
        },
      },
    },
    XJHM: {
      active: true,
      languages: {
        sv: {
          label: 'Aktiebolag',
          abbreviations: ['AB'],
        },
      },
    },
  },
  CH: {
    '1BL5': {
      active: false,
      languages: {
        en: {
          label:
            'Swiss branch of an enterprise domiciled abroad not registered in the commercial register',
          abbreviations: ['Foreign Coop. & Ltd.Co.'],
        },
        fr: {
          label:
            "Succursale suisse d'une entreprise domiciliée à l'étranger non inscrite au registre de commerce",
          abbreviations: ['Coop & Sarl étranger'],
        },
        de: {
          label:
            'Ausländische Niederlassung nicht im Handelsregister eingetragen',
          abbreviations: ['Ausl. Gen. & GMBH'],
        },
        it: {
          label:
            "Succursali svizzere di una impresa domiciliata all'estero non iscritta al registro di commercio",
          abbreviations: ['Coop. & SAGL estero'],
        },
      },
    },
    '1RKS': {
      active: false,
      languages: {
        en: {
          label: 'Foreign public administration (e.g. embassy)',
          abbreviations: ['Embassy'],
        },
        fr: {
          label: 'Administration publique étrangère (ex. Ambassade)',
          abbreviations: ['Ambassade'],
        },
        de: {
          label: 'Ausländische öffentliche Verwaltung',
          abbreviations: ['Botschaft'],
        },
        it: {
          label: 'Amministrazione pubblica estera (ex. ambasciata)',
          abbreviations: ['Ambasciate'],
        },
      },
    },
    '2B81': {
      active: true,
      languages: {
        en: {
          label: 'Simple partnership',
          abbreviations: ['Simple Co.'],
        },
        fr: {
          label: 'Société simple',
          abbreviations: [],
        },
        de: {
          label: 'Einfache Gesellschaft',
          abbreviations: ['Einfache Gesellsch.'],
        },
        it: {
          label: 'Sociéta semplice',
          abbreviations: [],
        },
      },
    },
    '2JZ4': {
      active: true,
      languages: {
        en: {
          label: 'Foundation',
          abbreviations: [],
        },
        fr: {
          label: 'Fondation',
          abbreviations: [],
        },
        de: {
          label: 'Stiftung',
          abbreviations: [],
        },
        it: {
          label: 'Fondazione',
          abbreviations: [],
        },
      },
    },
    '2WFG': {
      active: false,
      languages: {
        en: {
          label: 'Foreign public company',
          abbreviations: ['Foreign legal nature'],
        },
        fr: {
          label: 'Entreprise publique étrangère',
          abbreviations: ['Nature jur. étran.'],
        },
        de: {
          label: 'Ausländisches öffentliches Unternehmen',
          abbreviations: ['Ausl. Rechtsform'],
        },
        it: {
          label: 'Impresa pubblica estera',
          abbreviations: ['Natura guiri. estera'],
        },
      },
    },
    '2XJA': {
      active: true,
      languages: {
        en: {
          label: 'Federal administration',
          abbreviations: [],
        },
        fr: {
          label: 'Administration de la Confédération',
          abbreviations: ['Confédération'],
        },
        de: {
          label: 'Verwaltung des Bundes',
          abbreviations: ['Bund'],
        },
        it: {
          label: 'Amministrazione della Confederazione',
          abbreviations: ['Confederazione'],
        },
      },
    },
    '3EKS': {
      active: true,
      languages: {
        en: {
          label: 'Limited liability company',
          abbreviations: ['Limited', 'Ltd'],
        },
        fr: {
          label: 'Société à responsabilité limitée (SARL)',
          abbreviations: [],
        },
        de: {
          label: 'Gesellschaft mit beschränkter Haftung (GmbH)',
          abbreviations: ['GMBH'],
        },
        it: {
          label: 'Società a garanzia limitata (SAGL)',
          abbreviations: [],
        },
      },
    },
    '54WI': {
      active: true,
      languages: {
        en: {
          label: 'Investment company with fixed capital',
          abbreviations: [],
        },
        fr: {
          label: "Société d'investissement à capital fixe (SICAF)",
          abbreviations: [],
        },
        de: {
          label: 'Investmentgesellschaft mit festem Kapital (SICAF)',
          abbreviations: [],
        },
        it: {
          label: 'Società di investimento a capitale fisso (SICAF)',
          abbreviations: [],
        },
      },
    },
    '5BEZ': {
      active: true,
      languages: {
        en: {
          label: 'Special legal form',
          abbreviations: [],
        },
        fr: {
          label: 'Forme juridique particulière',
          abbreviations: [],
        },
        de: {
          label: 'Besondere Rechtsform',
          abbreviations: [],
        },
        it: {
          label: 'Natura giuridica particolare',
          abbreviations: [],
        },
      },
    },
    '7MNN': {
      active: true,
      languages: {
        en: {
          label: 'Public sector institution',
          abbreviations: ['Pub. Sec. inst.'],
        },
        fr: {
          label: 'Institut de droit public',
          abbreviations: ['Inst. droit public'],
        },
        de: {
          label: 'Institut des öffentlichen Rechts',
          abbreviations: ['Inst. öff. Recht'],
        },
        it: {
          label: 'Istituti di diritto pubblico',
          abbreviations: ['Ist. dir. pubblico'],
        },
      },
    },
    AZA0: {
      active: true,
      languages: {
        en: {
          label: 'Sole proprietorship',
          abbreviations: [],
        },
        fr: {
          label: 'Entreprise individuelle',
          abbreviations: ['Raison individuelle'],
        },
        de: {
          label: 'Einzelunternehmen',
          abbreviations: ['Einzelfirma'],
        },
        it: {
          label: 'Ditta individuale',
          abbreviations: [],
        },
      },
    },
    BF9N: {
      active: true,
      languages: {
        en: {
          label: 'Federal public company',
          abbreviations: ['Fed. publ. co.'],
        },
        fr: {
          label: 'Entreprise publique fédérale',
          abbreviations: ['Ent. pub. fédérale'],
        },
        de: {
          label: 'Unternehmen des Bundes',
          abbreviations: ['öff. Unt. Bund'],
        },
        it: {
          label: 'Impresa pubblica federale',
          abbreviations: ['Imp. pubb. federale'],
        },
      },
    },
    CQMY: {
      active: true,
      languages: {
        en: {
          label: 'Limited partnership',
          abbreviations: ['Ltd partnership'],
        },
        fr: {
          label: 'Société en commandite',
          abbreviations: ['Soc. en commandite'],
        },
        de: {
          label: 'Kommanditgesellschaft',
          abbreviations: ['Kommanditgesellsch.'],
        },
        it: {
          label: 'Società in accomandita',
          abbreviations: ['Soc. in accomandita'],
        },
      },
    },
    DP2E: {
      active: true,
      languages: {
        en: {
          label: 'International organisation',
          abbreviations: ['Internat. Org.'],
        },
        fr: {
          label: 'Organisation Internationale',
          abbreviations: ['Org. Internationales'],
        },
        de: {
          label: 'Internationale Organisation',
          abbreviations: ['Int. Organisation'],
        },
        it: {
          label: 'Organizazioni Internazionali',
          abbreviations: ['Org. Internazionali'],
        },
      },
    },
    E0NE: {
      active: true,
      languages: {
        en: {
          label: 'Public corporation',
          abbreviations: [],
        },
        fr: {
          label: 'Corporation de droit public',
          abbreviations: ['Corp. droit public'],
        },
        de: {
          label: 'Öffentlich-rechtliche Körperschaft (Verwaltung)',
          abbreviations: ['öff.-rechtl. Körp.'],
        },
        it: {
          label: 'Amm. corporazioni, consorzi, patriziati di diritto pubblico',
          abbreviations: ['Corp. diritto pubb.'],
        },
      },
    },
    FFTN: {
      active: true,
      languages: {
        en: {
          label: 'Cantonal administration',
          abbreviations: [],
        },
        fr: {
          label: 'Administration du canton',
          abbreviations: ['Canton'],
        },
        de: {
          label: 'Verwaltung des Kantons',
          abbreviations: ['Kanton'],
        },
        it: {
          label: 'Amministrazione del cantone',
          abbreviations: ['Cantone'],
        },
      },
    },
    FJG4: {
      active: true,
      languages: {
        de: {
          label: 'Trust',
          abbreviations: [],
        },
        en: {
          label: 'Trust',
          abbreviations: [],
        },
        fr: {
          label: 'Trust',
          abbreviations: [],
        },
        it: {
          label: 'Trust',
          abbreviations: [],
        },
      },
    },
    FLNB: {
      active: true,
      languages: {
        de: {
          label: 'Fonds',
          abbreviations: [],
        },
        en: {
          label: 'Fund',
          abbreviations: [],
        },
        fr: {
          label: 'Fonds',
          abbreviations: [],
        },
        it: {
          label: 'Fondo',
          abbreviations: [],
        },
      },
    },
    GP8M: {
      active: true,
      languages: {
        en: {
          label: 'Local administration',
          abbreviations: [],
        },
        fr: {
          label: 'Administration communale',
          abbreviations: ['Commune'],
        },
        de: {
          label: 'Verwaltung der Gemeinde',
          abbreviations: ['Gemeinde'],
        },
        it: {
          label: 'Amministrazione comunale',
          abbreviations: ['Comune'],
        },
      },
    },
    H781: {
      active: true,
      languages: {
        en: {
          label: 'Association',
          abbreviations: [],
        },
        fr: {
          label: 'Association politique, religieuse, scientifique, etc.',
          abbreviations: [],
        },
        de: {
          label: 'Verein',
          abbreviations: [],
        },
        it: {
          label: 'Associazione politico, religioso, scientifico, ecc.',
          abbreviations: [],
        },
      },
    },
    HX77: {
      active: true,
      languages: {
        en: {
          label: 'Cantonal public company',
          abbreviations: ['Cant. publ. co.'],
        },
        fr: {
          label: 'Entreprise publique cantonale',
          abbreviations: ['Ent. pub. cantonale'],
        },
        de: {
          label: 'Unternehmen des Kantons',
          abbreviations: ['öff. Unt. Kanton'],
        },
        it: {
          label: 'Impresa pubblica cantonale',
          abbreviations: ['Imp. pubb. cantonale'],
        },
      },
    },
    JB25: {
      active: false,
      languages: {
        en: {
          label:
            'Swiss branch of an enterprise domiciled abroad registered in the commercial registrer',
          abbreviations: ['Foreign PLC'],
        },
        fr: {
          label:
            "Succursale suisse d'une entreprise domiciliée à l'étranger inscrite au registre de commerce",
          abbreviations: ['SAdom. étran.'],
        },
        de: {
          label: 'Ausländische Niederlassung im Handelsregister eingetragen',
          abbreviations: ['Ausl. AG & LTD'],
        },
        it: {
          label:
            "Succursale di una impresa domiciliata all'estero iscritta al registro di commercio",
          abbreviations: ['SA dom. estero'],
        },
      },
    },
    KJ9Q: {
      active: true,
      languages: {
        en: {
          label: 'Non-commercial power of attorney',
          abbreviations: ['Power Att.'],
        },
        fr: {
          label: 'Procurations non commerciales',
          abbreviations: ['Procuration'],
        },
        de: {
          label: 'Nichtkaufmännische Prokuren',
          abbreviations: ['Prokura'],
        },
        it: {
          label: 'Procura non commerciale',
          abbreviations: ['Procura'],
        },
      },
    },
    L5DU: {
      active: true,
      languages: {
        en: {
          label: 'Local public company',
          abbreviations: ['Loc. publ. co.'],
        },
        fr: {
          label: 'Entreprise publique communale',
          abbreviations: ['Ent. pub. communale'],
        },
        de: {
          label: 'Unternehmen der Gemeinde',
          abbreviations: ['öff. Unt. Gemeinde'],
        },
        it: {
          label: 'Impresa pubblica comunale',
          abbreviations: ['Imp. pubb. comunale'],
        },
      },
    },
    M848: {
      active: true,
      languages: {
        en: {
          label: 'Corpororate public company',
          abbreviations: ['Corp. publ. co.'],
        },
        fr: {
          label: "Entreprise publique d'une corpororation",
          abbreviations: ['Ent. pub. corpor.'],
        },
        de: {
          label: 'Öffentlich-rechtliche Körperschaft (Unternehmen)',
          abbreviations: ['öff. Unt. Körp.'],
        },
        it: {
          label: 'Impresa o ente pubblico di una corporazione',
          abbreviations: ['Imp. pubb. corpora.'],
        },
      },
    },
    MRSY: {
      active: true,
      languages: {
        en: {
          label: 'General partnership',
          abbreviations: [],
        },
        fr: {
          label: 'Société en nom collectif',
          abbreviations: ['Soc. nom collectif'],
        },
        de: {
          label: 'Kollektivgesellschaft',
          abbreviations: ['Kollektivgesellsch.'],
        },
        it: {
          label: 'Società in nome collettivo',
          abbreviations: ['Soc. nome collettivo'],
        },
      },
    },
    MVII: {
      active: true,
      languages: {
        en: {
          label: 'Company limited by shares',
          abbreviations: ['PLC'],
        },
        fr: {
          label: 'Société anonyme',
          abbreviations: ['SA'],
        },
        de: {
          label: 'Aktiengesellschaft',
          abbreviations: ['AG'],
        },
        it: {
          label: 'Società anonima',
          abbreviations: ['SA'],
        },
      },
    },
    OBFU: {
      active: true,
      languages: {
        en: {
          label: 'Representative of an ownership in undivided shares',
          abbreviations: ['Undivided'],
        },
        fr: {
          label: "Représentants d'indivisions",
          abbreviations: ['Indivisions'],
        },
        de: {
          label: 'Haupt von Gemeinderschaften',
          abbreviations: [],
        },
        it: {
          label: "Rappresentanti d'indivisioni",
          abbreviations: ['Indivisioni'],
        },
      },
    },
    QSI2: {
      active: true,
      languages: {
        en: {
          label: 'Cooperative',
          abbreviations: [],
        },
        fr: {
          label: 'Société coopérative',
          abbreviations: [],
        },
        de: {
          label: 'Genossenschaft',
          abbreviations: [],
        },
        it: {
          label: 'Società cooperativa',
          abbreviations: [],
        },
      },
    },
    R9TC: {
      active: false,
      languages: {
        en: {
          label: 'Foreign enterprise',
          abbreviations: [],
        },
        fr: {
          label: 'Entreprise étrangère',
          abbreviations: ['Ent. Etrangère'],
        },
        de: {
          label: 'Ausländische Unternehmen',
          abbreviations: ['Aus. Unt.'],
        },
        it: {
          label: 'Impresa straniera',
          abbreviations: ['Imp. Str.'],
        },
      },
    },
    TL87: {
      active: true,
      languages: {
        en: {
          label: 'Limited partnership for collective investments',
          abbreviations: ['Ldt part. Coll. Invest.'],
        },
        fr: {
          label: 'Société en commandite de placements collectifs',
          abbreviations: ['Soc. com. Investissement'],
        },
        de: {
          label: 'Kommanditgesellschaft fuer kollektive Kapitalanlagen',
          abbreviations: ['Kommandit. Kapitalanlagen'],
        },
        it: {
          label:
            'Società in accomandita per investimenti collettivi di capitale',
          abbreviations: ['Soc. com. investimenti'],
        },
      },
    },
    UNA9: {
      active: false,
      languages: {
        en: {
          label: 'Swiss branch registered at the registry of commerce',
          abbreviations: ['Branch RC'],
        },
        fr: {
          label: 'Succursale suisse enregistrée au registre de commerce',
          abbreviations: ['Succ. RC'],
        },
        de: {
          label:
            'Schweizerische Zweigniederlassung im Handelsregister eingetragen',
          abbreviations: ['Zweig. HR'],
        },
        it: {
          label: 'Succursale svizzera registrata nel registro di commercio',
          abbreviations: ['Succ. RC'],
        },
      },
    },
    VPRH: {
      active: true,
      languages: {
        en: {
          label: 'District public company',
          abbreviations: ['Distr. publ. co.'],
        },
        fr: {
          label: 'Entreprise publique de district',
          abbreviations: ['Ent. pub. district'],
        },
        de: {
          label: 'Öffentliches Unternehmen des Bezirks',
          abbreviations: ['öff. Unt. Bezirk'],
        },
        it: {
          label: 'Impresa pubblica di distretto',
          abbreviations: ['Imp. pubb. distretto'],
        },
      },
    },
    W6A7: {
      active: true,
      languages: {
        en: {
          label: 'Patnership limited by shares',
          abbreviations: [],
        },
        fr: {
          label: 'Société en commandite par action',
          abbreviations: ['Soc. comm. action'],
        },
        de: {
          label: 'Kommanditaktiengesellschaft',
          abbreviations: ['Kommandit-AG'],
        },
        it: {
          label: 'Società in accomandita per azioni',
          abbreviations: ['Soc. com. per azioni'],
        },
      },
    },
    XJOT: {
      active: true,
      languages: {
        en: {
          label: 'Investment company with variable capital',
          abbreviations: [],
        },
        fr: {
          label: "Société d'investissement à capital variable (SICAV)",
          abbreviations: [],
        },
        de: {
          label: 'Investmentgesellschaft mit variablem Kapital (SICAV)',
          abbreviations: [],
        },
        it: {
          label: 'Società di investimento a capitale variabile (SICAV)',
          abbreviations: [],
        },
      },
    },
    YRGM: {
      active: true,
      languages: {
        en: {
          label: 'District administration',
          abbreviations: [],
        },
        fr: {
          label: 'Administration du district',
          abbreviations: ['District'],
        },
        de: {
          label: 'Verwaltung des Bezirks',
          abbreviations: ['Bezirk'],
        },
        it: {
          label: 'Amministrazione del distretto',
          abbreviations: ['Distretto'],
        },
      },
    },
  },
  TW: {
    '14U1': {
      active: true,
      languages: {
        zh: {
          label: '兩合公司',
          abbreviations: [],
        },
      },
    },
    '346N': {
      active: true,
      languages: {
        zh: {
          label: '公益社團法人',
          abbreviations: [],
        },
      },
    },
    '6LI8': {
      active: true,
      languages: {
        zh: {
          label: '營利社團法人',
          abbreviations: [],
        },
      },
    },
    ALDM: {
      active: true,
      languages: {
        zh: {
          label: '合作社',
          abbreviations: [],
        },
      },
    },
    F5VB: {
      active: true,
      languages: {
        zh: {
          label: '財團法人',
          abbreviations: [],
        },
      },
    },
    IUOP: {
      active: true,
      languages: {
        zh: {
          label: '商號',
          abbreviations: [],
        },
      },
    },
    K9SK: {
      active: true,
      languages: {
        zh: {
          label: '合夥',
          abbreviations: [],
        },
      },
    },
    KHQ2: {
      active: true,
      languages: {
        zh: {
          label: '無限公司',
          abbreviations: [],
        },
      },
    },
    TD8P: {
      active: true,
      languages: {
        zh: {
          label: '股份有限公司',
          abbreviations: [],
        },
      },
    },
    Y45C: {
      active: true,
      languages: {
        zh: {
          label: '有限公司',
          abbreviations: [],
        },
      },
    },
  },
  TH: {
    '46FG': {
      active: true,
      languages: {
        th: {
          label: 'จังหวัด',
          abbreviations: [],
        },
      },
    },
    D87D: {
      active: true,
      languages: {
        th: {
          label: 'มูลนิธิจดทะเบียน',
          abbreviations: [],
        },
      },
    },
    FDRT: {
      active: true,
      languages: {
        th: {
          label: 'สมาคมจดทะเบียน',
          abbreviations: [],
        },
      },
    },
    JUEU: {
      active: true,
      languages: {
        th: {
          label: 'ห้างหุ้นส่วนจำกัด',
          abbreviations: [],
        },
      },
    },
    K09K: {
      active: true,
      languages: {
        th: {
          label: 'บริษัทจำกัด',
          abbreviations: [],
        },
      },
    },
    N8FJ: {
      active: true,
      languages: {
        th: {
          label: 'ส่วนราชการ',
          abbreviations: [],
        },
      },
    },
    O0OZ: {
      active: true,
      languages: {
        th: {
          label: 'บริษัทมหาชนจำกัด',
          abbreviations: [],
        },
      },
    },
    QFXX: {
      active: true,
      languages: {
        th: {
          label: 'ห้างหุ้นส่วนสามัญจดทะเบียน',
          abbreviations: [],
        },
      },
    },
    VSTJ: {
      active: true,
      languages: {
        th: {
          label: 'นิติบุคคลอื่นที่จัดตั้งขึ้นตามกฎหมายพิเศษ',
          abbreviations: [],
        },
      },
    },
  },
  TO: {
    UZUP: {
      active: true,
      languages: {
        en: {
          label: 'Local Company',
          abbreviations: [],
        },
      },
    },
    ZQEN: {
      active: true,
      languages: {
        en: {
          label: 'Overseas Company',
          abbreviations: [],
        },
      },
    },
  },
  TN: {
    AF67: {
      active: true,
      languages: {
        fr: {
          label: 'Société unipersonnelle à responsabilité limitée',
          abbreviations: ['SUARL'],
        },
      },
    },
    F502: {
      active: true,
      languages: {
        fr: {
          label: 'Entreprise individuelle',
          abbreviations: [],
        },
      },
    },
    WSE1: {
      active: true,
      languages: {
        fr: {
          label: 'Société à responsabilité limitée',
          abbreviations: ['SARL'],
        },
      },
    },
    YVSL: {
      active: true,
      languages: {
        fr: {
          label: 'Société anonyme',
          abbreviations: ['SA'],
        },
      },
    },
  },
  TR: {
    '2DY1': {
      active: true,
      languages: {
        tr: {
          label: 'Kamu tüzel kişiliği',
          abbreviations: [],
        },
      },
    },
    '5T3H': {
      active: true,
      languages: {
        tr: {
          label: 'Fonlar',
          abbreviations: [],
        },
      },
    },
    '8BXP': {
      active: true,
      languages: {
        tr: {
          label: 'Kooperatif',
          abbreviations: [],
        },
      },
    },
    D4KQ: {
      active: true,
      languages: {
        tr: {
          label: 'Özel mevzuat ile kurulmuş kuruluş',
          abbreviations: [],
        },
      },
    },
    HAAY: {
      active: true,
      languages: {
        tr: {
          label: 'Birlik',
          abbreviations: [],
        },
      },
    },
    JMQU: {
      active: true,
      languages: {
        tr: {
          label: 'Kollektif şirket',
          abbreviations: ['Koll.Şti.'],
        },
      },
    },
    LYA0: {
      active: true,
      languages: {
        tr: {
          label: 'Dernek',
          abbreviations: [],
        },
      },
    },
    ONVA: {
      active: true,
      languages: {
        tr: {
          label: 'Komandit şirket',
          abbreviations: ['Kom.Şti'],
        },
      },
    },
    R5UT: {
      active: true,
      languages: {
        tr: {
          label: 'Limited şirket',
          abbreviations: ['Ltd. Şti.'],
        },
      },
    },
    RLSQ: {
      active: true,
      languages: {
        tr: {
          label: 'Vakif',
          abbreviations: [],
        },
      },
    },
    W2SQ: {
      active: true,
      languages: {
        tr: {
          label: 'Anonim şirket',
          abbreviations: ['A.Ş.'],
        },
      },
    },
  },
  TV: {
    AJ2Y: {
      active: true,
      languages: {
        en: {
          label: 'Proprietary company',
          abbreviations: ['PTY'],
        },
      },
    },
    LZI3: {
      active: true,
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
    OTC0: {
      active: true,
      languages: {
        en: {
          label: 'Co-operative society',
          abbreviations: [],
        },
      },
    },
    PKOR: {
      active: true,
      languages: {
        en: {
          label: 'Public company',
          abbreviations: ['LTD'],
        },
      },
    },
    RS5D: {
      active: true,
      languages: {
        en: {
          label: 'Association',
          abbreviations: [],
        },
      },
    },
    W3YV: {
      active: true,
      languages: {
        en: {
          label: 'International company',
          abbreviations: [],
        },
      },
    },
  },
  AE: {
    F8VX: {
      active: true,
      languages: {
        en: {
          label: 'Joint Liability Company',
          abbreviations: [],
        },
      },
    },
    JGNU: {
      active: true,
      languages: {
        en: {
          label: 'Public Joint Stock Company',
          abbreviations: [],
        },
      },
    },
    LOL8: {
      active: true,
      languages: {
        en: {
          label: 'Simple Commandite Company',
          abbreviations: [],
        },
      },
    },
    MV4S: {
      active: true,
      languages: {
        en: {
          label: 'Sole Proprietor',
          abbreviations: [],
        },
      },
    },
    RWVW: {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    WR09: {
      active: true,
      languages: {
        en: {
          label: 'Private Joint Stock Company',
          abbreviations: [],
        },
      },
    },
    '4VPM': {
      active: true,
      subdivision: 'AE-AZ',
      languages: {
        en: {
          label: 'Incorporated Cell',
          abbreviations: [],
        },
      },
    },
    '6H9F': {
      active: true,
      subdivision: 'AE-AZ',
      languages: {
        en: {
          label: 'Open Ended Investment Company',
          abbreviations: [],
        },
      },
    },
    '9I58': {
      active: true,
      subdivision: 'AE-AZ',
      languages: {
        en: {
          label: 'Private Company Unlimited without Shares',
          abbreviations: [],
        },
      },
    },
    '9U6F': {
      active: true,
      subdivision: 'AE-AZ',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    B13W: {
      active: true,
      subdivision: 'AE-AZ',
      languages: {
        en: {
          label: 'Restricted Scope Company',
          abbreviations: [],
        },
      },
    },
    FE4G: {
      active: true,
      subdivision: 'AE-AZ',
      languages: {
        en: {
          label: 'Protected Cell Company',
          abbreviations: [],
        },
      },
    },
    GU5E: {
      active: true,
      subdivision: 'AE-AZ',
      languages: {
        en: {
          label: 'Public Company Limited by Shares',
          abbreviations: [],
        },
      },
    },
    H8MU: {
      active: true,
      subdivision: 'AE-AZ',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    HECG: {
      active: true,
      subdivision: 'AE-AZ',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    KAEM: {
      active: true,
      subdivision: 'AE-AZ',
      languages: {
        en: {
          label: 'Private Company Unlimited with Shares',
          abbreviations: [],
        },
      },
    },
    LZ3H: {
      active: true,
      subdivision: 'AE-AZ',
      languages: {
        en: {
          label: 'Close Ended Investment Company',
          abbreviations: [],
        },
      },
    },
    OSE2: {
      active: true,
      subdivision: 'AE-AZ',
      languages: {
        en: {
          label: 'Private Company Limited by Shares',
          abbreviations: [],
        },
      },
    },
    PNX6: {
      active: true,
      subdivision: 'AE-AZ',
      languages: {
        en: {
          label: 'Incorporated Cell Company',
          abbreviations: [],
        },
      },
    },
    R2YL: {
      active: true,
      subdivision: 'AE-AZ',
      languages: {
        en: {
          label: 'Private Company Limited by Guarantee',
          abbreviations: [],
        },
      },
    },
    VKZD: {
      active: true,
      subdivision: 'AE-AZ',
      languages: {
        en: {
          label: 'Foundation',
          abbreviations: [],
        },
      },
    },
    '375P': {
      active: true,
      subdivision: 'AE-DU',
      languages: {
        en: {
          label: 'Foundation',
          abbreviations: [],
        },
      },
    },
    '3P03': {
      active: true,
      subdivision: 'AE-DU',
      languages: {
        en: {
          label: 'Open Ended Investment Company',
          abbreviations: [],
        },
      },
    },
    '46QC': {
      active: true,
      subdivision: 'AE-DU',
      languages: {
        en: {
          label: 'Public Company Limited by Shares',
          abbreviations: [],
        },
      },
    },
    '70EO': {
      active: true,
      subdivision: 'AE-DU',
      languages: {
        en: {
          label: 'Private Company Limited by Shares',
          abbreviations: [],
        },
      },
    },
    AIR0: {
      active: true,
      subdivision: 'AE-DU',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    F3UE: {
      active: true,
      subdivision: 'AE-DU',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    RWX4: {
      active: true,
      subdivision: 'AE-DU',
      languages: {
        en: {
          label: 'Protected Cell Company',
          abbreviations: [],
        },
      },
    },
    V2PA: {
      active: true,
      subdivision: 'AE-DU',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    VTIP: {
      active: true,
      subdivision: 'AE-DU',
      languages: {
        en: {
          label: 'Close Ended Investment Company',
          abbreviations: [],
        },
      },
    },
    '35BX': {
      active: false,
      subdivision: 'AE-RK',
      languages: {
        en: {
          label: 'Intellectual Property Holding Company',
          abbreviations: [],
        },
      },
    },
    FHRL: {
      active: true,
      subdivision: 'AE-RK',
      languages: {
        en: {
          label: 'Segregated Portfolio Company',
          abbreviations: [],
        },
      },
    },
    GQ8F: {
      active: true,
      subdivision: 'AE-RK',
      languages: {
        en: {
          label: 'Company Limited By Guarantee',
          abbreviations: [],
        },
      },
    },
    HNPH: {
      active: true,
      subdivision: 'AE-RK',
      languages: {
        en: {
          label: 'Restricted Purposes Company',
          abbreviations: [],
        },
      },
    },
    QJVN: {
      active: true,
      subdivision: 'AE-RK',
      languages: {
        en: {
          label: 'Company Limited By Shares',
          abbreviations: [],
        },
      },
    },
    UAES: {
      active: true,
      subdivision: 'AE-RK',
      languages: {
        en: {
          label: 'RAK Economic Zone Company',
          abbreviations: ['FZ LLC'],
        },
      },
    },
    Z3P8: {
      active: true,
      subdivision: 'AE-RK',
      languages: {
        en: {
          label: 'Unlimited Company',
          abbreviations: [],
        },
      },
    },
  },
  GB: {
    '17R0': {
      active: true,
      languages: {
        en: {
          label: 'Community Interest Company',
          abbreviations: ['CIC'],
        },
      },
    },
    '1W62': {
      active: false,
      languages: {
        en: {
          label: 'Oversea Company',
          abbreviations: [],
        },
      },
    },
    '468Q': {
      active: true,
      languages: {
        en: {
          label: 'United Kingdom Societas',
          abbreviations: ['UKS'],
        },
      },
    },
    '4GJI': {
      active: true,
      languages: {
        en: {
          label: 'Private Limited by Guarantee',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    '55MA': {
      active: false,
      languages: {
        cy: {
          label: 'Cwmni Cyfyngedig Cyhoeddus',
          abbreviations: ['CCC'],
        },
      },
    },
    '57V7': {
      active: true,
      languages: {
        en: {
          label: 'Private Unlimited',
          abbreviations: [],
        },
      },
    },
    '60IF': {
      active: true,
      languages: {
        en: {
          label: 'Private Unlimited/No Share Capital',
          abbreviations: [],
        },
      },
    },
    '7T8N': {
      active: true,
      languages: {
        en: {
          label: 'Charitable Incorporated Organisation',
          abbreviations: [],
        },
      },
    },
    '8CF0': {
      active: true,
      languages: {
        en: {
          label: 'Assurance Company',
          abbreviations: [],
        },
      },
    },
    '9B78': {
      active: true,
      languages: {
        en: {
          label: 'Royal Charter Company',
          abbreviations: [],
        },
      },
    },
    A2X8: {
      active: false,
      languages: {
        en: {
          label: 'Unregistered Company',
          abbreviations: [],
        },
      },
    },
    AVYY: {
      active: true,
      languages: {
        en: {
          label: 'Government Entity',
          abbreviations: [],
        },
      },
    },
    B6ES: {
      active: true,
      languages: {
        en: {
          label: 'Public Limited Company',
          abbreviations: ['PLC'],
        },
        cy: {
          label: 'Cwmni Cyfyngedig Cyhoeddus',
          abbreviations: ['CCC'],
        },
      },
    },
    BX6Y: {
      active: true,
      languages: {
        en: {
          label: 'Friendly Society',
          abbreviations: [],
        },
      },
    },
    C605: {
      active: false,
      languages: {
        en: {
          label: 'Private Limited by Shares (Section 30 Exemption)',
          abbreviations: [],
        },
      },
    },
    CDOT: {
      active: false,
      languages: {
        en: {
          label: 'UK Establishment',
          abbreviations: ['BR'],
        },
      },
    },
    E12O: {
      active: true,
      languages: {
        en: {
          label: 'Building Society',
          abbreviations: [],
        },
      },
    },
    FVGZ: {
      active: false,
      languages: {
        en: {
          label: 'Industrial and Provident Society',
          abbreviations: [],
        },
      },
    },
    G12F: {
      active: true,
      languages: {
        en: {
          label: 'Private Limited by Guarantee/No Share Capital',
          abbreviations: [],
        },
      },
    },
    H0PO: {
      active: true,
      languages: {
        en: {
          label: 'Private Limited Company',
          abbreviations: ['Limited', 'Ltd'],
        },
        cy: {
          label: 'Cyfyngedig',
          abbreviations: ['cyf'],
        },
      },
    },
    HHYT: {
      active: false,
      languages: {
        en: {
          label:
            'European Public Limited-Liability Company (Societas Europaea)',
          abbreviations: ['SE'],
        },
      },
    },
    HX6D: {
      active: false,
      languages: {
        en: {
          label: 'Private Limited',
          abbreviations: [],
        },
      },
    },
    ID30: {
      active: true,
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    IYXU: {
      active: true,
      languages: {
        en: {
          label: 'Community Benefit Society',
          abbreviations: ['BenCom'],
        },
      },
    },
    NAUO: {
      active: false,
      languages: {
        en: {
          label: 'Other Company Type',
          abbreviations: [],
        },
      },
    },
    Q0M5: {
      active: true,
      languages: {
        en: {
          label: 'Unregistered Company',
          abbreviations: [],
        },
      },
    },
    T61R: {
      active: false,
      languages: {
        cy: {
          label: 'Cyfyngedig',
          abbreviations: ['cyf'],
        },
      },
    },
    TT2H: {
      active: true,
      languages: {
        en: {
          label: 'Protected Cell Company',
          abbreviations: [],
        },
      },
    },
    TYJK: {
      active: false,
      languages: {
        en: {
          label:
            'Private Limited by Guarantee/No Share Capital (Use of Limited Exemption)',
          abbreviations: [],
        },
      },
    },
    U6R9: {
      active: false,
      languages: {
        en: {
          label: 'European Economic Interest Grouping',
          abbreviations: ['EEIG'],
        },
      },
    },
    VV0W: {
      active: true,
      languages: {
        en: {
          label: 'Investment Company with Variable Capital',
          abbreviations: [],
        },
      },
    },
    VYF8: {
      active: true,
      languages: {
        en: {
          label: 'United Kingdom Economic Interest Grouping',
          abbreviations: ['UKEIG'],
        },
      },
    },
    WBQU: {
      active: true,
      languages: {
        en: {
          label: 'Credit Union',
          abbreviations: [],
        },
      },
    },
    WJ0A: {
      active: false,
      languages: {
        cy: {
          label: 'Partneriaeth Atebolrwydd Cyfyngedig',
          abbreviations: ['PAC'],
        },
      },
    },
    XLZV: {
      active: true,
      languages: {
        en: {
          label: 'Registered Society',
          abbreviations: [],
        },
      },
    },
    Z0EY: {
      active: true,
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
        cy: {
          label: 'Partneriaeth Atebolrwydd Cyfyngedig',
          abbreviations: ['PAC'],
        },
      },
    },
    ZQ6S: {
      active: true,
      languages: {
        en: {
          label: 'Old Public Company',
          abbreviations: ['Limited', 'Ltd'],
        },
      },
    },
    ZZGG: {
      active: true,
      languages: {
        en: {
          label: 'Co-operative Society',
          abbreviations: ['Co-op'],
        },
      },
    },
    '4A3J': {
      active: true,
      subdivision: 'GB-NIR',
      languages: {
        en: {
          label: 'Northern Ireland Company',
          abbreviations: [],
        },
      },
    },
    '5FRT': {
      active: true,
      subdivision: 'GB-NIR',
      languages: {
        en: {
          label: 'Other Type of Company (in Northern Ireland)',
          abbreviations: [],
        },
      },
    },
    '7VVZ': {
      active: true,
      subdivision: 'GB-NIR',
      languages: {
        en: {
          label: 'Co-operative Society (Northern Ireland)',
          abbreviations: ['Co-op'],
        },
      },
    },
    JTCO: {
      active: true,
      subdivision: 'GB-NIR',
      languages: {
        en: {
          label: 'Credit Union (Northern Ireland)',
          abbreviations: [],
        },
      },
    },
    UTY8: {
      active: true,
      subdivision: 'GB-NIR',
      languages: {
        en: {
          label: 'Community Benefit Society (Northern Ireland)',
          abbreviations: ['BenCom'],
        },
      },
    },
    NBTW: {
      active: true,
      subdivision: 'GB-SCT',
      languages: {
        en: {
          label: 'Scottish Partnership',
          abbreviations: [],
        },
      },
    },
    STX7: {
      active: true,
      subdivision: 'GB-SCT',
      languages: {
        en: {
          label: 'Scottish Charitable Incorporated Organisation',
          abbreviations: [],
        },
      },
    },
  },
  US: {
    '14OD': {
      active: true,
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '380O': {
      active: true,
      languages: {
        en: {
          label: 'Federal Savings Association',
          abbreviations: ['FSA'],
        },
      },
    },
    '3MM4': {
      active: true,
      languages: {
        en: {
          label: 'Edge Act Corporation',
          abbreviations: [],
        },
      },
    },
    '62VJ': {
      active: true,
      languages: {
        en: {
          label: 'National Bank',
          abbreviations: ['N.A.'],
        },
      },
    },
    Z7ER: {
      active: true,
      languages: {
        en: {
          label: 'Mutual Savings and Loan Holding Company',
          abbreviations: [],
        },
      },
    },
    A3YH: {
      active: true,
      subdivision: 'US-AL',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    CR3H: {
      active: true,
      subdivision: 'US-AL',
      languages: {
        en: {
          label: 'Registered Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    CWRI: {
      active: true,
      subdivision: 'US-AL',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LLC'],
        },
      },
    },
    FIP8: {
      active: true,
      subdivision: 'US-AL',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    HFGV: {
      active: true,
      subdivision: 'US-AL',
      languages: {
        en: {
          label: 'For-Profit Corporation',
          abbreviations: ['Corp.', 'Inc.'],
        },
      },
    },
    HN8W: {
      active: true,
      subdivision: 'US-AL',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    JPZW: {
      active: true,
      subdivision: 'US-AL',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    QUNR: {
      active: true,
      subdivision: 'US-AL',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    V65U: {
      active: true,
      subdivision: 'US-AL',
      languages: {
        en: {
          label: 'Non-Profit Corporation',
          abbreviations: [],
        },
      },
    },
    WDT2: {
      active: true,
      subdivision: 'US-AL',
      languages: {
        en: {
          label: 'Limited Liability Limited Partnership',
          abbreviations: [],
        },
      },
    },
    '7GTR': {
      active: true,
      subdivision: 'US-AK',
      languages: {
        en: {
          label: 'Public Corporation',
          abbreviations: [],
        },
      },
    },
    '7QKB': {
      active: true,
      subdivision: 'US-AK',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    '9A4Q': {
      active: true,
      subdivision: 'US-AK',
      languages: {
        en: {
          label: 'Religious Corporation',
          abbreviations: [],
        },
      },
    },
    BRO8: {
      active: true,
      subdivision: 'US-AK',
      languages: {
        en: {
          label: 'Business Corporation',
          abbreviations: ['INC'],
        },
      },
    },
    C0VE: {
      active: true,
      subdivision: 'US-AK',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    D4YS: {
      active: true,
      subdivision: 'US-AK',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LLC'],
        },
      },
    },
    EQAQ: {
      active: true,
      subdivision: 'US-AK',
      languages: {
        en: {
          label: 'Sole Proprietorship',
          abbreviations: [],
        },
      },
    },
    K2BJ: {
      active: true,
      subdivision: 'US-AK',
      languages: {
        en: {
          label: 'Non-Profit Corporation',
          abbreviations: [],
        },
      },
    },
    M886: {
      active: true,
      subdivision: 'US-AK',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    OVBT: {
      active: true,
      subdivision: 'US-AK',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: ['P.C.'],
        },
      },
    },
    TRS2: {
      active: true,
      subdivision: 'US-AK',
      languages: {
        en: {
          label: 'Cooperative Corporation',
          abbreviations: ['COOP'],
        },
      },
    },
    VXDE: {
      active: true,
      subdivision: 'US-AK',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    WNKG: {
      active: true,
      subdivision: 'US-AK',
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
    ZPRC: {
      active: true,
      subdivision: 'US-AK',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '1T9S': {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    '5MNR': {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: [],
        },
      },
    },
    '78H5': {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Corporation (Nonprofit)',
          abbreviations: [],
        },
      },
    },
    A9AW: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    D8PB: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Business Development Corporation',
          abbreviations: [],
        },
      },
    },
    FGVH: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Corporation (Business or for-profit)',
          abbreviations: [],
        },
      },
    },
    IMDT: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Limited Liability Limited Partnership',
          abbreviations: [],
        },
      },
    },
    IVQQ: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Corporation Sole',
          abbreviations: [],
        },
      },
    },
    N69M: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    O85W: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    P24O: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Business Trust',
          abbreviations: [],
        },
      },
    },
    QA1T: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Savings bank',
          abbreviations: [],
        },
      },
    },
    QEEJ: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Professional Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    QUJ5: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Benefit Corporation',
          abbreviations: [],
        },
      },
    },
    RSWJ: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    S68T: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Electric Cooperative Nonprofit Membership Corporation',
          abbreviations: [],
        },
      },
    },
    ST2Q: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Cooperative Marketing Association',
          abbreviations: [],
        },
      },
    },
    UGE3: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label:
            'Nonprofit Electric Generation and Transmission Cooperative Corporation',
          abbreviations: [],
        },
      },
    },
    VKPN: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Close Corporation',
          abbreviations: [],
        },
      },
    },
    XUUL: {
      active: true,
      subdivision: 'US-AZ',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '1K9U': {
      active: true,
      subdivision: 'US-AR',
      languages: {
        en: {
          label: 'Non-Profit Corporation',
          abbreviations: [],
        },
      },
    },
    EJX1: {
      active: true,
      subdivision: 'US-AR',
      languages: {
        en: {
          label: 'For-Profit Corporation',
          abbreviations: ['Co.', 'Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    GD6J: {
      active: true,
      subdivision: 'US-AR',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    JR6U: {
      active: true,
      subdivision: 'US-AR',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    KGZ8: {
      active: true,
      subdivision: 'US-AR',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    L2DM: {
      active: true,
      subdivision: 'US-AR',
      languages: {
        en: {
          label: 'Limited Liability Limited Partnership',
          abbreviations: ['LLLP'],
        },
      },
    },
    M4FO: {
      active: true,
      subdivision: 'US-AR',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [
            'Company',
            'Corporation',
            'Incorporated',
            'Limited',
            'Co.',
            'Corp.',
            'Inc.',
            'Ltd.',
          ],
        },
      },
    },
    MJJZ: {
      active: true,
      subdivision: 'US-AR',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    Q3NF: {
      active: true,
      subdivision: 'US-AR',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '4JCS': {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    '5HQ4': {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LLLP', 'LP'],
        },
      },
    },
    '5Y1L': {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'Industrial Bank',
          abbreviations: [],
        },
      },
    },
    '7CDL': {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'For-Profit Corporation Close',
          abbreviations: [
            'Co',
            'Company',
            'Corp',
            'Corporation',
            'Inc',
            'Incorporated',
            'Incorporation',
            'Limited',
            'Ltd',
          ],
        },
      },
    },
    BADE: {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'Nonprofit Common Interest Development Association',
          abbreviations: [],
        },
      },
    },
    CVXK: {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'Nonprofit Corporation Religious',
          abbreviations: [],
        },
      },
    },
    EI4J: {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LLC'],
        },
      },
    },
    G1P6: {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'Nonprofit Corporation Mutual Benefit',
          abbreviations: [],
        },
      },
    },
    H1UM: {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'For-Profit Corporation General Stock',
          abbreviations: [
            'Co',
            'Company',
            'Corp',
            'Corporation',
            'Inc',
            'Incorporated',
            'Incorporation',
            'Limited',
            'Ltd',
          ],
        },
      },
    },
    K7YU: {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'Nonprofit Corporation Public Benefit',
          abbreviations: [],
        },
      },
    },
    KQXA: {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    LYRX: {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    N295: {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    O6AU: {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    PZR6: {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'For-Profit Corporation Professional',
          abbreviations: ['PC'],
        },
      },
    },
    SQ7B: {
      active: true,
      subdivision: 'US-CA',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    '0GY3': {
      active: true,
      subdivision: 'US-CO',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '1JXS': {
      active: true,
      subdivision: 'US-CO',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    '81WV': {
      active: true,
      subdivision: 'US-CO',
      languages: {
        en: {
          label: 'Limited Cooperative Association',
          abbreviations: ['LCA'],
        },
      },
    },
    BC32: {
      active: true,
      subdivision: 'US-CO',
      languages: {
        en: {
          label: 'Limited Partnership Association',
          abbreviations: [],
        },
      },
    },
    HLCG: {
      active: true,
      subdivision: 'US-CO',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['company', 'limited', 'lp', 'co.', 'ltd.'],
        },
      },
    },
    I3Z9: {
      active: true,
      subdivision: 'US-CO',
      languages: {
        en: {
          label: 'For-Profit Public Benefit Corporation',
          abbreviations: [
            'Co',
            'Company',
            'Corp',
            'Corporation',
            'Inc',
            'Incorporated',
            'Limited',
            'Ltd',
          ],
        },
      },
    },
    L10T: {
      active: true,
      subdivision: 'US-CO',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [
            'limited',
            'llc',
            'limited liability co.',
            'ltd.',
            'ltd. liability co.',
            'ltd. liability company',
          ],
        },
      },
    },
    LDHG: {
      active: true,
      subdivision: 'US-CO',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    M64D: {
      active: true,
      subdivision: 'US-CO',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['Limited', 'LLP', 'RLLP', 'Ltd.'],
        },
      },
    },
    OWR6: {
      active: true,
      subdivision: 'US-CO',
      languages: {
        en: {
          label: 'For-Profit Corporation',
          abbreviations: [
            'Company',
            'Corporation',
            'Incorporated',
            'Limited',
            'Co.',
            'Corp.',
            'Inc.',
            'Ltd.',
          ],
        },
      },
    },
    PDLV: {
      active: true,
      subdivision: 'US-CO',
      languages: {
        en: {
          label: 'Non-Profit Corporation',
          abbreviations: [],
        },
      },
    },
    TOBE: {
      active: true,
      subdivision: 'US-CO',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    WE9D: {
      active: true,
      subdivision: 'US-CO',
      languages: {
        en: {
          label: 'Limited Liability Limited Partnership',
          abbreviations: [
            'Company',
            'Limited',
            'Lllp',
            'Lp',
            'RLLLP',
            'Co.',
            'LTD.',
          ],
        },
      },
    },
    ZCHO: {
      active: true,
      subdivision: 'US-CO',
      languages: {
        en: {
          label: 'Cooperative Association',
          abbreviations: [
            'ass’n',
            'assn',
            'company',
            'coop',
            'incorporated',
            'limited',
            'assoc.',
            'co.',
            'inc.',
            'ltd.',
          ],
        },
      },
    },
    '7W53': {
      active: true,
      subdivision: 'US-CT',
      languages: {
        en: {
          label: 'Nonstock Corporation',
          abbreviations: [],
        },
      },
    },
    JKOT: {
      active: true,
      subdivision: 'US-CT',
      languages: {
        en: {
          label: 'Stock Corporation',
          abbreviations: ['Co.', 'Corp.', 'Inc.'],
        },
      },
    },
    L7HH: {
      active: true,
      subdivision: 'US-CT',
      languages: {
        en: {
          label: 'Religious Society or Religious Corporation',
          abbreviations: [],
        },
      },
    },
    LIEA: {
      active: true,
      subdivision: 'US-CT',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    LKQ2: {
      active: true,
      subdivision: 'US-CT',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    SERH: {
      active: true,
      subdivision: 'US-CT',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    SHCN: {
      active: true,
      subdivision: 'US-CT',
      languages: {
        en: {
          label: 'Statutory Trust',
          abbreviations: [],
        },
      },
    },
    T5X4: {
      active: true,
      subdivision: 'US-CT',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    T80N: {
      active: true,
      subdivision: 'US-CT',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    WT0G: {
      active: true,
      subdivision: 'US-CT',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    Y182: {
      active: true,
      subdivision: 'US-CT',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [
            'LLC',
            'PLLC',
            ', Limited Liability Co.',
            'Ltd. Liability Co',
            'Ltd. Liability Company',
          ],
        },
      },
    },
    '12N6': {
      active: true,
      subdivision: 'US-DE',
      languages: {
        en: {
          label: 'Unincorporated Nonprofit Association',
          abbreviations: [],
        },
      },
    },
    '1HXP': {
      active: true,
      subdivision: 'US-DE',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    '4FSX': {
      active: true,
      subdivision: 'US-DE',
      languages: {
        en: {
          label: 'Statutory Trust',
          abbreviations: [],
        },
      },
    },
    '9ASJ': {
      active: true,
      subdivision: 'US-DE',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    HZEH: {
      active: true,
      subdivision: 'US-DE',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    JU79: {
      active: true,
      subdivision: 'US-DE',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    MIPY: {
      active: true,
      subdivision: 'US-DE',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    N7VF: {
      active: true,
      subdivision: 'US-DE',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    QF4W: {
      active: true,
      subdivision: 'US-DE',
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
    T91T: {
      active: true,
      subdivision: 'US-DE',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    TGMR: {
      active: true,
      subdivision: 'US-DE',
      languages: {
        en: {
          label: 'Limited Liability Limited Partnership',
          abbreviations: [],
        },
      },
    },
    XTIQ: {
      active: true,
      subdivision: 'US-DE',
      languages: {
        en: {
          label: 'Corporation',
          abbreviations: [],
        },
      },
    },
    '74LJ': {
      active: true,
      subdivision: 'US-DC',
      languages: {
        en: {
          label:
            'Limited Partnership (including Limited Liability Limited Partnership)',
          abbreviations: ['LLLP', 'RLLLP'],
        },
      },
    },
    '9AQ8': {
      active: true,
      subdivision: 'US-DC',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    CNQ3: {
      active: true,
      subdivision: 'US-DC',
      languages: {
        en: {
          label: 'Business Corporation (including professional corporation)',
          abbreviations: ['Chtd', 'Co.', 'Corp.', 'Inc.', 'Ltd.', 'P.C.'],
        },
      },
    },
    IPGV: {
      active: true,
      subdivision: 'US-DC',
      languages: {
        en: {
          label: 'Limited Cooperative Association',
          abbreviations: ['Assn', 'Assoc', 'Coop', 'LCA'],
        },
      },
    },
    NUQ2: {
      active: true,
      subdivision: 'US-DC',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    O35K: {
      active: true,
      subdivision: 'US-DC',
      languages: {
        en: {
          label: 'General Cooperative Association',
          abbreviations: ['Assn', 'Assoc', 'Coop'],
        },
      },
    },
    SQOE: {
      active: true,
      subdivision: 'US-DC',
      languages: {
        en: {
          label: 'Statutory Trust',
          abbreviations: [],
        },
      },
    },
    TJ6V: {
      active: true,
      subdivision: 'US-DC',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP', 'RLLP'],
        },
      },
    },
    VNIU: {
      active: true,
      subdivision: 'US-DC',
      languages: {
        en: {
          label:
            'Limited Liability Company (including professional LLC and series LLC)',
          abbreviations: ['PLLC'],
        },
      },
    },
    ZJPG: {
      active: true,
      subdivision: 'US-DC',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    '3LXM': {
      active: true,
      subdivision: 'US-FL',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    '3N55': {
      active: true,
      subdivision: 'US-FL',
      languages: {
        en: {
          label: 'Non-Profit Corporation',
          abbreviations: ['Corporation', 'Incorporated', 'Corp.', 'Inc.'],
        },
      },
    },
    '5DS0': {
      active: true,
      subdivision: 'US-FL',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['Limited', 'L.P.', 'Ltd.'],
        },
      },
    },
    '72CA': {
      active: true,
      subdivision: 'US-FL',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    '8N21': {
      active: true,
      subdivision: 'US-FL',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LLC', 'PLLC'],
        },
      },
    },
    D155: {
      active: true,
      subdivision: 'US-FL',
      languages: {
        en: {
          label: 'Limited Liability Limited Partnership',
          abbreviations: ['LLLP'],
        },
      },
    },
    E4LW: {
      active: true,
      subdivision: 'US-FL',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    QSKT: {
      active: true,
      subdivision: 'US-FL',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    TRI2: {
      active: true,
      subdivision: 'US-FL',
      languages: {
        en: {
          label: 'Profit Corporation',
          abbreviations: [
            'Chartered',
            'Co',
            'Company',
            'Corporation',
            'Incorporated',
            'Corp.',
            'Inc.',
            'P.A.',
          ],
        },
      },
    },
    '6IIM': {
      active: true,
      subdivision: 'US-GA',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LC', 'LLC'],
        },
      },
    },
    AD0H: {
      active: true,
      subdivision: 'US-GA',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    ALW3: {
      active: true,
      subdivision: 'US-GA',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    ASC7: {
      active: true,
      subdivision: 'US-GA',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: [],
        },
      },
    },
    EY94: {
      active: true,
      subdivision: 'US-GA',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    F9OB: {
      active: true,
      subdivision: 'US-GA',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    GR2X: {
      active: true,
      subdivision: 'US-GA',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    H5G0: {
      active: true,
      subdivision: 'US-GA',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    MFYJ: {
      active: true,
      subdivision: 'US-GA',
      languages: {
        en: {
          label: 'Profit Corporation',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    S7VR: {
      active: true,
      subdivision: 'US-GA',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    '6MB6': {
      active: true,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Limited Liability Limited Partnership',
          abbreviations: ['LLLP'],
        },
      },
    },
    '982Z': {
      active: false,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Service Mark',
          abbreviations: [],
        },
      },
    },
    '9G8O': {
      active: true,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    AQBO: {
      active: true,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    B38Q: {
      active: true,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    DX2N: {
      active: true,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: ['Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    FTNW: {
      active: true,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Cooperative',
          abbreviations: ['Co-op'],
        },
      },
    },
    IWRC: {
      active: true,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    L2QV: {
      active: true,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Corporation',
          abbreviations: ['Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    L5BO: {
      active: false,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Trade Name',
          abbreviations: [],
        },
      },
    },
    M2KR: {
      active: true,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Limited Liablity Partnership',
          abbreviations: ['LLP', 'RLLP'],
        },
      },
    },
    MJ9Z: {
      active: true,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    QJ1G: {
      active: true,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Industrial Bank',
          abbreviations: [],
        },
      },
    },
    S0BB: {
      active: true,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: ['Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    SBF3: {
      active: true,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Sustainable Business Corporation',
          abbreviations: ['Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    TTTV: {
      active: true,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Corporation Sole',
          abbreviations: ['Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    VPBH: {
      active: true,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LLC'],
        },
      },
    },
    WMTY: {
      active: false,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Publicity Rights Name Registration',
          abbreviations: [],
        },
      },
    },
    YOUG: {
      active: false,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Commercial Registered Agent',
          abbreviations: ['C.R.A.'],
        },
      },
    },
    ZLIW: {
      active: false,
      subdivision: 'US-HI',
      languages: {
        en: {
          label: 'Trademark',
          abbreviations: [],
        },
      },
    },
    '530K': {
      active: true,
      subdivision: 'US-ID',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    AB76: {
      active: true,
      subdivision: 'US-ID',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    EVE6: {
      active: true,
      subdivision: 'US-ID',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    H1J5: {
      active: true,
      subdivision: 'US-ID',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    JXUC: {
      active: true,
      subdivision: 'US-ID',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    QLWR: {
      active: true,
      subdivision: 'US-ID',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP', 'RLLP'],
        },
      },
    },
    RU6X: {
      active: true,
      subdivision: 'US-ID',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LC', 'LLC'],
        },
      },
    },
    U9HL: {
      active: true,
      subdivision: 'US-ID',
      languages: {
        en: {
          label: 'General Business Corporation',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    UK9P: {
      active: true,
      subdivision: 'US-ID',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    '1KU4': {
      active: true,
      subdivision: 'US-IL',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '1WZP': {
      active: true,
      subdivision: 'US-IL',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LLLP', 'LP'],
        },
      },
    },
    '22SC': {
      active: true,
      subdivision: 'US-IL',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    '8RLE': {
      active: true,
      subdivision: 'US-IL',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LLC'],
        },
      },
    },
    AZUK: {
      active: true,
      subdivision: 'US-IL',
      languages: {
        en: {
          label: 'Business Corporation',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    COKS: {
      active: true,
      subdivision: 'US-IL',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    F5VL: {
      active: true,
      subdivision: 'US-IL',
      languages: {
        en: {
          label: 'Professional Services Corporation',
          abbreviations: ['Chartered', 'Ltd.', 'P.C.', 'Prof. Corp.'],
        },
      },
    },
    HSPI: {
      active: true,
      subdivision: 'US-IL',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    QY7A: {
      active: true,
      subdivision: 'US-IL',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    VUXH: {
      active: true,
      subdivision: 'US-IL',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    YTY3: {
      active: true,
      subdivision: 'US-IL',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    '0SKB': {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '78PB': {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: ['PC', 'PSC'],
        },
      },
    },
    '8Z76': {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    '95W7': {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Financial Institution',
          abbreviations: [],
        },
      },
    },
    '9FD9': {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Master Limited Liability Company',
          abbreviations: ['Limited Liabilty Company', 'LLC'],
        },
      },
    },
    C639: {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Industrial Bank',
          abbreviations: [],
        },
      },
    },
    D92T: {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    DQBZ: {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LLC'],
        },
      },
    },
    EW9A: {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Business Trust',
          abbreviations: [],
        },
      },
    },
    EZ08: {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Agricultural Cooperative',
          abbreviations: [
            'Company',
            'Corp',
            'Corporation',
            'Incorporated',
            'Limited',
            'Co.',
            'Inc.',
            'Ltd.',
          ],
        },
      },
    },
    G4YY: {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    M1FY: {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    N0YQ: {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Insurance Corporation',
          abbreviations: [],
        },
      },
    },
    P91Q: {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    QR5I: {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    R0BI: {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'For-Profit Corporation',
          abbreviations: [
            'Company',
            'Corp',
            'Corporation',
            'Incorporated',
            'Limited',
            'Co.',
            'Inc.',
            'Ltd.',
          ],
        },
      },
    },
    V5G5: {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Professional Benefit Corporation',
          abbreviations: ['PC', 'Professional Corporation', 'PSC'],
        },
      },
    },
    V89I: {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [
            'Company',
            'Corp',
            'Corporation',
            'Incorporated',
            'Limited',
            'Co.',
            'Inc.',
            'Ltd.',
          ],
        },
      },
    },
    VCQZ: {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Series',
          abbreviations: ['LLC'],
        },
      },
    },
    X4EB: {
      active: true,
      subdivision: 'US-IN',
      languages: {
        en: {
          label: 'Benefit Corporation',
          abbreviations: [
            'Company',
            'Corp',
            'Corporation',
            'Incorporated',
            'Limited',
            'Inc. Co.',
            'Ltd.',
          ],
        },
      },
    },
    '32AX': {
      active: true,
      subdivision: 'US-IA',
      languages: {
        en: {
          label: 'Cooperative Association',
          abbreviations: [],
        },
      },
    },
    '7XPF': {
      active: true,
      subdivision: 'US-IA',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LC', 'LLC'],
        },
      },
    },
    '8VLM': {
      active: true,
      subdivision: 'US-IA',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    DU35: {
      active: true,
      subdivision: 'US-IA',
      languages: {
        en: {
          label: 'Profit Corporation',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    GDH0: {
      active: true,
      subdivision: 'US-IA',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    HPKC: {
      active: true,
      subdivision: 'US-IA',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    HUSW: {
      active: true,
      subdivision: 'US-IA',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    L22N: {
      active: true,
      subdivision: 'US-IA',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: [],
        },
      },
    },
    T7D4: {
      active: true,
      subdivision: 'US-IA',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    UGKR: {
      active: true,
      subdivision: 'US-IA',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    VVPD: {
      active: true,
      subdivision: 'US-IA',
      languages: {
        en: {
          label: 'Professional Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    VWY9: {
      active: true,
      subdivision: 'US-IA',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    '0WOU': {
      active: true,
      subdivision: 'US-KS',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '35QN': {
      active: true,
      subdivision: 'US-KS',
      languages: {
        en: {
          label: 'Public Benefit Corporation',
          abbreviations: ['PBC'],
        },
      },
    },
    '7U8S': {
      active: true,
      subdivision: 'US-KS',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    AREY: {
      active: true,
      subdivision: 'US-KS',
      languages: {
        en: {
          label: 'Sole Proprietorship',
          abbreviations: [],
        },
      },
    },
    CANT: {
      active: true,
      subdivision: 'US-KS',
      languages: {
        en: {
          label: 'Professional Association',
          abbreviations: ['PA'],
        },
      },
    },
    F9I4: {
      active: true,
      subdivision: 'US-KS',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    FBN0: {
      active: true,
      subdivision: 'US-KS',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LC', 'L.L.C.'],
        },
      },
    },
    FEC4: {
      active: true,
      subdivision: 'US-KS',
      languages: {
        en: {
          label: 'Not-For-Profit Corporation',
          abbreviations: [],
        },
      },
    },
    FGT5: {
      active: true,
      subdivision: 'US-KS',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    GCU5: {
      active: true,
      subdivision: 'US-KS',
      languages: {
        en: {
          label: 'Corporation',
          abbreviations: ['Co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    JIF7: {
      active: true,
      subdivision: 'US-KS',
      languages: {
        en: {
          label: 'Statutory Public Benefit Limited Liability Company',
          abbreviations: ['SPBLLC'],
        },
      },
    },
    VBVM: {
      active: true,
      subdivision: 'US-KS',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    WC8Q: {
      active: true,
      subdivision: 'US-KS',
      languages: {
        en: {
          label: 'Business Trust',
          abbreviations: [],
        },
      },
    },
    X4TB: {
      active: true,
      subdivision: 'US-KS',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    XQEC: {
      active: true,
      subdivision: 'US-KS',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    '3MMY': {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Limited Liability Limited Partership',
          abbreviations: ['LLLP'],
        },
      },
    },
    '5RRE': {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Corporation (professional)',
          abbreviations: ['PSC'],
        },
      },
    },
    '6GEC': {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Limited Liability Company (professional)',
          abbreviations: ['PLLC', 'PROFESSONAL LIMITED LIABILITY COMPANY'],
        },
      },
    },
    '85YQ': {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Statutory Trust',
          abbreviations: ['limited', 'LTD'],
        },
      },
    },
    A9VQ: {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Limited Cooperative Assocation',
          abbreviations: ['LCA', 'LIMITED COOPERATIVE', 'LTD CO-OP'],
        },
      },
    },
    DAVB: {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Corporation (non-profit)',
          abbreviations: [
            'CO',
            'COMPANY',
            'CORP',
            'CORPORATION',
            'INC',
            'LIMITED',
            'LTD',
          ],
        },
      },
    },
    EBP8: {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    F2QV: {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Limited Liability Company (profit)',
          abbreviations: ['LIMITED LIABILITY COMPANY', 'LLC', 'LTD. CO'],
        },
      },
    },
    HH12: {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    LU9O: {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Unincorporated Non-Profit Assocation',
          abbreviations: ['Limited', 'Ltd.'],
        },
      },
    },
    MBKN: {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    MY61: {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Limited Liability Company (non-profit)',
          abbreviations: ['LIMITED LIABILITY COMPANY', 'LLC', 'LTD. CO'],
        },
      },
    },
    NJ57: {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    O5PH: {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Public Benefit Corporation (profit)',
          abbreviations: [
            'Benefit Corporation',
            'PBC',
            'Public Benefit Corporation',
          ],
        },
      },
    },
    OFGO: {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Business Trust',
          abbreviations: ['limited', 'LTD'],
        },
      },
    },
    QWPR: {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Corporation (profit)',
          abbreviations: [
            'CO',
            'COMPANY',
            'CORPORATION',
            'INC',
            'LIMITED CORP',
            'LTD',
          ],
        },
      },
    },
    SJQO: {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    T362: {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    VE28: {
      active: true,
      subdivision: 'US-KY',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP', 'LTD'],
        },
      },
    },
    '1V0I': {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Domestic Benefit Corporation',
          abbreviations: ['A Benefit Corporation'],
        },
      },
    },
    '6DVA': {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Foreign Non-Profit Limited Liability Company',
          abbreviations: ['limited liability company', 'L.C.', 'L.L.C.'],
        },
      },
    },
    '6EDK': {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Domestic Non-Profit Corporation',
          abbreviations: [],
        },
      },
    },
    '6R7O': {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    '6UYJ': {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '8PUO': {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Foreign Partnership',
          abbreviations: [],
        },
      },
    },
    '9L6B': {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Foreign Limited Liability Company',
          abbreviations: ['limited liability company', 'L.C.', 'L.L.C.'],
        },
      },
    },
    C1F4: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Domestic Public Benefit Corporation',
          abbreviations: [],
        },
      },
    },
    CD9O: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Domestic Limited Liability Company',
          abbreviations: ['limited liability company', 'L.C.', 'L.L.C.'],
        },
      },
    },
    EO9A: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Foreign Real Estate Investment Trust',
          abbreviations: [],
        },
      },
    },
    HQYG: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Foreign Corporation',
          abbreviations: [
            'company',
            'corporation',
            'incorporated',
            'limited',
            'co.',
            'corp.',
            'inc.',
            'ltd.',
          ],
        },
      },
    },
    LTKC: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Home Service Contract Provider',
          abbreviations: [
            'company',
            'corporation',
            'incorporated',
            'limited',
            'limited liability company',
            'co.',
            'corp.',
            'inc.',
            'L.C.',
            'L.L.C.',
            'ltd.',
          ],
        },
      },
    },
    MQU4: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Domestic Unincorporated Association',
          abbreviations: [],
        },
      },
    },
    N71W: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Cable & Video Franchise',
          abbreviations: [],
        },
      },
    },
    NI44: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Domestic Corporation',
          abbreviations: [
            'company',
            'corporation',
            'incorporated',
            'limited',
            'co.',
            'corp.',
            'inc.',
            'ltd.',
          ],
        },
      },
    },
    NV9X: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Domestic Real Estate Investment Trust',
          abbreviations: [],
        },
      },
    },
    O6QP: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Domestic Partnership',
          abbreviations: [],
        },
      },
    },
    ONJ1: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Domestic Low-Profit Limited Liability Company',
          abbreviations: ['L3C', 'low-profit limited liability company'],
        },
      },
    },
    Q8RV: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Foreign Benefit Corporation',
          abbreviations: ['A Benefit Corporation'],
        },
      },
    },
    SJKV: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Foreign Non-Profit Corporation',
          abbreviations: [],
        },
      },
    },
    TDBW: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Domestic Registered Limited Liability Partnership',
          abbreviations: ['registered limited liability partnership', 'L.L.P.'],
        },
      },
    },
    TZDZ: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    WP6R: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Co-op',
          abbreviations: ['co.'],
        },
      },
    },
    XFUO: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    Z016: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Collection Agency',
          abbreviations: [],
        },
      },
    },
    ZQZW: {
      active: true,
      subdivision: 'US-LA',
      languages: {
        en: {
          label: 'Foreign Public Benefit',
          abbreviations: [],
        },
      },
    },
    '2XXG': {
      active: true,
      subdivision: 'US-ME',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    '53DC': {
      active: true,
      subdivision: 'US-ME',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    '5KRB': {
      active: true,
      subdivision: 'US-ME',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    AT9F: {
      active: true,
      subdivision: 'US-ME',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    H99T: {
      active: true,
      subdivision: 'US-ME',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    IIZ4: {
      active: true,
      subdivision: 'US-ME',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    JR3Z: {
      active: true,
      subdivision: 'US-ME',
      languages: {
        en: {
          label: 'Cooperative',
          abbreviations: [],
        },
      },
    },
    M9A1: {
      active: true,
      subdivision: 'US-ME',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    P1VP: {
      active: true,
      subdivision: 'US-ME',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    TTB3: {
      active: true,
      subdivision: 'US-ME',
      languages: {
        en: {
          label: 'Business Corporation',
          abbreviations: [],
        },
      },
    },
    AZH4: {
      active: true,
      subdivision: 'US-MD',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    BSLM: {
      active: true,
      subdivision: 'US-MD',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    EW8U: {
      active: true,
      subdivision: 'US-MD',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    GMFE: {
      active: true,
      subdivision: 'US-MD',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    HLR4: {
      active: true,
      subdivision: 'US-MD',
      languages: {
        en: {
          label: 'Stock Corporation',
          abbreviations: ['Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    J5NM: {
      active: true,
      subdivision: 'US-MD',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    JJ9M: {
      active: true,
      subdivision: 'US-MD',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['L.L.C., LLC , L.C., L C'],
        },
      },
    },
    LKD5: {
      active: true,
      subdivision: 'US-MD',
      languages: {
        en: {
          label: 'Close Corporation',
          abbreviations: ['Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    OCVJ: {
      active: true,
      subdivision: 'US-MD',
      languages: {
        en: {
          label: 'Religious Corporation',
          abbreviations: [],
        },
      },
    },
    R2PI: {
      active: true,
      subdivision: 'US-MD',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    XHT1: {
      active: true,
      subdivision: 'US-MD',
      languages: {
        en: {
          label: 'Sole Proprietorship',
          abbreviations: [],
        },
      },
    },
    ZVS9: {
      active: true,
      subdivision: 'US-MD',
      languages: {
        en: {
          label: 'Nonstock Corporation',
          abbreviations: [],
        },
      },
    },
    '1XME': {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Housing Cooperative Corporation',
          abbreviations: [
            'Company',
            'Corporation',
            'Incorporated',
            'Corp.',
            'Inc.',
          ],
        },
      },
    },
    '22EO': {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '672E': {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Cooperative Corporation',
          abbreviations: [
            'Company',
            'Corporation',
            'Incorporated',
            'Corp.',
            'Inc.',
          ],
        },
      },
    },
    '6I75': {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: [
            'company',
            'corporation',
            'incorporated',
            'co.',
            'corp.',
            'limited or ltd.',
            'or inc.',
          ],
        },
      },
    },
    '7G8G': {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Cooperative Bank',
          abbreviations: [],
        },
      },
    },
    BE3O: {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    BYFU: {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LC', 'Limited Company', 'LLC'],
        },
      },
    },
    CAGH: {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    G76T: {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    GOGQ: {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    KU3O: {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    NETO: {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Employee Cooperative Corporation',
          abbreviations: [
            'Company',
            'Corporation',
            'Incorporated',
            'Corp.',
            'Inc.',
          ],
        },
      },
    },
    QX9N: {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label:
            'Domestic Benefit Corporation (including professional corporations)',
          abbreviations: [
            'Company',
            'Corporation',
            'Incorporated',
            'Co.',
            'Corp.',
            'Inc. Limited',
          ],
        },
      },
    },
    R7QO: {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Non-Profit Corporation',
          abbreviations: [
            'Company',
            'Corporation',
            'Incorporated',
            'Corp.',
            'Inc.',
          ],
        },
      },
    },
    YP04: {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    Z73Z: {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Voluntary Association and Business Trusts',
          abbreviations: [],
        },
      },
    },
    ZJTK: {
      active: true,
      subdivision: 'US-MA',
      languages: {
        en: {
          label: 'Domestic Business  Corporation',
          abbreviations: [
            'Company',
            'Corporation',
            'Incorporated',
            'Co.',
            'Corp.',
            'Inc. Limited',
            'Ltd.',
          ],
        },
      },
    },
    '47LQ': {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'Corporation (Nonprofit)',
          abbreviations: [],
        },
      },
    },
    '58N0': {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    '6E4G': {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    '6RZK': {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    '88XU': {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'Sole proprietorship',
          abbreviations: [],
        },
      },
    },
    HQJV: {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: ['PC'],
        },
      },
    },
    IN4H: {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'Professional Limited Liability Company',
          abbreviations: ['PLLC'],
        },
      },
    },
    LJH5: {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LC', 'LLC'],
        },
      },
    },
    MI0H: {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'For profit and not-for profit co-operatives',
          abbreviations: ['Cooperative', 'coop.', 'or co-op'],
        },
      },
    },
    NK3V: {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    NR96: {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'L3C',
          abbreviations: [],
        },
      },
    },
    TPO4: {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    U7HC: {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'Corporation (For-Profit)',
          abbreviations: [
            'Co',
            'Company',
            'Corp',
            'Corporation',
            'Inc',
            'Incorporated',
            'Limited',
            'Ltd',
          ],
        },
      },
    },
    UJZB: {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'Ecclesiastical Corporation',
          abbreviations: [],
        },
      },
    },
    XTOF: {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'Railroad',
          abbreviations: [],
        },
      },
    },
    Y8GA: {
      active: true,
      subdivision: 'US-MI',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '1ASH': {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Religious corporations',
          abbreviations: [],
        },
      },
    },
    '1ONH': {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Public Benefit Corporations',
          abbreviations: [],
        },
      },
    },
    '37F5': {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Professional Firms',
          abbreviations: [],
        },
      },
    },
    '43LY': {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    '4P36': {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '6VCW': {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    '6ZAR': {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    '8OK2': {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Business Trusts',
          abbreviations: [],
        },
      },
    },
    '9HKD': {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Financial Corporations',
          abbreviations: [],
        },
      },
    },
    '9I4Y': {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Non-Profit Corporation',
          abbreviations: [],
        },
      },
    },
    BQRL: {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    DEMP: {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    IYZI: {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Limited Liability Limited Partnership',
          abbreviations: [],
        },
      },
    },
    LDBS: {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Cooperative (Producer)',
          abbreviations: [],
        },
      },
    },
    OXAZ: {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Insurance Corporations',
          abbreviations: [],
        },
      },
    },
    S2K8: {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Business Corporation',
          abbreviations: [],
        },
      },
    },
    S968: {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Industrial Bank',
          abbreviations: [],
        },
      },
    },
    SGT8: {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    T4OL: {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Cemetery associations',
          abbreviations: [],
        },
      },
    },
    TBN1: {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Non-Profit Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    TS1K: {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    UJ49: {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Cooperative (Investor)',
          abbreviations: [],
        },
      },
    },
    VSDJ: {
      active: true,
      subdivision: 'US-MN',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    '7WQO': {
      active: true,
      subdivision: 'US-MS',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    '8YBQ': {
      active: true,
      subdivision: 'US-MS',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    AHK4: {
      active: true,
      subdivision: 'US-MS',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    BG8P: {
      active: true,
      subdivision: 'US-MS',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    HDOD: {
      active: true,
      subdivision: 'US-MS',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    NDBR: {
      active: true,
      subdivision: 'US-MS',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    O4NK: {
      active: true,
      subdivision: 'US-MS',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    U7GR: {
      active: true,
      subdivision: 'US-MS',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP', 'RLLP'],
        },
      },
    },
    WPCN: {
      active: true,
      subdivision: 'US-MS',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LLC'],
        },
      },
    },
    XST3: {
      active: true,
      subdivision: 'US-MS',
      languages: {
        en: {
          label: 'Business Corporation',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    '1ADA': {
      active: true,
      subdivision: 'US-MO',
      languages: {
        en: {
          label: 'Family Trust Company',
          abbreviations: [],
        },
      },
    },
    '21OE': {
      active: true,
      subdivision: 'US-MO',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    '7F5B': {
      active: true,
      subdivision: 'US-MO',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LC', 'LLC'],
        },
      },
    },
    '9BH2': {
      active: true,
      subdivision: 'US-MO',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    EMLK: {
      active: true,
      subdivision: 'US-MO',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    J1JO: {
      active: true,
      subdivision: 'US-MO',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    KC7Z: {
      active: true,
      subdivision: 'US-MO',
      languages: {
        en: {
          label: 'For-Profit Corporation',
          abbreviations: [],
        },
      },
    },
    QSHG: {
      active: true,
      subdivision: 'US-MO',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    R8SH: {
      active: true,
      subdivision: 'US-MO',
      languages: {
        en: {
          label: 'Not For Profit Corporation',
          abbreviations: [],
        },
      },
    },
    SU5T: {
      active: true,
      subdivision: 'US-MO',
      languages: {
        en: {
          label: 'Cooperative Association',
          abbreviations: ['C.A.', 'Co-op'],
        },
      },
    },
    U7OR: {
      active: true,
      subdivision: 'US-MO',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    UJKE: {
      active: true,
      subdivision: 'US-MO',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '1S9L': {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Professional Series Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    '1XOG': {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Agricultural Marketing Association',
          abbreviations: [],
        },
      },
    },
    '30PQ': {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Limited Liability Limited Partnership',
          abbreviations: [],
        },
      },
    },
    '30TX': {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Trust Company',
          abbreviations: [],
        },
      },
    },
    '40SO': {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Mutual Benefit Corporation',
          abbreviations: [],
        },
      },
    },
    '5AE9': {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Builidng and Loan Association',
          abbreviations: [],
        },
      },
    },
    '5MRP': {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Close Corporation',
          abbreviations: [],
        },
      },
    },
    '7OS8': {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Congressional Chartered Corporation',
          abbreviations: [],
        },
      },
    },
    '93CA': {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Agricultural Association',
          abbreviations: [],
        },
      },
    },
    '9OSW': {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    '9STD': {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Corporation',
          abbreviations: [],
        },
      },
    },
    A770: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: [],
        },
      },
    },
    AEK0: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    B2F4: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Cooperative Association',
          abbreviations: [],
        },
      },
    },
    HEMZ: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Credit Union',
          abbreviations: [],
        },
      },
    },
    JGPP: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Rural Cooperative Association',
          abbreviations: [],
        },
      },
    },
    KPH8: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Investment Company',
          abbreviations: [],
        },
      },
    },
    L1PM: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Professional Limited Liability Limited Partnership',
          abbreviations: [],
        },
      },
    },
    LPLY: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    LXI4: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    MY93: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Professional Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    OOX5: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Benefit Corporation',
          abbreviations: [],
        },
      },
    },
    PNF3: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Corporate Credit Union',
          abbreviations: [],
        },
      },
    },
    Q6K2: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    QB0A: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Business Trust',
          abbreviations: [],
        },
      },
    },
    SCX8: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Public Benefit Corporation',
          abbreviations: [],
        },
      },
    },
    SW88: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    T91C: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Professional Close Corporation',
          abbreviations: [],
        },
      },
    },
    WRF9: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Religious Corporation',
          abbreviations: [],
        },
      },
    },
    XVC6: {
      active: true,
      subdivision: 'US-MT',
      languages: {
        en: {
          label: 'Series Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    '3GTV': {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Sanitary & Improvement District',
          abbreviations: [],
        },
      },
    },
    '4TMV': {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Domestic Limited Cooperative Association',
          abbreviations: [],
        },
      },
    },
    '4WTP': {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    '5OET': {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Foreign Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    '639V': {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Non Profit Domesticated Foreign Corporation',
          abbreviations: [],
        },
      },
    },
    '6ICB': {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Foreign Corp Professional Corporation',
          abbreviations: [],
        },
      },
    },
    '7BQ5': {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Non Stock Corporation',
          abbreviations: [],
        },
      },
    },
    '8APW': {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Domestic Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    '8HNT': {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Foreign Corporation',
          abbreviations: [],
        },
      },
    },
    B843: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Domestic Professional Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    BJ2V: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Foreign Professional Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    CXIO: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Domesticated Foreign Corporation Professional Corporation',
          abbreviations: [],
        },
      },
    },
    D2MO: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Joint Public Agency',
          abbreviations: [],
        },
      },
    },
    DFPP: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Domestic Limited Partnership',
          abbreviations: [],
        },
      },
    },
    ECLT: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Domestic Corporation Professional Corporation',
          abbreviations: [],
        },
      },
    },
    GEXT: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    HV3B: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Non Taxable Corporation',
          abbreviations: [],
        },
      },
    },
    IOWN: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Non Profit Foreign Limited Cooperative Association',
          abbreviations: [],
        },
      },
    },
    KFPS: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Domestic General Partnership',
          abbreviations: [],
        },
      },
    },
    LQZC: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Nebraska Benefit Corporation',
          abbreviations: [],
        },
      },
    },
    MPFG: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Foreign Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    NGZJ: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Domesticated Foreign Corporation',
          abbreviations: [],
        },
      },
    },
    O256: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Non Profit Foreign Corporation',
          abbreviations: [],
        },
      },
    },
    Q17J: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    R22H: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Registered Agent Designation',
          abbreviations: [],
        },
      },
    },
    R3J6: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Foreign General Apartnership',
          abbreviations: [],
        },
      },
    },
    R7JP: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Non Profit (Dom) Corporation',
          abbreviations: [],
        },
      },
    },
    RH6N: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Domestic Corporation',
          abbreviations: [],
        },
      },
    },
    T172: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Insurance Company',
          abbreviations: [],
        },
      },
    },
    V4RX: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Non Profit Dom Limited Cooperative Association',
          abbreviations: [],
        },
      },
    },
    VYEO: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Fraternal Society',
          abbreviations: [],
        },
      },
    },
    XBKP: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Agricultural Association',
          abbreviations: [],
        },
      },
    },
    XUVE: {
      active: false,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Bank',
          abbreviations: [],
        },
      },
    },
    Y7BG: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Hospital Authority',
          abbreviations: [],
        },
      },
    },
    YQDQ: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Domestic Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    YWK0: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Foreign Limited Partnership',
          abbreviations: [],
        },
      },
    },
    ZDW0: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    ZEZ2: {
      active: true,
      subdivision: 'US-NE',
      languages: {
        en: {
          label: 'Foreign Limited Cooperative Association',
          abbreviations: [],
        },
      },
    },
    '62L3': {
      active: true,
      subdivision: 'US-NV',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    '7K6U': {
      active: true,
      subdivision: 'US-NV',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    '8WM4': {
      active: true,
      subdivision: 'US-NV',
      languages: {
        en: {
          label: 'Profit Corporation',
          abbreviations: ['Co.', 'Corp.', 'Inc.', 'Ltd.'],
        },
      },
    },
    '92OB': {
      active: true,
      subdivision: 'US-NV',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    HCTP: {
      active: true,
      subdivision: 'US-NV',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    IY8C: {
      active: true,
      subdivision: 'US-NV',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    K3J6: {
      active: true,
      subdivision: 'US-NV',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    MM8M: {
      active: true,
      subdivision: 'US-NV',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LC', 'LLC'],
        },
      },
    },
    SUEQ: {
      active: true,
      subdivision: 'US-NV',
      languages: {
        en: {
          label: 'Business Trust',
          abbreviations: ['BT'],
        },
      },
    },
    Y9F2: {
      active: true,
      subdivision: 'US-NV',
      languages: {
        en: {
          label: 'Industrial Bank',
          abbreviations: [],
        },
      },
    },
    '2JB4': {
      active: true,
      subdivision: 'US-NH',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    '3LNE': {
      active: true,
      subdivision: 'US-NH',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    '520I': {
      active: true,
      subdivision: 'US-NH',
      languages: {
        en: {
          label: 'Foundation',
          abbreviations: [],
        },
      },
    },
    '6M6O': {
      active: true,
      subdivision: 'US-NH',
      languages: {
        en: {
          label: 'Business Corporation',
          abbreviations: [],
        },
      },
    },
    '9M2Q': {
      active: true,
      subdivision: 'US-NH',
      languages: {
        en: {
          label: 'Benefit Corporation',
          abbreviations: [],
        },
      },
    },
    G66U: {
      active: true,
      subdivision: 'US-NH',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    OI5N: {
      active: true,
      subdivision: 'US-NH',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    OJ9K: {
      active: true,
      subdivision: 'US-NH',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    P3LZ: {
      active: true,
      subdivision: 'US-NH',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    RCNI: {
      active: true,
      subdivision: 'US-NH',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    S97G: {
      active: true,
      subdivision: 'US-NH',
      languages: {
        en: {
          label: 'Investment Trust',
          abbreviations: [],
        },
      },
    },
    W1DV: {
      active: true,
      subdivision: 'US-NH',
      languages: {
        en: {
          label: 'Cooperative Bank',
          abbreviations: [],
        },
      },
    },
    '7HY7': {
      active: true,
      subdivision: 'US-NJ',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    FFBM: {
      active: true,
      subdivision: 'US-NJ',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    G42I: {
      active: true,
      subdivision: 'US-NJ',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    L2SY: {
      active: true,
      subdivision: 'US-NJ',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    N508: {
      active: true,
      subdivision: 'US-NJ',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    P7RH: {
      active: true,
      subdivision: 'US-NJ',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LLC'],
        },
      },
    },
    T4M6: {
      active: true,
      subdivision: 'US-NJ',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: ['corp.', 'inc.'],
        },
      },
    },
    VWC5: {
      active: true,
      subdivision: 'US-NJ',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    XSNP: {
      active: true,
      subdivision: 'US-NJ',
      languages: {
        en: {
          label: 'Business Corporation',
          abbreviations: [],
        },
      },
    },
    '4YOA': {
      active: true,
      subdivision: 'US-NM',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    '7GMS': {
      active: true,
      subdivision: 'US-NM',
      languages: {
        en: {
          label: 'Cooperative Association',
          abbreviations: [],
        },
      },
    },
    F69V: {
      active: true,
      subdivision: 'US-NM',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    POG3: {
      active: true,
      subdivision: 'US-NM',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    VG3S: {
      active: true,
      subdivision: 'US-NM',
      languages: {
        en: {
          label: 'Profit Corporation',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    W0U4: {
      active: true,
      subdivision: 'US-NM',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    W0XQ: {
      active: true,
      subdivision: 'US-NM',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    Y1ZD: {
      active: true,
      subdivision: 'US-NM',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    '4VH5': {
      active: true,
      subdivision: 'US-NY',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    '51RC': {
      active: true,
      subdivision: 'US-NY',
      languages: {
        en: {
          label: 'Not-for-profit Corporation',
          abbreviations: [],
        },
      },
    },
    BO6L: {
      active: true,
      subdivision: 'US-NY',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    D6JI: {
      active: true,
      subdivision: 'US-NY',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    EPCY: {
      active: true,
      subdivision: 'US-NY',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    M0ER: {
      active: true,
      subdivision: 'US-NY',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    PJ10: {
      active: true,
      subdivision: 'US-NY',
      languages: {
        en: {
          label: 'Business Corporation',
          abbreviations: [],
        },
      },
    },
    SDX0: {
      active: true,
      subdivision: 'US-NY',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    XIZI: {
      active: true,
      subdivision: 'US-NY',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    YVSB: {
      active: true,
      subdivision: 'US-NY',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    '1QMT': {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Business Corporation',
          abbreviations: [
            'company',
            'corporation',
            'Incorporated',
            'limited',
            'co.',
            'corp.',
            'inc.',
            'ltd.',
          ],
        },
      },
    },
    '358I': {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [
            'company',
            'corporation',
            'Incorporated',
            'limited',
            'co.',
            'corp.',
            'inc.',
            'ltd.',
          ],
        },
      },
    },
    '3DXJ': {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Professional Limited Liability Company',
          abbreviations: ['PLLC'],
        },
      },
    },
    '4LKE': {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'County Agricultural Fair',
          abbreviations: [
            'company',
            'corporation',
            'Incorporated',
            'limited',
            'co.',
            'corp.',
            'inc.',
            'ltd.',
          ],
        },
      },
    },
    '5AAO': {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    '5JAL': {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Insurance Company',
          abbreviations: [
            'company',
            'corporation',
            'Incorporated',
            'limited',
            'co.',
            'corp.',
            'inc.',
            'ltd.',
          ],
        },
      },
    },
    '6NI8': {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Railroad',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    '8E0H': {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '8N0C': {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    '8QMN': {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: [
            'company',
            'corporation',
            'Incorporated',
            'limited',
            'PC',
            'co.',
            'corp.',
            'inc.',
            'ltd.',
          ],
        },
      },
    },
    ARON: {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Limited partnership',
          abbreviations: ['LP', 'Ltd. Partnership'],
        },
      },
    },
    CJ58: {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Cooperative Association',
          abbreviations: [
            'company',
            'cooperative',
            'corporation',
            'Incorporated',
            'limited',
            'co.',
            'coop.',
            'corp.',
            'inc.',
            'ltd.',
          ],
        },
      },
    },
    F99D: {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Electric Membership Cooperative',
          abbreviations: [
            'company',
            'corporation',
            'emc',
            'Incorporated',
            'limited',
            'co.',
            'corp.',
            'inc.',
            'ltd.',
          ],
        },
      },
    },
    IHLF: {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Savings & Loan Association',
          abbreviations: [
            'company',
            'corporation',
            'limited',
            'S&L',
            'co.',
            'corp.',
            'inc.',
            'ltd. Incorporated',
          ],
        },
      },
    },
    JF6D: {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Nonprofit Community Trust',
          abbreviations: [
            'company',
            'corporation',
            'limited',
            'co.',
            'corp.',
            'inc.',
            'ltd. Incorporated',
          ],
        },
      },
    },
    Q4F9: {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Mutual Association',
          abbreviations: [
            'company',
            'corporation',
            'limited',
            'co.',
            'corp.',
            'inc.',
          ],
        },
      },
    },
    Q6EM: {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'L3C',
          abbreviations: [],
        },
      },
    },
    SIST: {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Public Transportation Authority',
          abbreviations: [
            'company',
            'corporation',
            'limited',
            'co.',
            'corp.',
            'inc.',
            'ltd. Incorporated',
          ],
        },
      },
    },
    U94O: {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Captive Insurance Company',
          abbreviations: [
            'company',
            'corporation',
            'limited',
            'co.',
            'corp.',
            'inc.',
            'ltd. Incorporated',
          ],
        },
      },
    },
    UFIY: {
      active: false,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Bank',
          abbreviations: [],
        },
      },
    },
    UKX4: {
      active: false,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'State Savings Bank',
          abbreviations: [
            'company',
            'corporation',
            'limited',
            'SSB',
            'co.',
            'corp.',
            'inc.',
          ],
        },
      },
    },
    UVH6: {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    WY1B: {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Municipal',
          abbreviations: ['company', 'limited', 'co.', 'corp.', 'inc.'],
        },
      },
    },
    X0MP: {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Limited liability partnership',
          abbreviations: ['Liability partnership', 'LLP', 'ltd', 'rllp'],
        },
      },
    },
    X1EL: {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['liability company', 'LLC', 'ltd'],
        },
      },
    },
    Y5L0: {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Mutual Burial Association',
          abbreviations: [
            'company',
            'corporation',
            'Incorporated',
            'limited',
            'co.',
            'corp.',
            'inc.',
            'ltd.',
          ],
        },
      },
    },
    YJZ3: {
      active: true,
      subdivision: 'US-NC',
      languages: {
        en: {
          label: 'Registered Limited Liability Limited Partnership',
          abbreviations: [
            'LLLP',
            'Partnership',
            'RLLLP',
            'Liability Ltd.',
            'Registered Ltd.',
          ],
        },
      },
    },
    '2WJZ': {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Cooperative Association',
          abbreviations: ['coop', 'assn.', 'assoc.'],
        },
      },
    },
    '4U9V': {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Professional Limited Liabity Partnership',
          abbreviations: ['LLP', 'PLLP'],
        },
      },
    },
    '64HG': {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Professional Limited Liability Company',
          abbreviations: ['LLC', 'PLLC'],
        },
      },
    },
    '6JCE': {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: ['GP'],
        },
      },
    },
    AZYL: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    CPK1: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Mutual Aid Cooperative',
          abbreviations: ['coop'],
        },
      },
    },
    DLEW: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Nonprofit Limited Liability Company',
          abbreviations: ['LLC'],
        },
      },
    },
    EO24: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Cooperative Grazing Associations',
          abbreviations: ['coop'],
        },
      },
    },
    ER7C: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Publicly Traded Corporation',
          abbreviations: ['corp', 'inc.'],
        },
      },
    },
    FK53: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Farm/Ranch Limited Liability Company',
          abbreviations: ['LLC'],
        },
      },
    },
    GHB2: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: '(Business) Limited Liability Company',
          abbreviations: ['LLC'],
        },
      },
    },
    J1V0: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    KO5T: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    LF4E: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Farm/Ranch Corporation',
          abbreviations: ['corp', 'inc.'],
        },
      },
    },
    MTDW: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Limited Liability Limited Partnership',
          abbreviations: ['LLLP'],
        },
      },
    },
    NHGN: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    NJA5: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Real Estate Investment Trusts',
          abbreviations: ['REIT'],
        },
      },
    },
    OGHV: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: ['PC', 'corp.', 'inc.'],
        },
      },
    },
    OVCL: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    S745: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: '(Business) Corporation',
          abbreviations: ['BC', 'corp.', 'inc.'],
        },
      },
    },
    U87X: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: ['corp.', 'inc.'],
        },
      },
    },
    WIU6: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Community Development Corporation',
          abbreviations: ['CDC', 'corp', 'inc.'],
        },
      },
    },
    YOB3: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Electric Cooperative Corporations',
          abbreviations: ['coop'],
        },
      },
    },
    ZULC: {
      active: true,
      subdivision: 'US-ND',
      languages: {
        en: {
          label: 'Development Corporation',
          abbreviations: ['corp', 'inc.'],
        },
      },
    },
    '2EPF': {
      active: true,
      subdivision: 'US-OH',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    '2R1N': {
      active: true,
      subdivision: 'US-OH',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    '52U0': {
      active: true,
      subdivision: 'US-OH',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['RLLP', 'L.L.P.', 'P.L.L.'],
        },
      },
    },
    '7VK5': {
      active: true,
      subdivision: 'US-OH',
      languages: {
        en: {
          label: 'Corporation (Nonprofit)',
          abbreviations: [],
        },
      },
    },
    '95OK': {
      active: true,
      subdivision: 'US-OH',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    AEJF: {
      active: true,
      subdivision: 'US-OH',
      languages: {
        en: {
          label: 'Professional Association',
          abbreviations: [
            'corporation',
            'incorporated',
            'company, co.',
            'corp.',
            'inc.',
          ],
        },
      },
    },
    BTQ1: {
      active: true,
      subdivision: 'US-OH',
      languages: {
        en: {
          label: 'Corporation (For-Profit)',
          abbreviations: [
            'corporation',
            'incorporated',
            'company, co.',
            'corp.',
            'inc.',
          ],
        },
      },
    },
    EZNQ: {
      active: true,
      subdivision: 'US-OH',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['limited', 'LLC', 'ltd'],
        },
      },
    },
    FZMT: {
      active: true,
      subdivision: 'US-OH',
      languages: {
        en: {
          label: 'Cooperative',
          abbreviations: ['assn', 'co', 'company', 'co-op', 'corp.', 'inc.'],
        },
      },
    },
    GXLH: {
      active: true,
      subdivision: 'US-OH',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    JBQI: {
      active: true,
      subdivision: 'US-OH',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    N566: {
      active: true,
      subdivision: 'US-OH',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    ZD39: {
      active: true,
      subdivision: 'US-OH',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['Limited', 'L.P.', 'Ltd.'],
        },
      },
    },
    '30D6': {
      active: true,
      subdivision: 'US-OK',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    B8XC: {
      active: true,
      subdivision: 'US-OK',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LC', 'LLC'],
        },
      },
    },
    BGH4: {
      active: true,
      subdivision: 'US-OK',
      languages: {
        en: {
          label: 'Profit Corporation',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    CD96: {
      active: true,
      subdivision: 'US-OK',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    EDOR: {
      active: true,
      subdivision: 'US-OK',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    GIPE: {
      active: true,
      subdivision: 'US-OK',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    OJDX: {
      active: true,
      subdivision: 'US-OK',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['RLLP, LLP, R.L.L.P., L.L.P.'],
        },
      },
    },
    PQXK: {
      active: true,
      subdivision: 'US-OK',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    VJXH: {
      active: true,
      subdivision: 'US-OK',
      languages: {
        en: {
          label: 'Not-for-profit Corporation',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    '0AWU': {
      active: true,
      subdivision: 'US-OR',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '2WCH': {
      active: true,
      subdivision: 'US-OR',
      languages: {
        en: {
          label: 'Savings bank',
          abbreviations: [],
        },
      },
    },
    '4BEM': {
      active: true,
      subdivision: 'US-OR',
      languages: {
        en: {
          label: 'Assumed Business Name',
          abbreviations: ['DBA', 'General Partnership', 'Sole Proprietor'],
        },
      },
    },
    GEE0: {
      active: true,
      subdivision: 'US-OR',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    LGVF: {
      active: true,
      subdivision: 'US-OR',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    QK2J: {
      active: true,
      subdivision: 'US-OR',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LLC'],
        },
      },
    },
    R18M: {
      active: true,
      subdivision: 'US-OR',
      languages: {
        en: {
          label: 'District Improvement Company',
          abbreviations: [],
        },
      },
    },
    T2DF: {
      active: true,
      subdivision: 'US-OR',
      languages: {
        en: {
          label: 'Business Trust',
          abbreviations: ['trust'],
        },
      },
    },
    T5ZE: {
      active: true,
      subdivision: 'US-OR',
      languages: {
        en: {
          label: 'Business Corporation',
          abbreviations: ['Company', 'Corporation', 'Incorporated', 'Limited'],
        },
      },
    },
    U1EG: {
      active: true,
      subdivision: 'US-OR',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    UQWQ: {
      active: true,
      subdivision: 'US-OR',
      languages: {
        en: {
          label: 'Cooperative Corporation',
          abbreviations: ['Cooperative', 'co-op'],
        },
      },
    },
    UZ83: {
      active: true,
      subdivision: 'US-OR',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    V10Q: {
      active: true,
      subdivision: 'US-OR',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: ['P.C.', 'Prof. Corp'],
        },
      },
    },
    WQLU: {
      active: true,
      subdivision: 'US-OR',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    Z9C5: {
      active: true,
      subdivision: 'US-OR',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    '23Q4': {
      active: true,
      subdivision: 'US-PA',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    '3JTE': {
      active: true,
      subdivision: 'US-PA',
      languages: {
        en: {
          label: 'Business Corporation',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.', 'P.C.'],
        },
      },
    },
    '3L7Q': {
      active: true,
      subdivision: 'US-PA',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    '51AN': {
      active: true,
      subdivision: 'US-PA',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    '9C19': {
      active: true,
      subdivision: 'US-PA',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    '9EJ6': {
      active: true,
      subdivision: 'US-PA',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    B8KO: {
      active: true,
      subdivision: 'US-PA',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    HSEV: {
      active: true,
      subdivision: 'US-PA',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    HV9Q: {
      active: true,
      subdivision: 'US-PA',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    R9OY: {
      active: true,
      subdivision: 'US-PA',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    '4NMI': {
      active: true,
      subdivision: 'US-RI',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    '5E0K': {
      active: true,
      subdivision: 'US-RI',
      languages: {
        en: {
          label: 'Benefit Professional Corporation',
          abbreviations: [],
        },
      },
    },
    '7RLC': {
      active: true,
      subdivision: 'US-RI',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    AVLE: {
      active: true,
      subdivision: 'US-RI',
      languages: {
        en: {
          label: 'Non-profit Corporation',
          abbreviations: [],
        },
      },
    },
    C2O4: {
      active: true,
      subdivision: 'US-RI',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    DRSE: {
      active: true,
      subdivision: 'US-RI',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['l.l.c.'],
        },
      },
    },
    FW66: {
      active: true,
      subdivision: 'US-RI',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    HA7M: {
      active: true,
      subdivision: 'US-RI',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    MG8V: {
      active: true,
      subdivision: 'US-RI',
      languages: {
        en: {
          label: 'L3C Low Profit LLC',
          abbreviations: [],
        },
      },
    },
    N263: {
      active: true,
      subdivision: 'US-RI',
      languages: {
        en: {
          label: 'Workers Cooperative',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    QMI2: {
      active: true,
      subdivision: 'US-RI',
      languages: {
        en: {
          label: 'Benefit Corporation',
          abbreviations: [],
        },
      },
    },
    QYFI: {
      active: true,
      subdivision: 'US-RI',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    RZ5R: {
      active: true,
      subdivision: 'US-RI',
      languages: {
        en: {
          label: 'Professional Service Corporation',
          abbreviations: ['corp.', 'inc.', 'ltd.', 'p.c.'],
        },
      },
    },
    Z54A: {
      active: true,
      subdivision: 'US-RI',
      languages: {
        en: {
          label: 'Business Corporation',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    ZHZP: {
      active: true,
      subdivision: 'US-RI',
      languages: {
        en: {
          label: 'Cooperative',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    '11GD': {
      active: true,
      subdivision: 'US-SC',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    '5DBJ': {
      active: true,
      subdivision: 'US-SC',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    '7QV2': {
      active: true,
      subdivision: 'US-SC',
      languages: {
        en: {
          label: 'Business Corporation',
          abbreviations: [],
        },
      },
    },
    '9JWK': {
      active: true,
      subdivision: 'US-SC',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    D2EI: {
      active: true,
      subdivision: 'US-SC',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    DBGD: {
      active: true,
      subdivision: 'US-SC',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LC', 'LLC', 'Ltd. Co.'],
        },
      },
    },
    G0HE: {
      active: true,
      subdivision: 'US-SC',
      languages: {
        en: {
          label: 'Statutory Close Corporation',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    G6VI: {
      active: true,
      subdivision: 'US-SC',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    N10D: {
      active: true,
      subdivision: 'US-SC',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: ['PA', 'PC'],
        },
      },
    },
    PNSZ: {
      active: true,
      subdivision: 'US-SC',
      languages: {
        en: {
          label: 'Benefit Corporation',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    WTWK: {
      active: true,
      subdivision: 'US-SC',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['L.L.P.'],
        },
      },
    },
    YS05: {
      active: true,
      subdivision: 'US-SC',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    '15JS': {
      active: true,
      subdivision: 'US-SD',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    '4LZW': {
      active: true,
      subdivision: 'US-SD',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    '6TGS': {
      active: true,
      subdivision: 'US-SD',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    C276: {
      active: true,
      subdivision: 'US-SD',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LC', 'LLC'],
        },
      },
    },
    I7JL: {
      active: true,
      subdivision: 'US-SD',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    JZWN: {
      active: true,
      subdivision: 'US-SD',
      languages: {
        en: {
          label: 'Business Corporation',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    PXNI: {
      active: true,
      subdivision: 'US-SD',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    UX5E: {
      active: true,
      subdivision: 'US-SD',
      languages: {
        en: {
          label: 'Limited Liability Limited Partnership',
          abbreviations: ['LLLP'],
        },
      },
    },
    Z9CH: {
      active: true,
      subdivision: 'US-SD',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['RLLP, LLP, R.L.L.P., L.L.P.'],
        },
      },
    },
    '7TJ1': {
      active: true,
      subdivision: 'US-TN',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    '8MBD': {
      active: true,
      subdivision: 'US-TN',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    BRHI: {
      active: true,
      subdivision: 'US-TN',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    C8HJ: {
      active: true,
      subdivision: 'US-TN',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    DE0G: {
      active: true,
      subdivision: 'US-TN',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    DQUB: {
      active: true,
      subdivision: 'US-TN',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    I2XB: {
      active: true,
      subdivision: 'US-TN',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LLC'],
        },
      },
    },
    ND93: {
      active: true,
      subdivision: 'US-TN',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    QJ9F: {
      active: true,
      subdivision: 'US-TN',
      languages: {
        en: {
          label: 'For-Profit Corporation',
          abbreviations: ['co.', 'corp.', 'inc.'],
        },
      },
    },
    RD1T: {
      active: true,
      subdivision: 'US-TN',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    '828X': {
      active: true,
      subdivision: 'US-TX',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '9AAS': {
      active: true,
      subdivision: 'US-TX',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: [],
        },
      },
    },
    C5K7: {
      active: true,
      subdivision: 'US-TX',
      languages: {
        en: {
          label: 'For-Profit Corporation',
          abbreviations: [],
        },
      },
    },
    FE1L: {
      active: true,
      subdivision: 'US-TX',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    HTV5: {
      active: true,
      subdivision: 'US-TX',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    MXWB: {
      active: true,
      subdivision: 'US-TX',
      languages: {
        en: {
          label: 'Professional Association',
          abbreviations: [],
        },
      },
    },
    N5OS: {
      active: true,
      subdivision: 'US-TX',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    OGSS: {
      active: true,
      subdivision: 'US-TX',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    TCLA: {
      active: true,
      subdivision: 'US-TX',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    WYG5: {
      active: true,
      subdivision: 'US-TX',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    YY5A: {
      active: true,
      subdivision: 'US-TX',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    '1CZS': {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'General Partnership',
          abbreviations: [],
        },
      },
    },
    '2I4P': {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Profit Corporation',
          abbreviations: [],
        },
      },
    },
    '3ZXC': {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Limited Liability Company (LLC)',
          abbreviations: [],
        },
      },
    },
    '65B6': {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    '6OGF': {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    '7AJT': {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    '7H0X': {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['RLLP, LLP, R.L.L.P., L.L.P.'],
        },
      },
    },
    B12O: {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Business Trust',
          abbreviations: [],
        },
      },
    },
    GIN3: {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Benefit LLC',
          abbreviations: [],
        },
      },
    },
    IDFN: {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: ['P.C'],
        },
      },
    },
    NOBH: {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Non-profit Corporation',
          abbreviations: [],
        },
      },
    },
    OK2B: {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    Q1N4: {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    RC44: {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Industrial Bank',
          abbreviations: [],
        },
      },
    },
    T0XH: {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Benefit Corporation',
          abbreviations: [],
        },
      },
    },
    UEKV: {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Low Profit LLC',
          abbreviations: ['L3C'],
        },
      },
    },
    YQLO: {
      active: true,
      subdivision: 'US-UT',
      languages: {
        en: {
          label: 'Uniform Limited Cooperative Association',
          abbreviations: [],
        },
      },
    },
    '8XN0': {
      active: true,
      subdivision: 'US-VT',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP', 'RLLP'],
        },
      },
    },
    AMV2: {
      active: true,
      subdivision: 'US-VT',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    FXHR: {
      active: true,
      subdivision: 'US-VT',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    GZMZ: {
      active: true,
      subdivision: 'US-VT',
      languages: {
        en: {
          label: 'Professional Corporation',
          abbreviations: [],
        },
      },
    },
    JJ5L: {
      active: true,
      subdivision: 'US-VT',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    JWTD: {
      active: true,
      subdivision: 'US-VT',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    K4MF: {
      active: true,
      subdivision: 'US-VT',
      languages: {
        en: {
          label: 'Professional Limited Liability Company',
          abbreviations: ['PLC'],
        },
      },
    },
    LPEE: {
      active: true,
      subdivision: 'US-VT',
      languages: {
        en: {
          label: 'Cooperative',
          abbreviations: ['Corp.'],
        },
      },
    },
    NYUD: {
      active: true,
      subdivision: 'US-VT',
      languages: {
        en: {
          label: 'Profit Corporation',
          abbreviations: [],
        },
      },
    },
    OE6T: {
      active: true,
      subdivision: 'US-VT',
      languages: {
        en: {
          label: 'Limited Liability Company (LLC)',
          abbreviations: ['Ltd Co', 'Ltd Liability Co'],
        },
      },
    },
    PNZI: {
      active: true,
      subdivision: 'US-VT',
      languages: {
        en: {
          label: 'Non-profit Corporation',
          abbreviations: [],
        },
      },
    },
    R8O9: {
      active: true,
      subdivision: 'US-VT',
      languages: {
        en: {
          label: 'Low Profit LLC',
          abbreviations: ['L3C'],
        },
      },
    },
    TCC0: {
      active: true,
      subdivision: 'US-VT',
      languages: {
        en: {
          label: 'Mutual Benefit Enterprise',
          abbreviations: ['MBE'],
        },
      },
    },
    UF6Y: {
      active: true,
      subdivision: 'US-VT',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    '456O': {
      active: true,
      subdivision: 'US-VA',
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
    '4WN7': {
      active: true,
      subdivision: 'US-VA',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    '5Y4V': {
      active: true,
      subdivision: 'US-VA',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '8KA4': {
      active: true,
      subdivision: 'US-VA',
      languages: {
        en: {
          label: 'Registered Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    BOEX: {
      active: true,
      subdivision: 'US-VA',
      languages: {
        en: {
          label: 'Business Trust',
          abbreviations: [],
        },
      },
    },
    DQMV: {
      active: true,
      subdivision: 'US-VA',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: [],
        },
      },
    },
    HOV4: {
      active: true,
      subdivision: 'US-VA',
      languages: {
        en: {
          label: 'Stock Corporation',
          abbreviations: [],
        },
      },
    },
    OF3Q: {
      active: true,
      subdivision: 'US-VA',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    PLMC: {
      active: true,
      subdivision: 'US-VA',
      languages: {
        en: {
          label: 'Nonstock Corporation',
          abbreviations: [],
        },
      },
    },
    Q28E: {
      active: true,
      subdivision: 'US-VA',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    S4U2: {
      active: true,
      subdivision: 'US-VA',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    VVJ3: {
      active: true,
      subdivision: 'US-VA',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    '9U5M': {
      active: true,
      subdivision: 'US-WA',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    F8DD: {
      active: true,
      subdivision: 'US-WA',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LLC'],
        },
      },
    },
    FQLY: {
      active: true,
      subdivision: 'US-WA',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    LBJ1: {
      active: true,
      subdivision: 'US-WA',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    NHYA: {
      active: true,
      subdivision: 'US-WA',
      languages: {
        en: {
          label: 'Profit Corporation',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    PM3Y: {
      active: true,
      subdivision: 'US-WA',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    RR8G: {
      active: true,
      subdivision: 'US-WA',
      languages: {
        en: {
          label: 'Non-profit Corporation',
          abbreviations: [],
        },
      },
    },
    RRXD: {
      active: true,
      subdivision: 'US-WA',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['LLP'],
        },
      },
    },
    VUUU: {
      active: true,
      subdivision: 'US-WA',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    '4HC4': {
      active: true,
      subdivision: 'US-WV',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '724Q': {
      active: true,
      subdivision: 'US-WV',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    DURX: {
      active: true,
      subdivision: 'US-WV',
      languages: {
        en: {
          label: 'Voluntary Association',
          abbreviations: [],
        },
      },
    },
    IJHI: {
      active: true,
      subdivision: 'US-WV',
      languages: {
        en: {
          label: 'Corporation (for profit)',
          abbreviations: [],
        },
      },
    },
    O1EZ: {
      active: true,
      subdivision: 'US-WV',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    O9MN: {
      active: true,
      subdivision: 'US-WV',
      languages: {
        en: {
          label: 'Business Trust',
          abbreviations: [],
        },
      },
    },
    OJBU: {
      active: true,
      subdivision: 'US-WV',
      languages: {
        en: {
          label: 'Unincorporated Non-Profit Association',
          abbreviations: [],
        },
      },
    },
    PXGA: {
      active: true,
      subdivision: 'US-WV',
      languages: {
        en: {
          label: 'Corporation (non-profit)',
          abbreviations: [],
        },
      },
    },
    QDZK: {
      active: true,
      subdivision: 'US-WV',
      languages: {
        en: {
          label: 'Cooperative Association',
          abbreviations: ['co-op', 'co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    R27J: {
      active: true,
      subdivision: 'US-WV',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    RC5L: {
      active: true,
      subdivision: 'US-WV',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LC', 'LLC'],
        },
      },
    },
    SSN4: {
      active: true,
      subdivision: 'US-WV',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    SUMS: {
      active: true,
      subdivision: 'US-WV',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    '10GE': {
      active: true,
      subdivision: 'US-WI',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
    '6S32': {
      active: true,
      subdivision: 'US-WI',
      languages: {
        en: {
          label: 'Business Corporation',
          abbreviations: ['co.', 'corp.', 'inc.', 'ltd.'],
        },
      },
    },
    B5YE: {
      active: true,
      subdivision: 'US-WI',
      languages: {
        en: {
          label: 'Non-deposit Trust Company',
          abbreviations: [],
        },
      },
    },
    C0CR: {
      active: true,
      subdivision: 'US-WI',
      languages: {
        en: {
          label: 'Cooperative Association',
          abbreviations: [],
        },
      },
    },
    EVBW: {
      active: true,
      subdivision: 'US-WI',
      languages: {
        en: {
          label: 'Corporation Nonstock Nonprofit',
          abbreviations: [],
        },
      },
    },
    I5XP: {
      active: true,
      subdivision: 'US-WI',
      languages: {
        en: {
          label: 'Limited Liability Limited Partnership',
          abbreviations: ['LLLP'],
        },
      },
    },
    JNYX: {
      active: true,
      subdivision: 'US-WI',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    M5RM: {
      active: true,
      subdivision: 'US-WI',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LLC'],
        },
      },
    },
    QSJ1: {
      active: true,
      subdivision: 'US-WI',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    WNV6: {
      active: true,
      subdivision: 'US-WI',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    Y7PW: {
      active: true,
      subdivision: 'US-WI',
      languages: {
        en: {
          label: 'Savings and Loan Association',
          abbreviations: [],
        },
      },
    },
    Z92A: {
      active: true,
      subdivision: 'US-WI',
      languages: {
        en: {
          label: 'Limited Liability Partnership',
          abbreviations: ['RLLP, LLP, R.L.L.P., L.L.P.'],
        },
      },
    },
    ZXZ7: {
      active: true,
      subdivision: 'US-WI',
      languages: {
        en: {
          label: 'Common Law Trust (Business Trust)',
          abbreviations: [],
        },
      },
    },
    '1YA4': {
      active: true,
      subdivision: 'US-WY',
      languages: {
        en: {
          label: 'Statutory Foundation',
          abbreviations: ['SF'],
        },
      },
    },
    '71ZI': {
      active: true,
      subdivision: 'US-WY',
      languages: {
        en: {
          label: 'Registered Limited Liability Partnership',
          abbreviations: ['RLLP, LLP, R.L.L.P., L.L.P.'],
        },
      },
    },
    '9GXA': {
      active: true,
      subdivision: 'US-WY',
      languages: {
        en: {
          label: 'Profit Corporation',
          abbreviations: [],
        },
      },
    },
    HXKE: {
      active: true,
      subdivision: 'US-WY',
      languages: {
        en: {
          label: 'Savings Bank',
          abbreviations: [],
        },
      },
    },
    NB58: {
      active: true,
      subdivision: 'US-WY',
      languages: {
        en: {
          label: 'Limited Liability Company',
          abbreviations: ['LC', 'LLC'],
        },
      },
    },
    PUJR: {
      active: true,
      subdivision: 'US-WY',
      languages: {
        en: {
          label: 'Nonprofit Corporation',
          abbreviations: [],
        },
      },
    },
    QR4Y: {
      active: true,
      subdivision: 'US-WY',
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['LP'],
        },
      },
    },
    RDQZ: {
      active: true,
      subdivision: 'US-WY',
      languages: {
        en: {
          label: 'Statutory Trust',
          abbreviations: [],
        },
      },
    },
    S6TP: {
      active: true,
      subdivision: 'US-WY',
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    WXPM: {
      active: true,
      subdivision: 'US-WY',
      languages: {
        en: {
          label: 'Credit union',
          abbreviations: [],
        },
      },
    },
  },
  VU: {
    A35I: {
      active: true,
      languages: {
        en: {
          label: 'Overseas Company',
          abbreviations: [],
        },
      },
    },
    JTJE: {
      active: true,
      languages: {
        en: {
          label: 'Local Company',
          abbreviations: [],
        },
      },
    },
    WMJ9: {
      active: true,
      languages: {
        en: {
          label: 'Foundation',
          abbreviations: [],
        },
      },
    },
  },
  VN: {
    '0OCP': {
      active: true,
      languages: {
        vi: {
          label: 'Công ty trách nhiệm hữu hạn',
          abbreviations: [],
        },
      },
    },
    '4RXL': {
      active: true,
      languages: {
        vi: {
          label: 'Công ty trách nhiệm hữu hạn một thành viên',
          abbreviations: [],
        },
      },
    },
    BB0P: {
      active: true,
      languages: {
        vi: {
          label: 'Doanh nghiệp tư nhân',
          abbreviations: [],
        },
      },
    },
    CZPI: {
      active: true,
      languages: {
        vi: {
          label: 'Doanh nghiệp nhà nước',
          abbreviations: [],
        },
      },
    },
    KQWF: {
      active: true,
      languages: {
        vi: {
          label: 'Nhóm Cty',
          abbreviations: [],
        },
      },
    },
    OMP4: {
      active: true,
      languages: {
        vi: {
          label: 'Công ty cổ phần',
          abbreviations: [],
        },
      },
    },
    QYCU: {
      active: true,
      languages: {
        vi: {
          label: 'Công ty hợp danh',
          abbreviations: [],
        },
      },
    },
    S97E: {
      active: true,
      languages: {
        vi: {
          label: 'Hợp tác xã',
          abbreviations: [],
        },
      },
    },
  },
  VG: {
    '1GR6': {
      active: true,
      languages: {
        en: {
          label: 'Partnership',
          abbreviations: [],
        },
      },
    },
    '6EH6': {
      active: true,
      languages: {
        en: {
          label: 'Company limited by shares',
          abbreviations: ['Corp', 'Inc', 'Ltd', 'S.A.'],
        },
      },
    },
    BST2: {
      active: true,
      languages: {
        en: {
          label:
            'Company limited by guarantee that is not authorised to issue shares',
          abbreviations: ['Corp', 'Inc', 'Ltd', 'S.A.'],
        },
      },
    },
    GLCI: {
      active: true,
      languages: {
        en: {
          label: 'Restricted purposes company',
          abbreviations: ['(SPV) Ltd'],
        },
      },
    },
    JS65: {
      active: true,
      languages: {
        en: {
          label: 'Unlimited company that is not authorised to issue shares',
          abbreviations: ['Unltd'],
        },
      },
    },
    KORB: {
      active: true,
      languages: {
        en: {
          label: 'Limited Partnership',
          abbreviations: ['L.P.'],
        },
      },
    },
    N28C: {
      active: true,
      languages: {
        en: {
          label: 'Restricted purposes company segregated portfolio company',
          abbreviations: ['(SPV) SPC'],
        },
      },
    },
    Q62B: {
      active: true,
      languages: {
        en: {
          label: 'Unlimited company that is authorised to issue shares',
          abbreviations: ['Unltd'],
        },
      },
    },
    YOP9: {
      active: true,
      languages: {
        en: {
          label: 'Segregated portfolio company',
          abbreviations: ['SPC'],
        },
      },
    },
    ZHED: {
      active: true,
      languages: {
        en: {
          label:
            'Company limited by guarantee that is authorised to issue shares',
          abbreviations: ['Corp', 'Inc', 'Ltd', 'S.A.'],
        },
      },
    },
  },
  VI: {
    '6QCE': {
      active: true,
      languages: {
        en: {
          label: 'Commercial Bank',
          abbreviations: [],
        },
      },
    },
    A30N: {
      active: true,
      languages: {
        en: {
          label: 'Foreign Trade & Labor Corporation',
          abbreviations: [],
        },
      },
    },
    AN8Z: {
      active: true,
      languages: {
        en: {
          label:
            'Foreign Limited Partnership / Limited Liability Limited Partnership',
          abbreviations: [],
        },
      },
    },
    CHWX: {
      active: true,
      languages: {
        en: {
          label: 'Domestic Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    DMNZ: {
      active: true,
      languages: {
        en: {
          label: 'Foreign Non-Profit Corporation',
          abbreviations: [],
        },
      },
    },
    MGUM: {
      active: true,
      languages: {
        en: {
          label:
            'Domestic Limited Partnership / Limited Liability Limited Partnership',
          abbreviations: [],
        },
      },
    },
    MH3L: {
      active: true,
      languages: {
        en: {
          label: 'Domestic Trade & Labor Corporation',
          abbreviations: [],
        },
      },
    },
    NNLM: {
      active: true,
      languages: {
        en: {
          label: 'Domestic Profit Corporation',
          abbreviations: [],
        },
      },
    },
    PKZ2: {
      active: true,
      languages: {
        en: {
          label: 'Domestic Non-Profit Corporation',
          abbreviations: [],
        },
      },
    },
    Q367: {
      active: true,
      languages: {
        en: {
          label: 'Foreign Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    SOX5: {
      active: true,
      languages: {
        en: {
          label: 'Foreign Limited Liability Company',
          abbreviations: [],
        },
      },
    },
    TA9Z: {
      active: true,
      languages: {
        en: {
          label: 'Domestic Limited Liability Partnership',
          abbreviations: [],
        },
      },
    },
    UZ9W: {
      active: true,
      languages: {
        en: {
          label: 'Foreign Profit Corporation',
          abbreviations: [],
        },
      },
    },
  },
};
